!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("algoliaBundle", [], t) : "object" == typeof exports ? exports.algoliaBundle = t() : e.algoliaBundle = t();
}(this, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var i = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    e.exports = {
      instantsearch: n(1),
      algoliasearch: n(2),
      algoliasearchHelper: n(3),
      Hogan: n(27),
      autocomplete: n(30).autocomplete,
      getAlgoliaResults: n(30).getAlgoliaResults,
      createQuerySuggestionsPlugin: n(31),
      createLocalStorageRecentSearchesPlugin: n(32),
      createAlgoliaInsightsPlugin: n(33)
    };
  }, function (e, t, n) {
    !function (t, n) {
      e.exports = n();
    }(this, function () {
      "use strict";

      function e(t) {
        return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(t);
      }
      function t(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function n(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function r(e, t, r) {
        return t && n(e.prototype, t), r && n(e, r), e;
      }
      function i(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function a() {
        return (a = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
      }
      function s(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function o(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? s(Object(n), !0).forEach(function (t) {
            i(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && l(e, t);
      }
      function u(e) {
        return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function l(e, t) {
        return (l = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function f(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              i = {},
              a = Object.keys(e);
            for (r = 0; r < a.length; r++) n = a[r], 0 <= t.indexOf(n) || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++) n = a[r], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }
      function h(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function d(e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            r = u(e);
          if (t) {
            var i = u(this).constructor;
            n = Reflect.construct(r, arguments, i);
          } else n = r.apply(this, arguments);
          return function (e, t) {
            return !t || "object" != typeof t && "function" != typeof t ? h(e) : t;
          }(this, n);
        };
      }
      function p(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
            var n = [],
              r = !0,
              i = !1,
              a = void 0;
            try {
              for (var s, o = e[Symbol.iterator](); !(r = (s = o.next()).done) && (n.push(s.value), !t || n.length !== t); r = !0);
            } catch (e) {
              i = !0, a = e;
            } finally {
              try {
                r || null == o.return || o.return();
              } finally {
                if (i) throw a;
              }
            }
            return n;
          }
        }(e, t) || g(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function m(e) {
        return function (e) {
          if (Array.isArray(e)) return v(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
        }(e) || g(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function g(e, t) {
        if (e) {
          if ("string" == typeof e) return v(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e, t) : void 0;
        }
      }
      function v(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function y(e) {
        return "function" == typeof e || Array.isArray(e) || "[object Object]" === Object.prototype.toString.call(e);
      }
      function b(e, t) {
        if (e === t) return e;
        for (var n in t) if (Object.prototype.hasOwnProperty.call(t, n) && "__proto__" !== n) {
          var r = t[n],
            i = e[n];
          void 0 !== i && void 0 === r || (y(i) && y(r) ? e[n] = b(i, r) : e[n] = "object" == typeof (a = r) && null !== a ? b(Array.isArray(a) ? [] : {}, a) : a);
        }
        var a;
        return e;
      }
      function R(e, t) {
        return Array.isArray(e) && Array.isArray(t) ? e.length === t.length && e.every(function (e, n) {
          return R(t[n], e);
        }) : e === t;
      }
      function S(e) {
        var t = e ? S._parseNumbers(e) : {};
        void 0 === t.userToken || mr(t.userToken) || console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"), this.facets = t.facets || [], this.disjunctiveFacets = t.disjunctiveFacets || [], this.hierarchicalFacets = t.hierarchicalFacets || [], this.facetsRefinements = t.facetsRefinements || {}, this.facetsExcludes = t.facetsExcludes || {}, this.disjunctiveFacetsRefinements = t.disjunctiveFacetsRefinements || {}, this.numericRefinements = t.numericRefinements || {}, this.tagRefinements = t.tagRefinements || [], this.hierarchicalFacetsRefinements = t.hierarchicalFacetsRefinements || {};
        var n = this;
        Object.keys(t).forEach(function (e) {
          var r = -1 !== S.PARAMETERS.indexOf(e),
            i = void 0 !== t[e];
          !r && i && (n[e] = t[e]);
        });
      }
      function _(e, t) {
        if (e !== t) {
          var n = void 0 !== e,
            r = null === e,
            i = void 0 !== t,
            a = null === t;
          if (!a && t < e || r && i || !n) return 1;
          if (!r && e < t || a && n || !i) return -1;
        }
        return 0;
      }
      function w(e) {
        return Array.isArray(e) ? e.filter(Boolean) : [];
      }
      function P(e, t) {
        if (!Array.isArray(e)) return -1;
        for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
        return -1;
      }
      function O(e, t) {
        var n = (t || []).map(function (e) {
          return e.split(":");
        });
        return e.reduce(function (e, t) {
          var r = t.split(":"),
            i = fr(n, function (e) {
              return e[0] === r[0];
            });
          return 1 < r.length || !i ? (e[0].push(r[0]), e[1].push(r[1])) : (e[0].push(i[0]), e[1].push(i[1])), e;
        }, [[], []]);
      }
      function x(e) {
        var t = {};
        return e.forEach(function (e, n) {
          t[e] = n;
        }), t;
      }
      function j(e, t, n) {
        t && t[n] && (e.stats = t[n]);
      }
      function I(e, t, n) {
        var r = t[0];
        this._rawResults = t;
        var i = this;
        Object.keys(r).forEach(function (e) {
          i[e] = r[e];
        }), Object.keys(n || {}).forEach(function (e) {
          i[e] = n[e];
        }), this.processingTimeMS = t.reduce(function (e, t) {
          return void 0 === t.processingTimeMS ? e : e + t.processingTimeMS;
        }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = e.hierarchicalFacets.map(function () {
          return [];
        }), this.facets = [];
        var a = e.getRefinedDisjunctiveFacets(),
          s = x(e.facets),
          o = x(e.disjunctiveFacets),
          c = 1,
          u = r.facets || {};
        Object.keys(u).forEach(function (t) {
          var n = u[t],
            a = function (e, t) {
              return fr(e, function (e) {
                return -1 < (e.attributes || []).indexOf(t);
              });
            }(e.hierarchicalFacets, t);
          if (a) {
            var c = a.attributes.indexOf(t),
              l = P(e.hierarchicalFacets, function (e) {
                return e.name === a.name;
              });
            i.hierarchicalFacets[l][c] = {
              attribute: t,
              data: n,
              exhaustive: r.exhaustiveFacetsCount
            };
          } else {
            var f,
              h = -1 !== e.disjunctiveFacets.indexOf(t),
              d = -1 !== e.facets.indexOf(t);
            h && (f = o[t], i.disjunctiveFacets[f] = {
              name: t,
              data: n,
              exhaustive: r.exhaustiveFacetsCount
            }, j(i.disjunctiveFacets[f], r.facets_stats, t)), d && (f = s[t], i.facets[f] = {
              name: t,
              data: n,
              exhaustive: r.exhaustiveFacetsCount
            }, j(i.facets[f], r.facets_stats, t));
          }
        }), this.hierarchicalFacets = w(this.hierarchicalFacets), a.forEach(function (n) {
          var a = t[c],
            s = a && a.facets ? a.facets : {},
            u = e.getHierarchicalFacetByName(n);
          Object.keys(s).forEach(function (t) {
            var n,
              c = s[t];
            if (u) {
              n = P(e.hierarchicalFacets, function (e) {
                return e.name === u.name;
              });
              var l = P(i.hierarchicalFacets[n], function (e) {
                return e.attribute === t;
              });
              if (-1 === l) return;
              i.hierarchicalFacets[n][l].data = cr({}, i.hierarchicalFacets[n][l].data, c);
            } else {
              n = o[t];
              var f = r.facets && r.facets[t] || {};
              i.disjunctiveFacets[n] = {
                name: t,
                data: ur({}, c, f),
                exhaustive: a.exhaustiveFacetsCount
              }, j(i.disjunctiveFacets[n], a.facets_stats, t), e.disjunctiveFacetsRefinements[t] && e.disjunctiveFacetsRefinements[t].forEach(function (r) {
                !i.disjunctiveFacets[n].data[r] && -1 < e.disjunctiveFacetsRefinements[t].indexOf(xr(r)) && (i.disjunctiveFacets[n].data[r] = 0);
              });
            }
          }), c++;
        }), e.getRefinedHierarchicalFacets().forEach(function (n) {
          var r = e.getHierarchicalFacetByName(n),
            a = e._getHierarchicalFacetSeparator(r),
            s = e.getHierarchicalRefinement(n);
          if (!(0 === s.length || s[0].split(a).length < 2)) {
            var o = t[c],
              u = o && o.facets ? o.facets : {};
            Object.keys(u).forEach(function (t) {
              var n = u[t],
                o = P(e.hierarchicalFacets, function (e) {
                  return e.name === r.name;
                }),
                c = P(i.hierarchicalFacets[o], function (e) {
                  return e.attribute === t;
                });
              if (-1 !== c) {
                var l = {};
                if (0 < s.length) {
                  var f = s[0].split(a)[0];
                  l[f] = i.hierarchicalFacets[o][c].data[f];
                }
                i.hierarchicalFacets[o][c].data = ur(l, n, i.hierarchicalFacets[o][c].data);
              }
            }), c++;
          }
        }), Object.keys(e.facetsExcludes).forEach(function (t) {
          var n = e.facetsExcludes[t],
            a = s[t];
          i.facets[a] = {
            name: t,
            data: r.facets[t],
            exhaustive: r.exhaustiveFacetsCount
          }, n.forEach(function (e) {
            i.facets[a] = i.facets[a] || {
              name: t
            }, i.facets[a].data = i.facets[a].data || {}, i.facets[a].data[e] = 0;
          });
        }), this.hierarchicalFacets = this.hierarchicalFacets.map(_r(e)), this.facets = w(this.facets), this.disjunctiveFacets = w(this.disjunctiveFacets), this._state = e;
      }
      function F(e, t) {
        var n = fr(e, function (e) {
          return e.name === t;
        });
        return n && n.stats;
      }
      function N(e, t, n, r, i) {
        var a = fr(i, function (e) {
            return e.name === n;
          }),
          s = a && a.data && a.data[r] ? a.data[r] : 0,
          o = a && a.exhaustive || !1;
        return {
          type: t,
          attributeName: n,
          name: r,
          count: s,
          exhaustive: o
        };
      }
      function E() {
        this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
      }
      function C(e) {
        return "function" == typeof e;
      }
      function T(e) {
        return "object" == typeof e && null !== e;
      }
      function k(e) {
        return void 0 === e;
      }
      function A(e, t) {
        this.main = e, this.fn = t, this.lastResults = null;
      }
      function D(e, t, n) {
        "function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (3.8.2)"), this.setClient(e);
        var r = n || {};
        r.index = t, this.state = yr.make(r), this.lastResults = null, this._queryId = 0, this._lastQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0;
      }
      function L(e) {
        if (e < 0) throw new Error("Page requested below 0.");
        return this._change({
          state: this.state.setPage(e),
          isPageReset: !1
        }), this;
      }
      function M() {
        return this.state.page;
      }
      function H(e, t, n) {
        return new Ar(e, t, n);
      }
      function q(e) {
        function t() {
          for (var t = arguments.length, i = new Array(t), a = 0; a < t; a++) i[a] = arguments[a];
          null === n && (n = Lr.then(function () {
            n = null, r ? r = !1 : e.apply(void 0, i);
          }));
        }
        var n = null,
          r = !1;
        return t.wait = function () {
          if (null === n) throw new Error("The deferred function should be called before calling `wait()`");
          return n;
        }, t.cancel = function () {
          null !== n && (r = !0);
        }, t;
      }
      function B(e) {
        var t = "string" == typeof e,
          n = t ? document.querySelector(e) : e;
        if (function (e) {
          return e instanceof HTMLElement || Boolean(e) && 0 < e.nodeType;
        }(n)) return n;
        var r = "Container must be `string` or `HTMLElement`.";
        throw t && (r += " Unable to find ".concat(e)), new Error(r);
      }
      function W(e) {
        return 1 === e.button || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
      }
      function Q(e) {
        return e.filter(function (e, t, n) {
          return n.indexOf(e) === t;
        });
      }
      function U(e) {
        var t = e.defaultTemplates,
          n = e.templates;
        return o({
          templatesConfig: e.templatesConfig
        }, function (e, t) {
          var n = 1 < arguments.length && void 0 !== t ? t : {};
          return Q([].concat(m(Object.keys(e || {})), m(Object.keys(n)))).reduce(function (t, r) {
            var i = e ? e[r] : void 0,
              a = n[r],
              s = void 0 !== a && a !== i;
            return t.templates[r] = s ? a : i, t.useCustomCompileOptions[r] = s, t;
          }, {
            templates: {},
            useCustomCompileOptions: {}
          });
        }(t, n));
      }
      function V(e, t) {
        return e(t = {
          exports: {}
        }, t.exports), t.exports;
      }
      function $(t) {
        var n = t.templates,
          r = t.templateKey,
          a = t.compileOptions,
          s = t.helpers,
          c = t.data,
          u = t.bindEvent,
          l = n[r];
        if ("string" != typeof l && "function" != typeof l) throw new Error("Template must be 'string' or 'function', was '".concat(e(l), "' (key: ").concat(r, ")"));
        if ("function" == typeof l) return l(c, u);
        var f = function (e, t, n) {
          var r = 0 < arguments.length && void 0 !== e ? e : {},
            a = 1 < arguments.length ? t : void 0,
            s = 2 < arguments.length ? n : void 0;
          return Object.keys(r).reduce(function (e, t) {
            return o(o({}, e), {}, i({}, t, function () {
              var e = this;
              return function (n) {
                return r[t].call(s, n, function (t) {
                  return $r.compile(t, a).render(e);
                });
              };
            }));
          }, {});
        }(s, a, c);
        return $r.compile(l, a).render(o(o({}, c), {}, {
          helpers: f
        })).replace(/[ \n\r\t\f\xA0]+/g, function (e) {
          return e.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
        }).trim();
      }
      function z(e, t) {
        for (var n, r = 0; r < e.length; r++) if (t(n = e[r], r, e)) return n;
      }
      function K(e) {
        return "number" == typeof e && e < 0 || "string" == typeof e ? String(e).replace(/^-/, "\\-") : e;
      }
      function J(e, t, n, r, i) {
        var a,
          s = 4 < arguments.length && void 0 !== i ? i : [],
          o = {
            type: t,
            attribute: n,
            name: r,
            escapedValue: K(r)
          },
          c = z(s, function (e) {
            return e.name === n;
          });
        return "hierarchical" === t ? function () {
          for (var t = e.getHierarchicalFacetByName(n), i = r.split(t.separator), s = function (e) {
              c = c && c.data && z(Object.keys(c.data).map(function (e) {
                return function (t) {
                  return e[t];
                };
              }(c.data)), function (t) {
                return t.name === i[e];
              });
            }, o = 0; void 0 !== c && o < i.length; ++o) s(o);
          a = c && c.count;
        }() : a = c && c.data && c.data[o.name], void 0 !== a && (o.count = a), c && void 0 !== c.exhaustive && (o.exhaustive = c.exhaustive), o;
      }
      function G(e, t, n) {
        var r = 2 < arguments.length && void 0 !== n && n,
          i = [],
          a = t.facetsRefinements,
          s = void 0 === a ? {} : a,
          o = t.facetsExcludes,
          c = void 0 === o ? {} : o,
          u = t.disjunctiveFacetsRefinements,
          l = void 0 === u ? {} : u,
          f = t.hierarchicalFacetsRefinements,
          h = void 0 === f ? {} : f,
          d = t.numericRefinements,
          p = void 0 === d ? {} : d,
          m = t.tagRefinements,
          g = void 0 === m ? [] : m;
        return Object.keys(s).forEach(function (n) {
          s[n].forEach(function (r) {
            i.push(J(t, "facet", n, r, e.facets));
          });
        }), Object.keys(c).forEach(function (e) {
          c[e].forEach(function (t) {
            i.push({
              type: "exclude",
              attribute: e,
              name: t,
              exclude: !0
            });
          });
        }), Object.keys(l).forEach(function (n) {
          l[n].forEach(function (r) {
            i.push(J(t, "disjunctive", n, function (e) {
              return "string" == typeof e ? e.replace(/^\\-/, "-") : e;
            }(r), e.disjunctiveFacets));
          });
        }), Object.keys(h).forEach(function (n) {
          h[n].forEach(function (r) {
            i.push(J(t, "hierarchical", n, r, e.hierarchicalFacets));
          });
        }), Object.keys(p).forEach(function (e) {
          var t = p[e];
          Object.keys(t).forEach(function (n) {
            var r = n,
              a = t[r];
            (Array.isArray(a) ? a : [a]).forEach(function (t) {
              i.push({
                type: "numeric",
                attribute: e,
                name: "".concat(t),
                numericValue: t,
                operator: r
              });
            });
          });
        }), g.forEach(function (e) {
          i.push({
            type: "tag",
            attribute: "_tags",
            name: e
          });
        }), r && t.query && t.query.trim() && i.push({
          attribute: "query",
          type: "query",
          name: t.query,
          query: t.query
        }), i;
      }
      function Y(e) {
        var t = e.helper,
          n = e.attributesToClear,
          r = void 0 === n ? [] : n,
          i = t.state.setPage(0);
        return i = r.reduce(function (e, t) {
          return i.isNumericRefined(t) ? e.removeNumericRefinement(t) : i.isHierarchicalFacet(t) ? e.removeHierarchicalFacetRefinement(t) : i.isDisjunctiveFacet(t) ? e.removeDisjunctiveFacetRefinement(t) : i.isConjunctiveFacet(t) ? e.removeFacetRefinement(t) : e;
        }, i), -1 !== r.indexOf("query") && (i = i.setQuery("")), i;
      }
      function X(e, t) {
        if (void 0 === e || "function" != typeof e) throw new Error("The render function is not valid (received type ".concat(function (e) {
          return Object.prototype.toString.call(e).slice(8, -1);
        }(e), ").\n\n").concat(t));
      }
      function Z() {}
      function ee(e, t) {
        return e;
      }
      function te(e, t) {
        return (Array.isArray(t) ? t : t.split(".")).reduce(function (e, t) {
          return e && e[t];
        }, e);
      }
      function ne(e) {
        return "number" == typeof e && isFinite(e);
      }
      function re(t) {
        if (!function (t) {
          return "object" === e(t) && null !== t;
        }(t) || "[object Object]" !== function (e) {
          return null === e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
        }(t)) return !1;
        if (null === Object.getPrototypeOf(t)) return !0;
        for (var n = t; null !== Object.getPrototypeOf(n);) n = Object.getPrototypeOf(n);
        return Object.getPrototypeOf(t) === n;
      }
      function ie(e) {
        var t = e.start,
          n = void 0 === t ? 0 : t,
          r = e.end,
          i = e.step,
          a = void 0 === i ? 1 : i,
          s = 0 === a ? 1 : a,
          o = Math.round((r - n) / s);
        return m(Array(o)).map(function (e, t) {
          return n + t * s;
        });
      }
      function ae(e) {
        return e !== Object(e);
      }
      function se(e, t) {
        if (e === t) return !0;
        if (ae(e) || ae(t) || "function" == typeof e || "function" == typeof t) return e === t;
        if (Object.keys(e).length !== Object.keys(t).length) return !1;
        for (var n = 0, r = Object.keys(e); n < r.length; n++) {
          var i = r[n];
          if (!(i in t)) return !1;
          if (!se(e[i], t[i])) return !1;
        }
        return !0;
      }
      function oe(e) {
        return function (e) {
          return e && Jr.test(e) ? e.replace(Kr, function (e) {
            return zr[e];
          }) : e;
        }(e).replace(new RegExp(Zr.highlightPreTag, "g"), ei.highlightPreTag).replace(new RegExp(Zr.highlightPostTag, "g"), ei.highlightPostTag);
      }
      function ce(e) {
        return re(e) && "string" != typeof e.value ? Object.keys(e).reduce(function (t, n) {
          return o(o({}, t), {}, i({}, n, ce(e[n])));
        }, {}) : Array.isArray(e) ? e.map(ce) : o(o({}, e), {}, {
          value: oe(e.value)
        });
      }
      function ue(e) {
        return void 0 === e.__escaped && ((e = e.map(function (e) {
          var t = a({}, e);
          return t._highlightResult && (t._highlightResult = ce(t._highlightResult)), t._snippetResult && (t._snippetResult = ce(t._snippetResult)), t;
        })).__escaped = !0), e;
      }
      function le(e) {
        var t = ei.highlightPreTag,
          n = ei.highlightPostTag;
        return e.map(function (e) {
          return e.isHighlighted ? t + e.value + n : e.value;
        }).join("");
      }
      function fe(e) {
        var t = ei.highlightPostTag,
          n = ei.highlightPreTag,
          r = e.split(n),
          i = r.shift(),
          a = i ? [{
            value: i,
            isHighlighted: !1
          }] : [];
        return r.forEach(function (e) {
          var n = e.split(t);
          a.push({
            value: n[0],
            isHighlighted: !0
          }), "" !== n[1] && a.push({
            value: n[1],
            isHighlighted: !1
          });
        }), a;
      }
      function he(e, t) {
        var n,
          r,
          i = e[t],
          a = (null === (n = e[t + 1]) || void 0 === n ? void 0 : n.isHighlighted) || !0,
          s = (null === (r = e[t - 1]) || void 0 === r ? void 0 : r.isHighlighted) || !0;
        return ti.test(function (e) {
          return e && Xr.test(e) ? e.replace(Yr, function (e) {
            return Gr[e];
          }) : e;
        }(i.value)) || s !== a ? i.isHighlighted : s;
      }
      function de(e) {
        return e.some(function (e) {
          return e.isHighlighted;
        }) ? e.map(function (t, n) {
          return o(o({}, t), {}, {
            isHighlighted: !he(e, n)
          });
        }) : e.map(function (e) {
          return o(o({}, e), {}, {
            isHighlighted: !1
          });
        });
      }
      function pe(e, t) {
        return e.setQueryParameters({
          hierarchicalFacets: t.hierarchicalFacets.reduce(function (e, t) {
            var n = function (e, t) {
              if (!Array.isArray(e)) return -1;
              for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
              return -1;
            }(e, function (e) {
              return e.name === t.name;
            });
            if (-1 === n) return e.concat(t);
            var r = e.slice();
            return r.splice(n, 1, t), r;
          }, e.hierarchicalFacets)
        });
      }
      function me() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return t.reduce(function (e, t) {
          var n = function (e, t) {
            return e.setQueryParameters({
              hierarchicalFacetsRefinements: o(o({}, e.hierarchicalFacetsRefinements), t.hierarchicalFacetsRefinements)
            });
          }(e, t);
          return function (e, t) {
            t.facets, t.disjunctiveFacets, t.facetsRefinements, t.facetsExcludes, t.disjunctiveFacetsRefinements, t.numericRefinements, t.tagRefinements, t.hierarchicalFacets, t.hierarchicalFacetsRefinements, t.ruleContexts;
            var n = f(t, ["facets", "disjunctiveFacets", "facetsRefinements", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacets", "hierarchicalFacetsRefinements", "ruleContexts"]);
            return e.setQueryParameters(n);
          }(function (e, t) {
            return t.facets.reduce(function (e, t) {
              return e.addFacet(t);
            }, e);
          }(function (e, t) {
            var n = Q([].concat(e.ruleContexts).concat(t.ruleContexts).filter(Boolean));
            return 0 < n.length ? e.setQueryParameters({
              ruleContexts: n
            }) : e;
          }(function (e, t) {
            return t.disjunctiveFacets.reduce(function (e, t) {
              return e.addDisjunctiveFacet(t);
            }, e);
          }(function (e, t) {
            return e.setQueryParameters({
              facetsRefinements: o(o({}, e.facetsRefinements), t.facetsRefinements)
            });
          }(function (e, t) {
            return e.setQueryParameters({
              facetsExcludes: o(o({}, e.facetsExcludes), t.facetsExcludes)
            });
          }(function (e, t) {
            return e.setQueryParameters({
              disjunctiveFacetsRefinements: o(o({}, e.disjunctiveFacetsRefinements), t.disjunctiveFacetsRefinements)
            });
          }(function (e, t) {
            return e.setQueryParameters({
              numericRefinements: o(o({}, e.numericRefinements), t.numericRefinements)
            });
          }(function (e, t) {
            return t.tagRefinements.reduce(function (e, t) {
              return e.addTagRefinement(t);
            }, e);
          }(pe(n, t), t), t), t), t), t), t), t), t), t);
        });
      }
      function ge(e) {
        return Array.isArray(e) ? e : [e];
      }
      function ve() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        var r = t.map(function (e) {
          return function (e) {
            var t = e.name,
              n = e.connector;
            return ["https://www.algolia.com/doc/api-reference/widgets/", t, "/js/", void 0 !== n && n ? "#connector" : ""].join("");
          }(e);
        }).join(", ");
        return function (e) {
          return [e, "See documentation: ".concat(r)].filter(Boolean).join("\n\n");
        };
      }
      function ye(e) {
        return Array.isArray(e) ? function (e) {
          var t = p(e, 1)[0],
            n = p(t = void 0 === t ? [void 0, void 0, void 0, void 0] : t, 4),
            r = n[0],
            i = n[1],
            a = n[2],
            s = n[3];
          if (!(r && i && a && s)) throw new Error('Invalid value for "insideBoundingBox" parameter: ['.concat(e, "]"));
          return {
            northEast: {
              lat: r,
              lng: i
            },
            southWest: {
              lat: a,
              lng: s
            }
          };
        }(e) : function (e) {
          var t = p(e.split(",").map(parseFloat), 4),
            n = t[0],
            r = t[1],
            i = t[2],
            a = t[3];
          if (!(n && r && i && a)) throw new Error('Invalid value for "insideBoundingBox" parameter: "'.concat(e, '"'));
          return {
            northEast: {
              lat: n,
              lng: r
            },
            southWest: {
              lat: i,
              lng: a
            }
          };
        }(e);
      }
      function be(e, t, n) {
        return e.map(function (e, r) {
          return o(o({}, e), {}, {
            __position: n * t + r + 1
          });
        });
      }
      function Re(e, t) {
        return t ? e.map(function (e) {
          return o(o({}, e), {}, {
            __queryID: t
          });
        }) : e;
      }
      function Se(t) {
        var n = t.instantSearchInstance,
          r = t.helper,
          i = t.attribute,
          a = t.widgetType;
        return function () {
          for (var t = arguments.length, s = new Array(t), o = 0; o < t; o++) s[o] = arguments[o];
          var c = s[0],
            u = s[1],
            l = s[2],
            f = void 0 === l ? "Filter Applied" : l;
          1 === s.length && "object" === e(s[0]) ? n.sendEventToInsights(s[0]) : "click" !== c || 2 !== s.length && 3 !== s.length || function (e, t, n) {
            return e.state.isHierarchicalFacet(t) ? e.state.isHierarchicalFacetRefined(t, n) : e.state.isConjunctiveFacet(t) ? e.state.isFacetRefined(t, n) : e.state.isDisjunctiveFacetRefined(t, n);
          }(r, i, u) || n.sendEventToInsights({
            insightsMethod: "clickedFilters",
            widgetType: a,
            eventType: c,
            payload: {
              eventName: f,
              index: r.getIndex(),
              filters: ["".concat(i, ":").concat(u)]
            },
            attribute: i
          });
        };
      }
      function _e(e) {
        return btoa(encodeURIComponent(JSON.stringify(e)));
      }
      function we(e) {
        return JSON.parse(decodeURIComponent(atob(e)));
      }
      function Pe(t) {
        var n = t.index,
          r = t.widgetType,
          i = (t.methodName, t.args);
        if (1 === i.length && "object" === e(i[0])) return [i[0]];
        var a = i[0],
          s = i[1],
          o = i[2];
        if (!s) return [];
        if (("click" === a || "conversion" === a) && !o) return [];
        var c = Array.isArray(s) ? function (e) {
          return e.slice();
        }(s) : [s];
        if (0 === c.length) return [];
        var u = c[0].__queryID,
          l = function (e, t) {
            for (var n = 1 < arguments.length && void 0 !== t ? t : 20, r = [], i = 0; i < Math.ceil(e.length / n); i++) r.push(e.slice(i * n, (i + 1) * n));
            return r;
          }(c),
          f = l.map(function (e) {
            return e.map(function (e) {
              return e.objectID;
            });
          }),
          h = l.map(function (e) {
            return e.map(function (e) {
              return e.__position;
            });
          });
        return "view" === a ? l.map(function (e, t) {
          return {
            insightsMethod: "viewedObjectIDs",
            widgetType: r,
            eventType: a,
            payload: {
              eventName: o || "Hits Viewed",
              index: n,
              objectIDs: f[t]
            },
            hits: e
          };
        }) : "click" === a ? l.map(function (e, t) {
          return {
            insightsMethod: "clickedObjectIDsAfterSearch",
            widgetType: r,
            eventType: a,
            payload: {
              eventName: o,
              index: n,
              queryID: u,
              objectIDs: f[t],
              positions: h[t]
            },
            hits: e
          };
        }) : "conversion" === a ? l.map(function (e, t) {
          return {
            insightsMethod: "convertedObjectIDsAfterSearch",
            widgetType: r,
            eventType: a,
            payload: {
              eventName: o,
              index: n,
              queryID: u,
              objectIDs: f[t]
            },
            hits: e
          };
        }) : [];
      }
      function Oe(e) {
        var t = e.instantSearchInstance,
          n = e.index,
          r = e.widgetType;
        return function () {
          for (var e = arguments.length, i = new Array(e), a = 0; a < e; a++) i[a] = arguments[a];
          Pe({
            widgetType: r,
            index: n,
            methodName: "sendEvent",
            args: i
          }).forEach(function (e) {
            return t.sendEventToInsights(e);
          });
        };
      }
      function xe(e) {
        var t = e.index,
          n = e.widgetType;
        return function () {
          for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++) r[i] = arguments[i];
          var a = Pe({
            widgetType: n,
            index: t,
            methodName: "bindEvent",
            args: r
          });
          return a.length ? "data-insights-event=".concat(_e(a)) : "";
        };
      }
      function je(e, t) {
        if (!e) return null;
        var n = e.numericRefinements[t],
          r = [];
        return Object.keys(n).filter(function (e) {
          return Array.isArray(n[e]) && 0 < n[e].length;
        }).forEach(function (e) {
          n[e].forEach(function (n) {
            r.push("".concat(t).concat(e).concat(n));
          });
        }), r;
      }
      function Ie(e, t) {
        var n = null;
        return function () {
          for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
          return new Promise(function (r, a) {
            n && clearTimeout(n), n = setTimeout(function () {
              n = null, Promise.resolve(e.apply(void 0, i)).then(r).catch(a);
            }, t);
          });
        };
      }
      function Fe(e, t) {
        var n,
          r = null === (n = e.getWidgetRenderState) || void 0 === n ? void 0 : n.call(e, t),
          i = null;
        if (r && r.widgetParams) {
          var a = r.widgetParams;
          a.attribute ? i = a.attribute : Array.isArray(a.attributes) && (i = a.attributes[0]);
        }
        if ("string" != typeof i) throw new Error("Could not find the attribute of the widget:\n\n".concat(JSON.stringify(e), "\n\nPlease check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly."));
        return i;
      }
      function Ne(e, t) {
        var n = (1 < arguments.length && void 0 !== t ? t : {
          fallback: function () {}
        }).fallback;
        return "undefined" == typeof window ? n() : e({
          window: window
        });
      }
      function Ee(e) {
        return "ais.index" === e.$$type;
      }
      function Ce(e, t) {
        var n = t.state,
          r = t.isPageReset,
          i = t._uiState;
        n !== e.state && (e.state = n, e.emit("change", {
          state: e.state,
          results: e.lastResults,
          isPageReset: r,
          _uiState: i
        }));
      }
      function Te(e, t, n) {
        var r = 2 < arguments.length && void 0 !== n ? n : {};
        return e.reduce(function (e, n) {
          return Ee(n) ? e : n.getWidgetUiState || n.getWidgetState ? n.getWidgetUiState ? n.getWidgetUiState(e, t) : n.getWidgetState(e, t) : e;
        }, r);
      }
      function ke(e, t) {
        var n = t.initialSearchParameters,
          r = f(t, ["initialSearchParameters"]);
        return e.filter(function (e) {
          return !Ee(e);
        }).reduce(function (e, t) {
          return t.getWidgetSearchParameters ? t.getWidgetSearchParameters(e, r) : e;
        }, n);
      }
      function Ae(e) {
        if (void 0 === e || void 0 === e.indexName) throw new Error(ri("The `indexName` option is required."));
        var t = e.indexName,
          n = e.indexId,
          r = void 0 === n ? t : n,
          a = [],
          s = {},
          c = null,
          u = null,
          l = null,
          f = null;
        return {
          $$type: "ais.index",
          $$widgetType: "ais.index",
          getIndexName: function () {
            return t;
          },
          getIndexId: function () {
            return r;
          },
          getHelper: function () {
            return l;
          },
          getResults: function () {
            return f && f.lastResults;
          },
          getScopedResults: function () {
            var e = this.getParent();
            return function e(t) {
              return t.filter(Ee).reduce(function (t, n) {
                return t.concat.apply(t, [{
                  indexId: n.getIndexId(),
                  results: n.getResults(),
                  helper: n.getHelper()
                }].concat(m(e(n.getWidgets()))));
              }, []);
            }(e ? e.getWidgets() : [this]);
          },
          getParent: function () {
            return u;
          },
          createURL: function (e) {
            return c._createURL(i({}, r, Te(a, {
              searchParameters: e,
              helper: l
            })));
          },
          getWidgets: function () {
            return a;
          },
          addWidgets: function (e) {
            var t = this;
            if (!Array.isArray(e)) throw new Error(ri("The `addWidgets` method expects an array of widgets."));
            if (e.some(function (e) {
              return "function" != typeof e.init && "function" != typeof e.render;
            })) throw new Error(ri("The widget definition expects a `render` and/or an `init` method."));
            return a = a.concat(e), c && Boolean(e.length) && (Ce(l, {
              state: ke(a, {
                uiState: s,
                initialSearchParameters: l.state
              }),
              _uiState: s
            }), e.forEach(function (e) {
              e.getRenderState && De({
                renderState: e.getRenderState(c.renderState[t.getIndexId()] || {}, {
                  uiState: c._initialUiState,
                  helper: t.getHelper(),
                  parent: t,
                  instantSearchInstance: c,
                  state: l.state,
                  renderState: c.renderState,
                  templatesConfig: c.templatesConfig,
                  createURL: t.createURL,
                  scopedResults: [],
                  searchMetadata: {
                    isSearchStalled: c._isSearchStalled
                  }
                }),
                instantSearchInstance: c,
                parent: t
              });
            }), e.forEach(function (e) {
              e.init && e.init({
                helper: l,
                parent: t,
                uiState: c._initialUiState,
                instantSearchInstance: c,
                state: l.state,
                renderState: c.renderState,
                templatesConfig: c.templatesConfig,
                createURL: t.createURL,
                scopedResults: [],
                searchMetadata: {
                  isSearchStalled: c._isSearchStalled
                }
              });
            }), c.scheduleSearch()), this;
          },
          removeWidgets: function (e) {
            var t = this;
            if (!Array.isArray(e)) throw new Error(ri("The `removeWidgets` method expects an array of widgets."));
            if (e.some(function (e) {
              return "function" != typeof e.dispose;
            })) throw new Error(ri("The widget definition expects a `dispose` method."));
            if (a = a.filter(function (t) {
              return -1 === e.indexOf(t);
            }), c && Boolean(e.length)) {
              var n = e.reduce(function (e, n) {
                return n.dispose({
                  helper: l,
                  state: e,
                  parent: t
                }) || e;
              }, l.state);
              s = Te(a, {
                searchParameters: n,
                helper: l
              }), l.setState(ke(a, {
                uiState: s,
                initialSearchParameters: n
              })), a.length && c.scheduleSearch();
            }
            return this;
          },
          init: function (e) {
            var n,
              i = this,
              o = e.instantSearchInstance,
              h = e.parent,
              d = e.uiState;
            if (null === l) {
              c = o, u = h, s = d[r] || {};
              var p = o.mainHelper,
                g = ke(a, {
                  uiState: s,
                  initialSearchParameters: new Dr.SearchParameters({
                    index: t
                  })
                });
              (l = Dr({}, g.index, g)).search = function () {
                return o.onStateChange ? (o.onStateChange({
                  uiState: o.mainIndex.getWidgetUiState({}),
                  setUiState: o.setUiState.bind(o)
                }), p) : p.search();
              }, l.searchWithoutTriggeringOnStateChange = function () {
                return p.search();
              }, l.searchForFacetValues = function (e, t, n, r) {
                var i = l.state.setQueryParameters(r);
                return p.searchForFacetValues(e, t, n, i);
              }, f = p.derive(function () {
                return me.apply(void 0, m(function (e) {
                  for (var t = e.getParent(), n = [e.getHelper().state]; null !== t;) n = [t.getHelper().state].concat(n), t = t.getParent();
                  return n;
                }(i)));
              });
              var v = null === (n = o._initialResults) || void 0 === n ? void 0 : n[this.getIndexId()];
              if (v) {
                var y = new Dr.SearchResults(new Dr.SearchParameters(v.state), v.results);
                f.lastResults = y, l.lastResults = y;
              }
              l.on("change", function (e) {
                e.isPageReset && !function e(t) {
                  var n = t.filter(Ee);
                  0 !== n.length && n.forEach(function (t) {
                    var n = t.getHelper();
                    Ce(n, {
                      state: n.state.resetPage(),
                      isPageReset: !0
                    }), e(t.getWidgets());
                  });
                }(a);
              }), f.on("search", function () {
                o.scheduleStalledRender();
              }), f.on("result", function (e) {
                var t = e.results;
                o.scheduleRender(), l.lastResults = t;
              }), a.forEach(function (e) {
                e.getRenderState && De({
                  renderState: e.getRenderState(o.renderState[i.getIndexId()] || {}, {
                    uiState: d,
                    helper: l,
                    parent: i,
                    instantSearchInstance: o,
                    state: l.state,
                    renderState: o.renderState,
                    templatesConfig: o.templatesConfig,
                    createURL: i.createURL,
                    scopedResults: [],
                    searchMetadata: {
                      isSearchStalled: o._isSearchStalled
                    }
                  }),
                  instantSearchInstance: o,
                  parent: i
                });
              }), a.forEach(function (e) {
                e.init && e.init({
                  uiState: d,
                  helper: l,
                  parent: i,
                  instantSearchInstance: o,
                  state: l.state,
                  renderState: o.renderState,
                  templatesConfig: o.templatesConfig,
                  createURL: i.createURL,
                  scopedResults: [],
                  searchMetadata: {
                    isSearchStalled: o._isSearchStalled
                  }
                });
              }), l.on("change", function (e) {
                var t = e.state,
                  n = e._uiState;
                s = Te(a, {
                  searchParameters: t,
                  helper: l
                }, n || {}), o.onStateChange || o.onInternalStateChange();
              }), v && o.scheduleRender();
            }
          },
          render: function (e) {
            var t = this,
              n = e.instantSearchInstance;
            this.getResults() && (a.forEach(function (e) {
              e.getRenderState && De({
                renderState: e.getRenderState(n.renderState[t.getIndexId()] || {}, {
                  helper: t.getHelper(),
                  parent: t,
                  instantSearchInstance: n,
                  results: t.getResults(),
                  scopedResults: t.getScopedResults(),
                  state: t.getResults()._state,
                  renderState: n.renderState,
                  templatesConfig: n.templatesConfig,
                  createURL: t.createURL,
                  searchMetadata: {
                    isSearchStalled: n._isSearchStalled
                  }
                }),
                instantSearchInstance: n,
                parent: t
              });
            }), a.forEach(function (e) {
              e.render && e.render({
                helper: l,
                parent: t,
                instantSearchInstance: n,
                results: t.getResults(),
                scopedResults: t.getScopedResults(),
                state: t.getResults()._state,
                renderState: n.renderState,
                templatesConfig: n.templatesConfig,
                createURL: t.createURL,
                searchMetadata: {
                  isSearchStalled: n._isSearchStalled
                }
              });
            }));
          },
          dispose: function () {
            var e = this;
            a.forEach(function (t) {
              t.dispose && t.dispose({
                helper: l,
                state: l.state,
                parent: e
              });
            }), u = c = null, l.removeAllListeners(), l = null, f.detach(), f = null;
          },
          getWidgetUiState: function (e) {
            return a.filter(Ee).reduce(function (e, t) {
              return t.getWidgetUiState(e);
            }, o(o({}, e), {}, i({}, this.getIndexId(), s)));
          },
          getWidgetState: function (e) {
            return this.getWidgetUiState(e);
          },
          getWidgetSearchParameters: function (e, t) {
            var n = t.uiState;
            return ke(a, {
              uiState: n,
              initialSearchParameters: e
            });
          },
          refreshUiState: function () {
            s = Te(a, {
              searchParameters: this.getHelper().state,
              helper: this.getHelper()
            }, s);
          }
        };
      }
      function De(e) {
        var t = e.renderState,
          n = e.instantSearchInstance,
          r = e.parent,
          a = r ? r.getIndexId() : n.mainIndex.getIndexId();
        n.renderState = o(o({}, n.renderState), {}, i({}, a, o(o({}, n.renderState[a]), t)));
      }
      function Le(e) {
        return function () {
          var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.descendantName,
            r = t.modifierName,
            i = n ? "-".concat(n) : "",
            a = r ? "--".concat(r) : "";
          return "".concat("ais", "-").concat(e).concat(i).concat(a);
        };
      }
      function Me(e) {
        var t = e.attribute,
          n = e.highlightedTagName,
          r = void 0 === n ? "mark" : n,
          i = e.hit,
          a = e.cssClasses,
          s = void 0 === a ? {} : a,
          o = (te(i._highlightResult, t) || {}).value,
          c = void 0 === o ? "" : o,
          u = ii({
            descendantName: "highlighted"
          }) + (s.highlighted ? " ".concat(s.highlighted) : "");
        return c.replace(new RegExp(ei.highlightPreTag, "g"), "<".concat(r, ' class="').concat(u, '">')).replace(new RegExp(ei.highlightPostTag, "g"), "</".concat(r, ">"));
      }
      function He(e) {
        var t = e.attribute,
          n = e.highlightedTagName,
          r = void 0 === n ? "mark" : n,
          i = e.hit,
          a = e.cssClasses,
          s = void 0 === a ? {} : a,
          o = (te(i._highlightResult, t) || {}).value,
          c = void 0 === o ? "" : o,
          u = ai({
            descendantName: "highlighted"
          }) + (s.highlighted ? " ".concat(s.highlighted) : "");
        return le(de(fe(c))).replace(new RegExp(ei.highlightPreTag, "g"), "<".concat(r, ' class="').concat(u, '">')).replace(new RegExp(ei.highlightPostTag, "g"), "</".concat(r, ">"));
      }
      function qe(e) {
        var t = e.attribute,
          n = e.highlightedTagName,
          r = void 0 === n ? "mark" : n,
          i = e.hit,
          a = e.cssClasses,
          s = void 0 === a ? {} : a,
          o = (te(i._snippetResult, t) || {}).value,
          c = void 0 === o ? "" : o,
          u = si({
            descendantName: "highlighted"
          }) + (s.highlighted ? " ".concat(s.highlighted) : "");
        return c.replace(new RegExp(ei.highlightPreTag, "g"), "<".concat(r, ' class="').concat(u, '">')).replace(new RegExp(ei.highlightPostTag, "g"), "</".concat(r, ">"));
      }
      function Be(e) {
        var t = e.attribute,
          n = e.highlightedTagName,
          r = void 0 === n ? "mark" : n,
          i = e.hit,
          a = e.cssClasses,
          s = void 0 === a ? {} : a,
          o = (te(i._snippetResult, t) || {}).value,
          c = void 0 === o ? "" : o,
          u = oi({
            descendantName: "highlighted"
          }) + (s.highlighted ? " ".concat(s.highlighted) : "");
        return le(de(fe(c))).replace(new RegExp(ei.highlightPreTag, "g"), "<".concat(r, ' class="').concat(u, '">')).replace(new RegExp(ei.highlightPostTag, "g"), "</".concat(r, ">"));
      }
      function We(t, n) {
        return function (t) {
          var n,
            r = t.method,
            i = t.payload;
          if ("object" !== e(i)) throw new Error("The insights helper expects the payload to be an object.");
          try {
            n = _e(i);
          } catch (e) {
            throw new Error("Could not JSON serialize the payload object.");
          }
          return 'data-insights-method="'.concat(r, '" data-insights-payload="').concat(n, '"');
        }({
          method: t,
          payload: n
        });
      }
      function Qe() {
        return function (e) {
          for (var t = "".concat(e, "="), n = document.cookie.split(";"), r = 0; r < n.length; r++) {
            for (var i = n[r]; " " === i.charAt(0);) i = i.substring(1);
            if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
          }
        }("_ALGOLIA");
      }
      function Ue(e) {
        return e.configure, f(e, ["configure"]);
      }
      function Ve() {
        return {
          stateToRoute: function (e) {
            return Object.keys(e).reduce(function (t, n) {
              return o(o({}, t), {}, i({}, n, Ue(e[n])));
            }, {});
          },
          routeToState: function (e) {
            var t = 0 < arguments.length && void 0 !== e ? e : {};
            return Object.keys(t).reduce(function (e, n) {
              return o(o({}, e), {}, i({}, n, Ue(t[n])));
            }, {});
          }
        };
      }
      function $e(e, t) {
        for (var n = t && t.plainObjects ? Object.create(null) : {}, r = 0; r < e.length; ++r) void 0 !== e[r] && (n[r] = e[r]);
        return n;
      }
      function ze(e, t) {
        bi.apply(e, yi(t) ? t : [t]);
      }
      function Ke(e, t, n, r, i, a, s, o, c, u, l, f, h, d) {
        var p = e;
        if ("function" == typeof s ? p = s(t, p) : p instanceof Date ? p = u(p) : "comma" === n && yi(p) && (p = mi.maybeMap(p, function (e) {
          return e instanceof Date ? u(e) : e;
        })), null === p) {
          if (r) return a && !h ? a(t, _i.encoder, d, "key", l) : t;
          p = "";
        }
        if (function (e) {
          return "string" == typeof e || "number" == typeof e || "boolean" == typeof e || "symbol" == typeof e || "bigint" == typeof e;
        }(p) || mi.isBuffer(p)) return a ? [f(h ? t : a(t, _i.encoder, d, "key", l)) + "=" + f(a(p, _i.encoder, d, "value", l))] : [f(t) + "=" + f(String(p))];
        var m,
          g = [];
        if (void 0 === p) return g;
        if ("comma" === n && yi(p)) m = [{
          value: 0 < p.length ? p.join(",") || null : void 0
        }];else if (yi(s)) m = s;else {
          var v = Object.keys(p);
          m = o ? v.sort(o) : v;
        }
        for (var y = 0; y < m.length; ++y) {
          var b = m[y],
            R = "object" == typeof b && void 0 !== b.value ? b.value : p[b];
          if (!i || null !== R) {
            var S = yi(p) ? "function" == typeof n ? n(t, b) : t : t + (c ? "." + b : "[" + b + "]");
            ze(g, Ke(R, S, n, r, i, a, s, o, c, u, l, f, h, d));
          }
        }
        return g;
      }
      function Je(e, t) {
        return e && "string" == typeof e && t.comma && -1 < e.indexOf(",") ? e.split(",") : e;
      }
      function Ge(e, t, n, r) {
        if (e) {
          var i = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
            a = /(\[[^[\]]*])/g,
            s = 0 < n.depth && /(\[[^[\]]*])/.exec(i),
            o = s ? i.slice(0, s.index) : i,
            c = [];
          if (o) {
            if (!n.plainObjects && wi.call(Object.prototype, o) && !n.allowPrototypes) return;
            c.push(o);
          }
          for (var u = 0; 0 < n.depth && null !== (s = a.exec(i)) && u < n.depth;) {
            if (u += 1, !n.plainObjects && wi.call(Object.prototype, s[1].slice(1, -1)) && !n.allowPrototypes) return;
            c.push(s[1]);
          }
          return s && c.push("[" + i.slice(s.index) + "]"), function (e, t, n, r) {
            for (var i = r ? t : Je(t, n), a = e.length - 1; 0 <= a; --a) {
              var s,
                o = e[a];
              if ("[]" === o && n.parseArrays) s = [].concat(i);else {
                s = n.plainObjects ? Object.create(null) : {};
                var c = "[" === o.charAt(0) && "]" === o.charAt(o.length - 1) ? o.slice(1, -1) : o,
                  u = parseInt(c, 10);
                n.parseArrays || "" !== c ? !isNaN(u) && o !== c && String(u) === c && 0 <= u && n.parseArrays && u <= n.arrayLimit ? (s = [])[u] = i : s[c] = i : s = {
                  0: i
                };
              }
              i = s;
            }
            return i;
          }(c, t, n, r);
        }
      }
      function Ye(e) {
        e && (window.document.title = e);
      }
      function Xe() {
        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.createURL,
          n = void 0 === t ? function (e) {
            var t = e.qsModule,
              n = e.routeState,
              r = e.location,
              i = r.protocol,
              a = r.hostname,
              s = r.port,
              o = void 0 === s ? "" : s,
              c = r.pathname,
              u = r.hash,
              l = t.stringify(n),
              f = "" === o ? "" : ":".concat(o);
            return l ? "".concat(i, "//").concat(a).concat(f).concat(c, "?").concat(l).concat(u) : "".concat(i, "//").concat(a).concat(f).concat(c).concat(u);
          } : t,
          r = e.parseURL,
          i = void 0 === r ? function (e) {
            var t = e.qsModule,
              n = e.location;
            return t.parse(n.search.slice(1), {
              arrayLimit: 99
            });
          } : r,
          a = e.writeDelay,
          s = void 0 === a ? 400 : a,
          o = e.windowTitle,
          c = e.getLocation;
        return new ji({
          createURL: n,
          parseURL: i,
          writeDelay: s,
          windowTitle: o,
          getLocation: void 0 === c ? function () {
            return Ne(function (e) {
              return e.window.location;
            }, {
              fallback: function () {
                throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
              }
            });
          } : c
        });
      }
      function Ze(e) {
        var t = 0 < arguments.length && void 0 !== e ? e : {},
          n = t.router,
          r = void 0 === n ? Xe() : n,
          a = t.stateMapping,
          s = void 0 === a ? Ve() : a;
        return function (e) {
          var t = e.instantSearchInstance;
          t._createURL = function (e) {
            var n = Object.keys(e).reduce(function (t, n) {
                return o(o({}, t), {}, i({}, n, e[n]));
              }, t.mainIndex.getWidgetUiState({})),
              a = s.stateToRoute(n);
            return r.createURL(a);
          };
          var n = void 0,
            a = t._initialUiState;
          return {
            onStateChange: function (e) {
              var t = e.uiState,
                i = s.stateToRoute(t);
              void 0 !== n && se(n, i) || (r.write(i), n = i);
            },
            subscribe: function () {
              t._initialUiState = o(o({}, a), s.routeToState(r.read())), r.onUpdate(function (e) {
                t.setUiState(s.routeToState(e));
              });
            },
            unsubscribe: function () {
              r.dispose();
            }
          };
        };
      }
      function et() {
        return Ne(function (e) {
          var t, n;
          return -1 < (null === (t = e.window.navigator) || void 0 === t ? void 0 : null === (n = t.userAgent) || void 0 === n ? void 0 : n.indexOf("Algolia Crawler"));
        }, {
          fallback: function () {
            return !1;
          }
        });
      }
      function tt() {
        return function (e) {
          var t = e.instantSearchInstance,
            n = {
              widgets: []
            },
            r = document.createElement("meta"),
            i = document.querySelector("head");
          return r.name = "instantsearch:widgets", {
            onStateChange: function () {},
            subscribe: function () {
              setTimeout(function () {
                var e = t.client;
                n.ua = e.transporter && e.transporter.userAgent ? e.transporter.userAgent.value : e._ua, function e(t, n, r) {
                  var i = n.mainIndex,
                    a = {
                      instantSearchInstance: n,
                      parent: i,
                      scopedResults: [],
                      state: i.getHelper().state,
                      helper: i.getHelper(),
                      createURL: i.createURL,
                      uiState: n._initialUiState,
                      renderState: n.renderState,
                      templatesConfig: n.templatesConfig,
                      searchMetadata: {
                        isSearchStalled: n._isSearchStalled
                      }
                    };
                  t.forEach(function (t) {
                    var i = {};
                    if (t.getWidgetRenderState) {
                      var s = t.getWidgetRenderState(a);
                      s && s.widgetParams && (i = s.widgetParams);
                    }
                    var o = Object.keys(i).filter(function (e) {
                      return void 0 !== i[e];
                    });
                    r.widgets.push({
                      type: t.$$type,
                      widgetType: t.$$widgetType,
                      params: o
                    }), "ais.index" === t.$$type && e(t.getWidgets(), n, r);
                  });
                }(t.mainIndex.getWidgets(), t, n), r.content = JSON.stringify(n), i.appendChild(r);
              }, 0);
            },
            unsubscribe: function () {
              r.remove();
            }
          };
        };
      }
      function nt() {
        return "#";
      }
      function rt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Ni()), function (t) {
          function r() {
            return d.refine();
          }
          function i() {
            return d.createURL();
          }
          var a = t || {},
            s = a.includedAttributes,
            c = void 0 === s ? [] : s,
            u = a.excludedAttributes,
            l = void 0 === u ? ["query"] : u,
            f = a.transformItems,
            h = void 0 === f ? function (e) {
              return e;
            } : f;
          if (t && t.includedAttributes && t.excludedAttributes) throw new Error(Ni("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
          var d = {
            refine: Z,
            createURL: function () {
              return "";
            },
            attributesToClear: []
          };
          return {
            $$type: "ais.clearRefinements",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function () {
              n();
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                clearRefinements: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.createURL,
                a = e.scopedResults,
                s = e.results;
              d.attributesToClear = a.reduce(function (e, t) {
                return e.concat(function (e) {
                  var t = e.scopedResult,
                    n = e.includedAttributes,
                    r = e.excludedAttributes,
                    i = e.transformItems,
                    a = e.results,
                    s = -1 !== n.indexOf("query") || -1 === r.indexOf("query");
                  return {
                    helper: t.helper,
                    items: i(Q(G(t.results, t.helper.state, s).map(function (e) {
                      return e.attribute;
                    }).filter(function (e) {
                      return 0 === n.length || -1 !== n.indexOf(e);
                    }).filter(function (e) {
                      return "query" === e && s || -1 === r.indexOf(e);
                    })), {
                      results: a
                    })
                  };
                }({
                  scopedResult: t,
                  includedAttributes: c,
                  excludedAttributes: l,
                  transformItems: h,
                  results: s
                }));
              }, []), d.refine = function () {
                d.attributesToClear.forEach(function (e) {
                  var t = e.helper,
                    n = e.items;
                  t.setState(Y({
                    helper: t,
                    attributesToClear: n
                  })).search();
                });
              }, d.createURL = function () {
                return n(me.apply(void 0, m(d.attributesToClear.map(function (e) {
                  return Y({
                    helper: e.helper,
                    attributesToClear: e.items
                  });
                }))));
              };
              var o = d.attributesToClear.some(function (e) {
                return 0 < e.items.length;
              });
              return {
                canRefine: o,
                hasRefinements: o,
                refine: r,
                createURL: i,
                widgetParams: t
              };
            }
          };
        };
      }
      function it(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Ei()), function (t) {
          if ((t || {}).includedAttributes && (t || {}).excludedAttributes) throw new Error(Ei("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
          var r = t || {},
            i = r.includedAttributes,
            a = r.excludedAttributes,
            s = void 0 === a ? ["query"] : a,
            c = r.transformItems,
            u = void 0 === c ? function (e) {
              return e;
            } : c;
          return {
            $$type: "ais.currentRefinements",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function () {
              n();
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                currentRefinements: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                r = e.scopedResults,
                a = e.createURL,
                o = e.helper,
                c = n ? r.reduce(function (e, t) {
                  return e.concat(u(at({
                    results: t.results,
                    helper: t.helper,
                    includedAttributes: i,
                    excludedAttributes: s
                  }), {
                    results: n
                  }));
                }, []) : u(at({
                  results: {},
                  helper: o,
                  includedAttributes: i,
                  excludedAttributes: s
                }), {
                  results: n
                });
              return {
                items: c,
                canRefine: 0 < c.length,
                refine: function (e) {
                  return ot(o, e);
                },
                createURL: function (e) {
                  return a(st(o.state, e));
                },
                widgetParams: t
              };
            }
          };
        };
      }
      function at(e) {
        var t = e.results,
          n = e.helper,
          r = e.includedAttributes,
          i = e.excludedAttributes,
          a = -1 !== (r || []).indexOf("query") || -1 === (i || []).indexOf("query"),
          s = r ? function (e) {
            return -1 !== r.indexOf(e.attribute);
          } : function (e) {
            return -1 === i.indexOf(e.attribute);
          },
          o = G(t, n.state, a).map(ct).filter(s);
        return o.reduce(function (e, t) {
          return [].concat(m(e.filter(function (e) {
            return e.attribute !== t.attribute;
          })), [{
            indexName: n.state.index,
            attribute: t.attribute,
            label: t.attribute,
            refinements: o.filter(function (e) {
              return e.attribute === t.attribute;
            }).sort(function (e, t) {
              return "numeric" === e.type ? e.value - t.value : 0;
            }),
            refine: function (e) {
              return ot(n, e);
            }
          }]);
        }, []);
      }
      function st(e, t) {
        switch (t.type) {
          case "facet":
            return e.removeFacetRefinement(t.attribute, String(t.value));
          case "disjunctive":
            return e.removeDisjunctiveFacetRefinement(t.attribute, String(t.value));
          case "hierarchical":
            return e.removeHierarchicalFacetRefinement(t.attribute);
          case "exclude":
            return e.removeExcludeRefinement(t.attribute, String(t.value));
          case "numeric":
            return e.removeNumericRefinement(t.attribute, t.operator, String(t.value));
          case "tag":
            return e.removeTagRefinement(String(t.value));
          case "query":
            return e.setQueryParameter("query", "");
          default:
            return e;
        }
      }
      function ot(e, t) {
        e.setState(st(e.state, t)).search();
      }
      function ct(e) {
        var t = function (e) {
            return "numeric" === e.type ? Number(e.name) : "escapedValue" in e ? e.escapedValue : e.name;
          }(e),
          n = e.operator ? "".concat(function (e) {
            switch (e) {
              case ">=":
                return "≥";
              case "<=":
                return "≤";
              default:
                return e;
            }
          }(e.operator), " ").concat(e.name) : e.name,
          r = {
            attribute: e.attribute,
            type: e.type,
            value: t,
            label: n
          };
        return void 0 !== e.operator && (r.operator = e.operator), void 0 !== e.count && (r.count = e.count), void 0 !== e.exhaustive && (r.exhaustive = e.exhaustive), r;
      }
      function ut(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Ci()), function (t) {
          function r() {
            N();
          }
          function a() {
            return E ? _ : y;
          }
          var s = t || {},
            c = s.attributes,
            u = s.separator,
            l = void 0 === u ? " > " : u,
            h = s.rootPath,
            d = void 0 === h ? null : h,
            m = s.showParentLevel,
            g = void 0 === m || m,
            v = s.limit,
            y = void 0 === v ? 10 : v,
            b = s.showMore,
            R = void 0 !== b && b,
            S = s.showMoreLimit,
            _ = void 0 === S ? 20 : S,
            w = s.sortBy,
            P = void 0 === w ? Ti : w,
            O = s.transformItems,
            x = void 0 === O ? function (e) {
              return e;
            } : O;
          if (!c || !Array.isArray(c) || 0 === c.length) throw new Error(Ci("The `attributes` option expects an array of strings."));
          if (!0 === R && _ <= y) throw new Error(Ci("The `showMoreLimit` option must be greater than `limit`."));
          var j,
            I,
            F = p(c, 1)[0],
            N = function () {},
            E = !1;
          return {
            $$type: "ais.hierarchicalMenu",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              N = function (e, t) {
                return function () {
                  E = !E, t.render(e);
                };
              }(t, this), e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.removeHierarchicalFacet(F).setQueryParameter("maxValuesPerFacet", void 0);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                hierarchicalMenu: o(o({}, e.hierarchicalMenu), {}, i({}, F, this.getWidgetRenderState(t)))
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                i = e.state,
                s = e.createURL,
                c = e.instantSearchInstance,
                u = e.helper,
                l = [],
                h = !1;
              if (j = j || Se({
                instantSearchInstance: c,
                helper: u,
                attribute: F,
                widgetType: this.$$type
              }), I = I || function (e) {
                j("click", e), u.toggleFacetRefinement(F, e).search();
              }, n) {
                var d = n.getFacetValues(F, {
                    sortBy: P,
                    facetOrdering: P === Ti
                  }),
                  p = d && !Array.isArray(d) && d.data ? d.data : [],
                  m = (i.maxValuesPerFacet || 0) > a() ? p.length <= a() : p.length < a();
                h = R && (E || !m), l = x(function e(t) {
                  return t.slice(0, a()).map(function (t) {
                    var n = t.name,
                      r = t.escapedValue,
                      i = t.data,
                      a = (t.path, o(o({}, f(t, ["name", "escapedValue", "data", "path"])), {}, {
                        value: r,
                        label: n,
                        data: null
                      }));
                    return Array.isArray(i) && (a.data = e(i)), a;
                  });
                }(p), {
                  results: n
                });
              }
              return {
                items: l,
                refine: I,
                canRefine: 0 < l.length,
                createURL: function (e) {
                  return s(i.resetPage().toggleFacetRefinement(F, e));
                },
                sendEvent: j,
                widgetParams: t,
                isShowingMore: E,
                toggleShowMore: r,
                canToggleShowMore: h
              };
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.getHierarchicalFacetBreadcrumb(F);
              return n.length ? o(o({}, e), {}, {
                hierarchicalMenu: o(o({}, e.hierarchicalMenu), {}, i({}, F, n))
              }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = n.hierarchicalMenu && n.hierarchicalMenu[F];
              e.isHierarchicalFacet(F) && e.getHierarchicalFacetByName(F);
              var a = e.removeHierarchicalFacet(F).addHierarchicalFacet({
                  name: F,
                  attributes: c,
                  separator: l,
                  rootPath: d,
                  showParentLevel: g
                }),
                s = a.maxValuesPerFacet || 0,
                u = Math.max(s, R ? _ : y),
                f = a.setQueryParameter("maxValuesPerFacet", u);
              return r ? f.addHierarchicalFacetRefinement(F, r.join(l)) : f.setQueryParameters({
                hierarchicalFacetsRefinements: o(o({}, f.hierarchicalFacetsRefinements), {}, i({}, F, []))
              });
            }
          };
        };
      }
      function lt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, ki()), function (t) {
          var r,
            a,
            s = t || {},
            c = s.escapeHTML,
            u = void 0 === c || c,
            l = s.transformItems,
            f = void 0 === l ? function (e) {
              return e;
            } : l;
          return {
            $$type: "ais.hits",
            init: function (t) {
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !0);
            },
            render: function (t) {
              var n = this.getWidgetRenderState(t);
              e(o(o({}, n), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !1), n.sendEvent("view", n.hits);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                hits: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                i = e.helper,
                s = e.instantSearchInstance;
              if (r = r || Oe({
                instantSearchInstance: s,
                index: i.getIndex(),
                widgetType: this.$$type
              }), a = a || xe({
                index: i.getIndex(),
                widgetType: this.$$type
              }), !n) return {
                hits: [],
                results: void 0,
                sendEvent: r,
                bindEvent: a,
                widgetParams: t
              };
              u && 0 < n.hits.length && (n.hits = ue(n.hits));
              var o = Re(be(n.hits, n.page, n.hitsPerPage), n.queryID);
              return {
                hits: f(o, {
                  results: n
                }),
                results: n,
                sendEvent: r,
                bindEvent: a,
                widgetParams: t
              };
            },
            dispose: function (e) {
              var t = e.state;
              return n(), u ? t.setQueryParameters(Object.keys(Zr).reduce(function (e, t) {
                return o(o({}, e), {}, i({}, t, void 0));
              }, {})) : t;
            },
            getWidgetSearchParameters: function (e) {
              return u ? e.setQueryParameters(Zr) : e;
            }
          };
        };
      }
      function ft(e) {
        var t = e.method,
          n = e.results,
          r = e.hits,
          i = e.objectIDs,
          a = n.index,
          s = function (e, t) {
            return t.map(function (t) {
              var n = z(e, function (e) {
                return e.objectID === t;
              });
              if (void 0 === n) throw new Error('Could not find objectID "'.concat(t, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
              return n;
            });
          }(r, i),
          o = function (e) {
            var t = Q(e.map(function (e) {
              return e.__queryID;
            }));
            if (1 < t.length) throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
            var n = t[0];
            if ("string" != typeof n) throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
            return n;
          }(s);
        switch (t) {
          case "clickedObjectIDsAfterSearch":
            return {
              index: a,
              queryID: o,
              objectIDs: i,
              positions: function (e) {
                return e.map(function (e) {
                  return e.__position;
                });
              }(s)
            };
          case "convertedObjectIDsAfterSearch":
            return {
              index: a,
              queryID: o,
              objectIDs: i
            };
          default:
            throw new Error('Unsupported method passed to insights: "'.concat(t, '".'));
        }
      }
      function ht(e) {
        return function (t, n) {
          return e(function (e, n) {
            var r = e.results,
              i = e.hits,
              a = e.instantSearchInstance;
            if (r && i && a) {
              var s = function (e, t, n) {
                return function (r) {
                  for (var i = arguments.length, a = new Array(1 < i ? i - 1 : 0), s = 1; s < i; s++) a[s - 1] = arguments[s];
                  var c = a[0];
                  if (!e) {
                    var u = ve({
                      name: "instantsearch"
                    });
                    throw new Error(u("The `insightsClient` option has not been provided to `instantsearch`."));
                  }
                  if (!Array.isArray(c.objectIDs)) throw new TypeError("Expected `objectIDs` to be an array.");
                  var l = ft({
                    method: r,
                    results: t,
                    hits: n,
                    objectIDs: c.objectIDs
                  });
                  e(r, o(o({}, l), c));
                };
              }(a.insightsClient, r, i);
              return t(o(o({}, e), {}, {
                insights: s
              }), n);
            }
            return t(e, n);
          }, n);
        };
      }
      function dt(e, t) {
        for (var n in t) e[n] = t[n];
        return e;
      }
      function pt(e) {
        var t = e.parentNode;
        t && t.removeChild(e);
      }
      function mt(e, t, n) {
        var r,
          i,
          a,
          s = {};
        for (a in t) "key" == a ? r = t[a] : "ref" == a ? i = t[a] : s[a] = t[a];
        if (2 < arguments.length && (s.children = 3 < arguments.length ? qr.call(arguments, 2) : n), "function" == typeof e && null != e.defaultProps) for (a in e.defaultProps) void 0 === s[a] && (s[a] = e.defaultProps[a]);
        return gt(e, s, r, i, null);
      }
      function gt(e, t, n, r, i) {
        var a = {
          type: e,
          props: t,
          key: n,
          ref: r,
          __k: null,
          __: null,
          __b: 0,
          __e: null,
          __d: void 0,
          __c: null,
          __h: null,
          constructor: void 0,
          __v: null == i ? ++Wr : i
        };
        return null == i && null != Br.vnode && Br.vnode(a), a;
      }
      function vt(e) {
        return e.children;
      }
      function yt(e, t) {
        this.props = e, this.context = t;
      }
      function bt(e, t) {
        if (null == t) return e.__ ? bt(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var n; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
        return "function" == typeof e.type ? bt(e) : null;
      }
      function Rt(e) {
        var t, n;
        if (null != (e = e.__) && null != e.__c) {
          for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) {
            e.__e = e.__c.base = n.__e;
            break;
          }
          return Rt(e);
        }
      }
      function St(e) {
        (!e.__d && (e.__d = !0) && Qr.push(e) && !_t.__r++ || Vr !== Br.debounceRendering) && ((Vr = Br.debounceRendering) || Ur)(_t);
      }
      function _t() {
        for (var e; _t.__r = Qr.length;) e = Qr.sort(function (e, t) {
          return e.__v.__b - t.__v.__b;
        }), Qr = [], e.some(function (e) {
          var t, n, r, i, a, s;
          e.__d && (a = (i = (t = e).__v).__e, (s = t.__P) && (n = [], (r = dt({}, i)).__v = i.__v + 1, Nt(s, i, r, t.__n, void 0 !== s.ownerSVGElement, null != i.__h ? [a] : null, n, null == a ? bt(i) : a, i.__h), Et(n, i), i.__e != a && Rt(i)));
        });
      }
      function wt(e, t, n, r, i, a, s, o, c, u) {
        var l,
          f,
          h,
          d,
          p,
          m,
          g,
          v = r && r.__k || Di,
          y = v.length;
        for (n.__k = [], l = 0; l < t.length; l++) if (null != (d = n.__k[l] = null == (d = t[l]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? gt(null, d, null, null, d) : Array.isArray(d) ? gt(vt, {
          children: d
        }, null, null, null) : 0 < d.__b ? gt(d.type, d.props, d.key, null, d.__v) : d)) {
          if (d.__ = n, d.__b = n.__b + 1, null === (h = v[l]) || h && d.key == h.key && d.type === h.type) v[l] = void 0;else for (f = 0; f < y; f++) {
            if ((h = v[f]) && d.key == h.key && d.type === h.type) {
              v[f] = void 0;
              break;
            }
            h = null;
          }
          Nt(e, d, h = h || Ai, i, a, s, o, c, u), p = d.__e, (f = d.ref) && h.ref != f && (g = g || [], h.ref && g.push(h.ref, null, d), g.push(f, d.__c || p, d)), null != p ? (null == m && (m = p), "function" == typeof d.type && d.__k === h.__k ? d.__d = c = Pt(d, c, e) : c = Ot(e, d, h, v, p, c), "function" == typeof n.type && (n.__d = c)) : c && h.__e == c && c.parentNode != e && (c = bt(h));
        }
        for (n.__e = m, l = y; l--;) null != v[l] && ("function" == typeof n.type && null != v[l].__e && v[l].__e == n.__d && (n.__d = bt(r, l + 1)), Tt(v[l], v[l]));
        if (g) for (l = 0; l < g.length; l++) Ct(g[l], g[++l], g[++l]);
      }
      function Pt(e, t, n) {
        for (var r, i = e.__k, a = 0; i && a < i.length; a++) (r = i[a]) && (r.__ = e, t = "function" == typeof r.type ? Pt(r, t, n) : Ot(n, r, r, i, r.__e, t));
        return t;
      }
      function Ot(e, t, n, r, i, a) {
        var s, o, c;
        if (void 0 !== t.__d) s = t.__d, t.__d = void 0;else if (null == n || i != a || null == i.parentNode) e: if (null == a || a.parentNode !== e) e.appendChild(i), s = null;else {
          for (o = a, c = 0; (o = o.nextSibling) && c < r.length; c += 2) if (o == i) break e;
          e.insertBefore(i, a), s = a;
        }
        return void 0 !== s ? s : i.nextSibling;
      }
      function xt(e, t, n) {
        "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || Li.test(t) ? n : n + "px";
      }
      function jt(e, t, n, r, i) {
        var a;
        e: if ("style" === t) {
          if ("string" == typeof n) e.style.cssText = n;else {
            if ("string" == typeof r && (e.style.cssText = r = ""), r) for (t in r) n && t in n || xt(e.style, t, "");
            if (n) for (t in n) r && n[t] === r[t] || xt(e.style, t, n[t]);
          }
        } else if ("o" === t[0] && "n" === t[1]) a = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + a] = n, n ? r || e.addEventListener(t, a ? Ft : It, a) : e.removeEventListener(t, a ? Ft : It, a);else if ("dangerouslySetInnerHTML" !== t) {
          if (i) t = t.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");else if ("href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e) try {
            e[t] = null == n ? "" : n;
            break e;
          } catch (e) {}
          "function" == typeof n || (null != n && (!1 !== n || "a" === t[0] && "r" === t[1]) ? e.setAttribute(t, n) : e.removeAttribute(t));
        }
      }
      function It(e) {
        this.l[e.type + !1](Br.event ? Br.event(e) : e);
      }
      function Ft(e) {
        this.l[e.type + !0](Br.event ? Br.event(e) : e);
      }
      function Nt(e, t, n, r, i, a, s, o, c) {
        var u,
          l,
          f,
          h,
          d,
          p,
          m,
          g,
          v,
          y,
          b,
          R = t.type;
        if (void 0 !== t.constructor) return null;
        null != n.__h && (c = n.__h, o = t.__e = n.__e, t.__h = null, a = [o]), (u = Br.__b) && u(t);
        try {
          e: if ("function" == typeof R) {
            if (g = t.props, v = (u = R.contextType) && r[u.__c], y = u ? v ? v.props.value : u.__ : r, n.__c ? m = (l = t.__c = n.__c).__ = l.__E : ("prototype" in R && R.prototype.render ? t.__c = l = new R(g, y) : (t.__c = l = new yt(g, y), l.constructor = R, l.render = kt), v && v.sub(l), l.props = g, l.state || (l.state = {}), l.context = y, l.__n = r, f = l.__d = !0, l.__h = []), null == l.__s && (l.__s = l.state), null != R.getDerivedStateFromProps && (l.__s == l.state && (l.__s = dt({}, l.__s)), dt(l.__s, R.getDerivedStateFromProps(g, l.__s))), h = l.props, d = l.state, f) null == R.getDerivedStateFromProps && null != l.componentWillMount && l.componentWillMount(), null != l.componentDidMount && l.__h.push(l.componentDidMount);else {
              if (null == R.getDerivedStateFromProps && g !== h && null != l.componentWillReceiveProps && l.componentWillReceiveProps(g, y), !l.__e && null != l.shouldComponentUpdate && !1 === l.shouldComponentUpdate(g, l.__s, y) || t.__v === n.__v) {
                l.props = g, l.state = l.__s, t.__v !== n.__v && (l.__d = !1), (l.__v = t).__e = n.__e, t.__k = n.__k, t.__k.forEach(function (e) {
                  e && (e.__ = t);
                }), l.__h.length && s.push(l);
                break e;
              }
              null != l.componentWillUpdate && l.componentWillUpdate(g, l.__s, y), null != l.componentDidUpdate && l.__h.push(function () {
                l.componentDidUpdate(h, d, p);
              });
            }
            l.context = y, l.props = g, l.state = l.__s, (u = Br.__r) && u(t), l.__d = !1, l.__v = t, l.__P = e, u = l.render(l.props, l.state, l.context), l.state = l.__s, null != l.getChildContext && (r = dt(dt({}, r), l.getChildContext())), f || null == l.getSnapshotBeforeUpdate || (p = l.getSnapshotBeforeUpdate(h, d)), b = null != u && u.type === vt && null == u.key ? u.props.children : u, wt(e, Array.isArray(b) ? b : [b], t, n, r, i, a, s, o, c), l.base = t.__e, t.__h = null, l.__h.length && s.push(l), m && (l.__E = l.__ = null), l.__e = !1;
          } else null == a && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = function (e, t, n, r, i, a, s, o) {
            var c,
              u,
              l,
              f = n.props,
              h = t.props,
              d = t.type,
              p = 0;
            if ("svg" === d && (i = !0), null != a) for (; p < a.length; p++) if ((c = a[p]) && "setAttribute" in c == !!d && (d ? c.localName === d : 3 === c.nodeType)) {
              e = c, a[p] = null;
              break;
            }
            if (null == e) {
              if (null === d) return document.createTextNode(h);
              e = i ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, h.is && h), a = null, o = !1;
            }
            if (null === d) f === h || o && e.data === h || (e.data = h);else {
              if (a = a && qr.call(e.childNodes), u = (f = n.props || Ai).dangerouslySetInnerHTML, l = h.dangerouslySetInnerHTML, !o) {
                if (null != a) for (f = {}, p = 0; p < e.attributes.length; p++) f[e.attributes[p].name] = e.attributes[p].value;
                (l || u) && (l && (u && l.__html == u.__html || l.__html === e.innerHTML) || (e.innerHTML = l && l.__html || ""));
              }
              if (function (e, t, n, r, i) {
                var a;
                for (a in n) "children" === a || "key" === a || a in t || jt(e, a, null, n[a], r);
                for (a in t) i && "function" != typeof t[a] || "children" === a || "key" === a || "value" === a || "checked" === a || n[a] === t[a] || jt(e, a, t[a], n[a], r);
              }(e, h, f, i, o), l) t.__k = [];else if (p = t.props.children, wt(e, Array.isArray(p) ? p : [p], t, n, r, i && "foreignObject" !== d, a, s, a ? a[0] : n.__k && bt(n, 0), o), null != a) for (p = a.length; p--;) null != a[p] && pt(a[p]);
              o || ("value" in h && void 0 !== (p = h.value) && (p !== f.value || p !== e.value || "progress" === d && !p) && jt(e, "value", p, f.value, !1), "checked" in h && void 0 !== (p = h.checked) && p !== e.checked && jt(e, "checked", p, f.checked, !1));
            }
            return e;
          }(n.__e, t, n, r, i, a, s, c);
          (u = Br.diffed) && u(t);
        } catch (e) {
          t.__v = null, !c && null == a || (t.__e = o, t.__h = !!c, a[a.indexOf(o)] = null), Br.__e(e, t, n);
        }
      }
      function Et(e, t) {
        Br.__c && Br.__c(t, e), e.some(function (t) {
          try {
            e = t.__h, t.__h = [], e.some(function (e) {
              e.call(t);
            });
          } catch (e) {
            Br.__e(e, t.__v);
          }
        });
      }
      function Ct(e, t, n) {
        try {
          "function" == typeof e ? e(t) : e.current = t;
        } catch (e) {
          Br.__e(e, n);
        }
      }
      function Tt(e, t, n) {
        var r, i;
        if (Br.unmount && Br.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || Ct(r, null, t)), null != (r = e.__c)) {
          if (r.componentWillUnmount) try {
            r.componentWillUnmount();
          } catch (e) {
            Br.__e(e, t);
          }
          r.base = r.__P = null;
        }
        if (r = e.__k) for (i = 0; i < r.length; i++) r[i] && Tt(r[i], t, "function" != typeof e.type);
        n || null == e.__e || pt(e.__e), e.__e = e.__d = void 0;
      }
      function kt(e, t, n) {
        return this.constructor(e, n);
      }
      function At(e, t, n) {
        var r, i, a;
        Br.__ && Br.__(e, t), i = (r = "function" == typeof n) ? null : n && n.__k || t.__k, a = [], Nt(t, e = (!r && n || t).__k = mt(vt, null, [e]), i || Ai, Ai, void 0 !== t.ownerSVGElement, !r && n ? [n] : i ? null : t.firstChild ? qr.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r), Et(a, e);
      }
      function Dt(e, t, n) {
        for (var r = e; r && !n(r);) {
          if (r === t) return null;
          r = r.parentElement;
        }
        return r;
      }
      function Lt(e) {
        return function (t) {
          return mt("div", {
            onClick: function (e) {
              if (t.sendEvent) {
                var n = Dt(e.target, e.currentTarget, function (e) {
                  return e.hasAttribute("data-insights-event");
                });
                n && function (e) {
                  var t = e.getAttribute("data-insights-event");
                  if ("string" != typeof t) throw new Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
                  try {
                    return we(t);
                  } catch (e) {
                    throw new Error("The insights middleware was unable to parse `data-insights-event`.");
                  }
                }(n).forEach(function (e) {
                  return t.sendEvent(e);
                });
              }
              var r = Dt(e.target, e.currentTarget, function (e) {
                return function (e) {
                  return e.hasAttribute("data-insights-method");
                }(e);
              });
              if (r) {
                var i = function (e) {
                    var t = e.getAttribute("data-insights-method"),
                      n = e.getAttribute("data-insights-payload");
                    if ("string" != typeof n) throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
                    try {
                      return {
                        method: t,
                        payload: we(n)
                      };
                    } catch (e) {
                      throw new Error("The insights helper was unable to parse `data-insights-payload`.");
                    }
                  }(r),
                  a = i.method,
                  s = i.payload;
                t.insights(a, s);
              }
            }
          }, mt(e, t));
        };
      }
      function Mt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Hi()), function (t) {
          var r = t || {},
            i = r.items,
            a = r.transformItems,
            s = void 0 === a ? function (e) {
              return e;
            } : a;
          if (!Array.isArray(i)) throw new Error(Hi("The `items` option expects an array of objects."));
          var c = i,
            u = c.filter(function (e) {
              return !0 === e.default;
            });
          if (0 === u.length) throw new Error(Hi("A default value must be specified in `items`."));
          if (1 < u.length) throw new Error(Hi("More than one default value is specified in `items`."));
          var l = u[0],
            f = function (e) {
              return function (t) {
                return t || 0 === t ? e.setQueryParameter("hitsPerPage", t).search() : e.setQueryParameter("hitsPerPage", void 0).search();
              };
            },
            h = function (e) {
              var t = e.state,
                n = e.createURL;
              return function (e) {
                return n(t.resetPage().setQueryParameter("hitsPerPage", e || 0 === e ? e : void 0));
              };
            };
          return {
            $$type: "ais.hitsPerPage",
            init: function (t) {
              var n = t.state,
                r = t.instantSearchInstance;
              c.some(function (e) {
                return Number(n.hitsPerPage) === Number(e.value);
              }) || (c = [{
                value: "",
                label: ""
              }].concat(m(c))), e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: r
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.setQueryParameter("hitsPerPage", void 0);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                hitsPerPage: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.state,
                r = e.results,
                i = e.createURL,
                a = e.helper;
              return {
                items: s(function (e) {
                  var t = e.hitsPerPage;
                  return c.map(function (e) {
                    return o(o({}, e), {}, {
                      isRefined: Number(e.value) === Number(t)
                    });
                  });
                }(n), {
                  results: r
                }),
                refine: f(a),
                createURL: h({
                  state: n,
                  createURL: i
                }),
                hasNoResults: !r || 0 === r.nbHits,
                widgetParams: t
              };
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.hitsPerPage;
              return void 0 === n || n === l.value ? e : o(o({}, e), {}, {
                hitsPerPage: n
              });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return e.setQueryParameters({
                hitsPerPage: n.hitsPerPage || l.value
              });
            }
          };
        };
      }
      function Ht(e) {
        var t = e || {};
        return t.page, f(t, ["page"]);
      }
      function qt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, qi()), function (t) {
          function r(e, t) {
            var n = e.page,
              r = void 0 === n ? 0 : n,
              i = Object.keys(t).map(Number);
            return 0 === i.length ? r : Math.min.apply(Math, [r].concat(m(i)));
          }
          function a(e, t) {
            var n = e.page,
              r = void 0 === n ? 0 : n,
              i = Object.keys(t).map(Number);
            return 0 === i.length ? r : Math.max.apply(Math, [r].concat(m(i)));
          }
          var s,
            c,
            u,
            l,
            f = t || {},
            h = f.escapeHTML,
            d = void 0 === h || h,
            p = f.transformItems,
            g = void 0 === p ? function (e) {
              return e;
            } : p,
            v = f.cache,
            y = void 0 === v ? function () {
              var e = null,
                t = null;
              return {
                read: function (n) {
                  var r = n.state;
                  return se(t, Ht(r)) ? e : null;
                },
                write: function (n) {
                  var r = n.state,
                    i = n.hits;
                  t = Ht(r), e = i;
                }
              };
            }() : v;
          return {
            $$type: "ais.infiniteHits",
            init: function (t) {
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance,
                r = this.getWidgetRenderState(t);
              e(o(o({}, r), {}, {
                instantSearchInstance: n
              }), !1), u("view", r.currentPageHits);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                infiniteHits: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var n,
                i = e.results,
                f = e.helper,
                h = e.state,
                p = e.instantSearchInstance,
                m = [],
                v = y.read({
                  state: h
                }) || {};
              if (i) {
                var b = h.page,
                  R = void 0 === b ? 0 : b;
                d && 0 < i.hits.length && (i.hits = ue(i.hits));
                var S = Re(be(i.hits, i.page, i.hitsPerPage), i.queryID),
                  _ = g(S, {
                    results: i
                  });
                void 0 !== v[R] || i.__isArtificial || (v[R] = _, y.write({
                  state: h,
                  hits: v
                })), m = _, n = 0 === r(h, v);
              } else s = function (e) {
                return function () {
                  e.overrideStateWithoutTriggeringChangeEvent(o(o({}, e.state), {}, {
                    page: r(e.state, y.read({
                      state: e.state
                    }) || {}) - 1
                  })).searchWithoutTriggeringOnStateChange();
                };
              }(f), c = function (e) {
                return function () {
                  e.setPage(a(e.state, y.read({
                    state: e.state
                  }) || {}) + 1).search();
                };
              }(f), u = Oe({
                instantSearchInstance: p,
                index: f.getIndex(),
                widgetType: this.$$type
              }), l = xe({
                index: f.getIndex(),
                widgetType: this.$$type
              }), n = void 0 === h.page || 0 === r(h, v);
              var w = function (e) {
                  return Object.keys(e).map(Number).sort(function (e, t) {
                    return e - t;
                  }).reduce(function (t, n) {
                    return t.concat(e[n]);
                  }, []);
                }(v),
                P = !i || i.nbPages <= a(h, v) + 1;
              return {
                hits: w,
                currentPageHits: m,
                sendEvent: u,
                bindEvent: l,
                results: i,
                showPrevious: s,
                showMore: c,
                isFirstPage: n,
                isLastPage: P,
                widgetParams: t
              };
            },
            dispose: function (e) {
              var t = e.state;
              n();
              var r = t.setQueryParameter("page", void 0);
              return d ? r.setQueryParameters(Object.keys(Zr).reduce(function (e, t) {
                return o(o({}, e), {}, i({}, t, void 0));
              }, {})) : r;
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.page || 0;
              return n ? o(o({}, e), {}, {
                page: n + 1
              }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = e;
              d && (r = e.setQueryParameters(Zr));
              var i = n.page ? n.page - 1 : 0;
              return r.setQueryParameter("page", i);
            }
          };
        };
      }
      function Bt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Wi()), function (t) {
          function r() {
            O();
          }
          function a() {
            return P ? b : m;
          }
          var s,
            c,
            u,
            l = t || {},
            h = l.attribute,
            d = l.limit,
            m = void 0 === d ? 10 : d,
            g = l.showMore,
            v = void 0 !== g && g,
            y = l.showMoreLimit,
            b = void 0 === y ? 20 : y,
            R = l.sortBy,
            S = void 0 === R ? Qi : R,
            _ = l.transformItems,
            w = void 0 === _ ? function (e) {
              return e;
            } : _;
          if (!h) throw new Error(Wi("The `attribute` option is required."));
          if (!0 === v && b <= m) throw new Error(Wi("The `showMoreLimit` option must be greater than `limit`."));
          var P = !1,
            O = function () {};
          return {
            $$type: "ais.menu",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.removeHierarchicalFacet(h).setQueryParameter("maxValuesPerFacet", void 0);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                menu: o(o({}, e.menu), {}, i({}, h, this.getWidgetRenderState(t)))
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                i = e.createURL,
                l = e.instantSearchInstance,
                d = e.helper,
                m = [],
                g = !1;
              if (s = s || Se({
                instantSearchInstance: l,
                helper: d,
                attribute: h,
                widgetType: this.$$type
              }), c = c || function (e) {
                return i(d.state.resetPage().toggleFacetRefinement(h, e));
              }, u = u || function (e) {
                var t = p(d.getHierarchicalFacetBreadcrumb(h), 1)[0];
                s("click", e || t), d.toggleFacetRefinement(h, e || t).search();
              }, e.results && (O = function (e, t) {
                return function () {
                  P = !P, t.render(e);
                };
              }(e, this)), n) {
                var y = n.getFacetValues(h, {
                    sortBy: S,
                    facetOrdering: S === Qi
                  }),
                  b = y && !Array.isArray(y) && y.data ? y.data : [];
                g = v && (P || b.length > a()), m = w(b.slice(0, a()).map(function (e) {
                  var t = e.name,
                    n = e.escapedValue;
                  return e.path, o(o({}, f(e, ["name", "escapedValue", "path"])), {}, {
                    label: t,
                    value: n
                  });
                }), {
                  results: n
                });
              }
              return {
                items: m,
                createURL: c,
                refine: u,
                sendEvent: s,
                canRefine: 0 < m.length,
                widgetParams: t,
                isShowingMore: P,
                toggleShowMore: r,
                canToggleShowMore: g
              };
            },
            getWidgetUiState: function (e, t) {
              var n = p(t.searchParameters.getHierarchicalFacetBreadcrumb(h), 1)[0];
              return n ? o(o({}, e), {}, {
                menu: o(o({}, e.menu), {}, i({}, h, n))
              }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = n.menu && n.menu[h],
                a = e.removeHierarchicalFacet(h).addHierarchicalFacet({
                  name: h,
                  attributes: [h]
                }),
                s = a.maxValuesPerFacet || 0,
                c = Math.max(s, v ? b : m),
                u = a.setQueryParameter("maxValuesPerFacet", c);
              return r ? u.addHierarchicalFacetRefinement(h, r) : u.setQueryParameters({
                hierarchicalFacetsRefinements: o(o({}, u.hierarchicalFacetsRefinements), {}, i({}, h, []))
              });
            }
          };
        };
      }
      function Wt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Ui()), function (t) {
          var r = t || {},
            a = r.attribute,
            s = void 0 === a ? "" : a,
            c = r.items,
            u = void 0 === c ? [] : c,
            l = r.transformItems,
            f = void 0 === l ? function (e) {
              return e;
            } : l;
          if ("" === s) throw new Error(Ui("The `attribute` option is required."));
          if (!u || 0 === u.length) throw new Error(Ui("The `items` option expects an array of objects."));
          var h = {};
          return {
            $$type: Vi,
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.clearRefinements(s);
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.getNumericRefinements(s),
                r = n["="] && n["="][0];
              if (r || 0 === r) return o(o({}, e), {}, {
                numericMenu: o(o({}, e.numericMenu), {}, i({}, s, "".concat(n["="])))
              });
              var a = n[">="] && n[">="][0] || "",
                c = n["<="] && n["<="][0] || "";
              return "" === a && "" === c ? e : o(o({}, e), {}, {
                numericMenu: o(o({}, e.numericMenu), {}, i({}, s, "".concat(a, ":").concat(c)))
              });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = n.numericMenu && n.numericMenu[s],
                a = e.clearRefinements(s);
              if (!r) return a.setQueryParameters({
                numericRefinements: o(o({}, a.numericRefinements), {}, i({}, s, {}))
              });
              if (-1 === r.indexOf(":")) return a.addNumericRefinement(s, "=", Number(r));
              var c = p(r.split(":").map(parseFloat), 2),
                u = c[0],
                l = c[1],
                f = ne(u) ? a.addNumericRefinement(s, ">=", u) : a;
              return ne(l) ? f.addNumericRefinement(s, "<=", l) : f;
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                numericMenu: o(o({}, e.numericMenu), {}, i({}, s, this.getWidgetRenderState(t)))
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                r = e.state,
                i = e.instantSearchInstance,
                a = e.helper,
                o = e.createURL;
              return h.refine || (h.refine = function (e) {
                var t = Ut(a.state, s, e);
                h.sendEvent("click", e), a.setState(t).search();
              }), h.createURL || (h.createURL = function (e) {
                return function (t) {
                  return o(Ut(e, s, t));
                };
              }), h.sendEvent || (h.sendEvent = function (e) {
                var t = e.instantSearchInstance,
                  n = e.helper,
                  r = e.attribute;
                return function () {
                  for (var e = arguments.length, i = new Array(e), a = 0; a < e; a++) i[a] = arguments[a];
                  if (1 !== i.length) {
                    var s = i[0],
                      o = i[1],
                      c = i[2],
                      u = void 0 === c ? "Filter Applied" : c;
                    if ("click" === s) {
                      var l = je(Ut(n.state, r, o), r);
                      l && 0 < l.length && t.sendEventToInsights({
                        insightsMethod: "clickedFilters",
                        widgetType: Vi,
                        eventType: s,
                        payload: {
                          eventName: u,
                          index: n.getIndex(),
                          filters: l
                        },
                        attribute: r
                      });
                    }
                  } else t.sendEventToInsights(i[0]);
                };
              }({
                instantSearchInstance: i,
                helper: a,
                attribute: s
              })), {
                createURL: h.createURL(r),
                items: f(function (e) {
                  return u.map(function (t) {
                    var n = t.start,
                      r = t.end,
                      i = t.label;
                    return {
                      label: i,
                      value: encodeURI(JSON.stringify({
                        start: n,
                        end: r
                      })),
                      isRefined: Qt(e, s, {
                        start: n,
                        end: r,
                        label: i
                      })
                    };
                  });
                }(r), {
                  results: n
                }),
                hasNoResults: !n || 0 === n.nbHits,
                refine: h.refine,
                sendEvent: h.sendEvent,
                widgetParams: t
              };
            }
          };
        };
      }
      function Qt(e, t, n) {
        var r = e.getNumericRefinements(t);
        return void 0 !== n.start && void 0 !== n.end ? n.start === n.end ? Vt(r, "=", n.start) : Vt(r, ">=", n.start) && Vt(r, "<=", n.end) : void 0 !== n.start ? Vt(r, ">=", n.start) : void 0 !== n.end ? Vt(r, "<=", n.end) : void 0 === n.start && void 0 === n.end && Object.keys(r).every(function (e) {
          return 0 === (r[e] || []).length;
        });
      }
      function Ut(e, t, n) {
        var r = e,
          i = JSON.parse(decodeURI(n)),
          a = r.getNumericRefinements(t);
        if (void 0 === i.start && void 0 === i.end) return r.removeNumericRefinement(t);
        if (Qt(r, t, i) || (r = r.removeNumericRefinement(t)), void 0 !== i.start && void 0 !== i.end) {
          if (i.start > i.end) throw new Error("option.start should be > to option.end");
          if (i.start === i.end) return r = Vt(a, "=", i.start) ? r.removeNumericRefinement(t, "=", i.start) : r.addNumericRefinement(t, "=", i.start);
        }
        return void 0 !== i.start && (Vt(a, ">=", i.start) && (r = r.removeNumericRefinement(t, ">=", i.start)), r = r.addNumericRefinement(t, ">=", i.start)), void 0 !== i.end && (Vt(a, "<=", i.end) && (r = r.removeNumericRefinement(t, "<=", i.end)), r = r.addNumericRefinement(t, "<=", i.end)), "number" == typeof r.page && (r.page = 0), r;
      }
      function Vt(e, t, n) {
        return void 0 !== e[t] && e[t].includes(n);
      }
      function $t(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, zi()), function (t) {
          var r = t || {},
            i = r.totalPages,
            a = r.padding,
            s = new $i({
              currentPage: 0,
              total: 0,
              padding: void 0 === a ? 3 : a
            }),
            c = {};
          return {
            $$type: "ais.pagination",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.setQueryParameter("page", void 0);
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.page || 0;
              return n ? o(o({}, e), {}, {
                page: n + 1
              }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = n.page ? n.page - 1 : 0;
              return e.setQueryParameter("page", r);
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                r = e.helper,
                a = e.state,
                o = e.createURL;
              c.refine || (c.refine = function (e) {
                r.setPage(e), r.search();
              }), c.createURL || (c.createURL = function (e) {
                return function (t) {
                  return o(e.setPage(t));
                };
              });
              var u = a.page || 0,
                l = function (e) {
                  var t = e.nbPages;
                  return void 0 !== i ? Math.min(i, t) : t;
                }(n || {
                  nbPages: 0
                });
              return s.currentPage = u, s.total = l, {
                createURL: c.createURL(a),
                refine: c.refine,
                canRefine: 1 < l,
                currentRefinement: u,
                nbHits: (null == n ? void 0 : n.nbHits) || 0,
                nbPages: l,
                pages: n ? s.pages() : [],
                isFirstPage: s.isFirstPage(),
                isLastPage: s.isLastPage(),
                widgetParams: t
              };
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                pagination: this.getWidgetRenderState(t)
              });
            }
          };
        };
      }
      function zt(e) {
        var t = e.min,
          n = e.max,
          r = e.precision,
          i = Math.pow(10, r);
        return {
          min: t ? Math.floor(t * i) / i : t,
          max: n ? Math.ceil(n * i) / i : n
        };
      }
      function Kt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Ki()), function (t) {
          function r(e, t, n, r) {
            var i,
              a,
              s = e.state,
              o = t.min,
              c = t.max,
              u = p(s.getNumericRefinement(l, ">=") || [], 1)[0],
              d = p(s.getNumericRefinement(l, "<=") || [], 1)[0],
              g = void 0 === n || "" === n,
              v = void 0 === r || "" === r,
              y = zt({
                min: g ? void 0 : parseFloat(n),
                max: v ? void 0 : parseFloat(r),
                precision: m
              }),
              b = y.min,
              R = y.max;
            i = ne(f) || o !== b ? ne(f) && g ? f : b : void 0, a = ne(h) || c !== R ? ne(h) && v ? h : R : void 0;
            var S = void 0 === i,
              _ = ne(o) && o <= i,
              w = S || ne(i) && (!ne(o) || _),
              P = void 0 === a,
              O = ne(a) && a <= c,
              x = P || ne(a) && (!ne(c) || O);
            return (u !== i || d !== a) && w && x ? (s = s.removeNumericRefinement(l), ne(i) && (s = s.addNumericRefinement(l, ">=", i)), ne(a) && (s = s.addNumericRefinement(l, "<=", a)), s.resetPage()) : null;
          }
          function a(e, t, n, r) {
            var i = 3 < arguments.length && void 0 !== r ? r : "Filter Applied",
              a = je(e, l);
            a && 0 < a.length && t.sendEventToInsights({
              insightsMethod: "clickedFilters",
              widgetType: Ji,
              eventType: "click",
              payload: {
                eventName: i,
                index: n.getIndex(),
                filters: a
              },
              attribute: l
            });
          }
          function s(e, t, n) {
            return function () {
              var i = p(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [void 0, void 0], 2),
                s = i[0],
                o = i[1],
                c = r(t, n, s, o);
              c && (a(c, e, t), t.setState(c).search());
            };
          }
          var c = t || {},
            u = c.attribute,
            l = void 0 === u ? "" : u,
            f = c.min,
            h = c.max,
            d = c.precision,
            m = void 0 === d ? 0 : d;
          if (!l) throw new Error(Ki("The `attribute` option is required."));
          if (ne(f) && ne(h) && h < f) throw new Error(Ki("The `max` option can't be lower than `min`."));
          var g = {
            from: function (e) {
              return e.toLocaleString();
            },
            to: function (e) {
              return function (e) {
                return Number(Number(e).toFixed(m));
              }(e).toLocaleString();
            }
          };
          return {
            $$type: Ji,
            init: function (t) {
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !0);
            },
            render: function (t) {
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !1);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                range: o(o({}, e.range), {}, i({}, l, this.getWidgetRenderState(t)))
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                i = e.helper,
                c = e.instantSearchInstance,
                u = z(n && n.disjunctiveFacets || [], function (e) {
                  return e.name === l;
                }),
                d = function (e) {
                  return zt({
                    min: ne(f) ? f : ne(e.min) ? e.min : 0,
                    max: ne(h) ? h : ne(e.max) ? e.max : 0,
                    precision: m
                  });
                }(u && u.stats || {
                  min: void 0,
                  max: void 0
                }),
                v = function (e) {
                  var t = p(e.getNumericRefinement(l, ">=") || [], 1)[0],
                    n = p(e.getNumericRefinement(l, "<=") || [], 1)[0];
                  return [ne(t) ? t : -1 / 0, ne(n) ? n : 1 / 0];
                }(i);
              return {
                refine: s(c, i, n ? d : {
                  min: void 0,
                  max: void 0
                }),
                canRefine: d.min !== d.max,
                format: g,
                range: d,
                sendEvent: function (e, t, n) {
                  return function () {
                    for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++) s[o] = arguments[o];
                    if (1 !== s.length) {
                      var c = s[0],
                        u = s[1],
                        l = s[2];
                      if ("click" === c) {
                        var f = p(u, 2),
                          h = f[0],
                          d = f[1],
                          m = r(t, n, h, d);
                        a(m, e, t, l);
                      }
                    } else e.sendEventToInsights(s[0]);
                  };
                }(c, i, d),
                widgetParams: o(o({}, t), {}, {
                  precision: m
                }),
                start: v
              };
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.removeDisjunctiveFacet(l).removeNumericRefinement(l);
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.getNumericRefinements(l),
                r = n[">="],
                a = void 0 === r ? [] : r,
                s = n["<="],
                c = void 0 === s ? [] : s;
              return 0 === a.length && 0 === c.length ? e : o(o({}, e), {}, {
                range: o(o({}, e.range), {}, i({}, l, "".concat(a, ":").concat(c)))
              });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = e.addDisjunctiveFacet(l).setQueryParameters({
                  numericRefinements: o(o({}, e.numericRefinements), {}, i({}, l, {}))
                });
              ne(f) && (r = r.addNumericRefinement(l, ">=", f)), ne(h) && (r = r.addNumericRefinement(l, "<=", h));
              var a = n.range && n.range[l];
              if (!a || -1 === a.indexOf(":")) return r;
              var s = p(a.split(":").map(parseFloat), 2),
                c = s[0],
                u = s[1];
              return ne(c) && (!ne(f) || f < c) && (r = (r = r.removeNumericRefinement(l, ">=")).addNumericRefinement(l, ">=", c)), ne(u) && (!ne(h) || u < h) && (r = (r = r.removeNumericRefinement(l, "<=")).addNumericRefinement(l, "<=", u)), r;
            }
          };
        };
      }
      function Jt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Gi()), function (t) {
          function r(e) {
            var t = e.name,
              n = e.escapedValue;
            return o(o({}, f(e, ["name", "escapedValue"])), {}, {
              value: n,
              label: t,
              highlighted: t
            });
          }
          function a() {
            C();
          }
          function s() {
            return E ? b : m;
          }
          function c(t, n) {
            return function (r) {
              return function (i) {
                var a = r.instantSearchInstance,
                  c = r.results;
                if ("" === i && F) e(o(o({}, n.getWidgetRenderState(o(o({}, r), {}, {
                  results: x
                }))), {}, {
                  instantSearchInstance: a
                }), !1);else {
                  var u = {
                    highlightPreTag: w ? Zr.highlightPreTag : ei.highlightPreTag,
                    highlightPostTag: w ? Zr.highlightPostTag : ei.highlightPostTag
                  };
                  t.searchForFacetValues(l, i, Math.min(s(), 100), u).then(function (t) {
                    var i = w ? function (e) {
                        return e.map(function (e) {
                          return o(o({}, e), {}, {
                            highlighted: oe(e.highlighted)
                          });
                        });
                      }(t.facetHits) : t.facetHits,
                      s = O(i.map(function (e) {
                        var t = e.escapedValue,
                          n = e.value;
                        return o(o({}, f(e, ["escapedValue", "value"])), {}, {
                          value: t,
                          label: n
                        });
                      }), {
                        results: c
                      });
                    e(o(o({}, n.getWidgetRenderState(o(o({}, r), {}, {
                      results: x
                    }))), {}, {
                      items: s,
                      canToggleShowMore: !1,
                      canRefine: !0,
                      isFromSearch: !0,
                      instantSearchInstance: a
                    }), !1);
                  });
                }
              };
            };
          }
          var u = t || {},
            l = u.attribute,
            h = u.operator,
            d = void 0 === h ? "or" : h,
            p = u.limit,
            m = void 0 === p ? 10 : p,
            g = u.showMore,
            v = void 0 !== g && g,
            y = u.showMoreLimit,
            b = void 0 === y ? 20 : y,
            R = u.sortBy,
            S = void 0 === R ? Yi : R,
            _ = u.escapeFacetValues,
            w = void 0 === _ || _,
            P = u.transformItems,
            O = void 0 === P ? function (e) {
              return e;
            } : P;
          if (!l) throw new Error(Gi("The `attribute` option is required."));
          if (!/^(and|or)$/.test(d)) throw new Error(Gi('The `operator` must one of: `"and"`, `"or"` (got "'.concat(d, '").')));
          if (!0 === v && b <= m) throw new Error(Gi("`showMoreLimit` should be greater than `limit`."));
          var x,
            j,
            I,
            F = [],
            N = !0,
            E = !1,
            C = function () {},
            T = function () {
              return function () {};
            };
          return {
            $$type: "ais.refinementList",
            init: function (t) {
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !0);
            },
            render: function (t) {
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !1);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                refinementList: o(o({}, e.refinementList), {}, i({}, l, this.getWidgetRenderState(t)))
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                i = e.state,
                o = e.createURL,
                u = e.instantSearchInstance,
                f = e.helper,
                h = [],
                d = [];
              if (I && j && T || (I = Se({
                instantSearchInstance: u,
                helper: f,
                attribute: l,
                widgetType: this.$$type
              }), j = function (e) {
                I("click", e), f.toggleFacetRefinement(l, e).search();
              }, T = c(f, this)), n) {
                var p = n.getFacetValues(l, {
                  sortBy: S,
                  facetOrdering: S === Yi
                });
                d = p && Array.isArray(p) ? p : [], h = O(d.slice(0, s()).map(r), {
                  results: n
                });
                var g = i.maxValuesPerFacet,
                  y = s();
                N = y < g ? d.length <= y : d.length < y, x = n, F = h, e.results && (C = function (e, t) {
                  return function () {
                    E = !E, t.render(e);
                  };
                }(e, this));
              }
              var b = T && T(e),
                R = E && F.length > m || v && !N;
              return {
                createURL: function (e) {
                  return o(i.resetPage().toggleFacetRefinement(l, e));
                },
                items: h,
                refine: j,
                searchForItems: b,
                isFromSearch: !1,
                canRefine: 0 < h.length,
                widgetParams: t,
                isShowingMore: E,
                canToggleShowMore: R,
                toggleShowMore: a,
                sendEvent: I,
                hasExhaustiveItems: N
              };
            },
            dispose: function (e) {
              var t = e.state;
              n();
              var r = t.setQueryParameter("maxValuesPerFacet", void 0);
              return "and" === d ? r.removeFacet(l) : r.removeDisjunctiveFacet(l);
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters,
                r = "or" === d ? n.getDisjunctiveRefinements(l) : n.getConjunctiveRefinements(l);
              return r.length ? o(o({}, e), {}, {
                refinementList: o(o({}, e.refinementList), {}, i({}, l, r))
              }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = "or" === d,
                a = n.refinementList && n.refinementList[l],
                s = e.clearRefinements(l),
                c = r ? s.addDisjunctiveFacet(l) : s.addFacet(l),
                u = c.maxValuesPerFacet || 0,
                f = Math.max(u, v ? b : m),
                h = c.setQueryParameter("maxValuesPerFacet", f);
              if (a) return a.reduce(function (e, t) {
                return r ? e.addDisjunctiveFacetRefinement(l, t) : e.addFacetRefinement(l, t);
              }, h);
              var p = r ? "disjunctiveFacetsRefinements" : "facetsRefinements";
              return h.setQueryParameters(i({}, p, o(o({}, h[p]), {}, i({}, l, []))));
            }
          };
        };
      }
      function Gt(e, t) {
        return t(e);
      }
      function Yt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, Xi()), function (t) {
          var r,
            i,
            a = (t || {}).queryHook,
            s = void 0 === a ? Gt : a;
          return {
            $$type: "ais.searchBox",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.setQueryParameter("query", void 0);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                searchBox: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.helper,
                a = e.searchMetadata,
                o = e.state;
              return r || (r = function (e) {
                s(e, function (e) {
                  return n.setQuery(e).search();
                });
              }, i = function () {
                n.setQuery("").search();
              }), {
                query: o.query || "",
                refine: r,
                clear: i,
                widgetParams: t,
                isSearchStalled: a.isSearchStalled
              };
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.query || "";
              return "" === n || e && e.query === n ? e : o(o({}, e), {}, {
                query: n
              });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return e.setQueryParameter("query", n.query || "");
            }
          };
        };
      }
      function Xt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        X(e, Zi());
        var r = {};
        return function (t) {
          var i = t || {},
            a = i.items,
            s = i.transformItems,
            c = void 0 === s ? function (e) {
              return e;
            } : s;
          if (!Array.isArray(a)) throw new Error(Zi("The `items` option expects an array of objects."));
          return {
            $$type: "ais.sortBy",
            init: function (t) {
              var n = t.instantSearchInstance,
                r = this.getWidgetRenderState(t),
                i = r.currentRefinement;
              z(a, function (e) {
                return e.value === i;
              }), e(o(o({}, r), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return n(), r.initialIndex ? t.setIndex(r.initialIndex) : t;
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                sortBy: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                i = e.helper,
                s = e.state,
                o = e.parent;
              return !r.initialIndex && o && (r.initialIndex = o.getIndexName()), r.setIndex || (r.setIndex = function (e) {
                i.setIndex(e).search();
              }), {
                currentRefinement: s.index,
                options: c(a, {
                  results: n
                }),
                refine: r.setIndex,
                hasNoResults: !n || 0 === n.nbHits,
                widgetParams: t
              };
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.index;
              return o(o({}, e), {}, {
                sortBy: n !== r.initialIndex ? n : void 0
              });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return e.setQueryParameter("index", n.sortBy || r.initialIndex || e.index);
            }
          };
        };
      }
      function Zt(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, ea()), function (t) {
          function r(e) {
            var t,
              n = e.getNumericRefinements(u);
            if (null !== (t = n[">="]) && void 0 !== t && t.length) return n[">="][0];
          }
          function a(e, t) {
            var n = r(e) === Number(t),
              i = e.resetPage().removeNumericRefinement(u);
            return n ? i : i.addNumericRefinement(u, "<=", f).addNumericRefinement(u, ">=", Number(t));
          }
          var s,
            c = t || {},
            u = c.attribute,
            l = c.max,
            f = void 0 === l ? 5 : l;
          if (!u) throw new Error(ea("The `attribute` option is required."));
          var h = function (e) {
              return function (e, t) {
                s("click", t), e.setState(a(e.state, t)).search();
              }.bind(null, e);
            },
            d = function (e) {
              var t = e.state,
                n = e.createURL;
              return function (e) {
                return n(a(t, e));
              };
            };
          return {
            $$type: ta,
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                ratingMenu: o(o({}, e.ratingMenu), {}, i({}, u, this.getWidgetRenderState(t)))
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.helper,
                i = e.results,
                a = e.state,
                o = e.instantSearchInstance,
                c = e.createURL,
                l = [];
              if (s = s || function (e) {
                var t = e.instantSearchInstance,
                  n = e.helper,
                  r = e.getRefinedStar,
                  i = e.attribute;
                return function () {
                  for (var e = arguments.length, a = new Array(e), s = 0; s < e; s++) a[s] = arguments[s];
                  if (1 !== a.length) {
                    var o = a[0],
                      c = a[1],
                      u = a[2],
                      l = void 0 === u ? "Filter Applied" : u;
                    "click" === o && (r() === Number(c) || t.sendEventToInsights({
                      insightsMethod: "clickedFilters",
                      widgetType: ta,
                      eventType: o,
                      payload: {
                        eventName: l,
                        index: n.getIndex(),
                        filters: ["".concat(i, ">=").concat(c)]
                      },
                      attribute: i
                    }));
                  } else t.sendEventToInsights(a[0]);
                };
              }({
                instantSearchInstance: o,
                helper: n,
                getRefinedStar: function () {
                  return r(n.state);
                },
                attribute: u
              }), i) for (var g = i.getFacetValues(u, {}), v = (g.length, function (e) {
                  var t = 0;
                  e.forEach(function (e) {
                    var n = p(e.name.split("."), 2)[1],
                      r = void 0 === n ? "" : n;
                    t = Math.max(t, r.length);
                  });
                }(g), r(a)), y = function (e) {
                  var t = v === e,
                    n = g.filter(function (t) {
                      return Number(t.name) >= e && Number(t.name) <= f;
                    }).map(function (e) {
                      return e.count;
                    }).reduce(function (e, t) {
                      return e + t;
                    }, 0);
                  if (v && !t && 0 === n) return "continue";
                  var r = m(new Array(Math.floor(f / 1))).map(function (t, n) {
                    return 1 * n < e;
                  });
                  l.push({
                    stars: r,
                    name: String(e),
                    label: String(e),
                    value: String(e),
                    count: n,
                    isRefined: t
                  });
                }, b = 1; b < f; b += 1) y(b);
              return {
                items: l = l.reverse(),
                hasNoResults: !i || 0 === i.nbHits,
                canRefine: 0 < l.length,
                refine: h(n),
                sendEvent: s,
                createURL: d({
                  state: a,
                  createURL: c
                }),
                widgetParams: t
              };
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.removeNumericRefinement(u);
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters,
                a = r(n);
              return "number" != typeof a ? e : o(o({}, e), {}, {
                ratingMenu: o(o({}, e.ratingMenu), {}, i({}, u, a))
              });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = n.ratingMenu && n.ratingMenu[u],
                a = e.clearRefinements(u).addDisjunctiveFacet(u);
              return r ? a.addNumericRefinement(u, "<=", f).addNumericRefinement(u, ">=", r) : a.setQueryParameters({
                numericRefinements: o(o({}, a.numericRefinements), {}, i({}, u, {}))
              });
            }
          };
        };
      }
      function en(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, na()), function (t) {
          return {
            $$type: "ais.stats",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function () {
              n();
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                stats: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                r = e.state;
              return n ? {
                hitsPerPage: n.hitsPerPage,
                nbHits: n.nbHits,
                nbSortedHits: n.nbSortedHits,
                areHitsSorted: void 0 !== n.appliedRelevancyStrictness && 0 < n.appliedRelevancyStrictness && n.nbSortedHits !== n.nbHits,
                nbPages: n.nbPages,
                page: n.page,
                processingTimeMS: n.processingTimeMS,
                query: n.query,
                widgetParams: t
              } : {
                hitsPerPage: r.hitsPerPage,
                nbHits: 0,
                nbSortedHits: void 0,
                areHitsSorted: !1,
                nbPages: 0,
                page: r.page || 0,
                processingTimeMS: -1,
                query: r.query || "",
                widgetParams: t
              };
            }
          };
        };
      }
      function tn(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, ra()), function (t) {
          var r = t || {},
            a = r.attribute,
            s = r.on,
            c = void 0 === s || s,
            u = r.off;
          if (!a) throw new Error(ra("The `attribute` option is required."));
          var l,
            f = void 0 !== u,
            h = ge(c).map(K),
            d = f ? ge(u).map(K) : void 0,
            p = function (e, t) {
              var n = t.state,
                r = t.createURL;
              return function () {
                n = n.resetPage();
                var t = e ? h : d;
                t && t.forEach(function (e) {
                  n = n.removeDisjunctiveFacetRefinement(a, e);
                });
                var i = e ? d : h;
                return i && i.forEach(function (e) {
                  n = n.addDisjunctiveFacetRefinement(a, e);
                }), r(n);
              };
            };
          return {
            $$type: ia,
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.removeDisjunctiveFacet(a);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                toggleRefinement: o(o({}, e.toggleRefinement), {}, i({}, a, this.getWidgetRenderState(t)))
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.state,
                r = e.helper,
                i = e.results,
                s = e.createURL,
                o = e.instantSearchInstance,
                c = i ? h.every(function (e) {
                  return n.isDisjunctiveFacetRefined(a, e);
                }) : h.every(function (e) {
                  return n.isDisjunctiveFacetRefined(a, e);
                }),
                u = {
                  isRefined: c,
                  count: 0
                },
                m = {
                  isRefined: f && !c,
                  count: 0
                };
              if (i) {
                var g = ge(d || !1),
                  v = i.getFacetValues(a, {}) || [],
                  y = h.map(function (e) {
                    return z(v, function (t) {
                      return t.escapedValue === K(String(e));
                    });
                  }).filter(function (e) {
                    return void 0 !== e;
                  }),
                  b = f ? g.map(function (e) {
                    return z(v, function (t) {
                      return t.escapedValue === K(String(e));
                    });
                  }).filter(function (e) {
                    return void 0 !== e;
                  }) : [];
                u = {
                  isRefined: !!y.length && y.every(function (e) {
                    return e.isRefined;
                  }),
                  count: y.reduce(function (e, t) {
                    return e + t.count;
                  }, 0) || null
                }, m = {
                  isRefined: !!b.length && b.every(function (e) {
                    return e.isRefined;
                  }),
                  count: b.reduce(function (e, t) {
                    return e + t.count;
                  }, 0) || v.reduce(function (e, t) {
                    return e + t.count;
                  }, 0)
                };
              }
              l = l || function (e) {
                var t = e.instantSearchInstance,
                  n = e.helper,
                  r = e.attribute,
                  i = e.on;
                return function () {
                  for (var e = arguments.length, a = new Array(e), s = 0; s < e; s++) a[s] = arguments[s];
                  if (1 !== a.length) {
                    var o = a[0],
                      c = a[1],
                      u = a[2],
                      l = void 0 === u ? "Filter Applied" : u;
                    "click" === o && void 0 !== i && (c || t.sendEventToInsights({
                      insightsMethod: "clickedFilters",
                      widgetType: ia,
                      eventType: o,
                      payload: {
                        eventName: l,
                        index: n.getIndex(),
                        filters: i.map(function (e) {
                          return "".concat(r, ":").concat(e);
                        })
                      },
                      attribute: r
                    }));
                  } else t.sendEventToInsights(a[0]);
                };
              }({
                instantSearchInstance: o,
                attribute: a,
                on: h,
                helper: r
              });
              var R = c ? m : u;
              return {
                value: {
                  name: a,
                  isRefined: c,
                  count: i ? R.count : null,
                  onFacetValue: u,
                  offFacetValue: m
                },
                createURL: p(c, {
                  state: n,
                  createURL: s
                }),
                sendEvent: l,
                canRefine: Boolean(i ? R.count : null),
                refine: function (e) {
                  return function () {
                    var t = (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {
                      isRefined: !1
                    }).isRefined;
                    t ? (h.forEach(function (t) {
                      return e.removeDisjunctiveFacetRefinement(a, t);
                    }), f && d.forEach(function (t) {
                      return e.addDisjunctiveFacetRefinement(a, t);
                    })) : (l("click", t), f && d.forEach(function (t) {
                      return e.removeDisjunctiveFacetRefinement(a, t);
                    }), h.forEach(function (t) {
                      return e.addDisjunctiveFacetRefinement(a, t);
                    })), e.search();
                  };
                }(r),
                widgetParams: t
              };
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters,
                r = h && h.every(function (e) {
                  return n.isDisjunctiveFacetRefined(a, e);
                });
              return r ? o(o({}, e), {}, {
                toggle: o(o({}, e.toggle), {}, i({}, a, r))
              }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = e.clearRefinements(a).addDisjunctiveFacet(a);
              return Boolean(n.toggle && n.toggle[a]) ? (h && h.forEach(function (e) {
                r = r.addDisjunctiveFacetRefinement(a, e);
              }), r) : f ? (d && d.forEach(function (e) {
                r = r.addDisjunctiveFacetRefinement(a, e);
              }), r) : r.setQueryParameters({
                disjunctiveFacetsRefinements: o(o({}, e.disjunctiveFacetsRefinements), {}, i({}, a, []))
              });
            }
          };
        };
      }
      function nn(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        X(e, aa());
        var r = {};
        return function (t) {
          function a(e, t) {
            if (t) return e.resetPage().toggleFacetRefinement(g, t);
            var n = e.getHierarchicalFacetBreadcrumb(g);
            return 0 === n.length ? e : e.resetPage().toggleFacetRefinement(g, n[0]);
          }
          var s = t || {},
            c = s.attributes,
            u = s.separator,
            l = void 0 === u ? " > " : u,
            f = s.rootPath,
            h = void 0 === f ? null : f,
            d = s.transformItems,
            m = void 0 === d ? function (e) {
              return e;
            } : d;
          if (!c || !Array.isArray(c) || 0 === c.length) throw new Error(aa("The `attributes` option expects an array of strings."));
          var g = p(c, 1)[0];
          return {
            $$type: "ais.breadcrumb",
            init: function (t) {
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !0);
            },
            render: function (t) {
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !1);
            },
            dispose: function () {
              n();
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                breadcrumb: o(o({}, e.breadcrumb), {}, i({}, g, this.getWidgetRenderState(t)))
              });
            },
            getWidgetRenderState: function (e) {
              var n = e.helper,
                i = e.createURL,
                s = e.results,
                o = e.state,
                c = function () {
                  if (!s || 0 === o.hierarchicalFacets.length) return [];
                  var e = p(o.hierarchicalFacets, 1)[0].name,
                    t = s.getFacetValues(e, {}),
                    n = Array.isArray(t.data) ? t.data : [];
                  return m(function (e) {
                    return e.map(function (t, n) {
                      return {
                        label: t.label,
                        value: n + 1 === e.length ? null : e[n + 1].value
                      };
                    });
                  }(function e(t) {
                    return t.reduce(function (t, n) {
                      return n.isRefined && (t.push({
                        label: n.name,
                        value: n.escapedValue
                      }), Array.isArray(n.data) && (t = t.concat(e(n.data)))), t;
                    }, []);
                  }(n)), {
                    results: s
                  });
                }();
              return r.createURL || (r.createURL = function (e) {
                return i(a(n.state, e));
              }), r.refine || (r.refine = function (e) {
                n.setState(a(n.state, e)).search();
              }), {
                canRefine: 0 < c.length,
                createURL: r.createURL,
                items: c,
                refine: r.refine,
                widgetParams: t
              };
            },
            getWidgetSearchParameters: function (e) {
              return e.isHierarchicalFacet(g) ? (e.getHierarchicalFacetByName(g), e) : e.addHierarchicalFacet({
                name: g,
                attributes: c,
                separator: l,
                rootPath: h
              });
            }
          };
        };
      }
      function rn(e) {
        return e.insideBoundingBox || "";
      }
      function an(e, t) {
        return e.setQueryParameter("insideBoundingBox", t);
      }
      function sn(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, sa()), function (t) {
          function r(e) {
            return e.aroundLatLng ? function (e) {
              var t = e.match(ni);
              if (!t) throw new Error('Invalid value for "aroundLatLng" parameter: "'.concat(e, '"'));
              return {
                lat: parseFloat(t[1]),
                lng: parseFloat(t[2])
              };
            }(e.aroundLatLng) : void 0;
          }
          function i() {
            return v.internalToggleRefineOnMapMove();
          }
          function a(e, t) {
            return function () {
              v.isRefineOnMapMove = !v.isRefineOnMapMove, t(e);
            };
          }
          function s() {
            return v.isRefineOnMapMove;
          }
          function c() {
            return v.internalSetMapMoveSinceLastRefine();
          }
          function u(e, t) {
            return function () {
              var n = !0 !== v.hasMapMoveSinceLastRefine;
              v.hasMapMoveSinceLastRefine = !0, n && t(e);
            };
          }
          function l() {
            return v.hasMapMoveSinceLastRefine;
          }
          var f,
            h = t || {},
            d = h.enableRefineOnMapMove,
            p = void 0 === d || d,
            m = h.transformItems,
            g = void 0 === m ? function (e) {
              return e;
            } : m,
            v = {
              isRefineOnMapMove: p,
              hasMapMoveSinceLastRefine: !1,
              lastRefinePosition: "",
              lastRefineBoundingBox: "",
              internalToggleRefineOnMapMove: Z,
              internalSetMapMoveSinceLastRefine: Z
            };
          return {
            $$type: oa,
            init: function (t) {
              var n = t.instantSearchInstance;
              v.internalToggleRefineOnMapMove = a(t, Z), v.internalSetMapMoveSinceLastRefine = u(t, Z), e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.helper,
                r = t.instantSearchInstance,
                i = n.state,
                s = Boolean(i.aroundLatLng) && Boolean(v.lastRefinePosition) && i.aroundLatLng !== v.lastRefinePosition,
                c = !i.insideBoundingBox && Boolean(v.lastRefineBoundingBox) && i.insideBoundingBox !== v.lastRefineBoundingBox;
              (s || c) && (v.hasMapMoveSinceLastRefine = !1), v.lastRefinePosition = i.aroundLatLng || "", v.lastRefineBoundingBox = rn(i), v.internalToggleRefineOnMapMove = a(t, this.render.bind(this)), v.internalSetMapMoveSinceLastRefine = u(t, this.render.bind(this));
              var l = this.getWidgetRenderState(t);
              f("view", l.items), e(o(o({}, l), {}, {
                instantSearchInstance: r
              }), !1);
            },
            getWidgetRenderState: function (e) {
              var n = e.helper,
                a = e.results,
                o = e.instantSearchInstance,
                u = n.state,
                h = a ? g(a.hits.filter(function (e) {
                  return e._geoloc;
                }), {
                  results: a
                }) : [];
              return f = f || Oe({
                instantSearchInstance: o,
                index: n.getIndex(),
                widgetType: oa
              }), {
                items: h,
                position: r(u),
                currentRefinement: function (e) {
                  return e.insideBoundingBox && ye(e.insideBoundingBox);
                }(u),
                refine: function (e) {
                  return function (t) {
                    var n = t.northEast,
                      r = t.southWest,
                      i = [n.lat, n.lng, r.lat, r.lng].join();
                    e.setState(an(e.state, i).resetPage()).search(), v.hasMapMoveSinceLastRefine = !1, v.lastRefineBoundingBox = i;
                  };
                }(n),
                sendEvent: f,
                clearMapRefinement: function (e) {
                  return function () {
                    e.setQueryParameter("insideBoundingBox", void 0).search();
                  };
                }(n),
                isRefinedWithMap: function (e) {
                  return function () {
                    return Boolean(e.insideBoundingBox);
                  };
                }(u),
                toggleRefineOnMapMove: i,
                isRefineOnMapMove: s,
                setMapMoveSinceLastRefine: c,
                hasMapMoveSinceLastRefine: l,
                widgetParams: t
              };
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                geoSearch: this.getWidgetRenderState(t)
              });
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t.setQueryParameter("insideBoundingBox", void 0);
            },
            getWidgetUiState: function (e, t) {
              var n = rn(t.searchParameters);
              return !n || e && e.geoSearch && e.geoSearch.boundingBox === n ? e : o(o({}, e), {}, {
                geoSearch: {
                  boundingBox: n
                }
              });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return n && n.geoSearch ? an(e, n.geoSearch.boundingBox) : e.setQueryParameter("insideBoundingBox", void 0);
            }
          };
        };
      }
      function on(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        X(e, ca());
        var r = "https://www.algolia.com/?utm_source=instantsearch.js&utm_medium=website&" + "utm_content=".concat(Ne(function (e) {
          var t;
          return (null === (t = e.window.location) || void 0 === t ? void 0 : t.hostname) || "";
        }, {
          fallback: function () {
            return "";
          }
        }), "&") + "utm_campaign=poweredby";
        return function (t) {
          var i = (t || {}).url,
            a = void 0 === i ? r : i;
          return {
            $$type: "ais.poweredBy",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                poweredBy: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function () {
              return {
                url: a,
                widgetParams: t
              };
            },
            dispose: function () {
              n();
            }
          };
        };
      }
      function cn(e, t) {
        return e.setQueryParameters(Object.keys(t.searchParameters).reduce(function (e, t) {
          return o(o({}, e), {}, i({}, t, void 0));
        }, {}));
      }
      function un(e, t) {
        var n = 0 < arguments.length && void 0 !== e ? e : Z,
          r = 1 < arguments.length && void 0 !== t ? t : Z;
        return function (e) {
          if (!e || !re(e.searchParameters)) throw new Error(ua("The `searchParameters` option expects an object."));
          var t = {};
          return {
            $$type: "ais.configure",
            init: function (e) {
              var t = e.instantSearchInstance;
              n(o(o({}, this.getWidgetRenderState(e)), {}, {
                instantSearchInstance: t
              }), !0);
            },
            render: function (e) {
              var t = e.instantSearchInstance;
              n(o(o({}, this.getWidgetRenderState(e)), {}, {
                instantSearchInstance: t
              }), !1);
            },
            dispose: function (t) {
              var n = t.state;
              return r(), cn(n, e);
            },
            getRenderState: function (e, t) {
              var n,
                r = this.getWidgetRenderState(t);
              return o(o({}, e), {}, {
                configure: o(o({}, r), {}, {
                  widgetParams: o(o({}, r.widgetParams), {}, {
                    searchParameters: me(new Dr.SearchParameters(null === (n = e.configure) || void 0 === n ? void 0 : n.widgetParams.searchParameters), new Dr.SearchParameters(r.widgetParams.searchParameters)).getQueryParams()
                  })
                })
              });
            },
            getWidgetRenderState: function (n) {
              var r = n.helper;
              return t.refine || (t.refine = function (t) {
                return function (n) {
                  var r = cn(t.state, e),
                    i = me(r, new Dr.SearchParameters(n));
                  e.searchParameters = n, t.setState(i).search();
                };
              }(r)), {
                refine: t.refine,
                widgetParams: e
              };
            },
            getWidgetSearchParameters: function (t, n) {
              var r = n.uiState;
              return me(t, new Dr.SearchParameters(o(o({}, r.configure), e.searchParameters)));
            },
            getWidgetUiState: function (t) {
              return o(o({}, t), {}, {
                configure: o(o({}, t.configure), e.searchParameters)
              });
            }
          };
        };
      }
      function ln(e) {
        var t = e.attributeName,
          n = e.attributeValue,
          r = e.attributeScore;
        return "".concat(t, ":").concat(n, "<score=").concat(r || 1, ">");
      }
      function fn(e, t) {
        return function (n) {
          var r = n || {},
            i = r.hit,
            a = r.matchingPatterns,
            s = r.transformSearchParameters,
            c = void 0 === s ? function (e) {
              return e;
            } : s;
          if (!i) throw new Error(la("The `hit` option is required."));
          if (!a) throw new Error(la("The `matchingPatterns` option is required."));
          var u = Object.keys(a).reduce(function (e, t) {
              var n = a[t],
                r = te(i, t),
                s = n.score;
              return Array.isArray(r) ? [].concat(m(e), [r.map(function (e) {
                return ln({
                  attributeName: t,
                  attributeValue: e,
                  attributeScore: s
                });
              })]) : "string" == typeof r ? [].concat(m(e), [ln({
                attributeName: t,
                attributeValue: r,
                attributeScore: s
              })]) : e;
            }, []),
            l = o({}, c(new Dr.SearchParameters({
              sumOrFiltersScores: !0,
              facetFilters: ["objectID:-".concat(i.objectID)],
              optionalFilters: u
            })));
          return o(o({}, un(e, t)({
            searchParameters: l
          })), {}, {
            $$type: "ais.configureRelatedItems"
          });
        };
      }
      function hn(e) {
        var t = this.helper,
          n = this.initialRuleContexts,
          r = this.trackedFilters,
          i = this.transformRuleContexts,
          a = e.state,
          s = a.ruleContexts || [],
          c = function (e) {
            var t = e.helper,
              n = e.sharedHelperState,
              r = e.trackedFilters;
            return Object.keys(r).reduce(function (e, i) {
              var a = G(t.lastResults || {}, n, !0).filter(function (e) {
                  return e.attribute === i;
                }).map(function (e) {
                  return e.numericValue || e.name;
                }),
                s = (0, r[i])(a);
              return [].concat(m(e), m(a.filter(function (e) {
                return s.includes(e);
              }).map(function (e) {
                return function (e) {
                  return e.replace(/[^a-z0-9-_]+/gi, "_");
                }("ais-".concat(i, "-").concat(e));
              })));
            }, []);
          }({
            helper: t,
            sharedHelperState: a,
            trackedFilters: r
          }),
          u = i([].concat(m(n), m(c))).slice(0, 10);
        se(s, u) || t.overrideStateWithoutTriggeringChangeEvent(o(o({}, a), {}, {
          ruleContexts: u
        }));
      }
      function dn(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, ha()), function (t) {
          var r = t || {},
            i = r.trackedFilters,
            a = void 0 === i ? {} : i,
            s = r.transformRuleContexts,
            c = void 0 === s ? function (e) {
              return e;
            } : s,
            u = r.transformItems,
            l = void 0 === u ? function (e) {
              return e;
            } : u;
          Object.keys(a).forEach(function (e) {
            if ("function" != typeof a[e]) throw new Error(ha("'The \"".concat(e, '" filter value in the `trackedFilters` option expects a function.')));
          });
          var f,
            h = 0 < Object.keys(a).length,
            d = [];
          return {
            $$type: "ais.queryRules",
            init: function (n) {
              var r = n.helper,
                i = n.state,
                s = n.instantSearchInstance;
              d = i.ruleContexts || [], f = hn.bind({
                helper: r,
                initialRuleContexts: d,
                trackedFilters: a,
                transformRuleContexts: c
              }), h && ((function (e) {
                return [e.disjunctiveFacetsRefinements, e.facetsRefinements, e.hierarchicalFacetsRefinements, e.numericRefinements].some(function (e) {
                  return Boolean(e && 0 < Object.keys(e).length);
                });
              }(i) || Boolean(t.transformRuleContexts)) && f({
                state: i
              }), r.on("change", f)), e(o(o({}, this.getWidgetRenderState(n)), {}, {
                instantSearchInstance: s
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            getWidgetRenderState: function (e) {
              var n = e.results,
                r = (n || {}).userData;
              return {
                items: l(void 0 === r ? [] : r, {
                  results: n
                }),
                widgetParams: t
              };
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                queryRules: this.getWidgetRenderState(t)
              });
            },
            dispose: function (e) {
              var t = e.helper,
                r = e.state;
              return n(), h ? (t.removeListener("change", f), r.setQueryParameter("ruleContexts", d)) : r;
            }
          };
        };
      }
      function pn(e) {
        function t(e) {
          return {
            status: e,
            transcript: "",
            isSpeechFinal: !1,
            errorCode: void 0
          };
        }
        function n(e) {
          var t = 0 < arguments.length && void 0 !== e ? e : {};
          g = o(o({}, g), t), p();
        }
        function r(e) {
          n(t(0 < arguments.length && void 0 !== e ? e : "initial"));
        }
        function i() {
          n({
            status: "waiting"
          });
        }
        function a(e) {
          n({
            status: "error",
            errorCode: e.error
          });
        }
        function s(e) {
          n({
            status: "recognizing",
            transcript: e.results[0] && e.results[0][0] && e.results[0][0].transcript || "",
            isSpeechFinal: e.results[0] && e.results[0].isFinal
          }), f && g.transcript && d(g.transcript);
        }
        function c() {
          g.errorCode || !g.transcript || f || d(g.transcript), "error" !== g.status && n({
            status: "finished"
          });
        }
        function u() {
          l && (l.stop(), l.removeEventListener("start", i), l.removeEventListener("error", a), l.removeEventListener("result", s), l.removeEventListener("end", c), l = void 0);
        }
        var l,
          f = e.searchAsYouSpeak,
          h = e.language,
          d = e.onQueryChange,
          p = e.onStateChange,
          m = window.webkitSpeechRecognition || window.SpeechRecognition,
          g = t("initial");
        return {
          getState: function () {
            return g;
          },
          isBrowserSupported: function () {
            return Boolean(m);
          },
          isListening: function () {
            return "askingPermission" === g.status || "waiting" === g.status || "recognizing" === g.status;
          },
          startListening: function () {
            (l = new m()) && (r("askingPermission"), l.interimResults = !0, h && (l.lang = h), l.addEventListener("start", i), l.addEventListener("error", a), l.addEventListener("result", s), l.addEventListener("end", c), l.start());
          },
          stopListening: function () {
            u(), r("finished");
          },
          dispose: u
        };
      }
      function mn(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, da()), function (t) {
          var r = t.searchAsYouSpeak,
            i = void 0 !== r && r,
            a = t.language,
            s = t.additionalQueryParameters,
            c = t.createVoiceSearchHelper,
            u = void 0 === c ? pn : c;
          return {
            $$type: "ais.voiceSearch",
            init: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !0);
            },
            render: function (t) {
              var n = t.instantSearchInstance;
              e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: n
              }), !1);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                voiceSearch: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (n) {
              var r = this,
                c = n.helper,
                l = n.instantSearchInstance;
              this._refine || (this._refine = function (e) {
                if (e !== c.state.query) {
                  var t = a ? [a.split("-")[0]] : void 0;
                  c.setQueryParameter("queryLanguages", t), "function" == typeof s && c.setState(c.state.setQueryParameters(o({
                    ignorePlurals: !0,
                    removeStopWords: !0,
                    optionalWords: e
                  }, s({
                    query: e
                  })))), c.setQuery(e).search();
                }
              }), this._voiceSearchHelper || (this._voiceSearchHelper = u({
                searchAsYouSpeak: i,
                language: a,
                onQueryChange: function (e) {
                  return r._refine(e);
                },
                onStateChange: function () {
                  e(o(o({}, r.getWidgetRenderState(n)), {}, {
                    instantSearchInstance: l
                  }), !1);
                }
              }));
              var f = this._voiceSearchHelper,
                h = f.isBrowserSupported,
                d = f.isListening,
                p = f.startListening,
                m = f.stopListening,
                g = f.getState;
              return {
                isBrowserSupported: h(),
                isListening: d(),
                toggleListening: function () {
                  h() && (d() ? m() : p());
                },
                voiceListeningState: g(),
                widgetParams: t
              };
            },
            dispose: function (e) {
              var t = e.state;
              this._voiceSearchHelper.dispose(), n();
              var r = t;
              if ("function" == typeof s) {
                var i = s({
                    query: ""
                  }),
                  a = i ? Object.keys(i).reduce(function (e, t) {
                    return e[t] = void 0, e;
                  }, {}) : {};
                r = t.setQueryParameters(o({
                  queryLanguages: void 0,
                  ignorePlurals: void 0,
                  removeStopWords: void 0,
                  optionalWords: void 0
                }, a));
              }
              return r.setQueryParameter("query", void 0);
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters.query || "";
              return n ? o(o({}, e), {}, {
                query: n
              }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return e.setQueryParameter("query", n.query || "");
            }
          };
        };
      }
      function gn(e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : Z;
        return X(e, pa()), function (t) {
          var r = t || {},
            i = r.queryLanguages,
            a = r.attributesForPrediction,
            s = r.nbHits,
            c = void 0 === s ? 1 : s,
            u = r.renderDebounceTime,
            l = void 0 === u ? 100 : u,
            f = r.searchDebounceTime,
            h = void 0 === f ? 100 : f,
            d = r.escapeHTML,
            p = void 0 === d || d,
            m = r.extraParameters,
            g = void 0 === m ? {} : m;
          if (!i || 0 === i.length) throw new Error(pa("The `queryLanguages` expects an array of strings."));
          var v,
            y = function () {
              var e = -1,
                t = -1,
                n = void 0;
              return function (r) {
                var i = ++e;
                return Promise.resolve(r).then(function (e) {
                  return n && i < t ? n : (t = i, n = e);
                });
              };
            }(),
            b = [],
            R = !1,
            S = Ie(e, l);
          return {
            $$type: "ais.answers",
            init: function (t) {
              var n = t.state,
                r = t.instantSearchInstance.client.initIndex(n.index);
              if (!function (e) {
                return "function" == typeof e.findAnswers;
              }(r)) throw new Error(pa("`algoliasearch` >= 4.8.0 required."));
              v = Ie(r.findAnswers, h), e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !0);
            },
            render: function (t) {
              var n = this,
                r = t.state.query;
              return r ? (b = [], R = !0, e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !1), y(v(r, i, o(o({}, g), {}, {
                nbHits: c,
                attributesForPrediction: a
              }))).then(function (e) {
                if (e) {
                  p && 0 < e.hits.length && (e.hits = ue(e.hits));
                  var r = Re(be(e.hits, 0, c), e.queryID);
                  b = r, R = !1, S(o(o({}, n.getWidgetRenderState(t)), {}, {
                    instantSearchInstance: t.instantSearchInstance
                  }), !1);
                }
              }), void 0) : (R = !(b = []), void e(o(o({}, this.getWidgetRenderState(t)), {}, {
                instantSearchInstance: t.instantSearchInstance
              }), !1));
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                answers: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function () {
              return {
                hits: b,
                isLoading: R,
                widgetParams: t
              };
            },
            dispose: function (e) {
              var t = e.state;
              return n(), t;
            },
            getWidgetSearchParameters: function (e) {
              return e;
            }
          };
        };
      }
      function vn(e, t) {
        var n = 0 < arguments.length && void 0 !== e ? e : Z,
          r = 1 < arguments.length && void 0 !== t ? t : Z;
        return function (e) {
          var t = {};
          return {
            $$type: "ais.relevantSort",
            init: function (e) {
              var t = e.instantSearchInstance;
              n(o(o({}, this.getWidgetRenderState(e)), {}, {
                instantSearchInstance: t
              }), !0);
            },
            render: function (e) {
              var t = e.instantSearchInstance;
              n(o(o({}, this.getWidgetRenderState(e)), {}, {
                instantSearchInstance: t
              }), !1);
            },
            dispose: function (e) {
              var t = e.state;
              return r(), t.setQueryParameter("relevancyStrictness", void 0);
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                relevantSort: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (n) {
              var r = n.results,
                i = n.helper;
              t.refine || (t.refine = function (e) {
                i.setQueryParameter("relevancyStrictness", e).search();
              });
              var a = (r || {}).appliedRelevancyStrictness,
                s = void 0 !== a;
              return {
                isRelevantSorted: void 0 !== a && 0 < a,
                isVirtualReplica: s,
                canRefine: s,
                refine: t.refine,
                widgetParams: e
              };
            },
            getWidgetSearchParameters: function (e, t) {
              var n,
                r = t.uiState;
              return e.setQueryParameter("relevancyStrictness", null !== (n = r.relevantSort) && void 0 !== n ? n : e.relevancyStrictness);
            },
            getWidgetUiState: function (e, t) {
              var n = t.searchParameters;
              return o(o({}, e), {}, {
                relevantSort: n.relevancyStrictness || e.relevantSort
              });
            }
          };
        };
      }
      function yn(t, n) {
        var r = 1 < arguments.length && void 0 !== n ? n : Z;
        return X(t, ma()), function (n) {
          var i = n.widgets,
            a = n.maxValuesPerFacet,
            s = void 0 === a ? 20 : a,
            c = n.facets,
            u = void 0 === c ? ["*"] : c,
            l = n.transformItems,
            f = void 0 === l ? function (e) {
              return e;
            } : l,
            h = n.fallbackWidget;
          if (!(i && Array.isArray(i) && i.every(function (t) {
            return "object" === e(t);
          }))) throw new Error(ma("The `widgets` option expects an array of widgets."));
          if (!(Array.isArray(u) && u.length <= 1) || "*" !== u[0] && void 0 !== u[0]) throw new Error(ma('The `facets` option only accepts [] or ["*"], you passed '.concat(JSON.stringify(u))));
          var d = new Map();
          return {
            $$type: "ais.dynamicWidgets",
            init: function (e) {
              i.forEach(function (t) {
                var n = Fe(t, e);
                d.set(n, {
                  widget: t,
                  isMounted: !1
                });
              }), t(o(o({}, this.getWidgetRenderState(e)), {}, {
                instantSearchInstance: e.instantSearchInstance
              }), !0);
            },
            render: function (e) {
              var n = e.parent,
                r = this.getWidgetRenderState(e),
                i = [],
                a = [];
              h && r.attributesToRender.forEach(function (e) {
                if (!d.has(e)) {
                  var t = h({
                    attribute: e
                  });
                  d.set(e, {
                    widget: t,
                    isMounted: !1
                  });
                }
              }), d.forEach(function (e, t) {
                var n = e.widget,
                  s = e.isMounted,
                  o = -1 < r.attributesToRender.indexOf(t);
                !s && o ? (a.push(n), d.set(t, {
                  widget: n,
                  isMounted: !0
                })) : s && !o && (i.push(n), d.set(t, {
                  widget: n,
                  isMounted: !1
                }));
              }), n.addWidgets(a), setTimeout(function () {
                return n.removeWidgets(i);
              }, 0), t(o(o({}, r), {}, {
                instantSearchInstance: e.instantSearchInstance
              }), !1);
            },
            dispose: function (e) {
              var t = e.parent,
                n = [];
              d.forEach(function (e) {
                var t = e.widget;
                e.isMounted && n.push(t);
              }), t.removeWidgets(n), r();
            },
            getWidgetSearchParameters: function (e) {
              return u.reduce(function (e, t) {
                return e.addFacet(t);
              }, e.setQueryParameters({
                maxValuesPerFacet: Math.max(s || 0, e.maxValuesPerFacet || 0)
              }));
            },
            getRenderState: function (e, t) {
              return o(o({}, e), {}, {
                dynamicWidgets: this.getWidgetRenderState(t)
              });
            },
            getWidgetRenderState: function (e) {
              var t,
                r,
                i,
                a,
                s = e.results;
              if (e.state, !s) return {
                attributesToRender: [],
                widgetParams: n
              };
              var o = f(null !== (t = null === (r = s.renderingContent) || void 0 === r ? void 0 : null === (i = r.facetOrdering) || void 0 === i ? void 0 : null === (a = i.facets) || void 0 === a ? void 0 : a.order) && void 0 !== t ? t : [], {
                results: s
              });
              if (!Array.isArray(o)) throw new Error(ma("The `transformItems` option expects a function that returns an Array."));
              return {
                attributesToRender: o,
                widgetParams: n
              };
            }
          };
        };
      }
      function bn(e) {
        var t = e.items,
          n = e.cssClasses,
          r = e.templateProps,
          s = e.createURL,
          o = e.refine;
        return mt("div", {
          className: ba(n.root, i({}, n.noRefinementRoot, 0 === t.length))
        }, mt("ul", {
          className: n.list
        }, mt("li", {
          className: ba(n.item, i({}, n.selectedItem, 0 === t.length))
        }, mt(Ra, a({}, r, {
          templateKey: "home",
          rootTagName: "a",
          rootProps: {
            className: n.link,
            href: s(void 0),
            onClick: function (e) {
              e.preventDefault(), o(void 0);
            }
          }
        }))), t.map(function (e, c) {
          var u = c === t.length - 1;
          return mt("li", {
            key: e.label + c,
            className: ba(n.item, i({}, n.selectedItem, u))
          }, mt(Ra, a({}, r, {
            templateKey: "separator",
            rootTagName: "span",
            rootProps: {
              className: n.separator,
              "aria-hidden": !0
            }
          })), u ? e.label : mt("a", {
            className: n.link,
            href: s(e.value),
            onClick: function (t) {
              t.preventDefault(), o(e.value);
            }
          }, e.label));
        })));
      }
      function Rn(e) {
        var t = e.hasRefinements,
          n = e.refine,
          r = e.cssClasses,
          s = e.templateProps;
        return mt("div", {
          className: r.root
        }, mt(Ra, a({}, s, {
          templateKey: "resetLabel",
          rootTagName: "button",
          rootProps: {
            className: ba(r.button, i({}, r.disabledButton, !t)),
            onClick: n,
            disabled: !t
          },
          data: {
            hasRefinements: t
          }
        })));
      }
      function Sn(e) {
        var t = e.items,
          n = e.cssClasses;
        return mt("div", {
          className: n.root
        }, mt("ul", {
          className: n.list
        }, t.map(function (e, t) {
          return mt("li", {
            key: "".concat(e.indexName, "-").concat(e.attribute, "-").concat(t),
            className: n.item
          }, mt("span", {
            className: n.label
          }, function (e) {
            return e.toString().charAt(0).toUpperCase() + e.toString().slice(1);
          }(e.label), ":"), e.refinements.map(function (t) {
            return mt("span", {
              key: function (e) {
                var t = e.attribute,
                  n = e.value;
                return [t, e.type, n, e.operator].map(function (e) {
                  return e;
                }).filter(Boolean).join(":");
              }(t),
              className: n.category
            }, mt("span", {
              className: n.categoryLabel
            }, "query" === t.attribute ? mt("q", null, t.label) : t.label), mt("button", {
              className: n.delete,
              onClick: function (e) {
                return function (t) {
                  W(t) || (t.preventDefault(), e());
                };
              }(e.refine.bind(null, t))
            }, "✕"));
          }));
        })));
      }
      function _n(e, t) {
        var n = e.items,
          r = e.widgetParams;
        if (!t) {
          var i = r,
            a = i.container,
            s = i.cssClasses;
          At(mt(Sn, {
            cssClasses: s,
            items: n
          }), a);
        }
      }
      function wn(e) {
        var t = e.hits,
          n = e.isLoading,
          r = e.cssClasses,
          s = e.templateProps;
        return mt("div", {
          className: ba(r.root, i({}, r.emptyRoot, 0 === t.length))
        }, mt(Ra, a({}, s, {
          templateKey: "header",
          rootProps: {
            className: r.header
          },
          data: {
            hits: t,
            isLoading: n
          }
        })), n ? mt(Ra, a({}, s, {
          templateKey: "loader",
          rootProps: {
            className: r.loader
          }
        })) : mt("ul", {
          className: r.list
        }, t.map(function (e, t) {
          return mt(Ra, a({}, s, {
            templateKey: "item",
            rootTagName: "li",
            rootProps: {
              className: r.item
            },
            key: e.objectID,
            data: o(o({}, e), {}, {
              __hitIndex: t
            })
          }));
        })));
      }
      function Pn(e) {
        var t = document.createElement("div");
        return t.className = Ta({
          descendantName: "widget"
        }), e.appendChild(t), t;
      }
      function On(e) {
        var t = e || {},
          n = t.container,
          r = t.widgets,
          i = t.fallbackWidget,
          a = f(t, ["container", "widgets", "fallbackWidget"]);
        if (!n) throw new Error(Ca("The `container` option is required."));
        if (!(r && Array.isArray(r) && r.every(function (e) {
          return "function" == typeof e;
        }))) throw new Error(Ca("The `widgets` option expects an array of callbacks."));
        var s = B(n),
          c = document.createElement("div");
        c.className = Ta();
        var u = new Map(),
          l = [],
          h = yn(function (e, t) {
            var n = e.attributesToRender;
            t && s.appendChild(c), n.forEach(function (e) {
              if (u.has(e)) {
                var t = u.get(e);
                c.appendChild(t);
              }
            });
          }, function () {
            s.removeChild(c);
          })(o(o({}, a), {}, {
            widgets: l,
            fallbackWidget: "function" == typeof i ? function (e) {
              var t = e.attribute,
                n = Pn(c);
              return u.set(t, n), i({
                attribute: t,
                container: n
              });
            } : void 0
          }));
        return o(o({}, h), {}, {
          init: function (e) {
            r.forEach(function (t) {
              var n = Pn(c),
                r = t(n),
                i = Fe(r, e);
              u.set(i, n), l.push(r);
            }), h.init(e);
          },
          $$widgetType: "ais.dynamicWidgets"
        });
      }
      function xn(e) {
        var t = e.className,
          n = e.disabled,
          r = void 0 !== n && n;
        return mt("button", {
          className: t,
          onClick: e.onClick,
          disabled: r
        }, e.children);
      }
      function jn(e) {
        var t = e.classNameLabel,
          n = e.classNameInput,
          r = e.checked,
          i = e.onToggle,
          a = e.children;
        return mt("label", {
          className: t
        }, mt("input", {
          className: n,
          type: "checkbox",
          checked: r,
          onChange: i
        }), a);
      }
      function In(e) {
        var t = e.cssClasses,
          n = e.enableRefine,
          r = e.enableRefineControl,
          s = e.enableClearMapRefinement,
          o = e.isRefineOnMapMove,
          c = e.isRefinedWithMap,
          u = e.hasMapMoveSinceLastRefine,
          l = e.onRefineToggle,
          f = e.onRefineClick,
          h = e.onClearClick,
          d = e.templateProps;
        return mt(vt, null, n && mt("div", null, r && mt("div", {
          className: t.control
        }, o || !u ? mt(jn, {
          classNameLabel: ba(t.label, i({}, t.selectedLabel, o)),
          classNameInput: t.input,
          checked: o,
          onToggle: l
        }, mt(Ra, a({}, d, {
          templateKey: "toggle",
          rootTagName: "span"
        }))) : mt(xn, {
          className: t.redo,
          disabled: !u,
          onClick: f
        }, mt(Ra, a({}, d, {
          templateKey: "redo",
          rootTagName: "span"
        })))), !r && !o && mt("div", {
          className: t.control
        }, mt(xn, {
          className: ba(t.redo, i({}, t.disabledRedo, !u)),
          disabled: !u,
          onClick: f
        }, mt(Ra, a({}, d, {
          templateKey: "redo",
          rootTagName: "span"
        })))), s && c && mt(xn, {
          className: t.reset,
          onClick: h
        }, mt(Ra, a({}, d, {
          templateKey: "reset",
          rootTagName: "span"
        })))));
      }
      function Fn(e) {
        var t = e.refine,
          n = e.mapInstance;
        return t({
          northEast: n.getBounds().getNorthEast().toJSON(),
          southWest: n.getBounds().getSouthWest().toJSON()
        });
      }
      function Nn(e, t) {
        e.isUserInteraction = !1, t(), e.isUserInteraction = !0;
      }
      function En(e, t) {
        var n = e.items,
          r = e.position,
          i = e.currentRefinement,
          a = e.refine,
          s = e.clearMapRefinement,
          c = e.toggleRefineOnMapMove,
          u = e.isRefineOnMapMove,
          l = e.setMapMoveSinceLastRefine,
          f = e.hasMapMoveSinceLastRefine,
          h = e.isRefinedWithMap,
          d = e.widgetParams,
          m = e.instantSearchInstance,
          g = d.container,
          v = d.googleReference,
          y = d.cssClasses,
          b = d.templates,
          R = d.initialZoom,
          S = d.initialPosition,
          _ = d.enableRefine,
          w = d.enableClearMapRefinement,
          P = d.enableRefineControl,
          O = d.mapOptions,
          x = d.createMarker,
          j = d.markerOptions,
          I = d.renderState;
        if (t) {
          I.isUserInteraction = !0, I.isPendingRefine = !1, I.markers = [];
          var F = document.createElement("div");
          F.className = y.root, g.appendChild(F);
          var N = document.createElement("div");
          N.className = y.map, F.appendChild(N);
          var E = document.createElement("div");
          return E.className = y.tree, F.appendChild(E), I.mapInstance = new v.maps.Map(N, o({
            mapTypeControl: !1,
            fullscreenControl: !1,
            streetViewControl: !1,
            clickableIcons: !1,
            zoomControlOptions: {
              position: v.maps.ControlPosition.LEFT_TOP
            }
          }, O)), v.maps.event.addListenerOnce(I.mapInstance, "idle", function () {
            function e() {
              I.isUserInteraction && _ && (l(), u() && (I.isPendingRefine = !0));
            }
            I.mapInstance.addListener("center_changed", e), I.mapInstance.addListener("zoom_changed", e), I.mapInstance.addListener("dragstart", e), I.mapInstance.addListener("idle", function () {
              I.isUserInteraction && I.isPendingRefine && (I.isPendingRefine = !1, Fn({
                mapInstance: I.mapInstance,
                refine: a
              }));
            });
          }), void (I.templateProps = U({
            templatesConfig: m.templatesConfig,
            templates: b
          }));
        }
        var C = n.map(function (e) {
            return e.objectID;
          }),
          T = p(function (e, t) {
            return e.reduce(function (e, n) {
              var r = p(e, 2),
                i = r[0],
                a = r[1];
              return t.includes(n.__id) ? [i.concat(n), a] : [i, a.concat(n)];
            }, [[], []]);
          }(I.markers, C), 2),
          k = T[0],
          A = T[1],
          D = k.map(function (e) {
            return e.__id;
          }),
          L = n.filter(function (e) {
            return !D.includes(e.objectID);
          });
        A.forEach(function (e) {
          return e.setMap(null);
        }), I.markers = k.concat(L.map(function (e) {
          var t = x({
            map: I.mapInstance,
            item: e
          });
          return Object.keys(j.events).forEach(function (n) {
            t.addListener(n, function (r) {
              j.events[n]({
                map: I.mapInstance,
                event: r,
                item: e,
                marker: t
              });
            });
          }), t;
        }));
        var M = !f(),
          H = i ? 0 : null,
          q = !i && Boolean(I.markers.length) ? function (e, t) {
            var n = t.reduce(function (e, t) {
              return e.extend(t.getPosition());
            }, new e.maps.LatLngBounds());
            return {
              northEast: n.getNorthEast().toJSON(),
              southWest: n.getSouthWest().toJSON()
            };
          }(v, I.markers) : i;
        q && M ? Nn(I, function () {
          I.mapInstance.fitBounds(new v.maps.LatLngBounds(q.southWest, q.northEast), H);
        }) : M && Nn(I, function () {
          I.mapInstance.setCenter(r || S), I.mapInstance.setZoom(R);
        }), At(mt(In, {
          cssClasses: y,
          enableRefine: _,
          enableRefineControl: P,
          enableClearMapRefinement: w,
          isRefineOnMapMove: u(),
          isRefinedWithMap: h(),
          hasMapMoveSinceLastRefine: f(),
          onRefineToggle: c,
          onRefineClick: function () {
            return Fn({
              mapInstance: I.mapInstance,
              refine: a
            });
          },
          onClearClick: s,
          templateProps: I.templateProps
        }), g.querySelector(".".concat(y.tree)));
      }
      function Cn(e) {
        var t = e.className,
          n = e.handleClick,
          r = e.facetValueToRefine,
          i = e.isRefined,
          s = e.templateProps,
          o = e.templateKey,
          c = e.templateData,
          u = e.subItems;
        return mt("li", {
          className: t,
          onClick: function (e) {
            n({
              facetValueToRefine: r,
              isRefined: i,
              originalEvent: e
            });
          }
        }, mt(Ra, a({}, s, {
          templateKey: o,
          data: c
        })), u);
      }
      function Tn(e) {
        return void 0 !== e.data;
      }
      function kn(e) {
        var t = e.currentValue,
          n = e.options,
          r = e.cssClasses,
          i = e.setValue;
        return mt("select", {
          className: ba(r.select),
          onChange: function (e) {
            return i(e.target.value);
          },
          value: "".concat(t)
        }, n.map(function (e) {
          return mt("option", {
            className: ba(r.option),
            key: e.label + e.value,
            value: "".concat(e.value)
          }, e.label);
        }));
      }
      function An(e) {
        var t = e.cssClasses,
          n = e.templateProps,
          r = e.items,
          s = e.refine,
          o = (z(r, function (e) {
            return e.isRefined;
          }) || {
            value: ""
          }).value;
        return mt("div", {
          className: ba(t.root, i({}, t.noRefinementRoot, 0 === r.length))
        }, mt("select", {
          className: t.select,
          value: o,
          onChange: function (e) {
            s(e.target.value);
          }
        }, mt(Ra, a({}, n, {
          templateKey: "defaultOption",
          rootTagName: "option",
          rootProps: {
            value: "",
            className: t.option
          }
        })), r.map(function (e) {
          return mt(Ra, a({}, n, {
            templateKey: "item",
            rootTagName: "option",
            rootProps: {
              value: e.value,
              className: t.option
            },
            key: e.value,
            data: e
          }));
        })));
      }
      function Dn(e) {
        function t(t) {
          return function (n) {
            W(n) || (n.preventDefault(), e.setCurrentPage(t));
          };
        }
        return mt("div", {
          className: ba(e.cssClasses.root, i({}, e.cssClasses.noRefinementRoot, e.nbPages <= 1))
        }, mt("ul", {
          className: e.cssClasses.list
        }, e.showFirst && mt(Ln, {
          ariaLabel: "First",
          className: e.cssClasses.firstPageItem,
          isDisabled: e.isFirstPage,
          label: e.templates.first,
          pageNumber: 0,
          createURL: e.createURL,
          cssClasses: e.cssClasses,
          createClickHandler: t
        }), e.showPrevious && mt(Ln, {
          ariaLabel: "Previous",
          className: e.cssClasses.previousPageItem,
          isDisabled: e.isFirstPage,
          label: e.templates.previous,
          pageNumber: e.currentPage - 1,
          createURL: e.createURL,
          cssClasses: e.cssClasses,
          createClickHandler: t
        }), e.pages.map(function (n) {
          return mt(Ln, {
            key: n,
            ariaLabel: "".concat(n + 1),
            className: e.cssClasses.pageItem,
            isSelected: n === e.currentPage,
            label: "".concat(n + 1),
            pageNumber: n,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t
          });
        }), e.showNext && mt(Ln, {
          ariaLabel: "Next",
          className: e.cssClasses.nextPageItem,
          isDisabled: e.isLastPage,
          label: e.templates.next,
          pageNumber: e.currentPage + 1,
          createURL: e.createURL,
          cssClasses: e.cssClasses,
          createClickHandler: t
        }), e.showLast && mt(Ln, {
          ariaLabel: "Last",
          className: e.cssClasses.lastPageItem,
          isDisabled: e.isLastPage,
          label: e.templates.last,
          pageNumber: e.nbPages - 1,
          createURL: e.createURL,
          cssClasses: e.cssClasses,
          createClickHandler: t
        })));
      }
      function Ln(e) {
        var t = e.label,
          n = e.ariaLabel,
          r = e.pageNumber,
          i = e.className,
          a = e.isDisabled,
          s = void 0 !== a && a,
          o = e.isSelected,
          c = void 0 !== o && o,
          u = e.cssClasses,
          l = e.createURL,
          f = e.createClickHandler;
        return mt("li", {
          className: ba(u.item, i, s && u.disabledItem, c && u.selectedItem)
        }, s ? mt("span", {
          className: u.link,
          dangerouslySetInnerHTML: {
            __html: t
          }
        }) : mt("a", {
          className: u.link,
          "aria-label": n,
          href: l(r),
          onClick: f(r),
          dangerouslySetInnerHTML: {
            __html: t
          }
        }));
      }
      function Mn(e, t) {
        Br.__h && Br.__h(Ba, e, ps || t), ps = 0;
        var n = Ba.__H || (Ba.__H = {
          __: [],
          __h: []
        });
        return e >= n.__.length && n.__.push({}), n.__[e];
      }
      function Hn(e) {
        return ps = 1, function (e, t, n) {
          var r = Mn(qa++, 2);
          return r.t = e, r.__c || (r.__ = [n ? n(t) : Vn(void 0, t), function (e) {
            var t = r.t(r.__[0], e);
            r.__[0] !== t && (r.__ = [t, r.__[1]], r.__c.setState({}));
          }], r.__c = Ba), r.__;
        }(Vn, e);
      }
      function qn(e) {
        return ps = 5, function (e, t) {
          var n = Mn(qa++, 7);
          return Un(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
        }(function () {
          return {
            current: e
          };
        }, []);
      }
      function Bn() {
        var e;
        for (ms.sort(function (e, t) {
          return e.__v.__b - t.__v.__b;
        }); e = ms.pop();) if (e.__P) try {
          e.__H.__h.forEach(Wn), e.__H.__h.forEach(Qn), e.__H.__h = [];
        } catch (t) {
          e.__H.__h = [], Br.__e(t, e.__v);
        }
      }
      function Wn(e) {
        var t = Ba,
          n = e.__c;
        "function" == typeof n && (e.__c = void 0, n()), Ba = t;
      }
      function Qn(e) {
        var t = Ba;
        e.__c = e.__(), Ba = t;
      }
      function Un(e, t) {
        return !e || e.length !== t.length || t.some(function (t, n) {
          return t !== e[n];
        });
      }
      function Vn(e, t) {
        return "function" == typeof t ? t(e) : t;
      }
      function $n(e) {
        var t,
          n = p(Hn(e.isCollapsed), 2),
          r = n[0],
          a = n[1],
          s = p(Hn(!1), 2),
          o = s[0],
          c = s[1],
          u = qn(null);
        return function (e, t) {
          var n = Mn(qa++, 3);
          !Br.__s && Un(n.__H, t) && (n.__ = e, n.__H = t, Ba.__H.__h.push(n));
        }(function () {
          var t = u.current;
          if (t) return t.appendChild(e.bodyElement), function () {
            t.removeChild(e.bodyElement);
          };
        }, [u, e.bodyElement]), o || e.isCollapsed === r || a(e.isCollapsed), mt("div", {
          className: ba(e.cssClasses.root, (t = {}, i(t, e.cssClasses.noRefinementRoot, e.hidden), i(t, e.cssClasses.collapsibleRoot, e.collapsible), i(t, e.cssClasses.collapsedRoot, r), t)),
          hidden: e.hidden
        }, e.templates.header && mt("div", {
          className: e.cssClasses.header
        }, mt(Ra, {
          templates: e.templates,
          templateKey: "header",
          rootTagName: "span",
          data: e.data
        }), e.collapsible && mt("button", {
          className: e.cssClasses.collapseButton,
          "aria-expanded": !r,
          onClick: function (e) {
            e.preventDefault(), c(!0), a(function (e) {
              return !e;
            });
          }
        }, mt(Ra, {
          templates: e.templates,
          templateKey: "collapseButtonText",
          rootTagName: "span",
          data: {
            collapsed: r
          }
        }))), mt("div", {
          className: e.cssClasses.body,
          ref: u
        }), e.templates.footer && mt(Ra, {
          templates: e.templates,
          templateKey: "footer",
          rootProps: {
            className: e.cssClasses.footer
          },
          data: e.data
        }));
      }
      function zn(e) {
        var t = e.url,
          n = e.theme,
          r = e.cssClasses;
        return mt("div", {
          className: r.root
        }, mt("a", {
          href: t,
          target: "_blank",
          className: r.link,
          "aria-label": "Search by Algolia",
          rel: "noopener noreferrer"
        }, mt("svg", {
          height: "1.2em",
          className: r.logo,
          viewBox: "0 0 168 24",
          style: {
            width: "auto"
          }
        }, mt("path", {
          fill: "dark" === n ? "#FFF" : "#5D6494",
          d: "M6.97 6.68V8.3a4.47 4.47 0 00-2.42-.67 2.2 2.2 0 00-1.38.4c-.34.26-.5.6-.5 1.02 0 .43.16.77.49 1.03.33.25.83.53 1.51.83a7.04 7.04 0 011.9 1.08c.34.24.58.54.73.89.15.34.23.74.23 1.18 0 .95-.33 1.7-1 2.24a4 4 0 01-2.6.81 5.71 5.71 0 01-2.94-.68v-1.71c.84.63 1.81.94 2.92.94.58 0 1.05-.14 1.39-.4.34-.28.5-.65.5-1.13 0-.29-.1-.55-.3-.8a2.2 2.2 0 00-.65-.53 23.03 23.03 0 00-1.64-.78 13.67 13.67 0 01-1.11-.64c-.12-.1-.28-.22-.46-.4a1.72 1.72 0 01-.39-.5 4.46 4.46 0 01-.22-.6c-.07-.23-.1-.48-.1-.75 0-.91.33-1.63 1-2.17a4 4 0 012.57-.8c.97 0 1.8.18 2.47.52zm7.47 5.7v-.3a2.26 2.26 0 00-.5-1.44c-.3-.35-.74-.53-1.32-.53-.53 0-.99.2-1.37.58a2.9 2.9 0 00-.72 1.68h3.91zm1 2.79v1.4c-.6.34-1.38.51-2.36.51a4.02 4.02 0 01-3-1.13 4.04 4.04 0 01-1.11-2.97c0-1.3.34-2.32 1.02-3.06a3.38 3.38 0 012.6-1.1c1.03 0 1.85.32 2.46.96.6.64.9 1.57.9 2.78 0 .33-.03.68-.09 1.04h-5.31c.1.7.4 1.24.89 1.61.49.38 1.1.56 1.85.56.86 0 1.58-.2 2.15-.6zm6.61-1.78h-1.21c-.6 0-1.05.12-1.35.36-.3.23-.46.53-.46.89 0 .37.12.66.36.88.23.2.57.32 1.02.32.5 0 .9-.15 1.2-.43.3-.28.44-.65.44-1.1v-.92zm-4.07-2.55V9.33a4.96 4.96 0 012.5-.55c2.1 0 3.17 1.03 3.17 3.08V17H22.1v-.96c-.42.68-1.15 1.02-2.19 1.02-.76 0-1.38-.22-1.84-.66-.46-.44-.7-1-.7-1.68 0-.78.3-1.38.88-1.81.59-.43 1.4-.65 2.46-.65h1.34v-.46c0-.55-.13-.97-.4-1.25-.26-.29-.7-.43-1.32-.43-.86 0-1.65.24-2.35.72zm9.34-1.93v1.42c.39-1 1.1-1.5 2.12-1.5.15 0 .31.02.5.05v1.53c-.23-.1-.48-.14-.76-.14-.54 0-.99.24-1.34.71a2.8 2.8 0 00-.52 1.71V17h-1.57V8.91h1.57zm5 4.09a3 3 0 00.76 2.01c.47.53 1.14.8 2 .8.64 0 1.24-.18 1.8-.53v1.4c-.53.32-1.2.48-2 .48a3.98 3.98 0 01-4.17-4.18c0-1.16.38-2.15 1.14-2.98a4 4 0 013.1-1.23c.7 0 1.34.15 1.92.44v1.44a3.24 3.24 0 00-1.77-.5A2.65 2.65 0 0032.33 13zm7.92-7.28v4.58c.46-1 1.3-1.5 2.5-1.5.8 0 1.42.24 1.9.73.48.5.72 1.17.72 2.05V17H43.8v-5.1c0-.56-.14-.99-.43-1.29-.28-.3-.65-.45-1.1-.45-.54 0-1 .2-1.42.6-.4.4-.61 1.02-.61 1.85V17h-1.56V5.72h1.56zM55.2 15.74c.6 0 1.1-.25 1.5-.76.4-.5.6-1.16.6-1.95 0-.92-.2-1.62-.6-2.12-.4-.5-.92-.74-1.55-.74-.56 0-1.05.22-1.5.67-.44.45-.66 1.13-.66 2.06 0 .96.22 1.67.64 2.14.43.47.95.7 1.57.7zM53 5.72v4.42a2.74 2.74 0 012.43-1.34c1.03 0 1.86.38 2.51 1.15.65.76.97 1.78.97 3.05 0 1.13-.3 2.1-.92 2.9-.62.81-1.47 1.21-2.54 1.21s-1.9-.45-2.46-1.34V17h-1.58V5.72H53zm9.9 11.1l-3.22-7.9h1.74l1 2.62 1.26 3.42c.1-.32.48-1.46 1.15-3.42l.91-2.63h1.66l-2.92 7.87c-.78 2.07-1.96 3.1-3.56 3.1-.28 0-.53-.02-.73-.07v-1.34c.17.04.35.06.54.06 1.03 0 1.76-.57 2.17-1.7z"
        }), Ps, Os, mt("path", {
          fill: "dark" === n ? "#FFF" : "#5468FF",
          d: "M120.92 18.8c-4.38.02-4.38-3.54-4.38-4.1V1.36l2.67-.42v13.25c0 .32 0 2.36 1.71 2.37v2.24zm-10.84-2.18c.82 0 1.43-.04 1.85-.12v-2.72a5.48 5.48 0 00-1.57-.2c-.3 0-.6.02-.9.07-.3.04-.57.12-.81.24-.24.11-.44.28-.58.49a.93.93 0 00-.22.65c0 .63.22 1 .61 1.23.4.24.94.36 1.62.36zm-.23-9.7c.88 0 1.62.11 2.23.33.6.22 1.09.53 1.44.92.36.4.61.92.76 1.48.16.56.23 1.17.23 1.85v6.87a21.69 21.69 0 01-4.68.5c-.69 0-1.32-.07-1.9-.2a4 4 0 01-1.46-.63 3.3 3.3 0 01-.96-1.13 4.3 4.3 0 01-.34-1.8 3.13 3.13 0 011.43-2.63c.45-.3.95-.5 1.54-.62a8.8 8.8 0 013.79.05v-.44c0-.3-.04-.6-.11-.87a1.78 1.78 0 00-1.1-1.22 3.2 3.2 0 00-1.15-.2 9.75 9.75 0 00-2.95.46l-.33-2.19a11.43 11.43 0 013.56-.53zm52.84 9.63c.82 0 1.43-.05 1.85-.13V13.7a5.42 5.42 0 00-1.57-.2c-.3 0-.6.02-.9.07-.3.04-.57.12-.81.24-.24.12-.44.28-.58.5a.93.93 0 00-.22.65c0 .63.22.99.61 1.23.4.24.94.36 1.62.36zm-.23-9.7c.88 0 1.63.11 2.23.33.6.22 1.1.53 1.45.92.35.39.6.92.76 1.48.15.56.23 1.18.23 1.85v6.88c-.41.08-1.03.19-1.87.31-.83.12-1.77.18-2.81.18-.7 0-1.33-.06-1.9-.2a4 4 0 01-1.47-.63c-.4-.3-.72-.67-.95-1.13a4.3 4.3 0 01-.34-1.8c0-.66.13-1.08.38-1.53.26-.45.61-.82 1.05-1.1.44-.3.95-.5 1.53-.62a8.8 8.8 0 013.8.05v-.43c0-.31-.04-.6-.12-.88-.07-.28-.2-.52-.38-.73a1.78 1.78 0 00-.73-.5c-.3-.1-.68-.2-1.14-.2a9.85 9.85 0 00-2.95.47l-.32-2.19a11.63 11.63 0 013.55-.53zm-8.03-1.27a1.62 1.62 0 000-3.24 1.62 1.62 0 100 3.24zm1.35 13.22h-2.7V7.27l2.7-.42V18.8zm-4.72 0c-4.38.02-4.38-3.54-4.38-4.1l-.01-13.34 2.67-.42v13.25c0 .32 0 2.36 1.72 2.37v2.24zm-8.7-5.9a4.7 4.7 0 00-.74-2.79 2.4 2.4 0 00-2.07-1 2.4 2.4 0 00-2.06 1 4.7 4.7 0 00-.74 2.8c0 1.16.25 1.94.74 2.62a2.4 2.4 0 002.07 1.02c.88 0 1.57-.34 2.07-1.02a4.2 4.2 0 00.73-2.63zm2.74 0a6.46 6.46 0 01-1.52 4.23c-.49.53-1.07.94-1.76 1.22-.68.29-1.73.45-2.26.45a6.6 6.6 0 01-2.25-.45 5.1 5.1 0 01-2.88-3.13 7.3 7.3 0 01-.01-4.84 5.13 5.13 0 012.9-3.1 5.67 5.67 0 012.22-.42c.81 0 1.56.14 2.24.42.69.29 1.28.69 1.75 1.22.49.52.87 1.15 1.14 1.89a7 7 0 01.43 2.5zm-20.14 0c0 1.11.25 2.36.74 2.88.5.52 1.13.78 1.91.78a4.07 4.07 0 002.12-.6V9.33c-.19-.04-.99-.2-1.76-.23a2.67 2.67 0 00-2.23 1 4.73 4.73 0 00-.78 2.8zm7.44 5.27c0 1.82-.46 3.16-1.4 4-.94.85-2.37 1.27-4.3 1.27-.7 0-2.17-.13-3.34-.4l.43-2.11c.98.2 2.27.26 2.95.26 1.08 0 1.84-.22 2.3-.66.46-.43.68-1.08.68-1.94v-.44a5.2 5.2 0 01-2.54.6 5.6 5.6 0 01-2.01-.36 4.2 4.2 0 01-2.58-2.71 9.88 9.88 0 01.02-5.35 4.92 4.92 0 012.93-2.96 6.6 6.6 0 012.43-.46 19.64 19.64 0 014.43.66v10.6z"
        }))));
      }
      function Kn(e) {
        var t = e.cssClasses,
          n = e.templates,
          r = e.items;
        return mt(Ra, {
          templateKey: "default",
          templates: n,
          rootProps: {
            className: t.root
          },
          data: {
            items: r
          }
        });
      }
      function Jn(e, t, n) {
        return (e - t) / (n - t) * 100;
      }
      function Gn(e, t, n) {
        var r = e / 100;
        return 0 === e ? t : 100 === e ? n : Math.round((n - t) * r + t);
      }
      function Yn(e) {
        return ["rheostat", "vertical" === e.orientation ? "rheostat-vertical" : "rheostat-horizontal"].concat(e.className.split(" ")).join(" ");
      }
      function Xn(e) {
        return Number(e.currentTarget.getAttribute("data-handle-key"));
      }
      function Zn(e) {
        e.stopPropagation(), e.preventDefault();
      }
      function er(e) {
        var t = e.style,
          n = e.children,
          r = Math.round(parseFloat(t.left)),
          i = [0, 50, 100].includes(r),
          a = n,
          s = Math.round(100 * parseInt(a, 10)) / 100;
        return mt("div", {
          style: o(o({}, t), {}, {
            marginLeft: 100 === r ? "-2px" : 0
          }),
          className: ba("rheostat-marker", "rheostat-marker-horizontal", {
            "rheostat-marker-large": i
          })
        }, i && mt("div", {
          className: "rheostat-value"
        }, s));
      }
      function tr(e) {
        var t = e.cssClasses,
          n = e.templates,
          r = e.isRelevantSorted,
          i = e.isVirtualReplica,
          a = e.refine;
        return i ? mt("div", {
          className: t.root
        }, mt(Ra, {
          templateKey: "text",
          templates: n,
          rootProps: {
            className: t.text
          },
          data: {
            isRelevantSorted: r
          }
        }), mt("button", {
          type: "button",
          className: t.button,
          onClick: function () {
            a(r ? 0 : void 0);
          }
        }, mt(Ra, {
          rootTagName: "span",
          templateKey: "button",
          templates: n,
          data: {
            isRelevantSorted: r
          }
        }))) : null;
      }
      function nr(e) {
        var t = e.nbHits,
          n = e.nbSortedHits,
          r = e.cssClasses,
          i = e.templateProps,
          s = f(e, ["nbHits", "nbSortedHits", "cssClasses", "templateProps"]);
        return mt("div", {
          className: ba(r.root)
        }, mt(Ra, a({}, i, {
          templateKey: "text",
          rootTagName: "span",
          rootProps: {
            className: r.text
          },
          data: o({
            hasManySortedResults: n && 1 < n,
            hasNoSortedResults: 0 === n,
            hasOneSortedResults: 1 === n,
            hasManyResults: 1 < t,
            hasNoResults: 0 === t,
            hasOneResult: 1 === t,
            nbHits: t,
            nbSortedHits: n,
            cssClasses: r
          }, s)
        })));
      }
      function rr(e) {
        var t = e.currentRefinement,
          n = e.refine,
          r = e.cssClasses,
          i = e.templateProps;
        return mt("div", {
          className: r.root
        }, mt("label", {
          className: r.label
        }, mt("input", {
          className: r.checkbox,
          type: "checkbox",
          checked: t.isRefined,
          onChange: function (e) {
            return n({
              isRefined: !e.target.checked
            });
          }
        }), mt(Ra, a({}, i, {
          rootTagName: "span",
          rootProps: {
            className: r.labelText
          },
          templateKey: "labelText",
          data: t
        }))));
      }
      function ir(e) {
        var t = e.cssClasses,
          n = e.isBrowserSupported,
          r = e.isListening,
          i = e.toggleListening,
          a = e.voiceListeningState,
          s = e.templates,
          o = a.status,
          c = a.transcript,
          u = a.isSpeechFinal,
          l = a.errorCode;
        return mt("div", {
          className: t.root
        }, mt(Ra, {
          templateKey: "buttonText",
          rootTagName: "button",
          rootProps: {
            className: t.button,
            type: "button",
            title: "Search by voice".concat(n ? "" : " (not supported on this browser)"),
            onClick: function (e) {
              e.currentTarget instanceof HTMLElement && e.currentTarget.blur(), i();
            },
            disabled: !n
          },
          data: {
            status: o,
            errorCode: l,
            isListening: r,
            transcript: c,
            isSpeechFinal: u,
            isBrowserSupported: n
          },
          templates: s
        }), mt(Ra, {
          templateKey: "status",
          rootProps: {
            className: t.status
          },
          data: {
            status: o,
            errorCode: l,
            isListening: r,
            transcript: c,
            isSpeechFinal: u,
            isBrowserSupported: n
          },
          templates: s
        }));
      }
      function ar(e) {
        return e.configure, f(e, ["configure"]);
      }
      function sr(e) {
        var t = e || {};
        return t.page, f(t, ["page"]);
      }
      function or(e) {
        return new Fi(e);
      }
      var cr = function (e) {
          y(e) || (e = {});
          for (var t = 1, n = arguments.length; t < n; t++) {
            var r = arguments[t];
            y(r) && b(e, r);
          }
          return e;
        },
        ur = function () {
          return Array.prototype.slice.call(arguments).reduceRight(function (e, t) {
            return Object.keys(Object(t)).forEach(function (n) {
              void 0 !== t[n] && (void 0 !== e[n] && delete e[n], e[n] = t[n]);
            }), e;
          }, {});
        },
        lr = function (e, t) {
          return e.filter(function (n, r) {
            return -1 < t.indexOf(n) && e.indexOf(n) === r;
          });
        },
        fr = function (e, t) {
          if (Array.isArray(e)) for (var n = 0; n < e.length; n++) if (t(e[n])) return e[n];
        },
        hr = function e(t) {
          if ("number" == typeof t) return t;
          if ("string" == typeof t) return parseFloat(t);
          if (Array.isArray(t)) return t.map(e);
          throw new Error("The value should be a number, a parsable string or an array of those.");
        },
        dr = function (e, t) {
          if (null === e) return {};
          var n,
            r,
            i = {},
            a = Object.keys(e);
          for (r = 0; r < a.length; r++) n = a[r], 0 <= t.indexOf(n) || (i[n] = e[n]);
          return i;
        },
        pr = function (e) {
          return e && 0 < Object.keys(e).length;
        },
        mr = function (e) {
          return null !== e && /^[a-zA-Z0-9_-]{1,64}$/.test(e);
        },
        gr = {
          addRefinement: function (e, t, n) {
            if (gr.isRefined(e, t, n)) return e;
            var r = "" + n,
              i = e[t] ? e[t].concat(r) : [r],
              a = {};
            return a[t] = i, ur({}, a, e);
          },
          removeRefinement: function (e, t, n) {
            if (void 0 === n) return gr.clearRefinement(e, function (e, n) {
              return t === n;
            });
            var r = "" + n;
            return gr.clearRefinement(e, function (e, n) {
              return t === n && r === e;
            });
          },
          toggleRefinement: function (e, t, n) {
            if (void 0 === n) throw new Error("toggleRefinement should be used with a value");
            return gr.isRefined(e, t, n) ? gr.removeRefinement(e, t, n) : gr.addRefinement(e, t, n);
          },
          clearRefinement: function (e, t, n) {
            if (void 0 === t) return pr(e) ? {} : e;
            if ("string" == typeof t) return dr(e, [t]);
            if ("function" == typeof t) {
              var r = !1,
                i = Object.keys(e).reduce(function (i, a) {
                  var s = e[a] || [],
                    o = s.filter(function (e) {
                      return !t(e, a, n);
                    });
                  return o.length !== s.length && (r = !0), i[a] = o, i;
                }, {});
              return r ? i : e;
            }
          },
          isRefined: function (e, t, n) {
            var r = !!e[t] && 0 < e[t].length;
            if (void 0 === n || !r) return r;
            var i = "" + n;
            return -1 !== e[t].indexOf(i);
          }
        },
        vr = gr;
      S.PARAMETERS = Object.keys(new S()), S._parseNumbers = function (e) {
        if (e instanceof S) return e;
        var t = {};
        if (["aroundPrecision", "aroundRadius", "getRankingInfo", "minWordSizefor2Typos", "minWordSizefor1Typo", "page", "maxValuesPerFacet", "distinct", "minimumAroundRadius", "hitsPerPage", "minProximity"].forEach(function (n) {
          var r = e[n];
          if ("string" == typeof r) {
            var i = parseFloat(r);
            t[n] = isNaN(i) ? r : i;
          }
        }), Array.isArray(e.insideBoundingBox) && (t.insideBoundingBox = e.insideBoundingBox.map(function (e) {
          return Array.isArray(e) ? e.map(function (e) {
            return parseFloat(e);
          }) : e;
        })), e.numericRefinements) {
          var n = {};
          Object.keys(e.numericRefinements).forEach(function (t) {
            var r = e.numericRefinements[t] || {};
            n[t] = {}, Object.keys(r).forEach(function (e) {
              var i = r[e].map(function (e) {
                return Array.isArray(e) ? e.map(function (e) {
                  return "string" == typeof e ? parseFloat(e) : e;
                }) : "string" == typeof e ? parseFloat(e) : e;
              });
              n[t][e] = i;
            });
          }), t.numericRefinements = n;
        }
        return cr({}, e, t);
      }, S.make = function (e) {
        var t = new S(e);
        return (e.hierarchicalFacets || []).forEach(function (e) {
          if (e.rootPath) {
            var n = t.getHierarchicalRefinement(e.name);
            0 < n.length && 0 !== n[0].indexOf(e.rootPath) && (t = t.clearRefinements(e.name)), 0 === (n = t.getHierarchicalRefinement(e.name)).length && (t = t.toggleHierarchicalFacetRefinement(e.name, e.rootPath));
          }
        }), t;
      }, S.validate = function (e, t) {
        var n = t || {};
        return e.tagFilters && n.tagRefinements && 0 < n.tagRefinements.length ? new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.") : 0 < e.tagRefinements.length && n.tagFilters ? new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.") : e.numericFilters && n.numericRefinements && pr(n.numericRefinements) ? new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : pr(e.numericRefinements) && n.numericFilters ? new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : null;
      }, S.prototype = {
        constructor: S,
        clearRefinements: function (e) {
          var t = {
            numericRefinements: this._clearNumericRefinements(e),
            facetsRefinements: vr.clearRefinement(this.facetsRefinements, e, "conjunctiveFacet"),
            facetsExcludes: vr.clearRefinement(this.facetsExcludes, e, "exclude"),
            disjunctiveFacetsRefinements: vr.clearRefinement(this.disjunctiveFacetsRefinements, e, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: vr.clearRefinement(this.hierarchicalFacetsRefinements, e, "hierarchicalFacet")
          };
          return t.numericRefinements === this.numericRefinements && t.facetsRefinements === this.facetsRefinements && t.facetsExcludes === this.facetsExcludes && t.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && t.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(t);
        },
        clearTags: function () {
          return void 0 === this.tagFilters && 0 === this.tagRefinements.length ? this : this.setQueryParameters({
            tagFilters: void 0,
            tagRefinements: []
          });
        },
        setIndex: function (e) {
          return e === this.index ? this : this.setQueryParameters({
            index: e
          });
        },
        setQuery: function (e) {
          return e === this.query ? this : this.setQueryParameters({
            query: e
          });
        },
        setPage: function (e) {
          return e === this.page ? this : this.setQueryParameters({
            page: e
          });
        },
        setFacets: function (e) {
          return this.setQueryParameters({
            facets: e
          });
        },
        setDisjunctiveFacets: function (e) {
          return this.setQueryParameters({
            disjunctiveFacets: e
          });
        },
        setHitsPerPage: function (e) {
          return this.hitsPerPage === e ? this : this.setQueryParameters({
            hitsPerPage: e
          });
        },
        setTypoTolerance: function (e) {
          return this.typoTolerance === e ? this : this.setQueryParameters({
            typoTolerance: e
          });
        },
        addNumericRefinement: function (e, t, n) {
          var r = hr(n);
          if (this.isNumericRefined(e, t, r)) return this;
          var i = cr({}, this.numericRefinements);
          return i[e] = cr({}, i[e]), i[e][t] ? (i[e][t] = i[e][t].slice(), i[e][t].push(r)) : i[e][t] = [r], this.setQueryParameters({
            numericRefinements: i
          });
        },
        getConjunctiveRefinements: function (e) {
          return this.isConjunctiveFacet(e) && this.facetsRefinements[e] || [];
        },
        getDisjunctiveRefinements: function (e) {
          return this.isDisjunctiveFacet(e) && this.disjunctiveFacetsRefinements[e] || [];
        },
        getHierarchicalRefinement: function (e) {
          return this.hierarchicalFacetsRefinements[e] || [];
        },
        getExcludeRefinements: function (e) {
          return this.isConjunctiveFacet(e) && this.facetsExcludes[e] || [];
        },
        removeNumericRefinement: function (e, t, n) {
          return void 0 !== n ? this.isNumericRefined(e, t, n) ? this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function (r, i) {
              return i === e && r.op === t && R(r.val, hr(n));
            })
          }) : this : void 0 !== t ? this.isNumericRefined(e, t) ? this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function (n, r) {
              return r === e && n.op === t;
            })
          }) : this : this.isNumericRefined(e) ? this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function (t, n) {
              return n === e;
            })
          }) : this;
        },
        getNumericRefinements: function (e) {
          return this.numericRefinements[e] || {};
        },
        getNumericRefinement: function (e, t) {
          return this.numericRefinements[e] && this.numericRefinements[e][t];
        },
        _clearNumericRefinements: function (e) {
          if (void 0 === e) return pr(this.numericRefinements) ? {} : this.numericRefinements;
          if ("string" == typeof e) return dr(this.numericRefinements, [e]);
          if ("function" == typeof e) {
            var t = !1,
              n = this.numericRefinements,
              r = Object.keys(n).reduce(function (r, i) {
                var a = n[i],
                  s = {};
                return a = a || {}, Object.keys(a).forEach(function (n) {
                  var r = a[n] || [],
                    o = [];
                  r.forEach(function (t) {
                    e({
                      val: t,
                      op: n
                    }, i, "numeric") || o.push(t);
                  }), o.length !== r.length && (t = !0), s[n] = o;
                }), r[i] = s, r;
              }, {});
            return t ? r : this.numericRefinements;
          }
        },
        addFacet: function (e) {
          return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({
            facets: this.facets.concat([e])
          });
        },
        addDisjunctiveFacet: function (e) {
          return this.isDisjunctiveFacet(e) ? this : this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([e])
          });
        },
        addHierarchicalFacet: function (e) {
          if (this.isHierarchicalFacet(e.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + e.name + "`");
          return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([e])
          });
        },
        addFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
          return vr.isRefined(this.facetsRefinements, e, t) ? this : this.setQueryParameters({
            facetsRefinements: vr.addRefinement(this.facetsRefinements, e, t)
          });
        },
        addExcludeRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
          return vr.isRefined(this.facetsExcludes, e, t) ? this : this.setQueryParameters({
            facetsExcludes: vr.addRefinement(this.facetsExcludes, e, t)
          });
        },
        addDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
          return vr.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this : this.setQueryParameters({
            disjunctiveFacetsRefinements: vr.addRefinement(this.disjunctiveFacetsRefinements, e, t)
          });
        },
        addTagRefinement: function (e) {
          if (this.isTagRefined(e)) return this;
          var t = {
            tagRefinements: this.tagRefinements.concat(e)
          };
          return this.setQueryParameters(t);
        },
        removeFacet: function (e) {
          return this.isConjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
            facets: this.facets.filter(function (t) {
              return t !== e;
            })
          }) : this;
        },
        removeDisjunctiveFacet: function (e) {
          return this.isDisjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function (t) {
              return t !== e;
            })
          }) : this;
        },
        removeHierarchicalFacet: function (e) {
          return this.isHierarchicalFacet(e) ? this.clearRefinements(e).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function (t) {
              return t.name !== e;
            })
          }) : this;
        },
        removeFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
          return vr.isRefined(this.facetsRefinements, e, t) ? this.setQueryParameters({
            facetsRefinements: vr.removeRefinement(this.facetsRefinements, e, t)
          }) : this;
        },
        removeExcludeRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
          return vr.isRefined(this.facetsExcludes, e, t) ? this.setQueryParameters({
            facetsExcludes: vr.removeRefinement(this.facetsExcludes, e, t)
          }) : this;
        },
        removeDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
          return vr.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this.setQueryParameters({
            disjunctiveFacetsRefinements: vr.removeRefinement(this.disjunctiveFacetsRefinements, e, t)
          }) : this;
        },
        removeTagRefinement: function (e) {
          if (!this.isTagRefined(e)) return this;
          var t = {
            tagRefinements: this.tagRefinements.filter(function (t) {
              return t !== e;
            })
          };
          return this.setQueryParameters(t);
        },
        toggleRefinement: function (e, t) {
          return this.toggleFacetRefinement(e, t);
        },
        toggleFacetRefinement: function (e, t) {
          if (this.isHierarchicalFacet(e)) return this.toggleHierarchicalFacetRefinement(e, t);
          if (this.isConjunctiveFacet(e)) return this.toggleConjunctiveFacetRefinement(e, t);
          if (this.isDisjunctiveFacet(e)) return this.toggleDisjunctiveFacetRefinement(e, t);
          throw new Error("Cannot refine the undeclared facet " + e + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
        },
        toggleConjunctiveFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
          return this.setQueryParameters({
            facetsRefinements: vr.toggleRefinement(this.facetsRefinements, e, t)
          });
        },
        toggleExcludeFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
          return this.setQueryParameters({
            facetsExcludes: vr.toggleRefinement(this.facetsExcludes, e, t)
          });
        },
        toggleDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
          return this.setQueryParameters({
            disjunctiveFacetsRefinements: vr.toggleRefinement(this.disjunctiveFacetsRefinements, e, t)
          });
        },
        toggleHierarchicalFacetRefinement: function (e, t) {
          if (!this.isHierarchicalFacet(e)) throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration");
          var n = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)),
            r = {};
          return void 0 !== this.hierarchicalFacetsRefinements[e] && 0 < this.hierarchicalFacetsRefinements[e].length && (this.hierarchicalFacetsRefinements[e][0] === t || 0 === this.hierarchicalFacetsRefinements[e][0].indexOf(t + n)) ? -1 === t.indexOf(n) ? r[e] = [] : r[e] = [t.slice(0, t.lastIndexOf(n))] : r[e] = [t], this.setQueryParameters({
            hierarchicalFacetsRefinements: ur({}, r, this.hierarchicalFacetsRefinements)
          });
        },
        addHierarchicalFacetRefinement: function (e, t) {
          if (this.isHierarchicalFacetRefined(e)) throw new Error(e + " is already refined.");
          if (!this.isHierarchicalFacet(e)) throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
          var n = {};
          return n[e] = [t], this.setQueryParameters({
            hierarchicalFacetsRefinements: ur({}, n, this.hierarchicalFacetsRefinements)
          });
        },
        removeHierarchicalFacetRefinement: function (e) {
          if (!this.isHierarchicalFacetRefined(e)) return this;
          var t = {};
          return t[e] = [], this.setQueryParameters({
            hierarchicalFacetsRefinements: ur({}, t, this.hierarchicalFacetsRefinements)
          });
        },
        toggleTagRefinement: function (e) {
          return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e);
        },
        isDisjunctiveFacet: function (e) {
          return -1 < this.disjunctiveFacets.indexOf(e);
        },
        isHierarchicalFacet: function (e) {
          return void 0 !== this.getHierarchicalFacetByName(e);
        },
        isConjunctiveFacet: function (e) {
          return -1 < this.facets.indexOf(e);
        },
        isFacetRefined: function (e, t) {
          return !!this.isConjunctiveFacet(e) && vr.isRefined(this.facetsRefinements, e, t);
        },
        isExcludeRefined: function (e, t) {
          return !!this.isConjunctiveFacet(e) && vr.isRefined(this.facetsExcludes, e, t);
        },
        isDisjunctiveFacetRefined: function (e, t) {
          return !!this.isDisjunctiveFacet(e) && vr.isRefined(this.disjunctiveFacetsRefinements, e, t);
        },
        isHierarchicalFacetRefined: function (e, t) {
          if (!this.isHierarchicalFacet(e)) return !1;
          var n = this.getHierarchicalRefinement(e);
          return t ? -1 !== n.indexOf(t) : 0 < n.length;
        },
        isNumericRefined: function (e, t, n) {
          if (void 0 === n && void 0 === t) return !!this.numericRefinements[e];
          var r = this.numericRefinements[e] && void 0 !== this.numericRefinements[e][t];
          if (void 0 === n || !r) return r;
          var i = hr(n),
            a = void 0 !== function (e, t) {
              return fr(e, function (e) {
                return R(e, t);
              });
            }(this.numericRefinements[e][t], i);
          return r && a;
        },
        isTagRefined: function (e) {
          return -1 !== this.tagRefinements.indexOf(e);
        },
        getRefinedDisjunctiveFacets: function () {
          var e = this,
            t = lr(Object.keys(this.numericRefinements).filter(function (t) {
              return 0 < Object.keys(e.numericRefinements[t]).length;
            }), this.disjunctiveFacets);
          return Object.keys(this.disjunctiveFacetsRefinements).filter(function (t) {
            return 0 < e.disjunctiveFacetsRefinements[t].length;
          }).concat(t).concat(this.getRefinedHierarchicalFacets());
        },
        getRefinedHierarchicalFacets: function () {
          var e = this;
          return lr(this.hierarchicalFacets.map(function (e) {
            return e.name;
          }), Object.keys(this.hierarchicalFacetsRefinements).filter(function (t) {
            return 0 < e.hierarchicalFacetsRefinements[t].length;
          }));
        },
        getUnrefinedDisjunctiveFacets: function () {
          var e = this.getRefinedDisjunctiveFacets();
          return this.disjunctiveFacets.filter(function (t) {
            return -1 === e.indexOf(t);
          });
        },
        managedParameters: ["index", "facets", "disjunctiveFacets", "facetsRefinements", "hierarchicalFacets", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacetsRefinements"],
        getQueryParams: function () {
          var e = this.managedParameters,
            t = {},
            n = this;
          return Object.keys(this).forEach(function (r) {
            var i = n[r];
            -1 === e.indexOf(r) && void 0 !== i && (t[r] = i);
          }), t;
        },
        setQueryParameter: function (e, t) {
          if (this[e] === t) return this;
          var n = {};
          return n[e] = t, this.setQueryParameters(n);
        },
        setQueryParameters: function (e) {
          if (!e) return this;
          var t = S.validate(this, e);
          if (t) throw t;
          var n = this,
            r = S._parseNumbers(e),
            i = Object.keys(this).reduce(function (e, t) {
              return e[t] = n[t], e;
            }, {}),
            a = Object.keys(r).reduce(function (e, t) {
              var n = void 0 !== e[t],
                i = void 0 !== r[t];
              return n && !i ? dr(e, [t]) : (i && (e[t] = r[t]), e);
            }, i);
          return new this.constructor(a);
        },
        resetPage: function () {
          return void 0 === this.page ? this : this.setPage(0);
        },
        _getHierarchicalFacetSortBy: function (e) {
          return e.sortBy || ["isRefined:desc", "name:asc"];
        },
        _getHierarchicalFacetSeparator: function (e) {
          return e.separator || " > ";
        },
        _getHierarchicalRootPath: function (e) {
          return e.rootPath || null;
        },
        _getHierarchicalShowParentLevel: function (e) {
          return "boolean" != typeof e.showParentLevel || e.showParentLevel;
        },
        getHierarchicalFacetByName: function (e) {
          return fr(this.hierarchicalFacets, function (t) {
            return t.name === e;
          });
        },
        getHierarchicalFacetBreadcrumb: function (e) {
          if (!this.isHierarchicalFacet(e)) return [];
          var t = this.getHierarchicalRefinement(e)[0];
          if (!t) return [];
          var n = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e));
          return t.split(n).map(function (e) {
            return e.trim();
          });
        },
        toString: function () {
          return JSON.stringify(this, null, 2);
        }
      };
      var yr = S,
        br = function (e, t, n) {
          if (!Array.isArray(e)) return [];
          Array.isArray(n) || (n = []);
          var r = e.map(function (e, n) {
            return {
              criteria: t.map(function (t) {
                return e[t];
              }),
              index: n,
              value: e
            };
          });
          return r.sort(function (e, t) {
            for (var r = -1; ++r < e.criteria.length;) {
              var i = _(e.criteria[r], t.criteria[r]);
              if (i) return r >= n.length ? i : "desc" === n[r] ? -i : i;
            }
            return e.index - t.index;
          }), r.map(function (e) {
            return e.value;
          });
        },
        Rr = function (e) {
          return "string" != typeof e ? e : String(e).replace(/^-/, "\\-");
        },
        Sr = function (e) {
          return "string" != typeof e ? e : e.replace(/^\\-/, "-");
        },
        _r = function (e) {
          return function (t, n) {
            var r = e.hierarchicalFacets[n],
              i = e.hierarchicalFacetsRefinements[r.name] && e.hierarchicalFacetsRefinements[r.name][0] || "",
              a = e._getHierarchicalFacetSeparator(r),
              s = e._getHierarchicalRootPath(r),
              o = e._getHierarchicalShowParentLevel(r),
              c = O(e._getHierarchicalFacetSortBy(r)),
              u = t.every(function (e) {
                return e.exhaustive;
              }),
              l = function (e, t, n, r, i) {
                return function (a, s, o) {
                  var c = a;
                  if (0 < o) {
                    var u = 0;
                    for (c = a; u < o;) {
                      var l = c && Array.isArray(c.data) ? c.data : [];
                      c = fr(l, function (e) {
                        return e.isRefined;
                      }), u++;
                    }
                  }
                  if (c) {
                    var f = Object.keys(s.data).map(function (e) {
                      return [e, s.data[e]];
                    }).filter(function (e) {
                      return function (e, t, n, r, i, a) {
                        return (!i || 0 === e.indexOf(i) && i !== e) && (!i && -1 === e.indexOf(r) || i && e.split(r).length - i.split(r).length == 1 || -1 === e.indexOf(r) && -1 === n.indexOf(r) || 0 === n.indexOf(e) || 0 === e.indexOf(t + r) && (a || 0 === e.indexOf(n)));
                      }(e[0], c.path || n, i, t, n, r);
                    });
                    c.data = br(f.map(function (e) {
                      var n = e[0];
                      return function (e, t, n, r, i) {
                        var a = t.split(n);
                        return {
                          name: a[a.length - 1].trim(),
                          path: t,
                          escapedValue: wr(t),
                          count: e,
                          isRefined: r === t || 0 === r.indexOf(t + n),
                          exhaustive: i,
                          data: null
                        };
                      }(e[1], n, t, Pr(i), s.exhaustive);
                    }), e[0], e[1]);
                  }
                  return a;
                };
              }(c, a, s, o, i),
              f = t;
            return s && (f = t.slice(s.split(a).length)), f.reduce(l, {
              name: e.hierarchicalFacets[n].name,
              count: null,
              isRefined: !0,
              path: null,
              escapedValue: null,
              exhaustive: u,
              data: null
            });
          };
        },
        wr = Rr,
        Pr = Sr,
        Or = Rr,
        xr = Sr;
      I.prototype.getFacetByName = function (e) {
        function t(t) {
          return t.name === e;
        }
        return fr(this.facets, t) || fr(this.disjunctiveFacets, t) || fr(this.hierarchicalFacets, t);
      }, I.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"], I.prototype.getFacetValues = function (e, t) {
        var n = function (e, t) {
          function n(e) {
            return e.name === t;
          }
          if (e._state.isConjunctiveFacet(t)) {
            var r = fr(e.facets, n);
            return r ? Object.keys(r.data).map(function (n) {
              var i = Or(n);
              return {
                name: n,
                escapedValue: i,
                count: r.data[n],
                isRefined: e._state.isFacetRefined(t, i),
                isExcluded: e._state.isExcludeRefined(t, n)
              };
            }) : [];
          }
          if (e._state.isDisjunctiveFacet(t)) {
            var i = fr(e.disjunctiveFacets, n);
            return i ? Object.keys(i.data).map(function (n) {
              var r = Or(n);
              return {
                name: n,
                escapedValue: r,
                count: i.data[n],
                isRefined: e._state.isDisjunctiveFacetRefined(t, r)
              };
            }) : [];
          }
          if (e._state.isHierarchicalFacet(t)) return fr(e.hierarchicalFacets, n);
        }(this, e);
        if (n) {
          var r,
            i = ur({}, t, {
              sortBy: I.DEFAULT_SORT,
              facetOrdering: !(t && t.sortBy)
            }),
            a = this;
          return r = Array.isArray(n) ? [e] : a._state.getHierarchicalFacetByName(n.name).attributes, function e(t, n, r, i) {
            if (i = i || 0, Array.isArray(n)) return t(n, r[i]);
            if (!n.data || 0 === n.data.length) return n;
            var a = n.data.map(function (n) {
                return e(t, n, r, i + 1);
              }),
              s = t(a, r[i]);
            return ur({
              data: s
            }, n);
          }(function (e, t) {
            if (i.facetOrdering) {
              var n = function (e, t) {
                return e.renderingContent && e.renderingContent.facetOrdering && e.renderingContent.facetOrdering.values && e.renderingContent.facetOrdering.values[t];
              }(a, t);
              if (Boolean(n)) return function (e, t) {
                var n = [],
                  r = [],
                  i = (t.order || []).reduce(function (e, t, n) {
                    return e[t] = n, e;
                  }, {});
                e.forEach(function (e) {
                  var t = e.path || e.name;
                  void 0 !== i[t] ? n[i[t]] = e : r.push(e);
                }), n = n.filter(function (e) {
                  return e;
                });
                var a,
                  s = t.sortRemainingBy;
                return "hidden" === s ? n : (a = "alpha" === s ? [["path", "name"], ["asc", "asc"]] : [["count"], ["desc"]], n.concat(br(r, a[0], a[1])));
              }(e, n);
            }
            if (Array.isArray(i.sortBy)) {
              var r = O(i.sortBy, I.DEFAULT_SORT);
              return br(e, r[0], r[1]);
            }
            if ("function" == typeof i.sortBy) return function (e, t) {
              return t.sort(e);
            }(i.sortBy, e);
            throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
          }, n, r);
        }
      }, I.prototype.getFacetStats = function (e) {
        return this._state.isConjunctiveFacet(e) ? F(this.facets, e) : this._state.isDisjunctiveFacet(e) ? F(this.disjunctiveFacets, e) : void 0;
      }, I.prototype.getRefinements = function () {
        var e = this._state,
          t = this,
          n = [];
        return Object.keys(e.facetsRefinements).forEach(function (r) {
          e.facetsRefinements[r].forEach(function (i) {
            n.push(N(e, "facet", r, i, t.facets));
          });
        }), Object.keys(e.facetsExcludes).forEach(function (r) {
          e.facetsExcludes[r].forEach(function (i) {
            n.push(N(e, "exclude", r, i, t.facets));
          });
        }), Object.keys(e.disjunctiveFacetsRefinements).forEach(function (r) {
          e.disjunctiveFacetsRefinements[r].forEach(function (i) {
            n.push(N(e, "disjunctive", r, i, t.disjunctiveFacets));
          });
        }), Object.keys(e.hierarchicalFacetsRefinements).forEach(function (r) {
          e.hierarchicalFacetsRefinements[r].forEach(function (i) {
            n.push(function (e, t, n, r) {
              var i = e.getHierarchicalFacetByName(t),
                a = e._getHierarchicalFacetSeparator(i),
                s = n.split(a),
                o = fr(r, function (e) {
                  return e.name === t;
                }),
                c = s.reduce(function (e, t) {
                  var n = e && fr(e.data, function (e) {
                    return e.name === t;
                  });
                  return void 0 !== n ? n : e;
                }, o),
                u = c && c.count || 0,
                l = c && c.exhaustive || !1,
                f = c && c.path || "";
              return {
                type: "hierarchical",
                attributeName: t,
                name: f,
                count: u,
                exhaustive: l
              };
            }(e, r, i, t.hierarchicalFacets));
          });
        }), Object.keys(e.numericRefinements).forEach(function (t) {
          var r = e.numericRefinements[t];
          Object.keys(r).forEach(function (e) {
            r[e].forEach(function (r) {
              n.push({
                type: "numeric",
                attributeName: t,
                name: r,
                numericValue: r,
                operator: e
              });
            });
          });
        }), e.tagRefinements.forEach(function (e) {
          n.push({
            type: "tag",
            attributeName: "_tags",
            name: e
          });
        }), n;
      };
      var jr = I,
        Ir = E;
      E.prototype._events = void 0, E.prototype._maxListeners = void 0, E.defaultMaxListeners = 10, E.prototype.setMaxListeners = function (e) {
        if (!function (e) {
          return "number" == typeof e;
        }(e) || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
        return this._maxListeners = e, this;
      }, E.prototype.emit = function (e) {
        var t, n, r, i, a, s;
        if (this._events || (this._events = {}), "error" === e && (!this._events.error || T(this._events.error) && !this._events.error.length)) {
          if ((t = arguments[1]) instanceof Error) throw t;
          var o = new Error('Uncaught, unspecified "error" event. (' + t + ")");
          throw o.context = t, o;
        }
        if (k(n = this._events[e])) return !1;
        if (C(n)) switch (arguments.length) {
          case 1:
            n.call(this);
            break;
          case 2:
            n.call(this, arguments[1]);
            break;
          case 3:
            n.call(this, arguments[1], arguments[2]);
            break;
          default:
            i = Array.prototype.slice.call(arguments, 1), n.apply(this, i);
        } else if (T(n)) for (i = Array.prototype.slice.call(arguments, 1), r = (s = n.slice()).length, a = 0; a < r; a++) s[a].apply(this, i);
        return !0;
      }, E.prototype.on = E.prototype.addListener = function (e, t) {
        var n;
        if (!C(t)) throw TypeError("listener must be a function");
        return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, C(t.listener) ? t.listener : t), this._events[e] ? T(this._events[e]) ? this._events[e].push(t) : this._events[e] = [this._events[e], t] : this._events[e] = t, T(this._events[e]) && !this._events[e].warned && (n = k(this._maxListeners) ? E.defaultMaxListeners : this._maxListeners) && 0 < n && this._events[e].length > n && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace && console.trace()), this;
      }, E.prototype.once = function (e, t) {
        function n() {
          this.removeListener(e, n), r || (r = !0, t.apply(this, arguments));
        }
        if (!C(t)) throw TypeError("listener must be a function");
        var r = !1;
        return n.listener = t, this.on(e, n), this;
      }, E.prototype.removeListener = function (e, t) {
        var n, r, i, a;
        if (!C(t)) throw TypeError("listener must be a function");
        if (!this._events || !this._events[e]) return this;
        if (i = (n = this._events[e]).length, r = -1, n === t || C(n.listener) && n.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t);else if (T(n)) {
          for (a = i; 0 < a--;) if (n[a] === t || n[a].listener && n[a].listener === t) {
            r = a;
            break;
          }
          if (r < 0) return this;
          1 === n.length ? (n.length = 0, delete this._events[e]) : n.splice(r, 1), this._events.removeListener && this.emit("removeListener", e, t);
        }
        return this;
      }, E.prototype.removeAllListeners = function (e) {
        var t, n;
        if (!this._events) return this;
        if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e], this;
        if (0 === arguments.length) {
          for (t in this._events) "removeListener" !== t && this.removeAllListeners(t);
          return this.removeAllListeners("removeListener"), this._events = {}, this;
        }
        if (C(n = this._events[e])) this.removeListener(e, n);else if (n) for (; n.length;) this.removeListener(e, n[n.length - 1]);
        return delete this._events[e], this;
      }, E.prototype.listeners = function (e) {
        return this._events && this._events[e] ? C(this._events[e]) ? [this._events[e]] : this._events[e].slice() : [];
      }, E.prototype.listenerCount = function (e) {
        if (this._events) {
          var t = this._events[e];
          if (C(t)) return 1;
          if (t) return t.length;
        }
        return 0;
      }, E.listenerCount = function (e, t) {
        return e.listenerCount(t);
      };
      var Fr = function (e, t) {
        e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        });
      };
      Fr(A, Ir), A.prototype.detach = function () {
        this.removeAllListeners(), this.main.detachDerivedHelper(this);
      }, A.prototype.getModifiedState = function (e) {
        return this.fn(e);
      };
      var Nr = A,
        Er = {
          _getQueries: function (e, t) {
            var n = [];
            return n.push({
              indexName: e,
              params: Er._getHitsSearchParams(t)
            }), t.getRefinedDisjunctiveFacets().forEach(function (r) {
              n.push({
                indexName: e,
                params: Er._getDisjunctiveFacetSearchParams(t, r)
              });
            }), t.getRefinedHierarchicalFacets().forEach(function (r) {
              var i = t.getHierarchicalFacetByName(r),
                a = t.getHierarchicalRefinement(r),
                s = t._getHierarchicalFacetSeparator(i);
              0 < a.length && 1 < a[0].split(s).length && n.push({
                indexName: e,
                params: Er._getDisjunctiveFacetSearchParams(t, r, !0)
              });
            }), n;
          },
          _getHitsSearchParams: function (e) {
            var t = e.facets.concat(e.disjunctiveFacets).concat(Er._getHitsHierarchicalFacetsAttributes(e)),
              n = Er._getFacetFilters(e),
              r = Er._getNumericFilters(e),
              i = Er._getTagFilters(e),
              a = {
                facets: -1 < t.indexOf("*") ? ["*"] : t,
                tagFilters: i
              };
            return 0 < n.length && (a.facetFilters = n), 0 < r.length && (a.numericFilters = r), cr({}, e.getQueryParams(), a);
          },
          _getDisjunctiveFacetSearchParams: function (e, t, n) {
            var r = Er._getFacetFilters(e, t, n),
              i = Er._getNumericFilters(e, t),
              a = {
                hitsPerPage: 1,
                page: 0,
                attributesToRetrieve: [],
                attributesToHighlight: [],
                attributesToSnippet: [],
                tagFilters: Er._getTagFilters(e),
                analytics: !1,
                clickAnalytics: !1
              },
              s = e.getHierarchicalFacetByName(t);
            return a.facets = s ? Er._getDisjunctiveHierarchicalFacetAttribute(e, s, n) : t, 0 < i.length && (a.numericFilters = i), 0 < r.length && (a.facetFilters = r), cr({}, e.getQueryParams(), a);
          },
          _getNumericFilters: function (e, t) {
            if (e.numericFilters) return e.numericFilters;
            var n = [];
            return Object.keys(e.numericRefinements).forEach(function (r) {
              var i = e.numericRefinements[r] || {};
              Object.keys(i).forEach(function (e) {
                var a = i[e] || [];
                t !== r && a.forEach(function (t) {
                  if (Array.isArray(t)) {
                    var i = t.map(function (t) {
                      return r + e + t;
                    });
                    n.push(i);
                  } else n.push(r + e + t);
                });
              });
            }), n;
          },
          _getTagFilters: function (e) {
            return e.tagFilters ? e.tagFilters : e.tagRefinements.join(",");
          },
          _getFacetFilters: function (e, t, n) {
            var r = [],
              i = e.facetsRefinements || {};
            Object.keys(i).forEach(function (e) {
              (i[e] || []).forEach(function (t) {
                r.push(e + ":" + t);
              });
            });
            var a = e.facetsExcludes || {};
            Object.keys(a).forEach(function (e) {
              (a[e] || []).forEach(function (t) {
                r.push(e + ":-" + t);
              });
            });
            var s = e.disjunctiveFacetsRefinements || {};
            Object.keys(s).forEach(function (e) {
              var n = s[e] || [];
              if (e !== t && n && 0 !== n.length) {
                var i = [];
                n.forEach(function (t) {
                  i.push(e + ":" + t);
                }), r.push(i);
              }
            });
            var o = e.hierarchicalFacetsRefinements || {};
            return Object.keys(o).forEach(function (i) {
              var a = (o[i] || [])[0];
              if (void 0 !== a) {
                var s,
                  c,
                  u = e.getHierarchicalFacetByName(i),
                  l = e._getHierarchicalFacetSeparator(u),
                  f = e._getHierarchicalRootPath(u);
                if (t === i) {
                  if (-1 === a.indexOf(l) || !f && !0 === n || f && f.split(l).length === a.split(l).length) return;
                  a = f ? (c = f.split(l).length - 1, f) : (c = a.split(l).length - 2, a.slice(0, a.lastIndexOf(l))), s = u.attributes[c];
                } else c = a.split(l).length - 1, s = u.attributes[c];
                s && r.push([s + ":" + a]);
              }
            }), r;
          },
          _getHitsHierarchicalFacetsAttributes: function (e) {
            return e.hierarchicalFacets.reduce(function (t, n) {
              var r = e.getHierarchicalRefinement(n.name)[0];
              if (!r) return t.push(n.attributes[0]), t;
              var i = e._getHierarchicalFacetSeparator(n),
                a = r.split(i).length,
                s = n.attributes.slice(0, a + 1);
              return t.concat(s);
            }, []);
          },
          _getDisjunctiveHierarchicalFacetAttribute: function (e, t, n) {
            var r = e._getHierarchicalFacetSeparator(t);
            if (!0 === n) {
              var i = e._getHierarchicalRootPath(t),
                a = 0;
              return i && (a = i.split(r).length), [t.attributes[a]];
            }
            var s = (e.getHierarchicalRefinement(t.name)[0] || "").split(r).length - 1;
            return t.attributes.slice(0, 1 + s);
          },
          getSearchForFacetQuery: function (e, t, n, r) {
            var i = r.isDisjunctiveFacet(e) ? r.clearRefinements(e) : r,
              a = {
                facetQuery: t,
                facetName: e
              };
            return "number" == typeof n && (a.maxFacetHits = n), cr({}, Er._getHitsSearchParams(i), a);
          }
        },
        Cr = Er,
        Tr = "3.8.2",
        kr = Rr;
      Fr(D, Ir), D.prototype.search = function () {
        return this._search({
          onlyWithDerivedHelpers: !1
        }), this;
      }, D.prototype.searchOnlyWithDerivedHelpers = function () {
        return this._search({
          onlyWithDerivedHelpers: !0
        }), this;
      }, D.prototype.getQuery = function () {
        var e = this.state;
        return Cr._getHitsSearchParams(e);
      }, D.prototype.searchOnce = function (e, t) {
        var n = e ? this.state.setQueryParameters(e) : this.state,
          r = Cr._getQueries(n.index, n),
          i = this;
        return this._currentNbQueries++, this.emit("searchOnce", {
          state: n
        }), t ? void this.client.search(r).then(function (e) {
          i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), t(null, new jr(n, e.results), n);
        }).catch(function (e) {
          i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), t(e, null, n);
        }) : this.client.search(r).then(function (e) {
          return i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), {
            content: new jr(n, e.results),
            state: n,
            _originalResponse: e
          };
        }, function (e) {
          throw i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), e;
        });
      }, D.prototype.findAnswers = function (e) {
        var t = this.state,
          n = this.derivedHelpers[0];
        if (!n) return Promise.resolve([]);
        var r = n.getModifiedState(t),
          i = cr({
            attributesForPrediction: e.attributesForPrediction,
            nbHits: e.nbHits
          }, {
            params: dr(Cr._getHitsSearchParams(r), ["attributesToSnippet", "hitsPerPage", "restrictSearchableAttributes", "snippetEllipsisText"])
          }),
          a = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
        if ("function" != typeof this.client.initIndex) throw new Error(a);
        var s = this.client.initIndex(r.index);
        if ("function" != typeof s.findAnswers) throw new Error(a);
        return s.findAnswers(r.query, e.queryLanguages, i);
      }, D.prototype.searchForFacetValues = function (e, t, n, r) {
        var i = "function" == typeof this.client.searchForFacetValues;
        if (!i && "function" != typeof this.client.initIndex) throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
        var a = this.state.setQueryParameters(r || {}),
          s = a.isDisjunctiveFacet(e),
          o = Cr.getSearchForFacetQuery(e, t, n, a);
        this._currentNbQueries++;
        var c = this;
        return this.emit("searchForFacetValues", {
          state: a,
          facet: e,
          query: t
        }), (i ? this.client.searchForFacetValues([{
          indexName: a.index,
          params: o
        }]) : this.client.initIndex(a.index).searchForFacetValues(o)).then(function (t) {
          return c._currentNbQueries--, 0 === c._currentNbQueries && c.emit("searchQueueEmpty"), (t = Array.isArray(t) ? t[0] : t).facetHits.forEach(function (t) {
            t.escapedValue = kr(t.value), t.isRefined = s ? a.isDisjunctiveFacetRefined(e, t.escapedValue) : a.isFacetRefined(e, t.escapedValue);
          }), t;
        }, function (e) {
          throw c._currentNbQueries--, 0 === c._currentNbQueries && c.emit("searchQueueEmpty"), e;
        });
      }, D.prototype.setQuery = function (e) {
        return this._change({
          state: this.state.resetPage().setQuery(e),
          isPageReset: !0
        }), this;
      }, D.prototype.clearRefinements = function (e) {
        return this._change({
          state: this.state.resetPage().clearRefinements(e),
          isPageReset: !0
        }), this;
      }, D.prototype.clearTags = function () {
        return this._change({
          state: this.state.resetPage().clearTags(),
          isPageReset: !0
        }), this;
      }, D.prototype.addDisjunctiveFacetRefinement = function (e, t) {
        return this._change({
          state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.addDisjunctiveRefine = function () {
        return this.addDisjunctiveFacetRefinement.apply(this, arguments);
      }, D.prototype.addHierarchicalFacetRefinement = function (e, t) {
        return this._change({
          state: this.state.resetPage().addHierarchicalFacetRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.addNumericRefinement = function (e, t, n) {
        return this._change({
          state: this.state.resetPage().addNumericRefinement(e, t, n),
          isPageReset: !0
        }), this;
      }, D.prototype.addFacetRefinement = function (e, t) {
        return this._change({
          state: this.state.resetPage().addFacetRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.addRefine = function () {
        return this.addFacetRefinement.apply(this, arguments);
      }, D.prototype.addFacetExclusion = function (e, t) {
        return this._change({
          state: this.state.resetPage().addExcludeRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.addExclude = function () {
        return this.addFacetExclusion.apply(this, arguments);
      }, D.prototype.addTag = function (e) {
        return this._change({
          state: this.state.resetPage().addTagRefinement(e),
          isPageReset: !0
        }), this;
      }, D.prototype.removeNumericRefinement = function (e, t, n) {
        return this._change({
          state: this.state.resetPage().removeNumericRefinement(e, t, n),
          isPageReset: !0
        }), this;
      }, D.prototype.removeDisjunctiveFacetRefinement = function (e, t) {
        return this._change({
          state: this.state.resetPage().removeDisjunctiveFacetRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.removeDisjunctiveRefine = function () {
        return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
      }, D.prototype.removeHierarchicalFacetRefinement = function (e) {
        return this._change({
          state: this.state.resetPage().removeHierarchicalFacetRefinement(e),
          isPageReset: !0
        }), this;
      }, D.prototype.removeFacetRefinement = function (e, t) {
        return this._change({
          state: this.state.resetPage().removeFacetRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.removeRefine = function () {
        return this.removeFacetRefinement.apply(this, arguments);
      }, D.prototype.removeFacetExclusion = function (e, t) {
        return this._change({
          state: this.state.resetPage().removeExcludeRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.removeExclude = function () {
        return this.removeFacetExclusion.apply(this, arguments);
      }, D.prototype.removeTag = function (e) {
        return this._change({
          state: this.state.resetPage().removeTagRefinement(e),
          isPageReset: !0
        }), this;
      }, D.prototype.toggleFacetExclusion = function (e, t) {
        return this._change({
          state: this.state.resetPage().toggleExcludeFacetRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.toggleExclude = function () {
        return this.toggleFacetExclusion.apply(this, arguments);
      }, D.prototype.toggleRefinement = function (e, t) {
        return this.toggleFacetRefinement(e, t);
      }, D.prototype.toggleFacetRefinement = function (e, t) {
        return this._change({
          state: this.state.resetPage().toggleFacetRefinement(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.toggleRefine = function () {
        return this.toggleFacetRefinement.apply(this, arguments);
      }, D.prototype.toggleTag = function (e) {
        return this._change({
          state: this.state.resetPage().toggleTagRefinement(e),
          isPageReset: !0
        }), this;
      }, D.prototype.nextPage = function () {
        var e = this.state.page || 0;
        return this.setPage(e + 1);
      }, D.prototype.previousPage = function () {
        var e = this.state.page || 0;
        return this.setPage(e - 1);
      }, D.prototype.setCurrentPage = L, D.prototype.setPage = L, D.prototype.setIndex = function (e) {
        return this._change({
          state: this.state.resetPage().setIndex(e),
          isPageReset: !0
        }), this;
      }, D.prototype.setQueryParameter = function (e, t) {
        return this._change({
          state: this.state.resetPage().setQueryParameter(e, t),
          isPageReset: !0
        }), this;
      }, D.prototype.setState = function (e) {
        return this._change({
          state: yr.make(e),
          isPageReset: !1
        }), this;
      }, D.prototype.overrideStateWithoutTriggeringChangeEvent = function (e) {
        return this.state = new yr(e), this;
      }, D.prototype.hasRefinements = function (e) {
        return !!pr(this.state.getNumericRefinements(e)) || (this.state.isConjunctiveFacet(e) ? this.state.isFacetRefined(e) : this.state.isDisjunctiveFacet(e) ? this.state.isDisjunctiveFacetRefined(e) : !!this.state.isHierarchicalFacet(e) && this.state.isHierarchicalFacetRefined(e));
      }, D.prototype.isExcluded = function (e, t) {
        return this.state.isExcludeRefined(e, t);
      }, D.prototype.isDisjunctiveRefined = function (e, t) {
        return this.state.isDisjunctiveFacetRefined(e, t);
      }, D.prototype.hasTag = function (e) {
        return this.state.isTagRefined(e);
      }, D.prototype.isTagRefined = function () {
        return this.hasTagRefinements.apply(this, arguments);
      }, D.prototype.getIndex = function () {
        return this.state.index;
      }, D.prototype.getCurrentPage = M, D.prototype.getPage = M, D.prototype.getTags = function () {
        return this.state.tagRefinements;
      }, D.prototype.getRefinements = function (e) {
        var t = [];
        this.state.isConjunctiveFacet(e) ? (this.state.getConjunctiveRefinements(e).forEach(function (e) {
          t.push({
            value: e,
            type: "conjunctive"
          });
        }), this.state.getExcludeRefinements(e).forEach(function (e) {
          t.push({
            value: e,
            type: "exclude"
          });
        })) : this.state.isDisjunctiveFacet(e) && this.state.getDisjunctiveRefinements(e).forEach(function (e) {
          t.push({
            value: e,
            type: "disjunctive"
          });
        });
        var n = this.state.getNumericRefinements(e);
        return Object.keys(n).forEach(function (e) {
          var r = n[e];
          t.push({
            value: r,
            operator: e,
            type: "numeric"
          });
        }), t;
      }, D.prototype.getNumericRefinement = function (e, t) {
        return this.state.getNumericRefinement(e, t);
      }, D.prototype.getHierarchicalFacetBreadcrumb = function (e) {
        return this.state.getHierarchicalFacetBreadcrumb(e);
      }, D.prototype._search = function (e) {
        var t = this.state,
          n = [],
          r = [];
        e.onlyWithDerivedHelpers || (r = Cr._getQueries(t.index, t), n.push({
          state: t,
          queriesCount: r.length,
          helper: this
        }), this.emit("search", {
          state: t,
          results: this.lastResults
        }));
        var i = this.derivedHelpers.map(function (e) {
            var r = e.getModifiedState(t),
              i = Cr._getQueries(r.index, r);
            return n.push({
              state: r,
              queriesCount: i.length,
              helper: e
            }), e.emit("search", {
              state: r,
              results: e.lastResults
            }), i;
          }),
          a = Array.prototype.concat.apply(r, i),
          s = this._queryId++;
        this._currentNbQueries++;
        try {
          this.client.search(a).then(this._dispatchAlgoliaResponse.bind(this, n, s)).catch(this._dispatchAlgoliaError.bind(this, s));
        } catch (e) {
          this.emit("error", {
            error: e
          });
        }
      }, D.prototype._dispatchAlgoliaResponse = function (e, t, n) {
        if (!(t < this._lastQueryIdReceived)) {
          this._currentNbQueries -= t - this._lastQueryIdReceived, this._lastQueryIdReceived = t, 0 === this._currentNbQueries && this.emit("searchQueueEmpty");
          var r = n.results.slice();
          e.forEach(function (e) {
            var t = e.state,
              n = e.queriesCount,
              i = e.helper,
              a = r.splice(0, n),
              s = i.lastResults = new jr(t, a);
            i.emit("result", {
              results: s,
              state: t
            });
          });
        }
      }, D.prototype._dispatchAlgoliaError = function (e, t) {
        e < this._lastQueryIdReceived || (this._currentNbQueries -= e - this._lastQueryIdReceived, this._lastQueryIdReceived = e, this.emit("error", {
          error: t
        }), 0 === this._currentNbQueries && this.emit("searchQueueEmpty"));
      }, D.prototype.containsRefinement = function (e, t, n, r) {
        return e || 0 !== t.length || 0 !== n.length || 0 !== r.length;
      }, D.prototype._hasDisjunctiveRefinements = function (e) {
        return this.state.disjunctiveRefinements[e] && 0 < this.state.disjunctiveRefinements[e].length;
      }, D.prototype._change = function (e) {
        var t = e.state,
          n = e.isPageReset;
        t !== this.state && (this.state = t, this.emit("change", {
          state: this.state,
          results: this.lastResults,
          isPageReset: n
        }));
      }, D.prototype.clearCache = function () {
        return this.client.clearCache && this.client.clearCache(), this;
      }, D.prototype.setClient = function (e) {
        return this.client === e || ("function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (3.8.2)"), this.client = e), this;
      }, D.prototype.getClient = function () {
        return this.client;
      }, D.prototype.derive = function (e) {
        var t = new Nr(this, e);
        return this.derivedHelpers.push(t), t;
      }, D.prototype.detachDerivedHelper = function (e) {
        var t = this.derivedHelpers.indexOf(e);
        if (-1 === t) throw new Error("Derived helper already detached");
        this.derivedHelpers.splice(t, 1);
      }, D.prototype.hasPendingRequests = function () {
        return 0 < this._currentNbQueries;
      };
      var Ar = D;
      H.version = Tr, H.AlgoliaSearchHelper = Ar, H.SearchParameters = yr, H.SearchResults = jr;
      var Dr = H,
        Lr = Promise.resolve(),
        Mr = V(function (e, t) {
          !function (e) {
            function t(e) {
              "}" === e.n.substr(e.n.length - 1) && (e.n = e.n.substring(0, e.n.length - 1));
            }
            function n(e) {
              return e.trim ? e.trim() : e.replace(/^\s*|\s*$/g, "");
            }
            function r(e, t, n) {
              if (t.charAt(n) != e.charAt(0)) return !1;
              for (var r = 1, i = e.length; r < i; r++) if (t.charAt(n + r) != e.charAt(r)) return !1;
              return !0;
            }
            function i(e, t) {
              for (var n = 0, r = t.length; n < r; n++) if (t[n].o == e.n) return e.tag = "#", !0;
            }
            function a(e, t, n) {
              for (var r = 0, i = n.length; r < i; r++) if (n[r].c == e && n[r].o == t) return !0;
            }
            function s(e) {
              var t = [];
              for (var n in e.partials) t.push('"' + o(n) + '":{name:"' + o(e.partials[n].name) + '", ' + s(e.partials[n]) + "}");
              return "partials: {" + t.join(",") + "}, subs: " + function (e) {
                var t = [];
                for (var n in e) t.push('"' + o(n) + '": function(c,p,t,i) {' + e[n] + "}");
                return "{ " + t.join(",") + " }";
              }(e.subs);
            }
            function o(e) {
              return e.replace(g, "\\\\").replace(d, '\\"').replace(p, "\\n").replace(m, "\\r").replace(v, "\\u2028").replace(y, "\\u2029");
            }
            function c(e) {
              return ~e.indexOf(".") ? "d" : "f";
            }
            function u(e, t) {
              var n = "<" + (t.prefix || "") + e.n + R++;
              return t.partials[n] = {
                name: e.n,
                partials: {}
              }, t.code += 't.b(t.rp("' + o(n) + '",c,p,"' + (e.indent || "") + '"));', n;
            }
            function l(e, t) {
              t.code += "t.b(t.t(t." + c(e.n) + '("' + o(e.n) + '",c,p,0)));';
            }
            function f(e) {
              return "t.b(" + e + ");";
            }
            var h = /\S/,
              d = /\"/g,
              p = /\n/g,
              m = /\r/g,
              g = /\\/g,
              v = /\u2028/,
              y = /\u2029/;
            e.tags = {
              "#": 1,
              "^": 2,
              "<": 3,
              $: 4,
              "/": 5,
              "!": 6,
              ">": 7,
              "=": 8,
              _v: 9,
              "{": 10,
              "&": 11,
              _t: 12
            }, e.scan = function (i, a) {
              function s() {
                0 < y.length && (b.push({
                  tag: "_t",
                  text: new String(y)
                }), y = "");
              }
              function o(t, n) {
                if (s(), t && function () {
                  for (var t = !0, n = _; n < b.length; n++) if (!(t = e.tags[b[n].tag] < e.tags._v || "_t" == b[n].tag && null === b[n].text.match(h))) return !1;
                  return t;
                }()) for (var r, i = _; i < b.length; i++) b[i].text && ((r = b[i + 1]) && ">" == r.tag && (r.indent = b[i].text.toString()), b.splice(i, 1));else n || b.push({
                  tag: "\n"
                });
                R = !1, _ = b.length;
              }
              var c,
                u,
                l,
                f,
                d,
                p = i.length,
                m = 0,
                g = null,
                v = null,
                y = "",
                b = [],
                R = !1,
                S = 0,
                _ = 0,
                w = "{{",
                P = "}}";
              for (a && (a = a.split(" "), w = a[0], P = a[1]), S = 0; S < p; S++) 0 == m ? r(w, i, S) ? (--S, s(), m = 1) : "\n" == i.charAt(S) ? o(R) : y += i.charAt(S) : 1 == m ? (S += w.length - 1, m = "=" == (g = (v = e.tags[i.charAt(S + 1)]) ? i.charAt(S + 1) : "_v") ? (u = S, l = "=" + P, f = (c = i).indexOf(l, u), d = n(c.substring(c.indexOf("=", u) + 1, f)).split(" "), w = d[0], P = d[d.length - 1], S = f + l.length - 1, 0) : (v && S++, 2), R = S) : r(P, i, S) ? (b.push({
                tag: g,
                n: n(y),
                otag: w,
                ctag: P,
                i: "/" == g ? R - w.length : S + P.length
              }), y = "", S += P.length - 1, m = 0, "{" == g && ("}}" == P ? S++ : t(b[b.length - 1]))) : y += i.charAt(S);
              return o(R, !0), b;
            };
            var b = {
              _t: !0,
              "\n": !0,
              $: !0,
              "/": !0
            };
            e.stringify = function (t, n, r) {
              return "{code: function (c,p,i) { " + e.wrapMain(t.code) + " }," + s(t) + "}";
            };
            var R = 0;
            e.generate = function (t, n, r) {
              R = 0;
              var i = {
                code: "",
                subs: {},
                partials: {}
              };
              return e.walk(t, i), r.asString ? this.stringify(i, n, r) : this.makeTemplate(i, n, r);
            }, e.wrapMain = function (e) {
              return 'var t=this;t.b(i=i||"");' + e + "return t.fl();";
            }, e.template = e.Template, e.makeTemplate = function (e, t, n) {
              var r = this.makePartials(e);
              return r.code = new Function("c", "p", "i", this.wrapMain(e.code)), new this.template(r, t, this, n);
            }, e.makePartials = function (e) {
              var t,
                n = {
                  subs: {},
                  partials: e.partials,
                  name: e.name
                };
              for (t in n.partials) n.partials[t] = this.makePartials(n.partials[t]);
              for (t in e.subs) n.subs[t] = new Function("c", "p", "t", "i", e.subs[t]);
              return n;
            }, e.codegen = {
              "#": function (t, n) {
                n.code += "if(t.s(t." + c(t.n) + '("' + o(t.n) + '",c,p,1),c,p,0,' + t.i + "," + t.end + ',"' + t.otag + " " + t.ctag + '")){t.rs(c,p,function(c,p,t){', e.walk(t.nodes, n), n.code += "});c.pop();}";
              },
              "^": function (t, n) {
                n.code += "if(!t.s(t." + c(t.n) + '("' + o(t.n) + '",c,p,1),c,p,1,0,0,"")){', e.walk(t.nodes, n), n.code += "};";
              },
              ">": u,
              "<": function (t, n) {
                var r = {
                  partials: {},
                  code: "",
                  subs: {},
                  inPartial: !0
                };
                e.walk(t.nodes, r);
                var i = n.partials[u(t, n)];
                i.subs = r.subs, i.partials = r.partials;
              },
              $: function (t, n) {
                var r = {
                  subs: {},
                  code: "",
                  partials: n.partials,
                  prefix: t.n
                };
                e.walk(t.nodes, r), n.subs[t.n] = r.code, n.inPartial || (n.code += 't.sub("' + o(t.n) + '",c,p,i);');
              },
              "\n": function (e, t) {
                t.code += f('"\\n"' + (e.last ? "" : " + i"));
              },
              _v: function (e, t) {
                t.code += "t.b(t.v(t." + c(e.n) + '("' + o(e.n) + '",c,p,0)));';
              },
              _t: function (e, t) {
                t.code += f('"' + o(e.text) + '"');
              },
              "{": l,
              "&": l
            }, e.walk = function (t, n) {
              for (var r, i = 0, a = t.length; i < a; i++) (r = e.codegen[t[i].tag]) && r(t[i], n);
              return n;
            }, e.parse = function (t, n, r) {
              return function t(n, r, s, o) {
                var c,
                  u = [],
                  l = null,
                  f = null;
                for (c = s[s.length - 1]; 0 < n.length;) {
                  if (f = n.shift(), c && "<" == c.tag && !(f.tag in b)) throw new Error("Illegal content in < super tag.");
                  if (e.tags[f.tag] <= e.tags.$ || i(f, o)) s.push(f), f.nodes = t(n, f.tag, s, o);else {
                    if ("/" == f.tag) {
                      if (0 === s.length) throw new Error("Closing tag without opener: /" + f.n);
                      if (l = s.pop(), f.n != l.n && !a(f.n, l.n, o)) throw new Error("Nesting error: " + l.n + " vs. " + f.n);
                      return l.end = f.i, u;
                    }
                    "\n" == f.tag && (f.last = 0 == n.length || "\n" == n[0].tag);
                  }
                  u.push(f);
                }
                if (0 < s.length) throw new Error("missing closing tag: " + s.pop().n);
                return u;
              }(t, 0, [], (r = r || {}).sectionTags || []);
            }, e.cache = {}, e.cacheKey = function (e, t) {
              return [e, !!t.asString, !!t.disableLambda, t.delimiters, !!t.modelGet].join("||");
            }, e.compile = function (t, n) {
              n = n || {};
              var r = e.cacheKey(t, n),
                i = this.cache[r];
              if (i) {
                var a = i.partials;
                for (var s in a) delete a[s].instance;
                return i;
              }
              return i = this.generate(this.parse(this.scan(t, n.delimiters), t, n), t, n), this.cache[r] = i;
            };
          }(t);
        }),
        Hr = V(function (e, t) {
          !function (e) {
            function t(e, t, n) {
              var r;
              return t && "object" == typeof t && (void 0 !== t[e] ? r = t[e] : n && t.get && "function" == typeof t.get && (r = t.get(e))), r;
            }
            function n(e) {
              return String(null == e ? "" : e);
            }
            e.Template = function (e, t, n, r) {
              e = e || {}, this.r = e.code || this.r, this.c = n, this.options = r || {}, this.text = t || "", this.partials = e.partials || {}, this.subs = e.subs || {}, this.buf = "";
            }, e.Template.prototype = {
              r: function (e, t, n) {
                return "";
              },
              v: function (e) {
                return e = n(e), c.test(e) ? e.replace(r, "&amp;").replace(i, "&lt;").replace(a, "&gt;").replace(s, "&#39;").replace(o, "&quot;") : e;
              },
              t: n,
              render: function (e, t, n) {
                return this.ri([e], t || {}, n);
              },
              ri: function (e, t, n) {
                return this.r(e, t, n);
              },
              ep: function (e, t) {
                var n = this.partials[e],
                  r = t[n.name];
                if (n.instance && n.base == r) return n.instance;
                if ("string" == typeof r) {
                  if (!this.c) throw new Error("No compiler available.");
                  r = this.c.compile(r, this.options);
                }
                if (!r) return null;
                if (this.partials[e].base = r, n.subs) {
                  for (key in t.stackText || (t.stackText = {}), n.subs) t.stackText[key] || (t.stackText[key] = void 0 !== this.activeSub && t.stackText[this.activeSub] ? t.stackText[this.activeSub] : this.text);
                  r = function (e, t, n, r, i, a) {
                    function s() {}
                    function o() {}
                    var c;
                    o.prototype = (s.prototype = e).subs;
                    var u = new s();
                    for (c in u.subs = new o(), u.subsText = {}, u.buf = "", r = r || {}, u.stackSubs = r, u.subsText = a, t) r[c] || (r[c] = t[c]);
                    for (c in r) u.subs[c] = r[c];
                    for (c in i = i || {}, u.stackPartials = i, n) i[c] || (i[c] = n[c]);
                    for (c in i) u.partials[c] = i[c];
                    return u;
                  }(r, n.subs, n.partials, this.stackSubs, this.stackPartials, t.stackText);
                }
                return this.partials[e].instance = r;
              },
              rp: function (e, t, n, r) {
                var i = this.ep(e, n);
                return i ? i.ri(t, n, r) : "";
              },
              rs: function (e, t, n) {
                var r = e[e.length - 1];
                if (u(r)) for (var i = 0; i < r.length; i++) e.push(r[i]), n(e, t, this), e.pop();else n(e, t, this);
              },
              s: function (e, t, n, r, i, a, s) {
                var o;
                return (!u(e) || 0 !== e.length) && ("function" == typeof e && (e = this.ms(e, t, n, r, i, a, s)), o = !!e, !r && o && t && t.push("object" == typeof e ? e : t[t.length - 1]), o);
              },
              d: function (e, n, r, i) {
                var a,
                  s = e.split("."),
                  o = this.f(s[0], n, r, i),
                  c = this.options.modelGet,
                  l = null;
                if ("." === e && u(n[n.length - 2])) o = n[n.length - 1];else for (var f = 1; f < s.length; f++) o = void 0 !== (a = t(s[f], o, c)) ? (l = o, a) : "";
                return !(i && !o) && (i || "function" != typeof o || (n.push(l), o = this.mv(o, n, r), n.pop()), o);
              },
              f: function (e, n, r, i) {
                for (var a = !1, s = !1, o = this.options.modelGet, c = n.length - 1; 0 <= c; c--) if (void 0 !== (a = t(e, n[c], o))) {
                  s = !0;
                  break;
                }
                return s ? (i || "function" != typeof a || (a = this.mv(a, n, r)), a) : !i && "";
              },
              ls: function (e, t, r, i, a) {
                var s = this.options.delimiters;
                return this.options.delimiters = a, this.b(this.ct(n(e.call(t, i)), t, r)), this.options.delimiters = s, !1;
              },
              ct: function (e, t, n) {
                if (this.options.disableLambda) throw new Error("Lambda features disabled.");
                return this.c.compile(e, this.options).render(t, n);
              },
              b: function (e) {
                this.buf += e;
              },
              fl: function () {
                var e = this.buf;
                return this.buf = "", e;
              },
              ms: function (e, t, n, r, i, a, s) {
                var o,
                  c = t[t.length - 1],
                  u = e.call(c);
                return "function" == typeof u ? !!r || (o = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text, this.ls(u, c, n, o.substring(i, a), s)) : u;
              },
              mv: function (e, t, r) {
                var i = t[t.length - 1],
                  a = e.call(i);
                return "function" == typeof a ? this.ct(n(a.call(i)), i, r) : a;
              },
              sub: function (e, t, n, r) {
                var i = this.subs[e];
                i && (this.activeSub = e, i(t, n, this, r), this.activeSub = !1);
              }
            };
            var r = /&/g,
              i = /</g,
              a = />/g,
              s = /\'/g,
              o = /\"/g,
              c = /[&<>\"\']/,
              u = Array.isArray || function (e) {
                return "[object Array]" === Object.prototype.toString.call(e);
              };
          }(t);
        });
      Mr.Template = Hr.Template, Mr.template = Mr.Template;
      var qr,
        Br,
        Wr,
        Qr,
        Ur,
        Vr,
        $r = Mr,
        zr = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        },
        Kr = /[&<>"']/g,
        Jr = RegExp(Kr.source),
        Gr = {
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        },
        Yr = /&(amp|quot|lt|gt|#39);/g,
        Xr = RegExp(Yr.source),
        Zr = {
          highlightPreTag: "__ais-highlight__",
          highlightPostTag: "__/ais-highlight__"
        },
        ei = {
          highlightPreTag: "<mark>",
          highlightPostTag: "</mark>"
        },
        ti = new RegExp(/\w/i),
        ni = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/,
        ri = ve({
          name: "index-widget"
        }),
        ii = Le("Highlight"),
        ai = Le("ReverseHighlight"),
        si = Le("Snippet"),
        oi = Le("ReverseSnippet"),
        ci = String.prototype.replace,
        ui = /%20/g,
        li = "RFC3986",
        fi = {
          default: li,
          formatters: {
            RFC1738: function (e) {
              return ci.call(e, ui, "+");
            },
            RFC3986: function (e) {
              return String(e);
            }
          },
          RFC1738: "RFC1738",
          RFC3986: li
        },
        hi = Object.prototype.hasOwnProperty,
        di = Array.isArray,
        pi = function () {
          for (var e = [], t = 0; t < 256; ++t) e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
          return e;
        }(),
        mi = {
          arrayToObject: $e,
          assign: function (e, t) {
            return Object.keys(t).reduce(function (e, n) {
              return e[n] = t[n], e;
            }, e);
          },
          combine: function (e, t) {
            return [].concat(e, t);
          },
          compact: function (e) {
            for (var t = [{
                obj: {
                  o: e
                },
                prop: "o"
              }], n = [], r = 0; r < t.length; ++r) for (var i = t[r], a = i.obj[i.prop], s = Object.keys(a), o = 0; o < s.length; ++o) {
              var c = s[o],
                u = a[c];
              "object" == typeof u && null !== u && -1 === n.indexOf(u) && (t.push({
                obj: a,
                prop: c
              }), n.push(u));
            }
            return function (e) {
              for (; 1 < e.length;) {
                var t = e.pop(),
                  n = t.obj[t.prop];
                if (di(n)) {
                  for (var r = [], i = 0; i < n.length; ++i) void 0 !== n[i] && r.push(n[i]);
                  t.obj[t.prop] = r;
                }
              }
            }(t), e;
          },
          decode: function (e, t, n) {
            var r = e.replace(/\+/g, " ");
            if ("iso-8859-1" === n) return r.replace(/%[0-9a-f]{2}/gi, unescape);
            try {
              return decodeURIComponent(r);
            } catch (e) {
              return r;
            }
          },
          encode: function (e, t, n, r, i) {
            if (0 === e.length) return e;
            var a = e;
            if ("symbol" == typeof e ? a = Symbol.prototype.toString.call(e) : "string" != typeof e && (a = String(e)), "iso-8859-1" === n) return escape(a).replace(/%u[0-9a-f]{4}/gi, function (e) {
              return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
            });
            for (var s = "", o = 0; o < a.length; ++o) {
              var c = a.charCodeAt(o);
              45 === c || 46 === c || 95 === c || 126 === c || 48 <= c && c <= 57 || 65 <= c && c <= 90 || 97 <= c && c <= 122 || i === fi.RFC1738 && (40 === c || 41 === c) ? s += a.charAt(o) : c < 128 ? s += pi[c] : c < 2048 ? s += pi[192 | c >> 6] + pi[128 | 63 & c] : c < 55296 || 57344 <= c ? s += pi[224 | c >> 12] + pi[128 | c >> 6 & 63] + pi[128 | 63 & c] : (o += 1, c = 65536 + ((1023 & c) << 10 | 1023 & a.charCodeAt(o)), s += pi[240 | c >> 18] + pi[128 | c >> 12 & 63] + pi[128 | c >> 6 & 63] + pi[128 | 63 & c]);
            }
            return s;
          },
          isBuffer: function (e) {
            return !(!e || "object" != typeof e || !(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e)));
          },
          isRegExp: function (e) {
            return "[object RegExp]" === Object.prototype.toString.call(e);
          },
          maybeMap: function (e, t) {
            if (di(e)) {
              for (var n = [], r = 0; r < e.length; r += 1) n.push(t(e[r]));
              return n;
            }
            return t(e);
          },
          merge: function e(t, n, r) {
            if (!n) return t;
            if ("object" != typeof n) {
              if (di(t)) t.push(n);else {
                if (!t || "object" != typeof t) return [t, n];
                (r && (r.plainObjects || r.allowPrototypes) || !hi.call(Object.prototype, n)) && (t[n] = !0);
              }
              return t;
            }
            if (!t || "object" != typeof t) return [t].concat(n);
            var i = t;
            return di(t) && !di(n) && (i = $e(t, r)), di(t) && di(n) ? (n.forEach(function (n, i) {
              if (hi.call(t, i)) {
                var a = t[i];
                a && "object" == typeof a && n && "object" == typeof n ? t[i] = e(a, n, r) : t.push(n);
              } else t[i] = n;
            }), t) : Object.keys(n).reduce(function (t, i) {
              var a = n[i];
              return hi.call(t, i) ? t[i] = e(t[i], a, r) : t[i] = a, t;
            }, i);
          }
        },
        gi = Object.prototype.hasOwnProperty,
        vi = {
          brackets: function (e) {
            return e + "[]";
          },
          comma: "comma",
          indices: function (e, t) {
            return e + "[" + t + "]";
          },
          repeat: function (e) {
            return e;
          }
        },
        yi = Array.isArray,
        bi = Array.prototype.push,
        Ri = Date.prototype.toISOString,
        Si = fi.default,
        _i = {
          addQueryPrefix: !1,
          allowDots: !1,
          charset: "utf-8",
          charsetSentinel: !1,
          delimiter: "&",
          encode: !0,
          encoder: mi.encode,
          encodeValuesOnly: !1,
          format: Si,
          formatter: fi.formatters[Si],
          indices: !1,
          serializeDate: function (e) {
            return Ri.call(e);
          },
          skipNulls: !1,
          strictNullHandling: !1
        },
        wi = Object.prototype.hasOwnProperty,
        Pi = Array.isArray,
        Oi = {
          allowDots: !1,
          allowPrototypes: !1,
          arrayLimit: 20,
          charset: "utf-8",
          charsetSentinel: !1,
          comma: !1,
          decoder: mi.decode,
          delimiter: "&",
          depth: 5,
          ignoreQueryPrefix: !1,
          interpretNumericEntities: !1,
          parameterLimit: 1e3,
          parseArrays: !0,
          plainObjects: !1,
          strictNullHandling: !1
        },
        xi = {
          formats: fi,
          parse: function (e, t) {
            var n = function (e) {
              if (!e) return Oi;
              if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder) throw new TypeError("Decoder has to be a function.");
              if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
              var t = void 0 === e.charset ? Oi.charset : e.charset;
              return {
                allowDots: void 0 === e.allowDots ? Oi.allowDots : !!e.allowDots,
                allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : Oi.allowPrototypes,
                arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : Oi.arrayLimit,
                charset: t,
                charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : Oi.charsetSentinel,
                comma: "boolean" == typeof e.comma ? e.comma : Oi.comma,
                decoder: "function" == typeof e.decoder ? e.decoder : Oi.decoder,
                delimiter: "string" == typeof e.delimiter || mi.isRegExp(e.delimiter) ? e.delimiter : Oi.delimiter,
                depth: "number" == typeof e.depth || !1 === e.depth ? +e.depth : Oi.depth,
                ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
                interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : Oi.interpretNumericEntities,
                parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : Oi.parameterLimit,
                parseArrays: !1 !== e.parseArrays,
                plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : Oi.plainObjects,
                strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : Oi.strictNullHandling
              };
            }(t);
            if ("" === e || null == e) return n.plainObjects ? Object.create(null) : {};
            for (var r = "string" == typeof e ? function (e, t) {
                var n,
                  r = {},
                  i = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
                  a = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
                  s = i.split(t.delimiter, a),
                  o = -1,
                  c = t.charset;
                if (t.charsetSentinel) for (n = 0; n < s.length; ++n) 0 === s[n].indexOf("utf8=") && ("utf8=%E2%9C%93" === s[n] ? c = "utf-8" : "utf8=%26%2310003%3B" === s[n] && (c = "iso-8859-1"), o = n, n = s.length);
                for (n = 0; n < s.length; ++n) if (n !== o) {
                  var u,
                    l,
                    f = s[n],
                    h = f.indexOf("]="),
                    d = -1 === h ? f.indexOf("=") : h + 1;
                  (l = -1 === d ? (u = t.decoder(f, Oi.decoder, c, "key"), t.strictNullHandling ? null : "") : (u = t.decoder(f.slice(0, d), Oi.decoder, c, "key"), mi.maybeMap(Je(f.slice(d + 1), t), function (e) {
                    return t.decoder(e, Oi.decoder, c, "value");
                  }))) && t.interpretNumericEntities && "iso-8859-1" === c && (l = l.replace(/&#(\d+);/g, function (e, t) {
                    return String.fromCharCode(parseInt(t, 10));
                  })), -1 < f.indexOf("[]=") && (l = Pi(l) ? [l] : l), wi.call(r, u) ? r[u] = mi.combine(r[u], l) : r[u] = l;
                }
                return r;
              }(e, n) : e, i = n.plainObjects ? Object.create(null) : {}, a = Object.keys(r), s = 0; s < a.length; ++s) {
              var o = a[s],
                c = Ge(o, r[o], n, "string" == typeof e);
              i = mi.merge(i, c, n);
            }
            return mi.compact(i);
          },
          stringify: function (e, t) {
            var n,
              r = e,
              i = function (e) {
                if (!e) return _i;
                if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder) throw new TypeError("Encoder has to be a function.");
                var t = e.charset || _i.charset;
                if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                var n = fi.default;
                if (void 0 !== e.format) {
                  if (!gi.call(fi.formatters, e.format)) throw new TypeError("Unknown format option provided.");
                  n = e.format;
                }
                var r = fi.formatters[n],
                  i = _i.filter;
                return "function" != typeof e.filter && !yi(e.filter) || (i = e.filter), {
                  addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : _i.addQueryPrefix,
                  allowDots: void 0 === e.allowDots ? _i.allowDots : !!e.allowDots,
                  charset: t,
                  charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : _i.charsetSentinel,
                  delimiter: void 0 === e.delimiter ? _i.delimiter : e.delimiter,
                  encode: "boolean" == typeof e.encode ? e.encode : _i.encode,
                  encoder: "function" == typeof e.encoder ? e.encoder : _i.encoder,
                  encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : _i.encodeValuesOnly,
                  filter: i,
                  format: n,
                  formatter: r,
                  serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : _i.serializeDate,
                  skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : _i.skipNulls,
                  sort: "function" == typeof e.sort ? e.sort : null,
                  strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : _i.strictNullHandling
                };
              }(t);
            "function" == typeof i.filter ? r = (0, i.filter)("", r) : yi(i.filter) && (n = i.filter);
            var a,
              s = [];
            if ("object" != typeof r || null === r) return "";
            a = t && t.arrayFormat in vi ? t.arrayFormat : t && "indices" in t ? t.indices ? "indices" : "repeat" : "indices";
            var o = vi[a];
            n = n || Object.keys(r), i.sort && n.sort(i.sort);
            for (var c = 0; c < n.length; ++c) {
              var u = n[c];
              i.skipNulls && null === r[u] || ze(s, Ke(r[u], u, o, i.strictNullHandling, i.skipNulls, i.encode ? i.encoder : null, i.filter, i.sort, i.allowDots, i.serializeDate, i.format, i.formatter, i.encodeValuesOnly, i.charset));
            }
            var l = s.join(i.delimiter),
              f = !0 === i.addQueryPrefix ? "?" : "";
            return i.charsetSentinel && (f += "iso-8859-1" === i.charset ? "utf8=%26%2310003%3B&" : "utf8=%E2%9C%93&"), 0 < l.length ? f + l : "";
          }
        },
        ji = function () {
          function e(n) {
            var r = this,
              a = n.windowTitle,
              s = n.writeDelay,
              o = void 0 === s ? 400 : s,
              c = n.createURL,
              u = n.parseURL,
              l = n.getLocation;
            t(this, e), i(this, "windowTitle", void 0), i(this, "writeDelay", void 0), i(this, "_createURL", void 0), i(this, "parseURL", void 0), i(this, "getLocation", void 0), i(this, "writeTimer", void 0), i(this, "inPopState", !1), i(this, "isDisposed", !1), i(this, "latestAcknowledgedHistory", 0), this.windowTitle = a, this.writeTimer = void 0, this.writeDelay = o, this._createURL = c, this.parseURL = u, this.getLocation = l, Ne(function (e) {
              var t = e.window,
                n = r.windowTitle && r.windowTitle(r.read());
              Ye(n), r.latestAcknowledgedHistory = t.history.length;
            });
          }
          return r(e, [{
            key: "read",
            value: function () {
              return this.parseURL({
                qsModule: xi,
                location: this.getLocation()
              });
            }
          }, {
            key: "write",
            value: function (e) {
              var t = this;
              Ne(function (n) {
                var r = n.window,
                  i = t.createURL(e),
                  a = t.windowTitle && t.windowTitle(e);
                t.writeTimer && clearTimeout(t.writeTimer), t.writeTimer = setTimeout(function () {
                  Ye(a), t.shouldWrite(i) && (r.history.pushState(e, a || "", i), t.latestAcknowledgedHistory = r.history.length), t.inPopState = !1, t.writeTimer = void 0;
                }, t.writeDelay);
              });
            }
          }, {
            key: "onUpdate",
            value: function (e) {
              var t = this;
              this._onPopState = function (n) {
                t.writeTimer && (clearTimeout(t.writeTimer), t.writeTimer = void 0), t.inPopState = !0;
                var r = n.state;
                e(r || t.read());
              }, Ne(function (e) {
                e.window.addEventListener("popstate", t._onPopState);
              });
            }
          }, {
            key: "createURL",
            value: function (e) {
              return this._createURL({
                qsModule: xi,
                routeState: e,
                location: this.getLocation()
              });
            }
          }, {
            key: "dispose",
            value: function () {
              var e = this;
              this.isDisposed = !0, Ne(function (t) {
                var n = t.window;
                e._onPopState && n.removeEventListener("popstate", e._onPopState);
              }), this.writeTimer && clearTimeout(this.writeTimer), this.write({});
            }
          }, {
            key: "shouldWrite",
            value: function (e) {
              var t = this;
              return Ne(function (n) {
                var r = n.window,
                  i = !(t.isDisposed && t.latestAcknowledgedHistory !== r.history.length);
                return !t.inPopState && i && e !== r.location.href;
              });
            }
          }]), e;
        }(),
        Ii = ve({
          name: "instantsearch"
        }),
        Fi = function () {
          function e(r) {
            var a;
            t(this, e), i(h(a = n.call(this)), "client", void 0), i(h(a), "indexName", void 0), i(h(a), "insightsClient", void 0), i(h(a), "onStateChange", null), i(h(a), "helper", void 0), i(h(a), "mainHelper", void 0), i(h(a), "mainIndex", void 0), i(h(a), "started", void 0), i(h(a), "templatesConfig", void 0), i(h(a), "renderState", {}), i(h(a), "_stalledSearchDelay", void 0), i(h(a), "_searchStalledTimer", void 0), i(h(a), "_isSearchStalled", void 0), i(h(a), "_initialUiState", void 0), i(h(a), "_initialResults", void 0), i(h(a), "_createURL", void 0), i(h(a), "_searchFunction", void 0), i(h(a), "_mainHelperSearch", void 0), i(h(a), "middleware", []), i(h(a), "sendEventToInsights", void 0), i(h(a), "scheduleSearch", q(function () {
              a.started && a.mainHelper.search();
            })), i(h(a), "scheduleRender", q(function () {
              a.mainHelper.hasPendingRequests() || (clearTimeout(a._searchStalledTimer), a._searchStalledTimer = null, a._isSearchStalled = !1), a.mainIndex.render({
                instantSearchInstance: h(a)
              }), a.emit("render");
            })), i(h(a), "onInternalStateChange", q(function () {
              var e = a.mainIndex.getWidgetUiState({});
              a.middleware.forEach(function (t) {
                t.instance.onStateChange({
                  uiState: e
                });
              });
            }));
            var s = r.indexName,
              c = void 0 === s ? null : s,
              u = r.numberLocale,
              l = r.initialUiState,
              f = void 0 === l ? {} : l,
              d = r.routing,
              p = void 0 === d ? null : d,
              m = r.searchFunction,
              g = r.stalledSearchDelay,
              v = void 0 === g ? 200 : g,
              y = r.searchClient,
              b = void 0 === y ? null : y,
              R = r.insightsClient,
              S = void 0 === R ? null : R,
              _ = r.onStateChange,
              w = void 0 === _ ? null : _;
            if (null === c) throw new Error(Ii("The `indexName` option is required."));
            if (null === b) throw new Error(Ii("The `searchClient` option is required."));
            if ("function" != typeof b.search) throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
            if ("function" == typeof b.addAlgoliaAgent && b.addAlgoliaAgent("instantsearch.js (".concat("4.41.0", ")")), S && "function" != typeof S) throw new Error(Ii("The `insightsClient` option should be a function."));
            if (a.client = b, a.insightsClient = S, a.indexName = c, a.helper = null, a.mainHelper = null, a.mainIndex = Ae({
              indexName: c
            }), a.onStateChange = w, a.started = !1, a.templatesConfig = {
              helpers: function (e) {
                var t = e.numberLocale;
                return {
                  formatNumber: function (e, n) {
                    return Number(n(e)).toLocaleString(t);
                  },
                  highlight: function (e, t) {
                    try {
                      return t(Me(o(o({}, JSON.parse(e)), {}, {
                        hit: this
                      })));
                    } catch (e) {
                      throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
                    }
                  },
                  reverseHighlight: function (e, t) {
                    try {
                      return t(He(o(o({}, JSON.parse(e)), {}, {
                        hit: this
                      })));
                    } catch (e) {
                      throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
                    }
                  },
                  snippet: function (e, t) {
                    try {
                      return t(qe(o(o({}, JSON.parse(e)), {}, {
                        hit: this
                      })));
                    } catch (e) {
                      throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
                    }
                  },
                  reverseSnippet: function (e, t) {
                    try {
                      return t(Be(o(o({}, JSON.parse(e)), {}, {
                        hit: this
                      })));
                    } catch (e) {
                      throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
                    }
                  },
                  insights: function (e, t) {
                    try {
                      var n = JSON.parse(e),
                        r = n.method,
                        i = n.payload;
                      return t(We(r, o({
                        objectIDs: [this.objectID]
                      }, i)));
                    } catch (e) {
                      throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }');
                    }
                  }
                };
              }({
                numberLocale: u
              }),
              compileOptions: {}
            }, a._stalledSearchDelay = v, a._searchStalledTimer = null, a._isSearchStalled = !1, a._createURL = nt, a._initialUiState = f, a._initialResults = null, m && (a._searchFunction = m), a.sendEventToInsights = Z, p) {
              var P = "boolean" == typeof p ? void 0 : p;
              a.use(Ze(P));
            }
            return et() && a.use(tt()), a;
          }
          c(e, Ir);
          var n = d(e);
          return r(e, [{
            key: "use",
            value: function () {
              for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              var i = n.map(function (t) {
                var n = o({
                  subscribe: Z,
                  unsubscribe: Z,
                  onStateChange: Z
                }, t({
                  instantSearchInstance: e
                }));
                return e.middleware.push({
                  creator: t,
                  instance: n
                }), n;
              });
              return this.started && i.forEach(function (e) {
                e.subscribe();
              }), this;
            }
          }, {
            key: "unuse",
            value: function () {
              for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
              return this.middleware.filter(function (e) {
                return t.includes(e.creator);
              }).forEach(function (e) {
                return e.instance.unsubscribe();
              }), this.middleware = this.middleware.filter(function (e) {
                return !t.includes(e.creator);
              }), this;
            }
          }, {
            key: "EXPERIMENTAL_use",
            value: function () {
              return this.use.apply(this, arguments);
            }
          }, {
            key: "addWidget",
            value: function (e) {
              return this.addWidgets([e]);
            }
          }, {
            key: "addWidgets",
            value: function (e) {
              if (!Array.isArray(e)) throw new Error(Ii("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
              if (e.some(function (e) {
                return "function" != typeof e.init && "function" != typeof e.render;
              })) throw new Error(Ii("The widget definition expects a `render` and/or an `init` method."));
              return this.mainIndex.addWidgets(e), this;
            }
          }, {
            key: "removeWidget",
            value: function (e) {
              return this.removeWidgets([e]);
            }
          }, {
            key: "removeWidgets",
            value: function (e) {
              if (!Array.isArray(e)) throw new Error(Ii("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
              if (e.some(function (e) {
                return "function" != typeof e.dispose;
              })) throw new Error(Ii("The widget definition expects a `dispose` method."));
              return this.mainIndex.removeWidgets(e), this;
            }
          }, {
            key: "start",
            value: function () {
              var e = this;
              if (this.started) throw new Error(Ii("The `start` method has already been called once."));
              var t = this.mainHelper || Dr(this.client, this.indexName);
              if (t.search = function () {
                return t.searchOnlyWithDerivedHelpers();
              }, this._searchFunction) {
                var n = {
                  search: function () {
                    return new Promise(Z);
                  }
                };
                this._mainHelperSearch = t.search.bind(t), t.search = function () {
                  var r = e.mainIndex.getHelper(),
                    i = Dr(n, r.state.index, r.state);
                  return i.once("search", function (t) {
                    var n = t.state;
                    r.overrideStateWithoutTriggeringChangeEvent(n), e._mainHelperSearch();
                  }), i.on("change", function (e) {
                    var t = e.state;
                    r.setState(t);
                  }), e._searchFunction(i), t;
                };
              }
              if (t.on("error", function (t) {
                var n = t.error;
                n.error = n, e.emit("error", n);
              }), this.mainHelper = t, this.middleware.forEach(function (e) {
                e.instance.subscribe();
              }), this.mainIndex.init({
                instantSearchInstance: this,
                parent: null,
                uiState: this._initialUiState
              }), this._initialResults) {
                var r = this.scheduleSearch;
                this.scheduleSearch = q(Z), q(function () {
                  e.scheduleSearch = r;
                })();
              } else 0 < this.mainIndex.getWidgets().length && this.scheduleSearch();
              this.helper = this.mainIndex.getHelper(), this.started = !0;
            }
          }, {
            key: "dispose",
            value: function () {
              this.scheduleSearch.cancel(), this.scheduleRender.cancel(), clearTimeout(this._searchStalledTimer), this.removeWidgets(this.mainIndex.getWidgets()), this.mainIndex.dispose(), this.started = !1, this.removeAllListeners(), this.mainHelper.removeAllListeners(), this.mainHelper = null, this.helper = null, this.middleware.forEach(function (e) {
                e.instance.unsubscribe();
              });
            }
          }, {
            key: "scheduleStalledRender",
            value: function () {
              var e = this;
              this._searchStalledTimer || (this._searchStalledTimer = setTimeout(function () {
                e._isSearchStalled = !0, e.scheduleRender();
              }, this._stalledSearchDelay));
            }
          }, {
            key: "setUiState",
            value: function (e) {
              if (!this.mainHelper) throw new Error(Ii("The `start` method needs to be called before `setUiState`."));
              this.mainIndex.refreshUiState();
              var t = "function" == typeof e ? e(this.mainIndex.getWidgetUiState({})) : e;
              !function e(n) {
                var r = t[n.getIndexId()] || {};
                n.getHelper().setState(n.getWidgetSearchParameters(n.getHelper().state, {
                  uiState: r
                })), n.getWidgets().filter(Ee).forEach(e);
              }(this.mainIndex), this.scheduleSearch(), this.onInternalStateChange();
            }
          }, {
            key: "getUiState",
            value: function () {
              return this.started && this.mainIndex.refreshUiState(), this.mainIndex.getWidgetUiState({});
            }
          }, {
            key: "createURL",
            value: function (e) {
              var t = 0 < arguments.length && void 0 !== e ? e : {};
              if (!this.started) throw new Error(Ii("The `start` method needs to be called before `createURL`."));
              return this._createURL(t);
            }
          }, {
            key: "refresh",
            value: function () {
              if (!this.mainHelper) throw new Error(Ii("The `start` method needs to be called before `refresh`."));
              this.mainHelper.clearCache().search();
            }
          }]), e;
        }(),
        Ni = ve({
          name: "clear-refinements",
          connector: !0
        }),
        Ei = ve({
          name: "current-refinements",
          connector: !0
        }),
        Ci = ve({
          name: "hierarchical-menu",
          connector: !0
        }),
        Ti = ["name:asc"],
        ki = ve({
          name: "hits",
          connector: !0
        }),
        Ai = {},
        Di = [],
        Li = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
      qr = Di.slice, Br = {
        __e: function (e, t) {
          for (var n, r, i; t = t.__;) if ((n = t.__c) && !n.__) try {
            if ((r = n.constructor) && null != r.getDerivedStateFromError && (n.setState(r.getDerivedStateFromError(e)), i = n.__d), null != n.componentDidCatch && (n.componentDidCatch(e), i = n.__d), i) return n.__E = n;
          } catch (t) {
            e = t;
          }
          throw e;
        }
      }, Wr = 0, yt.prototype.setState = function (e, t) {
        var n;
        n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = dt({}, this.state), "function" == typeof e && (e = e(dt({}, n), this.props)), e && dt(n, e), null != e && this.__v && (t && this.__h.push(t), St(this));
      }, yt.prototype.forceUpdate = function (e) {
        this.__v && (this.__e = !0, e && this.__h.push(e), St(this));
      }, yt.prototype.render = vt, Qr = [], Ur = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, _t.__r = 0;
      var Mi = ht(lt),
        Hi = ve({
          name: "hits-per-page",
          connector: !0
        }),
        qi = ve({
          name: "infinite-hits",
          connector: !0
        }),
        Bi = ht(qt),
        Wi = ve({
          name: "menu",
          connector: !0
        }),
        Qi = ["isRefined", "name:asc"],
        Ui = ve({
          name: "numeric-menu",
          connector: !0
        }),
        Vi = "ais.numericMenu",
        $i = function () {
          function e(n) {
            t(this, e), i(this, "currentPage", void 0), i(this, "total", void 0), i(this, "padding", void 0), this.currentPage = n.currentPage, this.total = n.total, this.padding = n.padding;
          }
          return r(e, [{
            key: "pages",
            value: function () {
              var e = this.total,
                t = this.currentPage,
                n = this.padding;
              if (0 === e) return [0];
              var r = this.nbPagesDisplayed(n, e);
              if (r === e) return ie({
                end: e
              });
              var i = this.calculatePaddingLeft(t, n, e, r);
              return ie({
                start: t - i,
                end: t + (r - i)
              });
            }
          }, {
            key: "nbPagesDisplayed",
            value: function (e, t) {
              return Math.min(2 * e + 1, t);
            }
          }, {
            key: "calculatePaddingLeft",
            value: function (e, t, n, r) {
              return e <= t ? e : n - t <= e ? r - (n - e) : t;
            }
          }, {
            key: "isLastPage",
            value: function () {
              return this.currentPage === this.total - 1 || 0 === this.total;
            }
          }, {
            key: "isFirstPage",
            value: function () {
              return 0 === this.currentPage;
            }
          }]), e;
        }(),
        zi = ve({
          name: "pagination",
          connector: !0
        }),
        Ki = ve({
          name: "range-input",
          connector: !0
        }, {
          name: "range-slider",
          connector: !0
        }),
        Ji = "ais.range",
        Gi = ve({
          name: "refinement-list",
          connector: !0
        }),
        Yi = ["isRefined", "count:desc", "name:asc"],
        Xi = ve({
          name: "search-box",
          connector: !0
        }),
        Zi = ve({
          name: "sort-by",
          connector: !0
        }),
        ea = ve({
          name: "rating-menu",
          connector: !0
        }),
        ta = "ais.ratingMenu",
        na = ve({
          name: "stats",
          connector: !0
        }),
        ra = ve({
          name: "toggle-refinement",
          connector: !0
        }),
        ia = "ais.toggleRefinement",
        aa = ve({
          name: "breadcrumb",
          connector: !0
        }),
        sa = ve({
          name: "geo-search",
          connector: !0
        }),
        oa = "ais.geoSearch",
        ca = ve({
          name: "powered-by",
          connector: !0
        }),
        ua = ve({
          name: "configure",
          connector: !0
        }),
        la = ve({
          name: "configure-related-items",
          connector: !0
        }),
        fa = ve({
          name: "autocomplete",
          connector: !0
        }),
        ha = ve({
          name: "query-rules",
          connector: !0
        }),
        da = ve({
          name: "voice-search",
          connector: !0
        }),
        pa = ve({
          name: "answers",
          connector: !0
        }),
        ma = ve({
          name: "dynamic-widgets",
          connector: !0
        }),
        ga = ee(yn),
        va = Object.freeze({
          __proto__: null,
          connectDynamicWidgets: yn,
          EXPERIMENTAL_connectDynamicWidgets: ga,
          connectClearRefinements: rt,
          connectCurrentRefinements: it,
          connectHierarchicalMenu: ut,
          connectHits: lt,
          connectHitsWithInsights: Mi,
          connectHitsPerPage: Mt,
          connectInfiniteHits: qt,
          connectInfiniteHitsWithInsights: Bi,
          connectMenu: Bt,
          connectNumericMenu: Wt,
          connectPagination: $t,
          connectRange: Kt,
          connectRefinementList: Jt,
          connectSearchBox: Yt,
          connectSortBy: Xt,
          connectRatingMenu: Zt,
          connectStats: en,
          connectToggleRefinement: tn,
          connectBreadcrumb: nn,
          connectGeoSearch: sn,
          connectPoweredBy: on,
          connectConfigure: un,
          EXPERIMENTAL_connectConfigureRelatedItems: fn,
          connectAutocomplete: function (e, t) {
            var n = 1 < arguments.length && void 0 !== t ? t : Z;
            return X(e, fa()), function (t) {
              var r = (t || {}).escapeHTML,
                a = void 0 === r || r,
                s = {};
              return {
                $$type: "ais.autocomplete",
                init: function (t) {
                  var n = t.instantSearchInstance;
                  e(o(o({}, this.getWidgetRenderState(t)), {}, {
                    instantSearchInstance: n
                  }), !0);
                },
                render: function (t) {
                  var n = t.instantSearchInstance,
                    r = this.getWidgetRenderState(t);
                  r.indices.forEach(function (e) {
                    (0, e.sendEvent)("view", e.hits);
                  }), e(o(o({}, r), {}, {
                    instantSearchInstance: n
                  }), !1);
                },
                getRenderState: function (e, t) {
                  return o(o({}, e), {}, {
                    autocomplete: this.getWidgetRenderState(t)
                  });
                },
                getWidgetRenderState: function (e) {
                  var n = this,
                    r = e.helper,
                    i = e.state,
                    o = e.scopedResults,
                    c = e.instantSearchInstance;
                  s.refine || (s.refine = function (e) {
                    r.setQuery(e).search();
                  });
                  var u = o.map(function (e) {
                    e.results.hits = a ? ue(e.results.hits) : e.results.hits;
                    var t = Oe({
                      instantSearchInstance: c,
                      index: e.results.index,
                      widgetType: n.$$type
                    });
                    return {
                      indexId: e.indexId,
                      indexName: e.results.index,
                      hits: e.results.hits,
                      results: e.results,
                      sendEvent: t
                    };
                  });
                  return {
                    currentRefinement: i.query || "",
                    indices: u,
                    refine: s.refine,
                    widgetParams: t
                  };
                },
                getWidgetUiState: function (e, t) {
                  var n = t.searchParameters.query || "";
                  return "" === n || e && e.query === n ? e : o(o({}, e), {}, {
                    query: n
                  });
                },
                getWidgetSearchParameters: function (e, t) {
                  var n = {
                    query: t.uiState.query || ""
                  };
                  return a ? e.setQueryParameters(o(o({}, n), Zr)) : e.setQueryParameters(n);
                },
                dispose: function (e) {
                  var t = e.state;
                  n();
                  var r = t.setQueryParameter("query", void 0);
                  return a ? r.setQueryParameters(Object.keys(Zr).reduce(function (e, t) {
                    return o(o({}, e), {}, i({}, t, void 0));
                  }, {})) : r;
                }
              };
            };
          },
          connectQueryRules: dn,
          connectVoiceSearch: mn,
          EXPERIMENTAL_connectAnswers: gn,
          connectRelevantSort: vn
        }),
        ya = ve({
          name: "analytics"
        }),
        ba = V(function (e) {
          function t() {
            for (var e = [], r = 0; r < arguments.length; r++) {
              var i = arguments[r];
              if (i) {
                var a = typeof i;
                if ("string" == a || "number" == a) e.push(i);else if (Array.isArray(i) && i.length) {
                  var s = t.apply(null, i);
                  s && e.push(s);
                } else if ("object" == a) for (var o in i) n.call(i, o) && i[o] && e.push(o);
              }
            }
            return e.join(" ");
          }
          var n;
          n = {}.hasOwnProperty, e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
        }),
        Ra = function () {
          function e() {
            return t(this, e), n.apply(this, arguments);
          }
          c(e, yt);
          var n = d(e);
          return r(e, [{
            key: "shouldComponentUpdate",
            value: function (e) {
              return !se(this.props.data, e.data) || this.props.templateKey !== e.templateKey || !se(this.props.rootProps, e.rootProps);
            }
          }, {
            key: "render",
            value: function () {
              var e = this.props.rootTagName,
                t = this.props.useCustomCompileOptions[this.props.templateKey] ? this.props.templatesConfig.compileOptions : {},
                n = $({
                  templates: this.props.templates,
                  templateKey: this.props.templateKey,
                  compileOptions: t,
                  helpers: this.props.templatesConfig.helpers,
                  data: this.props.data,
                  bindEvent: this.props.bindEvent
                });
              return null === n ? null : mt(e, a({}, this.props.rootProps, {
                dangerouslySetInnerHTML: {
                  __html: n
                }
              }));
            }
          }]), e;
        }();
      i(Ra, "defaultProps", {
        data: {},
        rootTagName: "div",
        useCustomCompileOptions: {},
        templates: {},
        templatesConfig: {}
      });
      var Sa = {
          home: "Home",
          separator: ">"
        },
        _a = ve({
          name: "breadcrumb"
        }),
        wa = Le("Breadcrumb"),
        Pa = {
          resetLabel: "Clear refinements"
        },
        Oa = ve({
          name: "clear-refinements"
        }),
        xa = Le("ClearRefinements"),
        ja = ve({
          name: "current-refinements"
        }),
        Ia = Le("CurrentRefinements"),
        Fa = {
          header: "",
          loader: "",
          item: function (e) {
            return JSON.stringify(e);
          }
        },
        Na = ve({
          name: "answers"
        }),
        Ea = Le("Answers"),
        Ca = ve({
          name: "dynamic-widgets"
        }),
        Ta = Le("DynamicWidgets"),
        ka = {
          HTMLMarker: "<p>Your custom HTML Marker</p>",
          reset: "Clear the map refinement",
          toggle: "Search as I move the map",
          redo: "Redo search here"
        },
        Aa = ve({
          name: "geo-search"
        }),
        Da = Le("GeoSearch"),
        La = {
          query: "",
          showSubmit: !0,
          showReset: !0,
          showLoadingIndicator: !0,
          autofocus: !1,
          searchAsYouType: !0,
          isSearchStalled: !1,
          disabled: !1,
          onChange: Z,
          onSubmit: Z,
          onReset: Z,
          refine: Z
        },
        Ma = function () {
          function e() {
            var r;
            t(this, e);
            for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++) s[o] = arguments[o];
            return i(h(r = n.call.apply(n, [this].concat(s))), "state", {
              query: r.props.query,
              focused: !1
            }), i(h(r), "input", {
              current: null
            }), i(h(r), "onInput", function (e) {
              var t = r.props,
                n = t.searchAsYouType,
                i = t.refine,
                a = t.onChange,
                s = e.target.value;
              n && i(s), r.setState({
                query: s
              }), a(e);
            }), i(h(r), "onSubmit", function (e) {
              var t = r.props,
                n = t.searchAsYouType,
                i = t.refine,
                a = t.onSubmit;
              return e.preventDefault(), e.stopPropagation(), r.input.current && r.input.current.blur(), n || i(r.state.query), a(e), !1;
            }), i(h(r), "onReset", function (e) {
              var t = r.props,
                n = t.refine,
                i = t.onReset;
              r.input.current && r.input.current.focus(), n(""), r.setState({
                query: ""
              }), i(e);
            }), i(h(r), "onBlur", function () {
              r.setState({
                focused: !1
              });
            }), i(h(r), "onFocus", function () {
              r.setState({
                focused: !0
              });
            }), r;
          }
          c(e, yt);
          var n = d(e);
          return r(e, [{
            key: "resetInput",
            value: function () {
              this.setState({
                query: ""
              });
            }
          }, {
            key: "componentWillReceiveProps",
            value: function (e) {
              this.state.focused || e.query === this.state.query || this.setState({
                query: e.query
              });
            }
          }, {
            key: "render",
            value: function () {
              var e = this.props,
                t = e.cssClasses,
                n = e.placeholder,
                r = e.autofocus,
                i = e.showSubmit,
                a = e.showReset,
                s = e.showLoadingIndicator,
                o = e.templates,
                c = e.isSearchStalled;
              return mt("div", {
                className: t.root
              }, mt("form", {
                action: "",
                role: "search",
                className: t.form,
                noValidate: !0,
                onSubmit: this.onSubmit,
                onReset: this.onReset
              }, mt("input", {
                ref: this.input,
                value: this.state.query,
                disabled: this.props.disabled,
                className: t.input,
                type: "search",
                placeholder: n,
                autoFocus: r,
                autoComplete: "off",
                autoCorrect: "off",
                autoCapitalize: "off",
                spellCheck: "false",
                maxLength: 512,
                onInput: this.onInput,
                onBlur: this.onBlur,
                onFocus: this.onFocus
              }), mt(Ra, {
                templateKey: "submit",
                rootTagName: "button",
                rootProps: {
                  className: t.submit,
                  type: "submit",
                  title: "Submit the search query.",
                  hidden: !i
                },
                templates: o,
                data: {
                  cssClasses: t
                }
              }), mt(Ra, {
                templateKey: "reset",
                rootTagName: "button",
                rootProps: {
                  className: t.reset,
                  type: "reset",
                  title: "Clear the search query.",
                  hidden: !(a && this.state.query.trim() && !c)
                },
                templates: o,
                data: {
                  cssClasses: t
                }
              }), s && mt(Ra, {
                templateKey: "loadingIndicator",
                rootTagName: "span",
                rootProps: {
                  className: t.loadingIndicator,
                  hidden: !c
                },
                templates: o,
                data: {
                  cssClasses: t
                }
              })));
            }
          }]), e;
        }();
      i(Ma, "defaultProps", La);
      var Ha = function () {
        function e(r) {
          var a;
          return t(this, e), i(h(a = n.call(this, r)), "searchBox", {
            current: null
          }), a.handleItemClick = a.handleItemClick.bind(h(a)), a;
        }
        c(e, yt);
        var n = d(e);
        return r(e, [{
          key: "shouldComponentUpdate",
          value: function (e) {
            return !se(this.props.facetValues, e.facetValues);
          }
        }, {
          key: "refine",
          value: function (e) {
            this.props.toggleRefinement(e);
          }
        }, {
          key: "_generateFacetItem",
          value: function (t) {
            var n, r;
            if (Tn(t) && Array.isArray(t.data) && 0 < t.data.length) {
              var s = this.props.cssClasses,
                c = (s.root, f(s, ["root"]));
              r = mt(e, a({}, this.props, {
                cssClasses: c,
                depth: this.props.depth + 1,
                facetValues: t.data,
                showMore: !1,
                className: this.props.cssClasses.childList
              }));
            }
            var u = this.props.createURL(t.value),
              l = o(o({}, t), {}, {
                url: u,
                attribute: this.props.attribute,
                cssClasses: this.props.cssClasses,
                isFromSearch: this.props.isFromSearch
              }),
              h = t.value;
            void 0 !== t.isRefined && (h += "/".concat(t.isRefined)), void 0 !== t.count && (h += "/".concat(t.count));
            var d = ba(this.props.cssClasses.item, (i(n = {}, this.props.cssClasses.selectedItem, t.isRefined), i(n, this.props.cssClasses.disabledItem, !t.count), i(n, this.props.cssClasses.parentItem, Tn(t) && Array.isArray(t.data) && 0 < t.data.length), n));
            return mt(Cn, {
              templateKey: "item",
              key: h,
              facetValueToRefine: t.value,
              handleClick: this.handleItemClick,
              isRefined: t.isRefined,
              className: d,
              subItems: r,
              templateData: l,
              templateProps: this.props.templateProps
            });
          }
        }, {
          key: "handleItemClick",
          value: function (e) {
            var t = e.facetValueToRefine,
              n = e.isRefined,
              r = e.originalEvent;
            if (!W(r) && r.target instanceof HTMLElement && r.target.parentNode instanceof HTMLElement && (!n || !r.target.parentNode.querySelector('input[type="radio"]:checked'))) if ("INPUT" !== r.target.tagName) {
              for (var i = r.target; i !== r.currentTarget;) {
                if ("LABEL" === i.tagName && (i.querySelector('input[type="checkbox"]') || i.querySelector('input[type="radio"]'))) return;
                "A" === i.tagName && i.href && r.preventDefault(), i = i.parentNode;
              }
              r.stopPropagation(), this.refine(t);
            } else this.refine(t);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function (e) {
            this.searchBox.current && !e.isFromSearch && this.searchBox.current.resetInput();
          }
        }, {
          key: "refineFirstValue",
          value: function () {
            var e = this.props.facetValues && this.props.facetValues[0];
            if (e) {
              var t = e.value;
              this.props.toggleRefinement(t);
            }
          }
        }, {
          key: "render",
          value: function () {
            var e = this,
              t = ba(this.props.cssClasses.showMore, i({}, this.props.cssClasses.disabledShowMore, !(!0 === this.props.showMore && this.props.canToggleShowMore))),
              n = !0 === this.props.showMore && mt(Ra, a({}, this.props.templateProps, {
                templateKey: "showMoreText",
                rootTagName: "button",
                rootProps: {
                  className: t,
                  disabled: !this.props.canToggleShowMore,
                  onClick: this.props.toggleShowMore
                },
                data: {
                  isShowingMore: this.props.isShowingMore
                }
              })),
              r = !0 !== this.props.searchIsAlwaysActive && !(this.props.isFromSearch || !this.props.hasExhaustiveItems),
              s = this.props.searchFacetValues && mt("div", {
                className: this.props.cssClasses.searchBox
              }, mt(Ma, {
                ref: this.searchBox,
                placeholder: this.props.searchPlaceholder,
                disabled: r,
                cssClasses: this.props.cssClasses.searchable,
                templates: this.props.searchBoxTemplateProps.templates,
                onChange: function (t) {
                  return e.props.searchFacetValues(t.target.value);
                },
                onReset: function () {
                  return e.props.searchFacetValues("");
                },
                onSubmit: function () {
                  return e.refineFirstValue();
                },
                searchAsYouType: !1
              })),
              o = this.props.facetValues && 0 < this.props.facetValues.length && mt("ul", {
                className: this.props.cssClasses.list
              }, this.props.facetValues.map(this._generateFacetItem, this)),
              c = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || 0 === this.props.facetValues.length) && mt(Ra, a({}, this.props.templateProps, {
                templateKey: "searchableNoResults",
                rootProps: {
                  className: this.props.cssClasses.noResults
                }
              }));
            return mt("div", {
              className: ba(this.props.cssClasses.root, i({}, this.props.cssClasses.noRefinementRoot, !this.props.facetValues || 0 === this.props.facetValues.length), this.props.className)
            }, this.props.children, s, o, c, n);
          }
        }]), e;
      }();
      i(Ha, "defaultProps", {
        cssClasses: {},
        depth: 0
      });
      var qa,
        Ba,
        Wa,
        Qa = {
          item: '<a class="{{cssClasses.link}}" href="{{url}}"><span class="{{cssClasses.label}}">{{label}}</span><span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span></a>',
          showMoreText: "\n    {{#isShowingMore}}\n      Show less\n    {{/isShowingMore}}\n    {{^isShowingMore}}\n      Show more\n    {{/isShowingMore}}\n  "
        },
        Ua = ve({
          name: "hierarchical-menu"
        }),
        Va = Le("HierarchicalMenu"),
        $a = {
          empty: "No results",
          item: function (e) {
            return JSON.stringify(e, null, 2);
          }
        },
        za = ve({
          name: "hits"
        }),
        Ka = Le("Hits"),
        Ja = Lt(function (e) {
          var t = e.results,
            n = e.hits,
            r = e.bindEvent,
            i = e.cssClasses,
            s = e.templateProps;
          return 0 === t.hits.length ? mt(Ra, a({}, s, {
            templateKey: "empty",
            rootProps: {
              className: ba(i.root, i.emptyRoot)
            },
            data: t
          })) : mt("div", {
            className: i.root
          }, mt("ol", {
            className: i.list
          }, n.map(function (e, t) {
            return mt(Ra, a({}, s, {
              templateKey: "item",
              rootTagName: "li",
              rootProps: {
                className: i.item
              },
              key: e.objectID,
              data: o(o({}, e), {}, {
                __hitIndex: t
              }),
              bindEvent: r
            }));
          })));
        }),
        Ga = ve({
          name: "hits-per-page"
        }),
        Ya = Le("HitsPerPage"),
        Xa = {
          empty: "No results",
          showPreviousText: "Show previous results",
          showMoreText: "Show more results",
          item: function (e) {
            return JSON.stringify(e, null, 2);
          }
        },
        Za = ve({
          name: "infinite-hits"
        }),
        es = Le("InfiniteHits"),
        ts = Lt(function (e) {
          var t = e.results,
            n = e.hits,
            r = e.bindEvent,
            s = e.hasShowPrevious,
            c = e.showPrevious,
            u = e.showMore,
            l = e.isFirstPage,
            f = e.isLastPage,
            h = e.cssClasses,
            d = e.templateProps;
          return 0 === t.hits.length ? mt(Ra, a({}, d, {
            templateKey: "empty",
            rootProps: {
              className: ba(h.root, h.emptyRoot)
            },
            data: t
          })) : mt("div", {
            className: h.root
          }, s && mt(Ra, a({}, d, {
            templateKey: "showPreviousText",
            rootTagName: "button",
            rootProps: {
              className: ba(h.loadPrevious, i({}, h.disabledLoadPrevious, l)),
              disabled: l,
              onClick: c
            }
          })), mt("ol", {
            className: h.list
          }, n.map(function (e, t) {
            return mt(Ra, a({}, d, {
              templateKey: "item",
              rootTagName: "li",
              rootProps: {
                className: h.item
              },
              key: e.objectID,
              data: o(o({}, e), {}, {
                __hitIndex: t
              }),
              bindEvent: r
            }));
          })), mt(Ra, a({}, d, {
            templateKey: "showMoreText",
            rootTagName: "button",
            rootProps: {
              className: ba(h.loadMore, i({}, h.disabledLoadMore, f)),
              disabled: f,
              onClick: u
            }
          })));
        }),
        ns = {
          item: '<a class="{{cssClasses.link}}" href="{{url}}"><span class="{{cssClasses.label}}">{{label}}</span><span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span></a>',
          showMoreText: "\n    {{#isShowingMore}}\n      Show less\n    {{/isShowingMore}}\n    {{^isShowingMore}}\n      Show more\n    {{/isShowingMore}}\n  "
        },
        rs = ve({
          name: "menu"
        }),
        is = Le("Menu"),
        as = {
          item: "{{label}} ({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})",
          defaultOption: "See all"
        },
        ss = ve({
          name: "menu-select"
        }),
        os = Le("MenuSelect"),
        cs = {
          item: '<label class="{{cssClasses.label}}">\n  <input type="radio" class="{{cssClasses.radio}}" name="{{attribute}}"{{#isRefined}} checked{{/isRefined}} />\n  <span class="{{cssClasses.labelText}}">{{label}}</span>\n</label>'
        },
        us = ve({
          name: "numeric-menu"
        }),
        ls = Le("NumericMenu"),
        fs = Le("Pagination"),
        hs = ve({
          name: "pagination"
        }),
        ds = {
          previous: "‹",
          next: "›",
          first: "«",
          last: "»"
        },
        ps = 0,
        ms = [],
        gs = Br.__b,
        vs = Br.__r,
        ys = Br.diffed,
        bs = Br.__c,
        Rs = Br.unmount;
      Br.__b = function (e) {
        Ba = null, gs && gs(e);
      }, Br.__r = function (e) {
        vs && vs(e), qa = 0;
        var t = (Ba = e.__c).__H;
        t && (t.__h.forEach(Wn), t.__h.forEach(Qn), t.__h = []);
      }, Br.diffed = function (e) {
        ys && ys(e);
        var t = e.__c;
        t && t.__H && t.__H.__h.length && (1 !== ms.push(t) && Wa === Br.requestAnimationFrame || ((Wa = Br.requestAnimationFrame) || function (e) {
          function t() {
            clearTimeout(r), Ss && cancelAnimationFrame(n), setTimeout(e);
          }
          var n,
            r = setTimeout(t, 100);
          Ss && (n = requestAnimationFrame(t));
        })(Bn)), Ba = null;
      }, Br.__c = function (e, t) {
        t.some(function (e) {
          try {
            e.__h.forEach(Wn), e.__h = e.__h.filter(function (e) {
              return !e.__ || Qn(e);
            });
          } catch (n) {
            t.some(function (e) {
              e.__h && (e.__h = []);
            }), t = [], Br.__e(n, e.__v);
          }
        }), bs && bs(e, t);
      }, Br.unmount = function (e) {
        Rs && Rs(e);
        var t,
          n = e.__c;
        n && n.__H && (n.__H.__.forEach(function (e) {
          try {
            Wn(e);
          } catch (e) {
            t = e;
          }
        }), t && Br.__e(t, n.__v));
      };
      var Ss = "function" == typeof requestAnimationFrame,
        _s = ve({
          name: "panel"
        }),
        ws = Le("Panel"),
        Ps = mt("path", {
          fill: "#5468FF",
          d: "M78.99.94h16.6a2.97 2.97 0 012.96 2.96v16.6a2.97 2.97 0 01-2.97 2.96h-16.6a2.97 2.97 0 01-2.96-2.96V3.9A2.96 2.96 0 0179 .94"
        }),
        Os = mt("path", {
          fill: "#FFF",
          d: "M89.63 5.97v-.78a.98.98 0 00-.98-.97h-2.28a.98.98 0 00-.97.97V6c0 .09.08.15.17.13a7.13 7.13 0 013.9-.02c.08.02.16-.04.16-.13m-6.25 1L83 6.6a.98.98 0 00-1.38 0l-.46.46a.97.97 0 000 1.38l.38.39c.06.06.15.04.2-.02a7.49 7.49 0 011.63-1.62c.07-.04.08-.14.02-.2m4.16 2.45v3.34c0 .1.1.17.2.12l2.97-1.54c.06-.03.08-.12.05-.18a3.7 3.7 0 00-3.08-1.87c-.07 0-.14.06-.14.13m0 8.05a4.49 4.49 0 110-8.98 4.49 4.49 0 010 8.98m0-10.85a6.37 6.37 0 100 12.74 6.37 6.37 0 000-12.74"
        }),
        xs = Le("PoweredBy"),
        js = ve({
          name: "powered-by"
        }),
        Is = ve({
          name: "query-rule-context"
        }),
        Fs = {
          default: function (e) {
            var t = e.items;
            return JSON.stringify(t, null, 2);
          }
        },
        Ns = ve({
          name: "query-rule-custom-data"
        }),
        Es = Le("QueryRuleCustomData"),
        Cs = function () {
          function e() {
            var r;
            t(this, e);
            for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++) s[o] = arguments[o];
            return i(h(r = n.call.apply(n, [this].concat(s))), "state", {
              min: r.props.values.min,
              max: r.props.values.max
            }), i(h(r), "onInput", function (e) {
              return function (t) {
                var n = t.currentTarget.value;
                r.setState(i({}, e, Number(n)));
              };
            }), i(h(r), "onSubmit", function (e) {
              e.preventDefault(), r.props.refine([r.state.min, r.state.max]);
            }), r;
          }
          c(e, yt);
          var n = d(e);
          return r(e, [{
            key: "componentWillReceiveProps",
            value: function (e) {
              this.setState({
                min: e.values.min,
                max: e.values.max
              });
            }
          }, {
            key: "render",
            value: function () {
              var e = this.state,
                t = e.min,
                n = e.max,
                r = this.props,
                s = r.min,
                o = r.max,
                c = r.step,
                u = r.cssClasses,
                l = r.templateProps,
                f = !(!s || !o) && o <= s,
                h = Boolean(t || n);
              return mt("div", {
                className: ba(u.root, i({}, u.noRefinement, !h))
              }, mt("form", {
                className: u.form,
                onSubmit: this.onSubmit
              }, mt("label", {
                className: u.label
              }, mt("input", {
                className: ba(u.input, u.inputMin),
                type: "number",
                min: s,
                max: o,
                step: c,
                value: null != t ? t : "",
                onInput: this.onInput("min"),
                placeholder: null == s ? void 0 : s.toString(),
                disabled: f
              })), mt(Ra, a({}, l, {
                templateKey: "separatorText",
                rootTagName: "span",
                rootProps: {
                  className: u.separator
                }
              })), mt("label", {
                className: u.label
              }, mt("input", {
                className: ba(u.input, u.inputMax),
                type: "number",
                min: s,
                max: o,
                step: c,
                value: null != n ? n : "",
                onInput: this.onInput("max"),
                placeholder: null == o ? void 0 : o.toString(),
                disabled: f
              })), mt(Ra, a({}, l, {
                templateKey: "submitText",
                rootTagName: "button",
                rootProps: {
                  type: "submit",
                  className: u.submit,
                  disabled: f
                }
              }))));
            }
          }]), e;
        }(),
        Ts = ve({
          name: "range-input"
        }),
        ks = Le("RangeInput"),
        As = {
          separatorText: "to",
          submitText: "Go"
        },
        Ds = 40,
        Ls = 35,
        Ms = 27,
        Hs = 36,
        qs = 37,
        Bs = 34,
        Ws = 33,
        Qs = 39,
        Us = 38,
        Vs = 100,
        $s = mt("div", {
          className: "rheostat-background"
        }),
        zs = function () {
          function e(r) {
            var a;
            return t(this, e), i(h(a = n.call(this, r)), "state", {
              className: Yn(a.props),
              handlePos: a.props.values.map(function (e) {
                return Jn(e, a.props.min, a.props.max);
              }),
              handleDimensions: 0,
              mousePos: null,
              sliderBox: {},
              slidingIndex: null,
              values: a.props.values
            }), i(h(a), "rheostat", {
              current: null
            }), a.getPublicState = a.getPublicState.bind(h(a)), a.getSliderBoundingBox = a.getSliderBoundingBox.bind(h(a)), a.getProgressStyle = a.getProgressStyle.bind(h(a)), a.getMinValue = a.getMinValue.bind(h(a)), a.getMaxValue = a.getMaxValue.bind(h(a)), a.getHandleDimensions = a.getHandleDimensions.bind(h(a)), a.getClosestSnapPoint = a.getClosestSnapPoint.bind(h(a)), a.getSnapPosition = a.getSnapPosition.bind(h(a)), a.getNextPositionForKey = a.getNextPositionForKey.bind(h(a)), a.getNextState = a.getNextState.bind(h(a)), a.handleClick = a.handleClick.bind(h(a)), a.getClosestHandle = a.getClosestHandle.bind(h(a)), a.setStartSlide = a.setStartSlide.bind(h(a)), a.startMouseSlide = a.startMouseSlide.bind(h(a)), a.startTouchSlide = a.startTouchSlide.bind(h(a)), a.handleMouseSlide = a.handleMouseSlide.bind(h(a)), a.handleTouchSlide = a.handleTouchSlide.bind(h(a)), a.handleSlide = a.handleSlide.bind(h(a)), a.endSlide = a.endSlide.bind(h(a)), a.handleKeydown = a.handleKeydown.bind(h(a)), a.validatePosition = a.validatePosition.bind(h(a)), a.validateValues = a.validateValues.bind(h(a)), a.canMove = a.canMove.bind(h(a)), a.fireChangeEvent = a.fireChangeEvent.bind(h(a)), a.slideTo = a.slideTo.bind(h(a)), a.updateNewValues = a.updateNewValues.bind(h(a)), a;
          }
          c(e, yt);
          var n = d(e);
          return r(e, [{
            key: "componentWillReceiveProps",
            value: function (e) {
              var t = this.props,
                n = t.className,
                r = t.disabled,
                i = t.min,
                a = t.max,
                s = t.orientation,
                o = this.state,
                c = o.values,
                u = o.slidingIndex,
                l = e.min !== i || e.max !== a,
                f = c.length !== e.values.length || c.some(function (t, n) {
                  return e.values[n] !== t;
                }),
                h = e.className !== n || e.orientation !== s,
                d = e.disabled && !r;
              h && this.setState({
                className: Yn(e)
              }), (l || f) && this.updateNewValues(e), d && null !== u && this.endSlide();
            }
          }, {
            key: "getPublicState",
            value: function () {
              var e = this.props,
                t = e.min;
              return {
                max: e.max,
                min: t,
                values: this.state.values
              };
            }
          }, {
            key: "getSliderBoundingBox",
            value: function () {
              var e = this.rheostat.current,
                t = e.getBoundingClientRect();
              return {
                height: t.height || e.clientHeight,
                left: t.left,
                top: t.top,
                width: t.width || e.clientWidth
              };
            }
          }, {
            key: "getProgressStyle",
            value: function (e) {
              var t = this.state.handlePos,
                n = t[e];
              if (0 === e) return "vertical" === this.props.orientation ? {
                height: "".concat(n, "%"),
                top: 0
              } : {
                left: 0,
                width: "".concat(n, "%")
              };
              var r = t[e - 1],
                i = n - r;
              return "vertical" === this.props.orientation ? {
                height: "".concat(i, "%"),
                top: "".concat(r, "%")
              } : {
                left: "".concat(r, "%"),
                width: "".concat(i, "%")
              };
            }
          }, {
            key: "getMinValue",
            value: function (e) {
              return this.state.values[e - 1] ? Math.max(this.props.min, this.state.values[e - 1]) : this.props.min;
            }
          }, {
            key: "getMaxValue",
            value: function (e) {
              return this.state.values[e + 1] ? Math.min(this.props.max, this.state.values[e + 1]) : this.props.max;
            }
          }, {
            key: "getHandleDimensions",
            value: function (e, t) {
              var n = e.currentTarget || null;
              return n ? "vertical" === this.props.orientation ? n.clientHeight / t.height * Vs / 2 : n.clientWidth / t.width * Vs / 2 : 0;
            }
          }, {
            key: "getClosestSnapPoint",
            value: function (e) {
              return this.props.snapPoints.length ? this.props.snapPoints.reduce(function (t, n) {
                return Math.abs(t - e) < Math.abs(n - e) ? t : n;
              }) : e;
            }
          }, {
            key: "getSnapPosition",
            value: function (e) {
              if (!this.props.snap) return e;
              var t = this.props,
                n = t.max,
                r = t.min,
                i = Gn(e, r, n);
              return Jn(this.getClosestSnapPoint(i), r, n);
            }
          }, {
            key: "getNextPositionForKey",
            value: function (e, t) {
              var n,
                r = this.state,
                a = r.handlePos,
                s = r.values,
                o = this.props,
                c = o.max,
                u = o.min,
                l = o.snapPoints,
                f = this.props.snap,
                h = s[e],
                d = a[e],
                p = d,
                m = 1;
              100 <= c ? d = Math.round(d) : m = 100 / (c - u);
              var g = null;
              f && (g = l.indexOf(this.getClosestSnapPoint(s[e])));
              var v = (i(n = {}, qs, function (e) {
                return -1 * e;
              }), i(n, Qs, function (e) {
                return e;
              }), i(n, Us, function (e) {
                return e;
              }), i(n, Ds, function (e) {
                return -1 * e;
              }), i(n, Bs, function (e) {
                return 1 < e ? -e : -10 * e;
              }), i(n, Ws, function (e) {
                return 1 < e ? e : 10 * e;
              }), n);
              if (Object.prototype.hasOwnProperty.call(v, t)) d += v[t](m), f && g && (p < d ? g < l.length - 1 && (h = l[g + 1]) : 0 < g && (h = l[g - 1]));else if (t === Hs) d = 0, f && (h = l[0]);else {
                if (t !== Ls) return null;
                d = Vs, f && (h = l[l.length - 1]);
              }
              return f ? Jn(h, u, c) : d;
            }
          }, {
            key: "getNextState",
            value: function (e, t) {
              var n = this.state.handlePos,
                r = this.props,
                i = r.max,
                a = r.min,
                s = this.validatePosition(e, t),
                o = n.map(function (t, n) {
                  return n === e ? s : t;
                });
              return {
                handlePos: o,
                values: o.map(function (e) {
                  return Gn(e, a, i);
                })
              };
            }
          }, {
            key: "getClosestHandle",
            value: function (e) {
              var t = this.state.handlePos;
              return t.reduce(function (n, r, i) {
                return Math.abs(t[i] - e) < Math.abs(t[n] - e) ? i : n;
              }, 0);
            }
          }, {
            key: "setStartSlide",
            value: function (e, t, n) {
              var r = this.getSliderBoundingBox();
              this.setState({
                handleDimensions: this.getHandleDimensions(e, r),
                mousePos: {
                  x: t,
                  y: n
                },
                sliderBox: r,
                slidingIndex: Xn(e)
              });
            }
          }, {
            key: "startMouseSlide",
            value: function (e) {
              this.setStartSlide(e, e.clientX, e.clientY), document.addEventListener("mousemove", this.handleMouseSlide, !1), document.addEventListener("mouseup", this.endSlide, !1), Zn(e);
            }
          }, {
            key: "startTouchSlide",
            value: function (e) {
              if (!(1 < e.changedTouches.length)) {
                var t = e.changedTouches[0];
                this.setStartSlide(e, t.clientX, t.clientY), document.addEventListener("touchmove", this.handleTouchSlide, !1), document.addEventListener("touchend", this.endSlide, !1), this.props.onSliderDragStart && this.props.onSliderDragStart(), Zn(e);
              }
            }
          }, {
            key: "handleMouseSlide",
            value: function (e) {
              null !== this.state.slidingIndex && (this.handleSlide(e.clientX, e.clientY), Zn(e));
            }
          }, {
            key: "handleTouchSlide",
            value: function (e) {
              if (null !== this.state.slidingIndex) if (1 < e.changedTouches.length) this.endSlide();else {
                var t = e.changedTouches[0];
                this.handleSlide(t.clientX, t.clientY), Zn(e);
              }
            }
          }, {
            key: "handleSlide",
            value: function (e, t) {
              var n = this.state,
                r = n.slidingIndex,
                i = n.sliderBox,
                a = "vertical" === this.props.orientation ? (t - i.top) / i.height * Vs : (e - i.left) / i.width * Vs;
              this.slideTo(r, a), this.canMove(r, a) && (this.setState({
                mousePos: {
                  x: e,
                  y: t
                }
              }), this.props.onSliderDragMove && this.props.onSliderDragMove());
            }
          }, {
            key: "endSlide",
            value: function () {
              var e = this,
                t = this.state.slidingIndex;
              if (this.setState({
                slidingIndex: null
              }), document.removeEventListener("mouseup", this.endSlide, !1), document.removeEventListener("touchend", this.endSlide, !1), document.removeEventListener("touchmove", this.handleTouchSlide, !1), document.removeEventListener("mousemove", this.handleMouseSlide, !1), this.props.onSliderDragEnd && this.props.onSliderDragEnd(), this.props.snap) {
                var n = this.getSnapPosition(this.state.handlePos[t]);
                this.slideTo(t, n, function () {
                  return e.fireChangeEvent();
                });
              } else this.fireChangeEvent();
            }
          }, {
            key: "handleClick",
            value: function (e) {
              var t = this;
              if (!e.target.getAttribute("data-handle-key")) {
                var n = this.getSliderBoundingBox(),
                  r = ("vertical" === this.props.orientation ? (e.clientY - n.top) / n.height : (e.clientX - n.left) / n.width) * Vs,
                  i = this.getClosestHandle(r),
                  a = this.getSnapPosition(r);
                this.slideTo(i, a, function () {
                  return t.fireChangeEvent();
                }), this.props.onClick && this.props.onClick();
              }
            }
          }, {
            key: "handleKeydown",
            value: function (e) {
              var t = this,
                n = Xn(e);
              if (e.keyCode !== Ms) {
                var r = this.getNextPositionForKey(n, e.keyCode);
                null !== r && (this.canMove(n, r) && (this.slideTo(n, r, function () {
                  return t.fireChangeEvent();
                }), this.props.onKeyPress && this.props.onKeyPress()), Zn(e));
              } else e.currentTarget.blur();
            }
          }, {
            key: "validatePosition",
            value: function (e, t) {
              var n = this.state,
                r = n.handlePos,
                i = n.handleDimensions;
              return Math.max(Math.min(t, void 0 !== r[e + 1] ? r[e + 1] - i : Vs), void 0 !== r[e - 1] ? r[e - 1] + i : 0);
            }
          }, {
            key: "validateValues",
            value: function (e, t) {
              var n = t || this.props,
                r = n.max,
                i = n.min;
              return e.map(function (e, t, n) {
                var a = Math.max(Math.min(e, r), i);
                return n.length && a < n[t - 1] ? n[t - 1] : a;
              });
            }
          }, {
            key: "canMove",
            value: function (e, t) {
              var n = this.state,
                r = n.handlePos,
                i = n.handleDimensions;
              return !(t < 0 || Vs < t || (void 0 !== r[e + 1] ? r[e + 1] - i : 1 / 0) < t || t < (void 0 !== r[e - 1] ? r[e - 1] + i : -1 / 0));
            }
          }, {
            key: "fireChangeEvent",
            value: function () {
              var e = this.props.onChange;
              e && e(this.getPublicState());
            }
          }, {
            key: "slideTo",
            value: function (e, t, n) {
              var r = this,
                i = this.getNextState(e, t);
              this.setState(i, function () {
                var e = r.props.onValuesUpdated;
                e && e(r.getPublicState()), n && n();
              });
            }
          }, {
            key: "updateNewValues",
            value: function (e) {
              var t = this;
              if (null === this.state.slidingIndex) {
                var n = e.max,
                  r = e.min,
                  i = e.values,
                  a = this.validateValues(i, e);
                this.setState({
                  handlePos: a.map(function (e) {
                    return Jn(e, r, n);
                  }),
                  values: a
                }, function () {
                  return t.fireChangeEvent();
                });
              }
            }
          }, {
            key: "render",
            value: function () {
              var e = this,
                t = this.props,
                n = t.children,
                r = t.disabled,
                i = t.handle,
                a = t.max,
                s = t.min,
                o = t.orientation,
                c = t.pitComponent,
                u = t.pitPoints,
                l = t.progressBar,
                f = this.state,
                h = f.className,
                d = f.handlePos,
                p = f.values;
              return mt("div", {
                className: h,
                ref: this.rheostat,
                onClick: r ? void 0 : this.handleClick,
                style: {
                  position: "relative"
                }
              }, $s, d.map(function (t, n) {
                var a = "vertical" === o ? {
                  top: "".concat(t, "%"),
                  position: "absolute"
                } : {
                  left: "".concat(t, "%"),
                  position: "absolute"
                };
                return mt(i, {
                  "aria-valuemax": e.getMaxValue(n),
                  "aria-valuemin": e.getMinValue(n),
                  "aria-valuenow": p[n],
                  "aria-disabled": r,
                  "data-handle-key": n,
                  className: "rheostat-handle",
                  key: "handle-".concat(n),
                  onClick: Zn,
                  onKeyDown: r ? void 0 : e.handleKeydown,
                  onMouseDown: r ? void 0 : e.startMouseSlide,
                  onTouchStart: r ? void 0 : e.startTouchSlide,
                  role: "slider",
                  style: a,
                  tabIndex: 0
                });
              }), d.map(function (t, n, r) {
                return 0 === n && 1 < r.length ? null : mt(l, {
                  className: "rheostat-progress",
                  key: "progress-bar-".concat(n),
                  style: e.getProgressStyle(n)
                });
              }), c && u.map(function (e) {
                var t = Jn(e, s, a),
                  n = "vertical" === o ? {
                    top: "".concat(t, "%"),
                    position: "absolute"
                  } : {
                    left: "".concat(t, "%"),
                    position: "absolute"
                  };
                return mt(c, {
                  key: "pit-".concat(e),
                  style: n
                }, e);
              }), n);
            }
          }]), e;
        }();
      i(zs, "defaultProps", {
        className: "",
        children: null,
        disabled: !1,
        handle: function (e) {
          return mt("button", a({}, e, {
            type: "button"
          }));
        },
        max: Vs,
        min: 0,
        onClick: null,
        onChange: null,
        onKeyPress: null,
        onSliderDragEnd: null,
        onSliderDragMove: null,
        onSliderDragStart: null,
        onValuesUpdated: null,
        orientation: "horizontal",
        pitComponent: null,
        pitPoints: [],
        progressBar: "div",
        snap: !1,
        snapPoints: [],
        values: [0]
      });
      var Ks = function () {
          function n() {
            var r;
            t(this, n);
            for (var o = arguments.length, c = new Array(o), u = 0; u < o; u++) c[u] = arguments[u];
            return i(h(r = s.call.apply(s, [this].concat(c))), "handleChange", function (e) {
              var t = e.values;
              r.isDisabled || r.props.refine(t);
            }), i(h(r), "createHandleComponent", function (t) {
              return function (n) {
                var r = Math.round(100 * parseFloat(n["aria-valuenow"])) / 100,
                  i = "object" === e(t) && t.format ? t.format(r) : r;
                return mt("div", a({}, n, {
                  className: ba(n.className, {
                    "rheostat-handle-lower": 0 === n["data-handle-key"],
                    "rheostat-handle-upper": 1 === n["data-handle-key"]
                  })
                }), t && mt("div", {
                  className: "rheostat-tooltip"
                }, i));
              };
            }), r;
          }
          c(n, yt);
          var s = d(n);
          return r(n, [{
            key: "isDisabled",
            get: function () {
              return this.props.min >= this.props.max;
            }
          }, {
            key: "computeDefaultPitPoints",
            value: function (e) {
              var t = e.min,
                n = e.max,
                r = (n - t) / 34;
              return [t].concat(m(ie({
                end: 33
              }).map(function (e) {
                return t + r * (e + 1);
              })), [n]);
            }
          }, {
            key: "computeSnapPoints",
            value: function (e) {
              var t = e.min,
                n = e.max,
                r = e.step;
              if (r) return [].concat(m(ie({
                start: t,
                end: n,
                step: r
              })), [n]);
            }
          }, {
            key: "render",
            value: function () {
              var e = this.props,
                t = e.tooltips,
                n = e.step,
                r = e.pips,
                a = e.values,
                s = e.cssClasses,
                o = this.isDisabled ? {
                  min: this.props.min,
                  max: this.props.max + .001
                } : this.props,
                c = o.min,
                u = o.max,
                l = this.computeSnapPoints({
                  min: c,
                  max: u,
                  step: n
                }),
                f = !1 === r ? [] : this.computeDefaultPitPoints({
                  min: c,
                  max: u
                });
              return mt("div", {
                className: ba(s.root, i({}, s.disabledRoot, this.isDisabled))
              }, mt(zs, {
                handle: this.createHandleComponent(t),
                onChange: this.handleChange,
                min: c,
                max: u,
                pitComponent: er,
                pitPoints: f,
                snap: !0,
                snapPoints: l,
                values: this.isDisabled ? [c, u] : a,
                disabled: this.isDisabled
              }));
            }
          }]), n;
        }(),
        Js = ve({
          name: "range-slider"
        }),
        Gs = Le("RangeSlider"),
        Ys = {
          item: '{{#count}}<a class="{{cssClasses.link}}" aria-label="{{value}} & up" href="{{url}}">{{/count}}{{^count}}<div class="{{cssClasses.link}}" aria-label="{{value}} & up" disabled>{{/count}}\n  {{#stars}}<svg class="{{cssClasses.starIcon}} {{#.}}{{cssClasses.fullStarIcon}}{{/.}}{{^.}}{{cssClasses.emptyStarIcon}}{{/.}}" aria-hidden="true" width="24" height="24">\n    {{#.}}<use xlink:href="#ais-RatingMenu-starSymbol"></use>{{/.}}{{^.}}<use xlink:href="#ais-RatingMenu-starEmptySymbol"></use>{{/.}}\n  </svg>{{/stars}}\n  <span class="{{cssClasses.label}}">& Up</span>\n  {{#count}}<span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span>{{/count}}\n{{#count}}</a>{{/count}}{{^count}}</div>{{/count}}'
        },
        Xs = ve({
          name: "rating-menu"
        }),
        Zs = Le("RatingMenu"),
        eo = mt("path", {
          d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
        }),
        to = mt("path", {
          d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z"
        }),
        no = {
          reset: '\n<svg class="{{cssClasses.resetIcon}}" viewBox="0 0 20 20" width="10" height="10">\n  <path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"></path>\n</svg>\n  ',
          submit: '\n<svg class="{{cssClasses.submitIcon}}" width="10" height="10" viewBox="0 0 40 40">\n  <path d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"></path>\n</svg>\n  ',
          loadingIndicator: '\n<svg class="{{cssClasses.loadingIcon}}" width="16" height="16" viewBox="0 0 38 38" stroke="#444">\n  <g fill="none" fillRule="evenodd">\n    <g transform="translate(1 1)" strokeWidth="2">\n      <circle strokeOpacity=".5" cx="18" cy="18" r="18" />\n      <path d="M36 18c0-9.94-8.06-18-18-18">\n        <animateTransform\n          attributeName="transform"\n          type="rotate"\n          from="0 18 18"\n          to="360 18 18"\n          dur="1s"\n          repeatCount="indefinite"\n        />\n      </path>\n    </g>\n  </g>\n</svg>\n  '
        },
        ro = {
          item: '<label class="{{cssClasses.label}}">\n  <input type="checkbox"\n         class="{{cssClasses.checkbox}}"\n         value="{{value}}"\n         {{#isRefined}}checked{{/isRefined}} />\n  <span class="{{cssClasses.labelText}}">{{#isFromSearch}}{{{highlighted}}}{{/isFromSearch}}{{^isFromSearch}}{{highlighted}}{{/isFromSearch}}</span>\n  <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span>\n</label>',
          showMoreText: "\n    {{#isShowingMore}}\n      Show less\n    {{/isShowingMore}}\n    {{^isShowingMore}}\n      Show more\n    {{/isShowingMore}}\n    ",
          searchableNoResults: "No results"
        },
        io = ve({
          name: "refinement-list"
        }),
        ao = Le("RefinementList"),
        so = Le("SearchBox"),
        oo = {
          text: "",
          button: function (e) {
            return e.isRelevantSorted ? "See all results" : "See relevant results";
          }
        },
        co = ve({
          name: "relevant-sort"
        }),
        uo = Le("RelevantSort"),
        lo = ve({
          name: "search-box"
        }),
        fo = Le("SearchBox"),
        ho = ve({
          name: "sort-by"
        }),
        po = Le("SortBy"),
        mo = ve({
          name: "stats"
        }),
        go = Le("Stats"),
        vo = {
          text: "\n    {{#areHitsSorted}}\n      {{#hasNoSortedResults}}No relevant results{{/hasNoSortedResults}}\n      {{#hasOneSortedResults}}1 relevant result{{/hasOneSortedResults}}\n      {{#hasManySortedResults}}{{#helpers.formatNumber}}{{nbSortedHits}}{{/helpers.formatNumber}} relevant results{{/hasManySortedResults}}\n      sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}\n    {{/areHitsSorted}}\n    {{^areHitsSorted}}\n      {{#hasNoResults}}No results{{/hasNoResults}}\n      {{#hasOneResult}}1 result{{/hasOneResult}}\n      {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results{{/hasManyResults}}\n    {{/areHitsSorted}}\n    found in {{processingTimeMS}}ms"
        },
        yo = {
          labelText: "{{name}}"
        },
        bo = ve({
          name: "toggle-refinement"
        }),
        Ro = Le("ToggleRefinement"),
        So = {
          buttonText: function (e) {
            var t = e.status,
              n = e.errorCode,
              r = e.isListening;
            return '<svg\n       width="16"\n       height="16"\n       viewBox="0 0 24 24"\n       fill="none"\n       stroke="currentColor"\n       stroke-width="2"\n       stroke-linecap="round"\n       stroke-linejoin="round"\n     >\n       '.concat(function (e, t, n) {
              return "error" === e && "not-allowed" === t ? '<line x1="1" y1="1" x2="23" y2="23"></line>\n            <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path>\n            <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path>\n            <line x1="12" y1="19" x2="12" y2="23"></line>\n            <line x1="8" y1="23" x2="16" y2="23"></line>' : '<path\n            d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"\n            fill="'.concat(n ? "currentColor" : "none", '">\n          </path>\n          <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>\n          <line x1="12" y1="19" x2="12" y2="23"></line>\n          <line x1="8" y1="23" x2="16" y2="23"></line>');
            }(t, n, r), "\n     </svg>");
          },
          status: "<p>{{transcript}}</p>"
        },
        _o = ve({
          name: "voice-search"
        }),
        wo = Le("VoiceSearch"),
        Po = ee(On),
        Oo = Object.freeze({
          __proto__: null,
          dynamicWidgets: On,
          EXPERIMENTAL_dynamicWidgets: Po,
          analytics: function (e) {
            function t(e) {
              if (null !== e) {
                var t = [],
                  n = function (e) {
                    var t = [];
                    for (var n in e) if (e.hasOwnProperty(n)) {
                      var r = e[n].join("+");
                      t.push("".concat(encodeURIComponent(n), "=").concat(encodeURIComponent(n), "_").concat(encodeURIComponent(r)));
                    }
                    return t.join("&");
                  }(o(o(o({}, e.state.disjunctiveFacetsRefinements), e.state.facetsRefinements), e.state.hierarchicalFacetsRefinements)),
                  r = function (e) {
                    var t = [];
                    for (var n in e) if (e.hasOwnProperty(n)) {
                      var r = e[n];
                      if (r.hasOwnProperty(">=") && r.hasOwnProperty("<=")) r[">="] && r[">="][0] === r["<="] && r["<="][0] ? t.push("".concat(n, "=").concat(n, "_").concat(r[">="])) : t.push("".concat(n, "=").concat(n, "_").concat(r[">="], "to").concat(r["<="]));else if (r.hasOwnProperty(">=")) t.push("".concat(n, "=").concat(n, "_from").concat(r[">="]));else if (r.hasOwnProperty("<=")) t.push("".concat(n, "=").concat(n, "_to").concat(r["<="]));else if (r.hasOwnProperty("=")) {
                        var i = [];
                        for (var a in r["="]) r["="].hasOwnProperty(a) && i.push(r["="][a]);
                        t.push("".concat(n, "=").concat(n, "_").concat(i.join("-")));
                      }
                    }
                    return t.join("&");
                  }(e.state.numericRefinements);
                "" !== n && t.push(n), "" !== r && t.push(r);
                var i = t.join("&"),
                  s = "Query: ".concat(e.state.query || "", ", ").concat(i);
                !0 === p && (s += ", Page: ".concat(e.state.page || 0)), v !== s && (a(i, e.state, e.results), v = s);
              }
            }
            function n() {
              t(g);
            }
            function r() {
              t(g);
            }
            var i = e || {},
              a = i.pushFunction,
              s = i.delay,
              c = void 0 === s ? 3e3 : s,
              u = i.triggerOnUIInteraction,
              l = void 0 !== u && u,
              f = i.pushInitialSearch,
              h = void 0 === f || f,
              d = i.pushPagination,
              p = void 0 !== d && d;
            if (!a) throw new Error(ya("The `pushFunction` option is required."));
            var m,
              g = null,
              v = "",
              y = !0;
            return !0 === h && (y = !1), {
              $$type: "ais.analytics",
              $$widgetType: "ais.analytics",
              init: function () {
                !0 === l && (document.addEventListener("click", n), window.addEventListener("beforeunload", r));
              },
              render: function (e) {
                var n = e.results,
                  r = e.state;
                !0 !== y ? (g = {
                  results: n,
                  state: r
                }, m && clearTimeout(m), m = window.setTimeout(function () {
                  return t(g);
                }, c)) : y = !1;
              },
              dispose: function () {
                !0 === l && (document.removeEventListener("click", n), window.removeEventListener("beforeunload", r));
              },
              getRenderState: function (e, t) {
                return o(o({}, e), {}, {
                  analytics: this.getWidgetRenderState(t)
                });
              },
              getWidgetRenderState: function () {
                return {
                  widgetParams: e
                };
              }
            };
          },
          breadcrumb: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attributes,
              i = t.separator,
              a = t.rootPath,
              s = t.transformItems,
              c = t.templates,
              u = void 0 === c ? {} : c,
              l = t.cssClasses,
              f = void 0 === l ? {} : l;
            if (!n) throw new Error(_a("The `container` option is required."));
            var h = B(n),
              d = {
                root: ba(wa(), f.root),
                noRefinementRoot: ba(wa({
                  modifierName: "noRefinement"
                }), f.noRefinementRoot),
                list: ba(wa({
                  descendantName: "list"
                }), f.list),
                item: ba(wa({
                  descendantName: "item"
                }), f.item),
                selectedItem: ba(wa({
                  descendantName: "item",
                  modifierName: "selected"
                }), f.selectedItem),
                separator: ba(wa({
                  descendantName: "separator"
                }), f.separator),
                link: ba(wa({
                  descendantName: "link"
                }), f.link)
              },
              p = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.renderState,
                  i = e.templates;
                return function (e, a) {
                  var s = e.canRefine,
                    o = e.createURL,
                    c = e.instantSearchInstance,
                    u = e.items,
                    l = e.refine;
                  a ? r.templateProps = U({
                    defaultTemplates: Sa,
                    templatesConfig: c.templatesConfig,
                    templates: i
                  }) : At(mt(bn, {
                    canRefine: s,
                    cssClasses: n,
                    createURL: o,
                    items: u,
                    refine: l,
                    templateProps: r.templateProps
                  }), t);
                };
              }({
                containerNode: h,
                cssClasses: d,
                renderState: {},
                templates: u
              });
            return o(o({}, nn(p, function () {
              return At(null, h);
            })({
              attributes: r,
              separator: i,
              rootPath: a,
              transformItems: s
            })), {}, {
              $$widgetType: "ais.breadcrumb"
            });
          },
          clearRefinements: function (e) {
            var t = e || {},
              n = t.container,
              r = t.templates,
              i = void 0 === r ? {} : r,
              a = t.includedAttributes,
              s = t.excludedAttributes,
              c = t.transformItems,
              u = t.cssClasses,
              l = void 0 === u ? {} : u;
            if (!n) throw new Error(Oa("The `container` option is required."));
            var f = B(n),
              h = {
                root: ba(xa(), l.root),
                button: ba(xa({
                  descendantName: "button"
                }), l.button),
                disabledButton: ba(xa({
                  descendantName: "button",
                  modifierName: "disabled"
                }), l.disabledButton)
              },
              d = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.renderState,
                  i = e.templates;
                return function (e, a) {
                  var s = e.refine,
                    o = e.hasRefinements,
                    c = e.instantSearchInstance;
                  a ? r.templateProps = U({
                    defaultTemplates: Pa,
                    templatesConfig: c.templatesConfig,
                    templates: i
                  }) : At(mt(Rn, {
                    refine: s,
                    cssClasses: n,
                    hasRefinements: o,
                    templateProps: r.templateProps
                  }), t);
                };
              }({
                containerNode: f,
                cssClasses: h,
                renderState: {},
                templates: i
              });
            return o(o({}, rt(d, function () {
              return At(null, f);
            })({
              includedAttributes: a,
              excludedAttributes: s,
              transformItems: c
            })), {}, {
              $$widgetType: "ais.clearRefinements"
            });
          },
          configure: function (e) {
            return o(o({}, un(Z)({
              searchParameters: e
            })), {}, {
              $$widgetType: "ais.configure"
            });
          },
          currentRefinements: function (e) {
            var t = e || {},
              n = t.container,
              r = t.includedAttributes,
              i = t.excludedAttributes,
              a = t.cssClasses,
              s = void 0 === a ? {} : a,
              c = t.transformItems;
            if (!n) throw new Error(ja("The `container` option is required."));
            var u = B(n),
              l = {
                root: ba(Ia(), s.root),
                list: ba(Ia({
                  descendantName: "list"
                }), s.list),
                item: ba(Ia({
                  descendantName: "item"
                }), s.item),
                label: ba(Ia({
                  descendantName: "label"
                }), s.label),
                category: ba(Ia({
                  descendantName: "category"
                }), s.category),
                categoryLabel: ba(Ia({
                  descendantName: "categoryLabel"
                }), s.categoryLabel),
                delete: ba(Ia({
                  descendantName: "delete"
                }), s.delete)
              };
            return o(o({}, it(_n, function () {
              return At(null, u);
            })({
              container: u,
              cssClasses: l,
              includedAttributes: r,
              excludedAttributes: i,
              transformItems: c
            })), {}, {
              $$widgetType: "ais.currentRefinements"
            });
          },
          EXPERIMENTAL_answers: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attributesForPrediction,
              i = t.queryLanguages,
              a = t.nbHits,
              s = t.searchDebounceTime,
              c = t.renderDebounceTime,
              u = t.escapeHTML,
              l = t.extraParameters,
              f = t.templates,
              h = void 0 === f ? {} : f,
              d = t.cssClasses,
              p = void 0 === d ? {} : d;
            if (!n) throw new Error(Na("The `container` option is required."));
            var m = B(n),
              g = {
                root: ba(Ea(), p.root),
                emptyRoot: ba(Ea({
                  modifierName: "empty"
                }), p.emptyRoot),
                header: ba(Ea({
                  descendantName: "header"
                }), p.header),
                loader: ba(Ea({
                  descendantName: "loader"
                }), p.loader),
                list: ba(Ea({
                  descendantName: "list"
                }), p.list),
                item: ba(Ea({
                  descendantName: "item"
                }), p.item)
              },
              v = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.renderState,
                  i = e.templates;
                return function (e, a) {
                  var s = e.hits,
                    o = e.isLoading,
                    c = e.instantSearchInstance;
                  a ? r.templateProps = U({
                    defaultTemplates: Fa,
                    templatesConfig: c.templatesConfig,
                    templates: i
                  }) : At(mt(wn, {
                    cssClasses: n,
                    hits: s,
                    isLoading: o,
                    templateProps: r.templateProps
                  }), t);
                };
              }({
                containerNode: m,
                cssClasses: g,
                templates: h,
                renderState: {}
              });
            return o(o({}, gn(v, function () {
              return At(null, m);
            })({
              attributesForPrediction: r,
              queryLanguages: i,
              nbHits: a,
              searchDebounceTime: s,
              renderDebounceTime: c,
              escapeHTML: u,
              extraParameters: l
            })), {}, {
              $$widgetType: "ais.answers"
            });
          },
          EXPERIMENTAL_configureRelatedItems: function (e) {
            return o(o({}, fn(Z)(e)), {}, {
              $$widgetType: "ais.configureRelatedItems"
            });
          },
          geoSearch: function (e) {
            var n = e || {},
              a = n.initialZoom,
              s = void 0 === a ? 1 : a,
              u = n.initialPosition,
              l = void 0 === u ? {
                lat: 0,
                lng: 0
              } : u,
              p = n.templates,
              m = void 0 === p ? {} : p,
              g = n.cssClasses,
              v = void 0 === g ? {} : g,
              y = n.builtInMarker,
              b = void 0 === y ? {} : y,
              R = n.customHTMLMarker,
              S = n.enableRefine,
              _ = void 0 === S || S,
              w = n.enableClearMapRefinement,
              P = void 0 === w || w,
              O = n.enableRefineControl,
              x = void 0 === O || O,
              j = n.container,
              I = n.googleReference,
              F = f(n, ["initialZoom", "initialPosition", "templates", "cssClasses", "builtInMarker", "customHTMLMarker", "enableRefine", "enableClearMapRefinement", "enableRefineControl", "container", "googleReference"]);
            if (!j) throw new Error(Aa("The `container` option is required."));
            if (!I) throw new Error(Aa("The `googleReference` option is required."));
            var N = B(j),
              E = {
                root: ba(Da(), v.root),
                tree: Da({
                  descendantName: "tree"
                }),
                map: ba(Da({
                  descendantName: "map"
                }), v.map),
                control: ba(Da({
                  descendantName: "control"
                }), v.control),
                label: ba(Da({
                  descendantName: "label"
                }), v.label),
                selectedLabel: ba(Da({
                  descendantName: "label",
                  modifierName: "selected"
                }), v.selectedLabel),
                input: ba(Da({
                  descendantName: "input"
                }), v.input),
                redo: ba(Da({
                  descendantName: "redo"
                }), v.redo),
                disabledRedo: ba(Da({
                  descendantName: "redo",
                  modifierName: "disabled"
                }), v.disabledRedo),
                reset: ba(Da({
                  descendantName: "reset"
                }), v.reset)
              },
              C = o(o({}, ka), m),
              T = o(o({}, {
                createOptions: function () {
                  return {};
                },
                events: {}
              }), b),
              k = (Boolean(R) || Boolean(m.HTMLMarker)) && o(o({}, {
                createOptions: function () {
                  return {};
                },
                events: {}
              }), R),
              A = function (e) {
                return function () {
                  function n(r) {
                    var s,
                      o = r.__id,
                      c = r.position,
                      u = r.map,
                      l = r.template,
                      f = r.className,
                      d = r.anchor,
                      p = void 0 === d ? {
                        x: 0,
                        y: 0
                      } : d;
                    return t(this, n), i(h(s = a.call(this)), "__id", void 0), i(h(s), "anchor", void 0), i(h(s), "offset", void 0), i(h(s), "listeners", void 0), i(h(s), "latLng", void 0), i(h(s), "element", void 0), s.__id = o, s.anchor = p, s.listeners = {}, s.latLng = new e.maps.LatLng(c), s.element = document.createElement("div"), s.element.className = f, s.element.style.position = "absolute", s.element.innerHTML = l, s.setMap(u), s;
                  }
                  c(n, e.maps.OverlayView);
                  var a = d(n);
                  return r(n, [{
                    key: "onAdd",
                    value: function () {
                      this.getPanes().overlayMouseTarget.appendChild(this.element);
                      var e = this.element.getBoundingClientRect();
                      this.offset = {
                        x: this.anchor.x + e.width / 2,
                        y: this.anchor.y + e.height
                      }, this.element.style.width = "".concat(e.width, "px");
                    }
                  }, {
                    key: "draw",
                    value: function () {
                      var e = this.getProjection().fromLatLngToDivPixel(this.latLng);
                      this.element.style.left = "".concat(Math.round(e.x - this.offset.x), "px"), this.element.style.top = "".concat(Math.round(e.y - this.offset.y), "px"), this.element.style.zIndex = String(parseInt(this.element.style.top, 10));
                    }
                  }, {
                    key: "onRemove",
                    value: function () {
                      var e = this;
                      this.element && (this.element.parentNode.removeChild(this.element), Object.keys(this.listeners).forEach(function (t) {
                        e.element.removeEventListener(t, e.listeners[t]);
                      }), delete this.element, delete this.listeners);
                    }
                  }, {
                    key: "addListener",
                    value: function (e, t) {
                      this.listeners[e] = t;
                      var n = this.element;
                      return n.addEventListener(e, t), {
                        remove: function () {
                          return n.removeEventListener(e, t);
                        }
                      };
                    }
                  }, {
                    key: "getPosition",
                    value: function () {
                      return this.latLng;
                    }
                  }]), n;
                }();
              }(I),
              D = k ? function (e) {
                var t = e.item,
                  n = f(e, ["item"]);
                return new A(o(o(o({}, k.createOptions(t)), n), {}, {
                  __id: t.objectID,
                  position: t._geoloc,
                  className: ba(Da({
                    descendantName: "marker"
                  })),
                  template: $({
                    templateKey: "HTMLMarker",
                    templates: C,
                    data: t
                  })
                }));
              } : function (e) {
                var t = e.item,
                  n = f(e, ["item"]);
                return new I.maps.Marker(o(o(o({}, T.createOptions(t)), n), {}, {
                  __id: t.objectID,
                  position: t._geoloc
                }));
              },
              L = k || T;
            return o(o({}, sn(En, function () {
              return At(null, N);
            })(o(o({}, F), {}, {
              renderState: {},
              container: N,
              googleReference: I,
              initialZoom: s,
              initialPosition: l,
              templates: C,
              cssClasses: E,
              createMarker: D,
              markerOptions: L,
              enableRefine: _,
              enableClearMapRefinement: P,
              enableRefineControl: x
            }))), {}, {
              $$widgetType: "ais.geoSearch"
            });
          },
          hierarchicalMenu: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attributes,
              i = t.separator,
              a = t.rootPath,
              s = t.showParentLevel,
              c = t.limit,
              u = t.showMore,
              l = void 0 !== u && u,
              f = t.showMoreLimit,
              h = t.sortBy,
              d = t.transformItems,
              p = t.templates,
              m = void 0 === p ? {} : p,
              g = t.cssClasses,
              v = void 0 === g ? {} : g;
            if (!n) throw new Error(Ua("The `container` option is required."));
            var y = B(n),
              b = function (e) {
                var t = e.cssClasses,
                  n = e.containerNode,
                  r = e.showMore,
                  i = e.templates,
                  a = e.renderState;
                return function (e, s) {
                  var o = e.createURL,
                    c = e.items,
                    u = e.refine,
                    l = e.instantSearchInstance,
                    f = e.isShowingMore,
                    h = e.toggleShowMore,
                    d = e.canToggleShowMore;
                  s ? a.templateProps = U({
                    defaultTemplates: Qa,
                    templatesConfig: l.templatesConfig,
                    templates: i
                  }) : At(mt(Ha, {
                    createURL: o,
                    cssClasses: t,
                    facetValues: c,
                    templateProps: a.templateProps,
                    toggleRefinement: u,
                    showMore: r,
                    toggleShowMore: h,
                    isShowingMore: f,
                    canToggleShowMore: d
                  }), n);
                };
              }({
                cssClasses: {
                  root: ba(Va(), v.root),
                  noRefinementRoot: ba(Va({
                    modifierName: "noRefinement"
                  }), v.noRefinementRoot),
                  list: ba(Va({
                    descendantName: "list"
                  }), v.list),
                  childList: ba(Va({
                    descendantName: "list",
                    modifierName: "child"
                  }), v.childList),
                  item: ba(Va({
                    descendantName: "item"
                  }), v.item),
                  selectedItem: ba(Va({
                    descendantName: "item",
                    modifierName: "selected"
                  }), v.selectedItem),
                  parentItem: ba(Va({
                    descendantName: "item",
                    modifierName: "parent"
                  }), v.parentItem),
                  link: ba(Va({
                    descendantName: "link"
                  }), v.link),
                  label: ba(Va({
                    descendantName: "label"
                  }), v.label),
                  count: ba(Va({
                    descendantName: "count"
                  }), v.count),
                  showMore: ba(Va({
                    descendantName: "showMore"
                  }), v.showMore),
                  disabledShowMore: ba(Va({
                    descendantName: "showMore",
                    modifierName: "disabled"
                  }), v.disabledShowMore)
                },
                containerNode: y,
                templates: m,
                showMore: l,
                renderState: {}
              });
            return o(o({}, ut(b, function () {
              return At(null, y);
            })({
              attributes: r,
              separator: i,
              rootPath: a,
              showParentLevel: s,
              limit: c,
              showMore: l,
              showMoreLimit: f,
              sortBy: h,
              transformItems: d
            })), {}, {
              $$widgetType: "ais.hierarchicalMenu"
            });
          },
          hits: function (e) {
            var t = e || {},
              n = t.container,
              r = t.escapeHTML,
              i = t.transformItems,
              a = t.templates,
              s = void 0 === a ? {} : a,
              c = t.cssClasses,
              u = void 0 === c ? {} : c;
            if (!n) throw new Error(za("The `container` option is required."));
            var l = B(n),
              f = {
                root: ba(Ka(), u.root),
                emptyRoot: ba(Ka({
                  modifierName: "empty"
                }), u.emptyRoot),
                list: ba(Ka({
                  descendantName: "list"
                }), u.list),
                item: ba(Ka({
                  descendantName: "item"
                }), u.item)
              },
              h = function (e) {
                var t = e.renderState,
                  n = e.cssClasses,
                  r = e.containerNode,
                  i = e.templates;
                return function (e, a) {
                  var s = e.hits,
                    o = e.results,
                    c = e.instantSearchInstance,
                    u = e.insights,
                    l = e.bindEvent;
                  a ? t.templateProps = U({
                    defaultTemplates: $a,
                    templatesConfig: c.templatesConfig,
                    templates: i
                  }) : At(mt(Ja, {
                    cssClasses: n,
                    hits: s,
                    results: o,
                    templateProps: t.templateProps,
                    insights: u,
                    sendEvent: function (e) {
                      c.sendEventToInsights(e);
                    },
                    bindEvent: l
                  }), r);
                };
              }({
                containerNode: l,
                cssClasses: f,
                renderState: {},
                templates: s
              });
            return o(o({}, ht(lt)(h, function () {
              return At(null, l);
            })({
              escapeHTML: r,
              transformItems: i
            })), {}, {
              $$widgetType: "ais.hits"
            });
          },
          hitsPerPage: function (e) {
            var t = e || {},
              n = t.container,
              r = t.items,
              i = t.cssClasses,
              a = void 0 === i ? {} : i,
              s = t.transformItems;
            if (!n) throw new Error(Ga("The `container` option is required."));
            var c = B(n),
              u = {
                root: ba(Ya(), a.root),
                select: ba(Ya({
                  descendantName: "select"
                }), a.select),
                option: ba(Ya({
                  descendantName: "option"
                }), a.option)
              },
              l = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses;
                return function (e, r) {
                  var i = e.items,
                    a = e.refine;
                  if (!r) {
                    var s = (z(i, function (e) {
                      return e.isRefined;
                    }) || {}).value;
                    At(mt("div", {
                      className: n.root
                    }, mt(kn, {
                      cssClasses: n,
                      currentValue: s,
                      options: i,
                      setValue: a
                    })), t);
                  }
                };
              }({
                containerNode: c,
                cssClasses: u
              });
            return o(o({}, Mt(l, function () {
              return At(null, c);
            })({
              items: r,
              transformItems: s
            })), {}, {
              $$widgetType: "ais.hitsPerPage"
            });
          },
          index: Ae,
          infiniteHits: function (e) {
            var t = e || {},
              n = t.container,
              r = t.escapeHTML,
              i = t.transformItems,
              a = t.templates,
              s = void 0 === a ? {} : a,
              c = t.cssClasses,
              u = void 0 === c ? {} : c,
              l = t.showPrevious,
              f = t.cache;
            if (!n) throw new Error(Za("The `container` option is required."));
            var h = B(n),
              d = {
                root: ba(es(), u.root),
                emptyRoot: ba(es({
                  modifierName: "empty"
                }), u.emptyRoot),
                item: ba(es({
                  descendantName: "item"
                }), u.item),
                list: ba(es({
                  descendantName: "list"
                }), u.list),
                loadPrevious: ba(es({
                  descendantName: "loadPrevious"
                }), u.loadPrevious),
                disabledLoadPrevious: ba(es({
                  descendantName: "loadPrevious",
                  modifierName: "disabled"
                }), u.disabledLoadPrevious),
                loadMore: ba(es({
                  descendantName: "loadMore"
                }), u.loadMore),
                disabledLoadMore: ba(es({
                  descendantName: "loadMore",
                  modifierName: "disabled"
                }), u.disabledLoadMore)
              },
              p = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.renderState,
                  i = e.templates,
                  a = e.showPrevious;
                return function (e, s) {
                  var o = e.hits,
                    c = e.results,
                    u = e.showMore,
                    l = e.showPrevious,
                    f = e.isFirstPage,
                    h = e.isLastPage,
                    d = e.instantSearchInstance,
                    p = e.insights,
                    m = e.bindEvent;
                  s ? r.templateProps = U({
                    defaultTemplates: Xa,
                    templatesConfig: d.templatesConfig,
                    templates: i
                  }) : At(mt(ts, {
                    cssClasses: n,
                    hits: o,
                    results: c,
                    hasShowPrevious: a,
                    showPrevious: l,
                    showMore: u,
                    templateProps: r.templateProps,
                    isFirstPage: f,
                    isLastPage: h,
                    insights: p,
                    sendEvent: function (e) {
                      d.sendEventToInsights(e);
                    },
                    bindEvent: m
                  }), t);
                };
              }({
                containerNode: h,
                cssClasses: d,
                templates: s,
                showPrevious: l,
                renderState: {}
              });
            return o(o({}, ht(qt)(p, function () {
              return At(null, h);
            })({
              escapeHTML: r,
              transformItems: i,
              showPrevious: l,
              cache: f
            })), {}, {
              $$widgetType: "ais.infiniteHits"
            });
          },
          menu: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attribute,
              i = t.sortBy,
              a = t.limit,
              s = t.showMore,
              c = t.showMoreLimit,
              u = t.cssClasses,
              l = void 0 === u ? {} : u,
              f = t.templates,
              h = void 0 === f ? {} : f,
              d = t.transformItems;
            if (!n) throw new Error(rs("The `container` option is required."));
            var p = B(n),
              m = {
                root: ba(is(), l.root),
                noRefinementRoot: ba(is({
                  modifierName: "noRefinement"
                }), l.noRefinementRoot),
                list: ba(is({
                  descendantName: "list"
                }), l.list),
                item: ba(is({
                  descendantName: "item"
                }), l.item),
                selectedItem: ba(is({
                  descendantName: "item",
                  modifierName: "selected"
                }), l.selectedItem),
                link: ba(is({
                  descendantName: "link"
                }), l.link),
                label: ba(is({
                  descendantName: "label"
                }), l.label),
                count: ba(is({
                  descendantName: "count"
                }), l.count),
                showMore: ba(is({
                  descendantName: "showMore"
                }), l.showMore),
                disabledShowMore: ba(is({
                  descendantName: "showMore",
                  modifierName: "disabled"
                }), l.disabledShowMore)
              },
              g = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.renderState,
                  i = e.templates,
                  a = e.showMore;
                return function (e, s) {
                  var c = e.refine,
                    u = e.items,
                    l = e.createURL,
                    f = e.instantSearchInstance,
                    h = e.isShowingMore,
                    d = e.toggleShowMore,
                    p = e.canToggleShowMore;
                  if (s) r.templateProps = U({
                    defaultTemplates: ns,
                    templatesConfig: f.templatesConfig,
                    templates: i
                  });else {
                    var m = u.map(function (e) {
                      return o(o({}, e), {}, {
                        url: l(e.value)
                      });
                    });
                    At(mt(Ha, {
                      createURL: l,
                      cssClasses: n,
                      facetValues: m,
                      showMore: a,
                      templateProps: r.templateProps,
                      toggleRefinement: c,
                      toggleShowMore: d,
                      isShowingMore: h,
                      canToggleShowMore: p
                    }), t);
                  }
                };
              }({
                containerNode: p,
                cssClasses: m,
                renderState: {},
                templates: h,
                showMore: s
              });
            return o(o({}, Bt(g, function () {
              return At(null, p);
            })({
              attribute: r,
              limit: a,
              showMore: s,
              showMoreLimit: c,
              sortBy: i,
              transformItems: d
            })), {}, {
              $$widgetType: "ais.menu"
            });
          },
          menuSelect: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attribute,
              i = t.sortBy,
              a = void 0 === i ? ["name:asc"] : i,
              s = t.limit,
              c = void 0 === s ? 10 : s,
              u = t.cssClasses,
              l = void 0 === u ? {} : u,
              f = t.templates,
              h = void 0 === f ? {} : f,
              d = t.transformItems;
            if (!n) throw new Error(ss("The `container` option is required."));
            var p = B(n),
              m = {
                root: ba(os(), l.root),
                noRefinementRoot: ba(os({
                  modifierName: "noRefinement"
                }), l.noRefinementRoot),
                select: ba(os({
                  descendantName: "select"
                }), l.select),
                option: ba(os({
                  descendantName: "option"
                }), l.option)
              },
              g = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.renderState,
                  i = e.templates;
                return function (e, a) {
                  var s = e.refine,
                    o = e.items,
                    c = e.instantSearchInstance;
                  a ? r.templateProps = U({
                    defaultTemplates: as,
                    templatesConfig: c.templatesConfig,
                    templates: i
                  }) : At(mt(An, {
                    cssClasses: n,
                    items: o,
                    refine: s,
                    templateProps: r.templateProps
                  }), t);
                };
              }({
                containerNode: p,
                cssClasses: m,
                renderState: {},
                templates: h
              });
            return o(o({}, Bt(g, function () {
              return At(null, p);
            })({
              attribute: r,
              limit: c,
              sortBy: a,
              transformItems: d
            })), {}, {
              $$widgetType: "ais.menuSelect"
            });
          },
          numericMenu: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attribute,
              i = t.items,
              a = t.cssClasses,
              s = void 0 === a ? {} : a,
              c = t.templates,
              u = void 0 === c ? {} : c,
              l = t.transformItems;
            if (!n) throw new Error(us("The `container` option is required."));
            var f = B(n),
              h = {
                root: ba(ls(), s.root),
                noRefinementRoot: ba(ls({
                  modifierName: "noRefinement"
                }), s.noRefinementRoot),
                list: ba(ls({
                  descendantName: "list"
                }), s.list),
                item: ba(ls({
                  descendantName: "item"
                }), s.item),
                selectedItem: ba(ls({
                  descendantName: "item",
                  modifierName: "selected"
                }), s.selectedItem),
                label: ba(ls({
                  descendantName: "label"
                }), s.label),
                radio: ba(ls({
                  descendantName: "radio"
                }), s.radio),
                labelText: ba(ls({
                  descendantName: "labelText"
                }), s.labelText)
              },
              d = function (e) {
                var t = e.containerNode,
                  n = e.attribute,
                  r = e.cssClasses,
                  i = e.renderState,
                  a = e.templates;
                return function (e, s) {
                  var o = e.createURL,
                    c = e.instantSearchInstance,
                    u = e.refine,
                    l = e.items;
                  s ? i.templateProps = U({
                    defaultTemplates: cs,
                    templatesConfig: c.templatesConfig,
                    templates: a
                  }) : At(mt(Ha, {
                    createURL: o,
                    cssClasses: r,
                    facetValues: l,
                    templateProps: i.templateProps,
                    toggleRefinement: u,
                    attribute: n
                  }), t);
                };
              }({
                containerNode: f,
                attribute: r,
                cssClasses: h,
                renderState: {},
                templates: u
              });
            return o(o({}, Wt(d, function () {
              return At(null, f);
            })({
              attribute: r,
              items: i,
              transformItems: l
            })), {}, {
              $$widgetType: "ais.numericMenu"
            });
          },
          pagination: function (e) {
            var t = e || {},
              n = t.container,
              r = t.templates,
              i = void 0 === r ? {} : r,
              a = t.cssClasses,
              s = void 0 === a ? {} : a,
              c = t.totalPages,
              u = t.padding,
              l = t.showFirst,
              f = void 0 === l || l,
              h = t.showLast,
              d = void 0 === h || h,
              p = t.showPrevious,
              m = void 0 === p || p,
              g = t.showNext,
              v = void 0 === g || g,
              y = t.scrollTo,
              b = void 0 === y ? "body" : y;
            if (!n) throw new Error(hs("The `container` option is required."));
            var R = B(n),
              S = !0 === b ? "body" : b,
              _ = !1 !== S && B(S),
              w = {
                root: ba(fs(), s.root),
                noRefinementRoot: ba(fs({
                  modifierName: "noRefinement"
                }), s.noRefinementRoot),
                list: ba(fs({
                  descendantName: "list"
                }), s.list),
                item: ba(fs({
                  descendantName: "item"
                }), s.item),
                firstPageItem: ba(fs({
                  descendantName: "item",
                  modifierName: "firstPage"
                }), s.firstPageItem),
                lastPageItem: ba(fs({
                  descendantName: "item",
                  modifierName: "lastPage"
                }), s.lastPageItem),
                previousPageItem: ba(fs({
                  descendantName: "item",
                  modifierName: "previousPage"
                }), s.previousPageItem),
                nextPageItem: ba(fs({
                  descendantName: "item",
                  modifierName: "nextPage"
                }), s.nextPageItem),
                pageItem: ba(fs({
                  descendantName: "item",
                  modifierName: "page"
                }), s.pageItem),
                selectedItem: ba(fs({
                  descendantName: "item",
                  modifierName: "selected"
                }), s.selectedItem),
                disabledItem: ba(fs({
                  descendantName: "item",
                  modifierName: "disabled"
                }), s.disabledItem),
                link: ba(fs({
                  descendantName: "link"
                }), s.link)
              },
              P = o(o({}, ds), i),
              O = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.templates,
                  i = e.showFirst,
                  a = e.showLast,
                  s = e.showPrevious,
                  o = e.showNext,
                  c = e.scrollToNode;
                return function (e, u) {
                  var l = e.createURL,
                    f = e.currentRefinement,
                    h = e.nbPages,
                    d = e.pages,
                    p = e.isFirstPage,
                    m = e.isLastPage,
                    g = e.refine;
                  u || At(mt(Dn, {
                    createURL: l,
                    cssClasses: n,
                    currentPage: f,
                    templates: r,
                    nbPages: h,
                    pages: d,
                    isFirstPage: p,
                    isLastPage: m,
                    setCurrentPage: function (e) {
                      g(e), !1 !== c && c.scrollIntoView();
                    },
                    showFirst: i,
                    showLast: a,
                    showPrevious: s,
                    showNext: o
                  }), t);
                };
              }({
                containerNode: R,
                cssClasses: w,
                templates: P,
                showFirst: f,
                showLast: d,
                showPrevious: m,
                showNext: v,
                scrollToNode: _
              });
            return o(o({}, $t(O, function () {
              return At(null, R);
            })({
              totalPages: c,
              padding: u
            })), {}, {
              $$widgetType: "ais.pagination"
            });
          },
          panel: function (e) {
            var t = e || {},
              n = t.templates,
              r = void 0 === n ? {} : n,
              i = t.hidden,
              a = void 0 === i ? function () {
                return !1;
              } : i,
              s = t.collapsed,
              c = t.cssClasses,
              u = void 0 === c ? {} : c,
              l = document.createElement("div"),
              f = Boolean(s),
              h = "function" == typeof s ? s : function () {
                return !1;
              },
              d = {
                root: ba(ws(), u.root),
                noRefinementRoot: ba(ws({
                  modifierName: "noRefinement"
                }), u.noRefinementRoot),
                collapsibleRoot: ba(ws({
                  modifierName: "collapsible"
                }), u.collapsibleRoot),
                collapsedRoot: ba(ws({
                  modifierName: "collapsed"
                }), u.collapsedRoot),
                collapseButton: ba(ws({
                  descendantName: "collapseButton"
                }), u.collapseButton),
                collapseIcon: ba(ws({
                  descendantName: "collapseIcon"
                }), u.collapseIcon),
                body: ba(ws({
                  descendantName: "body"
                }), u.body),
                header: ba(ws({
                  descendantName: "header"
                }), u.header),
                footer: ba(ws({
                  descendantName: "footer"
                }), u.footer)
              };
            return function (e) {
              return function (t) {
                if (!t || !t.container) throw new Error(_s("The `container` option is required in the widget within the panel."));
                var n = B(t.container),
                  i = function (e) {
                    var t = e.containerNode,
                      n = e.bodyContainerNode,
                      r = e.cssClasses,
                      i = e.templates;
                    return function (e) {
                      var a = e.options,
                        s = e.hidden,
                        o = e.collapsible,
                        c = e.collapsed;
                      At(mt($n, {
                        cssClasses: r,
                        hidden: s,
                        collapsible: o,
                        isCollapsed: c,
                        templates: i,
                        data: a,
                        bodyElement: n
                      }), t);
                    };
                  }({
                    containerNode: n,
                    bodyContainerNode: l,
                    cssClasses: d,
                    templates: o(o({}, {
                      header: "",
                      footer: "",
                      collapseButtonText: function (e) {
                        var t = e.collapsed;
                        return '<svg\n          class="'.concat(d.collapseIcon, '"\n          width="1em"\n          height="1em"\n          viewBox="0 0 500 500"\n        >\n        <path d="').concat(t ? "M100 250l300-150v300z" : "M250 400l150-300H100z", '" fill="currentColor" />\n        </svg>');
                      }
                    }), r)
                  }),
                  s = e(o(o({}, t), {}, {
                    container: l
                  }));
                return o(o({}, s), {}, {
                  init: function () {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var r,
                      a = t[0],
                      c = o(o({}, s.getWidgetRenderState ? s.getWidgetRenderState(a) : {}), a);
                    i({
                      options: c,
                      hidden: !0,
                      collapsible: f,
                      collapsed: !1
                    }), "function" == typeof s.init && (r = s.init).call.apply(r, [this].concat(t));
                  },
                  render: function () {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var r,
                      c = t[0],
                      u = o(o({}, s.getWidgetRenderState ? s.getWidgetRenderState(c) : {}), c);
                    i({
                      options: u,
                      hidden: Boolean(a(u)),
                      collapsible: f,
                      collapsed: Boolean(h(u))
                    }), "function" == typeof s.render && (r = s.render).call.apply(r, [this].concat(t));
                  },
                  dispose: function () {
                    if (At(null, n), "function" == typeof s.dispose) {
                      for (var e, t = arguments.length, r = new Array(t), i = 0; i < t; i++) r[i] = arguments[i];
                      return (e = s.dispose).call.apply(e, [this].concat(r));
                    }
                  }
                });
              };
            };
          },
          places: function (e) {
            var t = e || {},
              n = t.placesReference,
              r = t.defaultPosition,
              i = void 0 === r ? [] : r,
              a = f(t, ["placesReference", "defaultPosition"]);
            if ("function" != typeof n) throw new Error("The `placesReference` option requires a valid Places.js reference.");
            var s = n(a),
              c = {
                query: "",
                initialLatLngViaIP: void 0,
                isInitialLatLngViaIPSet: !1
              };
            return {
              $$type: "ais.places",
              $$widgetType: "ais.places",
              init: function (e) {
                var t = e.helper;
                s.on("change", function (e) {
                  var n = e.suggestion,
                    r = n.value,
                    i = n.latlng,
                    a = i.lat,
                    s = i.lng;
                  c.query = r, t.setQueryParameter("insideBoundingBox", void 0).setQueryParameter("aroundLatLngViaIP", !1).setQueryParameter("aroundLatLng", "".concat(a, ",").concat(s)).search();
                }), s.on("clear", function () {
                  c.query = "", t.setQueryParameter("insideBoundingBox", void 0), 1 < i.length ? t.setQueryParameter("aroundLatLngViaIP", !1).setQueryParameter("aroundLatLng", i.join(",")) : t.setQueryParameter("aroundLatLngViaIP", c.initialLatLngViaIP).setQueryParameter("aroundLatLng", void 0), t.search();
                });
              },
              getWidgetUiState: function (e, t) {
                var n = t.searchParameters.aroundLatLng || i.join(",");
                return n !== i.join(",") || c.query ? o(o({}, e), {}, {
                  places: {
                    query: c.query,
                    position: n
                  }
                }) : (e.places, f(e, ["places"]));
              },
              getWidgetSearchParameters: function (e, t) {
                var n = t.uiState.places || {},
                  r = n.query,
                  a = void 0 === r ? "" : r,
                  o = n.position,
                  u = void 0 === o ? i.join(",") : o;
                return c.query = a, c.isInitialLatLngViaIPSet || (c.isInitialLatLngViaIPSet = !0, c.initialLatLngViaIP = e.aroundLatLngViaIP), s.setVal(a), s.close(), e.setQueryParameter("insideBoundingBox", void 0).setQueryParameter("aroundLatLngViaIP", !1).setQueryParameter("aroundLatLng", u || void 0);
              },
              getRenderState: function (e, t) {
                return o(o({}, e), {}, {
                  places: this.getWidgetRenderState(t)
                });
              },
              getWidgetRenderState: function () {
                return {
                  widgetParams: e
                };
              }
            };
          },
          poweredBy: function (e) {
            var t = e || {},
              n = t.container,
              r = t.cssClasses,
              i = void 0 === r ? {} : r,
              a = t.theme,
              s = void 0 === a ? "light" : a;
            if (!n) throw new Error(js("The `container` option is required."));
            var c = B(n),
              u = {
                root: ba(xs(), xs({
                  modifierName: "dark" === s ? "dark" : "light"
                }), i.root),
                link: ba(xs({
                  descendantName: "link"
                }), i.link),
                logo: ba(xs({
                  descendantName: "logo"
                }), i.logo)
              },
              l = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses;
                return function (e, r) {
                  var i = e.url,
                    a = e.widgetParams;
                  if (r) {
                    var s = a.theme;
                    At(mt(zn, {
                      cssClasses: n,
                      url: i,
                      theme: void 0 === s ? "light" : s
                    }), t);
                  }
                };
              }({
                containerNode: c,
                cssClasses: u
              });
            return o(o({}, on(l, function () {
              return At(null, c);
            })({
              theme: s
            })), {}, {
              $$widgetType: "ais.poweredBy"
            });
          },
          queryRuleContext: function (e) {
            var t = 0 < arguments.length && void 0 !== e ? e : {};
            if (!t.trackedFilters) throw new Error(Is("The `trackedFilters` option is required."));
            return o(o({}, dn(Z)(t)), {}, {
              $$widgetType: "ais.queryRuleContext"
            });
          },
          queryRuleCustomData: function (e) {
            var t = e || {},
              n = t.container,
              r = t.cssClasses,
              i = void 0 === r ? {} : r,
              a = t.templates,
              s = void 0 === a ? {} : a,
              c = t.transformItems,
              u = void 0 === c ? function (e) {
                return e;
              } : c;
            if (!n) throw new Error(Ns("The `container` option is required."));
            var l = {
                root: ba(Es(), i.root)
              },
              f = B(n),
              h = o(o({}, Fs), s),
              d = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.templates;
                return function (e) {
                  var i = e.items;
                  At(mt(Kn, {
                    cssClasses: n,
                    templates: r,
                    items: i
                  }), t);
                };
              }({
                containerNode: f,
                cssClasses: l,
                renderState: {},
                templates: h
              });
            return o(o({}, dn(d, function () {
              At(null, f);
            })({
              transformItems: u
            })), {}, {
              $$widgetType: "ais.queryRuleCustomData"
            });
          },
          rangeInput: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attribute,
              i = t.min,
              a = t.max,
              s = t.precision,
              c = void 0 === s ? 0 : s,
              u = t.cssClasses,
              l = void 0 === u ? {} : u,
              f = t.templates,
              h = void 0 === f ? {} : f;
            if (!n) throw new Error(Ts("The `container` option is required."));
            var d = B(n),
              m = {
                root: ba(ks(), l.root),
                noRefinement: ba(ks({
                  modifierName: "noRefinement"
                })),
                form: ba(ks({
                  descendantName: "form"
                }), l.form),
                label: ba(ks({
                  descendantName: "label"
                }), l.label),
                input: ba(ks({
                  descendantName: "input"
                }), l.input),
                inputMin: ba(ks({
                  descendantName: "input",
                  modifierName: "min"
                }), l.inputMin),
                inputMax: ba(ks({
                  descendantName: "input",
                  modifierName: "max"
                }), l.inputMax),
                separator: ba(ks({
                  descendantName: "separator"
                }), l.separator),
                submit: ba(ks({
                  descendantName: "submit"
                }), l.submit)
              },
              g = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.renderState,
                  i = e.templates;
                return function (e, a) {
                  var s = e.refine,
                    o = e.range,
                    c = e.start,
                    u = e.widgetParams,
                    l = e.instantSearchInstance;
                  if (a) r.templateProps = U({
                    defaultTemplates: As,
                    templatesConfig: l.templatesConfig,
                    templates: i
                  });else {
                    var f = o.min,
                      h = o.max,
                      d = p(c, 2),
                      m = d[0],
                      g = d[1],
                      v = 1 / Math.pow(10, u.precision || 0);
                    At(mt(Cs, {
                      min: f,
                      max: h,
                      step: v,
                      values: {
                        min: m !== -1 / 0 && m !== f ? m : void 0,
                        max: g !== 1 / 0 && g !== h ? g : void 0
                      },
                      cssClasses: n,
                      refine: s,
                      templateProps: r.templateProps
                    }), t);
                  }
                };
              }({
                containerNode: d,
                cssClasses: m,
                templates: h,
                renderState: {}
              });
            return o(o({}, Kt(g, function () {
              return At(null, d);
            })({
              attribute: r,
              min: i,
              max: a,
              precision: c
            })), {}, {
              $$type: "ais.rangeInput",
              $$widgetType: "ais.rangeInput"
            });
          },
          rangeSlider: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attribute,
              i = t.min,
              a = t.max,
              s = t.cssClasses,
              c = void 0 === s ? {} : s,
              u = t.step,
              l = t.pips,
              f = void 0 === l || l,
              h = t.precision,
              d = void 0 === h ? 0 : h,
              m = t.tooltips,
              g = void 0 === m || m;
            if (!n) throw new Error(Js("The `container` option is required."));
            var v = B(n),
              y = {
                root: ba(Gs(), c.root),
                disabledRoot: ba(Gs({
                  modifierName: "disabled"
                }), c.disabledRoot)
              },
              b = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.pips,
                  i = e.step,
                  a = e.tooltips;
                return function (e, s) {
                  var o = e.refine,
                    c = e.range,
                    u = e.start;
                  if (!s) {
                    var l = c.min,
                      f = c.max,
                      h = p(u, 2),
                      d = h[0],
                      m = h[1],
                      g = d === -1 / 0 ? l : d,
                      v = m === 1 / 0 ? f : m;
                    At(mt(Ks, {
                      cssClasses: n,
                      refine: o,
                      min: l,
                      max: f,
                      values: [f < g ? f : g, v < l ? l : v],
                      tooltips: a,
                      step: i,
                      pips: r
                    }), t);
                  }
                };
              }({
                containerNode: v,
                step: u,
                pips: f,
                tooltips: g,
                cssClasses: y
              });
            return o(o({}, Kt(b, function () {
              return At(null, v);
            })({
              attribute: r,
              min: i,
              max: a,
              precision: d
            })), {}, {
              $$type: "ais.rangeSlider",
              $$widgetType: "ais.rangeSlider"
            });
          },
          ratingMenu: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attribute,
              i = t.max,
              a = void 0 === i ? 5 : i,
              s = t.cssClasses,
              c = void 0 === s ? {} : s,
              u = t.templates,
              l = void 0 === u ? {} : u;
            if (!n) throw new Error(Xs("The `container` option is required."));
            var f = B(n),
              h = {
                root: ba(Zs(), c.root),
                noRefinementRoot: ba(Zs({
                  modifierName: "noRefinement"
                }), c.noRefinementRoot),
                list: ba(Zs({
                  descendantName: "list"
                }), c.list),
                item: ba(Zs({
                  descendantName: "item"
                }), c.item),
                selectedItem: ba(Zs({
                  descendantName: "item",
                  modifierName: "selected"
                }), c.selectedItem),
                disabledItem: ba(Zs({
                  descendantName: "item",
                  modifierName: "disabled"
                }), c.disabledItem),
                link: ba(Zs({
                  descendantName: "link"
                }), c.link),
                starIcon: ba(Zs({
                  descendantName: "starIcon"
                }), c.starIcon),
                fullStarIcon: ba(Zs({
                  descendantName: "starIcon",
                  modifierName: "full"
                }), c.fullStarIcon),
                emptyStarIcon: ba(Zs({
                  descendantName: "starIcon",
                  modifierName: "empty"
                }), c.emptyStarIcon),
                label: ba(Zs({
                  descendantName: "label"
                }), c.label),
                count: ba(Zs({
                  descendantName: "count"
                }), c.count)
              },
              d = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.templates,
                  i = e.renderState;
                return function (e, a) {
                  var s = e.refine,
                    o = e.items,
                    c = e.createURL,
                    u = e.instantSearchInstance;
                  a ? i.templateProps = U({
                    defaultTemplates: Ys,
                    templatesConfig: u.templatesConfig,
                    templates: r
                  }) : At(mt(Ha, {
                    createURL: c,
                    cssClasses: n,
                    facetValues: o,
                    templateProps: i.templateProps,
                    toggleRefinement: s
                  }, mt("svg", {
                    style: "display:none;"
                  }, mt("symbol", {
                    id: Zs({
                      descendantName: "starSymbol"
                    }),
                    viewBox: "0 0 24 24"
                  }, eo), mt("symbol", {
                    id: Zs({
                      descendantName: "starEmptySymbol"
                    }),
                    viewBox: "0 0 24 24"
                  }, to))), t);
                };
              }({
                containerNode: f,
                cssClasses: h,
                renderState: {},
                templates: l
              });
            return o(o({}, Zt(d, function () {
              return At(null, f);
            })({
              attribute: r,
              max: a
            })), {}, {
              $$widgetType: "ais.ratingMenu"
            });
          },
          refinementList: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attribute,
              i = t.operator,
              a = t.sortBy,
              s = t.limit,
              c = t.showMore,
              u = t.showMoreLimit,
              l = t.searchable,
              f = void 0 !== l && l,
              h = t.searchablePlaceholder,
              d = void 0 === h ? "Search..." : h,
              p = t.searchableEscapeFacetValues,
              m = void 0 === p || p,
              g = t.searchableIsAlwaysActive,
              v = void 0 === g || g,
              y = t.cssClasses,
              b = void 0 === y ? {} : y,
              R = t.templates,
              S = void 0 === R ? {} : R,
              _ = t.transformItems;
            if (!n) throw new Error(io("The `container` option is required."));
            var w = !!f && Boolean(m),
              P = B(n),
              O = {
                root: ba(ao(), b.root),
                noRefinementRoot: ba(ao({
                  modifierName: "noRefinement"
                }), b.noRefinementRoot),
                list: ba(ao({
                  descendantName: "list"
                }), b.list),
                item: ba(ao({
                  descendantName: "item"
                }), b.item),
                selectedItem: ba(ao({
                  descendantName: "item",
                  modifierName: "selected"
                }), b.selectedItem),
                searchBox: ba(ao({
                  descendantName: "searchBox"
                }), b.searchBox),
                label: ba(ao({
                  descendantName: "label"
                }), b.label),
                checkbox: ba(ao({
                  descendantName: "checkbox"
                }), b.checkbox),
                labelText: ba(ao({
                  descendantName: "labelText"
                }), b.labelText),
                count: ba(ao({
                  descendantName: "count"
                }), b.count),
                noResults: ba(ao({
                  descendantName: "noResults"
                }), b.noResults),
                showMore: ba(ao({
                  descendantName: "showMore"
                }), b.showMore),
                disabledShowMore: ba(ao({
                  descendantName: "showMore",
                  modifierName: "disabled"
                }), b.disabledShowMore),
                searchable: {
                  root: ba(so(), b.searchableRoot),
                  form: ba(so({
                    descendantName: "form"
                  }), b.searchableForm),
                  input: ba(so({
                    descendantName: "input"
                  }), b.searchableInput),
                  submit: ba(so({
                    descendantName: "submit"
                  }), b.searchableSubmit),
                  submitIcon: ba(so({
                    descendantName: "submitIcon"
                  }), b.searchableSubmitIcon),
                  reset: ba(so({
                    descendantName: "reset"
                  }), b.searchableReset),
                  resetIcon: ba(so({
                    descendantName: "resetIcon"
                  }), b.searchableResetIcon),
                  loadingIndicator: ba(so({
                    descendantName: "loadingIndicator"
                  }), b.searchableLoadingIndicator),
                  loadingIcon: ba(so({
                    descendantName: "loadingIcon"
                  }), b.searchableLoadingIcon)
                }
              },
              x = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.templates,
                  i = e.searchBoxTemplates,
                  a = e.renderState,
                  s = e.showMore,
                  o = e.searchable,
                  c = e.searchablePlaceholder,
                  u = e.searchableIsAlwaysActive;
                return function (e, l) {
                  var f = e.refine,
                    h = e.items,
                    d = e.createURL,
                    p = e.searchForItems,
                    m = e.isFromSearch,
                    g = e.instantSearchInstance,
                    v = e.toggleShowMore,
                    y = e.isShowingMore,
                    b = e.hasExhaustiveItems,
                    R = e.canToggleShowMore;
                  return l ? (a.templateProps = U({
                    defaultTemplates: ro,
                    templatesConfig: g.templatesConfig,
                    templates: r
                  }), void (a.searchBoxTemplateProps = U({
                    defaultTemplates: no,
                    templatesConfig: g.templatesConfig,
                    templates: i
                  }))) : void At(mt(Ha, {
                    createURL: d,
                    cssClasses: n,
                    facetValues: h,
                    templateProps: a.templateProps,
                    searchBoxTemplateProps: a.searchBoxTemplateProps,
                    toggleRefinement: f,
                    searchFacetValues: o ? p : void 0,
                    searchPlaceholder: c,
                    searchIsAlwaysActive: u,
                    isFromSearch: m,
                    showMore: s && !m && 0 < h.length,
                    toggleShowMore: v,
                    isShowingMore: y,
                    hasExhaustiveItems: b,
                    canToggleShowMore: R
                  }), t);
                };
              }({
                containerNode: P,
                cssClasses: O,
                templates: S,
                searchBoxTemplates: {
                  submit: S.searchableSubmit,
                  reset: S.searchableReset,
                  loadingIndicator: S.searchableLoadingIndicator
                },
                renderState: {},
                searchable: f,
                searchablePlaceholder: d,
                searchableIsAlwaysActive: v,
                showMore: c
              });
            return o(o({}, Jt(x, function () {
              return At(null, P);
            })({
              attribute: r,
              operator: i,
              limit: s,
              showMore: c,
              showMoreLimit: u,
              sortBy: a,
              escapeFacetValues: w,
              transformItems: _
            })), {}, {
              $$widgetType: "ais.refinementList"
            });
          },
          relevantSort: function (e) {
            var t = e.container,
              n = e.templates,
              r = void 0 === n ? {} : n,
              i = e.cssClasses,
              a = void 0 === i ? {} : i;
            if (!t) throw new Error(co("The `container` option is required."));
            var s = B(t),
              c = {
                root: ba(uo(), a.root),
                text: ba(uo({
                  descendantName: "text"
                }), a.text),
                button: ba(uo({
                  descendantName: "button"
                }), a.button)
              },
              u = o(o({}, oo), r),
              l = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.templates;
                return function (e) {
                  var i = e.isRelevantSorted,
                    a = e.isVirtualReplica,
                    s = e.refine;
                  At(mt(tr, {
                    cssClasses: n,
                    templates: r,
                    isRelevantSorted: i,
                    isVirtualReplica: a,
                    refine: s
                  }), t);
                };
              }({
                containerNode: s,
                cssClasses: c,
                renderState: {},
                templates: u
              });
            return o(o({}, vn(l, function () {
              At(null, s);
            })({})), {}, {
              $$widgetType: "ais.relevantSort"
            });
          },
          searchBox: function (e) {
            var t = e || {},
              n = t.container,
              r = t.placeholder,
              i = void 0 === r ? "" : r,
              a = t.cssClasses,
              s = void 0 === a ? {} : a,
              c = t.autofocus,
              u = void 0 !== c && c,
              l = t.searchAsYouType,
              f = void 0 === l || l,
              h = t.showReset,
              d = void 0 === h || h,
              p = t.showSubmit,
              m = void 0 === p || p,
              g = t.showLoadingIndicator,
              v = void 0 === g || g,
              y = t.queryHook,
              b = t.templates,
              R = void 0 === b ? {} : b;
            if (!n) throw new Error(lo("The `container` option is required."));
            var S = B(n),
              _ = {
                root: ba(fo(), s.root),
                form: ba(fo({
                  descendantName: "form"
                }), s.form),
                input: ba(fo({
                  descendantName: "input"
                }), s.input),
                submit: ba(fo({
                  descendantName: "submit"
                }), s.submit),
                submitIcon: ba(fo({
                  descendantName: "submitIcon"
                }), s.submitIcon),
                reset: ba(fo({
                  descendantName: "reset"
                }), s.reset),
                resetIcon: ba(fo({
                  descendantName: "resetIcon"
                }), s.resetIcon),
                loadingIndicator: ba(fo({
                  descendantName: "loadingIndicator"
                }), s.loadingIndicator),
                loadingIcon: ba(fo({
                  descendantName: "loadingIcon"
                }), s.loadingIcon)
              },
              w = o(o({}, no), R),
              P = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.placeholder,
                  i = e.templates,
                  a = e.autofocus,
                  s = e.searchAsYouType,
                  o = e.showReset,
                  c = e.showSubmit,
                  u = e.showLoadingIndicator;
                return function (e) {
                  var l = e.refine,
                    f = e.query,
                    h = e.isSearchStalled;
                  At(mt(Ma, {
                    query: f,
                    placeholder: r,
                    autofocus: a,
                    refine: l,
                    searchAsYouType: s,
                    templates: i,
                    showSubmit: c,
                    showReset: o,
                    showLoadingIndicator: u,
                    isSearchStalled: h,
                    cssClasses: n
                  }), t);
                };
              }({
                containerNode: S,
                cssClasses: _,
                placeholder: i,
                templates: w,
                autofocus: u,
                searchAsYouType: f,
                showReset: d,
                showSubmit: m,
                showLoadingIndicator: v
              });
            return o(o({}, Yt(P, function () {
              return At(null, S);
            })({
              queryHook: y
            })), {}, {
              $$widgetType: "ais.searchBox"
            });
          },
          sortBy: function (e) {
            var t = e || {},
              n = t.container,
              r = t.items,
              i = t.cssClasses,
              a = void 0 === i ? {} : i,
              s = t.transformItems;
            if (!n) throw new Error(ho("The `container` option is required."));
            var c = B(n),
              u = {
                root: ba(po(), a.root),
                select: ba(po({
                  descendantName: "select"
                }), a.select),
                option: ba(po({
                  descendantName: "option"
                }), a.option)
              },
              l = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses;
                return function (e, r) {
                  var i = e.currentRefinement,
                    a = e.options,
                    s = e.refine;
                  r || At(mt("div", {
                    className: n.root
                  }, mt(kn, {
                    cssClasses: n,
                    currentValue: i,
                    options: a,
                    setValue: s
                  })), t);
                };
              }({
                containerNode: c,
                cssClasses: u
              });
            return o(o({}, Xt(l, function () {
              return At(null, c);
            })({
              container: c,
              items: r,
              transformItems: s
            })), {}, {
              $$widgetType: "ais.sortBy"
            });
          },
          stats: function (e) {
            var t = e || {},
              n = t.container,
              r = t.cssClasses,
              i = void 0 === r ? {} : r,
              a = t.templates,
              s = void 0 === a ? {} : a;
            if (!n) throw new Error(mo("The `container` option is required."));
            var c = B(n),
              u = {
                root: ba(go(), i.root),
                text: ba(go({
                  descendantName: "text"
                }), i.text)
              },
              l = function (e) {
                var t = e.renderState,
                  n = e.cssClasses,
                  r = e.containerNode,
                  i = e.templates;
                return function (e, a) {
                  var s = e.hitsPerPage,
                    o = e.nbHits,
                    c = e.nbSortedHits,
                    u = e.areHitsSorted,
                    l = e.nbPages,
                    f = e.page,
                    h = e.processingTimeMS,
                    d = e.query,
                    p = e.instantSearchInstance;
                  a ? t.templateProps = U({
                    defaultTemplates: vo,
                    templatesConfig: p.templatesConfig,
                    templates: i
                  }) : At(mt(nr, {
                    cssClasses: n,
                    hitsPerPage: s,
                    nbHits: o,
                    nbSortedHits: c,
                    areHitsSorted: u,
                    nbPages: l,
                    page: f,
                    processingTimeMS: h,
                    query: d,
                    templateProps: t.templateProps
                  }), r);
                };
              }({
                containerNode: c,
                cssClasses: u,
                templates: s,
                renderState: {}
              });
            return o(o({}, en(l, function () {
              return At(null, c);
            })({})), {}, {
              $$widgetType: "ais.stats"
            });
          },
          toggleRefinement: function (e) {
            var t = e || {},
              n = t.container,
              r = t.attribute,
              i = t.cssClasses,
              a = void 0 === i ? {} : i,
              s = t.templates,
              c = void 0 === s ? {} : s,
              u = t.on,
              l = void 0 === u || u,
              f = t.off;
            if (!n) throw new Error(bo("The `container` option is required."));
            var h = B(n),
              d = {
                root: ba(Ro(), a.root),
                label: ba(Ro({
                  descendantName: "label"
                }), a.label),
                checkbox: ba(Ro({
                  descendantName: "checkbox"
                }), a.checkbox),
                labelText: ba(Ro({
                  descendantName: "labelText"
                }), a.labelText)
              },
              p = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.renderState,
                  i = e.templates;
                return function (e, a) {
                  var s = e.value,
                    o = e.refine,
                    c = e.instantSearchInstance;
                  a ? r.templateProps = U({
                    defaultTemplates: yo,
                    templatesConfig: c.templatesConfig,
                    templates: i
                  }) : At(mt(rr, {
                    cssClasses: n,
                    currentRefinement: s,
                    templateProps: r.templateProps,
                    refine: o
                  }), t);
                };
              }({
                containerNode: h,
                cssClasses: d,
                renderState: {},
                templates: c
              });
            return o(o({}, tn(p, function () {
              return At(null, h);
            })({
              attribute: r,
              on: l,
              off: f
            })), {}, {
              $$widgetType: "ais.toggleRefinement"
            });
          },
          voiceSearch: function (e) {
            var t = e || {},
              n = t.container,
              r = t.cssClasses,
              i = void 0 === r ? {} : r,
              a = t.templates,
              s = void 0 === a ? {} : a,
              c = t.searchAsYouSpeak,
              u = void 0 !== c && c,
              l = t.language,
              f = t.additionalQueryParameters,
              h = t.createVoiceSearchHelper;
            if (!n) throw new Error(_o("The `container` option is required."));
            var d = B(n),
              p = {
                root: ba(wo(), i.root),
                button: ba(wo({
                  descendantName: "button"
                }), i.button),
                status: ba(wo({
                  descendantName: "status"
                }), i.status)
              },
              m = o(o({}, So), s),
              g = function (e) {
                var t = e.containerNode,
                  n = e.cssClasses,
                  r = e.templates;
                return function (e) {
                  var i = e.isBrowserSupported,
                    a = e.isListening,
                    s = e.toggleListening,
                    o = e.voiceListeningState;
                  At(mt(ir, {
                    cssClasses: n,
                    templates: r,
                    isBrowserSupported: i,
                    isListening: a,
                    toggleListening: s,
                    voiceListeningState: o
                  }), t);
                };
              }({
                containerNode: d,
                cssClasses: p,
                templates: m
              });
            return o(o({}, mn(g, function () {
              return At(null, d);
            })({
              container: d,
              cssClasses: p,
              templates: m,
              searchAsYouSpeak: u,
              language: l,
              additionalQueryParameters: f,
              createVoiceSearchHelper: h
            })), {}, {
              $$widgetType: "ais.voiceSearch"
            });
          }
        }),
        xo = Object.freeze({
          __proto__: null,
          createInsightsMiddleware: function (e) {
            var t = e || {},
              n = t.insightsClient,
              r = t.insightsInitParams,
              i = t.onEvent;
            if (null !== n && !n) throw new Error("The `insightsClient` option is required. To disable, set it to `null`.");
            var a = Boolean(n),
              s = null === n ? Z : n;
            return function (e) {
              var t = e.instantSearchInstance,
                c = p(function (e) {
                  if (e.transporter) {
                    var t = e.transporter,
                      n = t.headers,
                      r = t.queryParameters,
                      i = "x-algolia-application-id",
                      a = "x-algolia-api-key";
                    return [n[i] || r[i], n[a] || r[a]];
                  }
                  return [e.applicationID, e.apiKey];
                }(t.client), 2),
                u = c[0],
                l = c[1],
                f = void 0,
                h = void 0;
              if (Array.isArray(s.queue)) {
                var d = p(z(s.queue.slice().reverse(), function (e) {
                  return "setUserToken" === p(e, 1)[0];
                }) || [], 2);
                f = d[1];
              }
              s("getUserToken", null, function (e, t) {
                h = t;
              }), s("init", o({
                appId: u,
                apiKey: l
              }, r));
              var m,
                g,
                v = un(Z);
              return {
                onStateChange: function () {},
                subscribe: function () {
                  function e(e) {
                    g && t.removeWidgets([g]), g = v({
                      searchParameters: {
                        userToken: e
                      }
                    }), t.addWidgets([g]);
                  }
                  s("addAlgoliaAgent", "insights-middleware"), m = v({
                    searchParameters: {
                      clickAnalytics: !0
                    }
                  }), t.addWidgets([m]);
                  var r = Qe();
                  a && r && e(r), h ? s("setUserToken", h) : f && s("setUserToken", f), s("onUserTokenChange", e, {
                    immediate: !0
                  }), t.sendEventToInsights = function (e) {
                    i ? i(e, n) : e.insightsMethod && Boolean(t.renderState[t.indexName].configure.widgetParams.searchParameters.userToken) && s(e.insightsMethod, e.payload);
                  };
                },
                unsubscribe: function () {
                  s("onUserTokenChange", void 0), t.removeWidgets([m, g]), g = m = void 0, t.sendEventToInsights = Z;
                }
              };
            };
          },
          createRouterMiddleware: Ze,
          isMetadataEnabled: et,
          createMetadataMiddleware: tt
        }),
        jo = Object.freeze({
          __proto__: null,
          history: Xe
        }),
        Io = Object.freeze({
          __proto__: null,
          simple: Ve,
          singleIndex: function (e) {
            return {
              stateToRoute: function (t) {
                return ar(t[e] || {});
              },
              routeToState: function (t) {
                return i({}, e, ar(0 < arguments.length && void 0 !== t ? t : {}));
              }
            };
          }
        }),
        Fo = "ais.infiniteHits";
      return or.version = "4.41.0", or.connectors = va, or.widgets = Oo, or.middlewares = xo, or.routers = jo, or.stateMappings = Io, or.createInfiniteHitsSessionStorageCache = function () {
        return {
          read: function (e) {
            var t = e.state,
              n = Ne(function (e) {
                return e.window.sessionStorage;
              });
            if (!n) return null;
            try {
              var r = JSON.parse(n.getItem(Fo));
              return r && se(r.state, sr(t)) ? r.hits : null;
            } catch (e) {
              if (e instanceof SyntaxError) try {
                n.removeItem(Fo);
              } catch (e) {}
              return null;
            }
          },
          write: function (e) {
            var t = e.state,
              n = e.hits,
              r = Ne(function (e) {
                return e.window.sessionStorage;
              });
            if (r) try {
              r.setItem(Fo, JSON.stringify({
                state: sr(t),
                hits: n
              }));
            } catch (e) {}
          }
        };
      }, or.highlight = Me, or.reverseHighlight = He, or.snippet = qe, or.reverseSnippet = Be, or.insights = We, or;
    });
  }, function (e, t, n) {
    !function (t, n) {
      e.exports = n();
    }(this, function () {
      "use strict";

      function e(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function t(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function n(n) {
        for (var r = 1; r < arguments.length; r++) {
          var i = null != arguments[r] ? arguments[r] : {};
          r % 2 ? t(Object(i), !0).forEach(function (t) {
            e(n, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function (e) {
            Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(i, e));
          });
        }
        return n;
      }
      function r(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              i = {},
              a = Object.keys(e);
            for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }
      function i(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
            var n = [],
              r = !0,
              i = !1,
              a = void 0;
            try {
              for (var s, o = e[Symbol.iterator](); !(r = (s = o.next()).done) && (n.push(s.value), !t || n.length !== t); r = !0);
            } catch (e) {
              i = !0, a = e;
            } finally {
              try {
                r || null == o.return || o.return();
              } finally {
                if (i) throw a;
              }
            }
            return n;
          }
        }(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function a(e) {
        return function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
            return n;
          }
        }(e) || function (e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }
      function s(e) {
        var t,
          n = "algoliasearch-client-js-".concat(e.key),
          r = function () {
            return void 0 === t && (t = e.localStorage || window.localStorage), t;
          },
          a = function () {
            return JSON.parse(r().getItem(n) || "{}");
          };
        return {
          get: function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
              miss: function () {
                return Promise.resolve();
              }
            };
            return Promise.resolve().then(function () {
              var n = JSON.stringify(e),
                r = a()[n];
              return Promise.all([r || t(), void 0 !== r]);
            }).then(function (e) {
              var t = i(e, 2),
                r = t[0],
                a = t[1];
              return Promise.all([r, a || n.miss(r)]);
            }).then(function (e) {
              return i(e, 1)[0];
            });
          },
          set: function (e, t) {
            return Promise.resolve().then(function () {
              var i = a();
              return i[JSON.stringify(e)] = t, r().setItem(n, JSON.stringify(i)), t;
            });
          },
          delete: function (e) {
            return Promise.resolve().then(function () {
              var t = a();
              delete t[JSON.stringify(e)], r().setItem(n, JSON.stringify(t));
            });
          },
          clear: function () {
            return Promise.resolve().then(function () {
              r().removeItem(n);
            });
          }
        };
      }
      function o(e) {
        var t = a(e.caches),
          n = t.shift();
        return void 0 === n ? {
          get: function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                miss: function () {
                  return Promise.resolve();
                }
              },
              r = t();
            return r.then(function (e) {
              return Promise.all([e, n.miss(e)]);
            }).then(function (e) {
              return i(e, 1)[0];
            });
          },
          set: function (e, t) {
            return Promise.resolve(t);
          },
          delete: function (e) {
            return Promise.resolve();
          },
          clear: function () {
            return Promise.resolve();
          }
        } : {
          get: function (e, r) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
              miss: function () {
                return Promise.resolve();
              }
            };
            return n.get(e, r, i).catch(function () {
              return o({
                caches: t
              }).get(e, r, i);
            });
          },
          set: function (e, r) {
            return n.set(e, r).catch(function () {
              return o({
                caches: t
              }).set(e, r);
            });
          },
          delete: function (e) {
            return n.delete(e).catch(function () {
              return o({
                caches: t
              }).delete(e);
            });
          },
          clear: function () {
            return n.clear().catch(function () {
              return o({
                caches: t
              }).clear();
            });
          }
        };
      }
      function c() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            serializable: !0
          },
          t = {};
        return {
          get: function (n, r) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                miss: function () {
                  return Promise.resolve();
                }
              },
              a = JSON.stringify(n);
            if (a in t) return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);
            var s = r(),
              o = i && i.miss || function () {
                return Promise.resolve();
              };
            return s.then(function (e) {
              return o(e);
            }).then(function () {
              return s;
            });
          },
          set: function (n, r) {
            return t[JSON.stringify(n)] = e.serializable ? JSON.stringify(r) : r, Promise.resolve(r);
          },
          delete: function (e) {
            return delete t[JSON.stringify(e)], Promise.resolve();
          },
          clear: function () {
            return t = {}, Promise.resolve();
          }
        };
      }
      function u(e, t, n) {
        var r = {
          "x-algolia-api-key": n,
          "x-algolia-application-id": t
        };
        return {
          headers: function () {
            return e === I.WithinHeaders ? r : {};
          },
          queryParameters: function () {
            return e === I.WithinQueryParameters ? r : {};
          }
        };
      }
      function l(e) {
        var t = 0;
        return e(function n() {
          return t++, new Promise(function (r) {
            setTimeout(function () {
              r(e(n));
            }, Math.min(100 * t, 1e3));
          });
        });
      }
      function f(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (e, t) {
          return Promise.resolve();
        };
        return Object.assign(e, {
          wait: function (n) {
            return f(e.then(function (e) {
              return Promise.all([t(e, n), e]);
            }).then(function (e) {
              return e[1];
            }));
          }
        });
      }
      function h(e) {
        for (var t = e.length - 1; t > 0; t--) {
          var n = Math.floor(Math.random() * (t + 1)),
            r = e[t];
          e[t] = e[n], e[n] = r;
        }
        return e;
      }
      function d(e, t) {
        return t ? (Object.keys(t).forEach(function (n) {
          e[n] = t[n](e);
        }), e) : e;
      }
      function p(e) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
        var i = 0;
        return e.replace(/%s/g, function () {
          return encodeURIComponent(n[i++]);
        });
      }
      function m(e, t) {
        var n = e || {},
          r = n.data || {};
        return Object.keys(n).forEach(function (e) {
          -1 === ["timeout", "headers", "queryParameters", "data", "cacheable"].indexOf(e) && (r[e] = n[e]);
        }), {
          data: Object.entries(r).length > 0 ? r : void 0,
          timeout: n.timeout || t,
          headers: n.headers || {},
          queryParameters: n.queryParameters || {},
          cacheable: n.cacheable
        };
      }
      function g(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : N;
        return n(n({}, e), {}, {
          status: t,
          lastUpdate: Date.now()
        });
      }
      function v(e) {
        return "string" == typeof e ? {
          protocol: "https",
          url: e,
          accept: F.Any
        } : {
          protocol: e.protocol || "https",
          url: e.url,
          accept: e.accept || F.Any
        };
      }
      function y(e, t) {
        return Promise.all(t.map(function (t) {
          return e.get(t, function () {
            return Promise.resolve(g(t));
          });
        })).then(function (e) {
          var n = e.filter(function (e) {
              return function (e) {
                return e.status === N || Date.now() - e.lastUpdate > 12e4;
              }(e);
            }),
            r = e.filter(function (e) {
              return function (e) {
                return e.status === C && Date.now() - e.lastUpdate <= 12e4;
              }(e);
            }),
            i = [].concat(a(n), a(r));
          return {
            getTimeout: function (e, t) {
              return (0 === r.length && 0 === e ? 1 : r.length + 3 + e) * t;
            },
            statelessHosts: i.length > 0 ? i.map(function (e) {
              return v(e);
            }) : t
          };
        });
      }
      function b(e, t, r, i) {
        var s = [],
          o = function (e, t) {
            if (e.method !== k && (void 0 !== e.data || void 0 !== t.data)) {
              var r = Array.isArray(e.data) ? e.data : n(n({}, e.data), t.data);
              return JSON.stringify(r);
            }
          }(r, i),
          c = function (e, t) {
            var r = n(n({}, e.headers), t.headers),
              i = {};
            return Object.keys(r).forEach(function (e) {
              var t = r[e];
              i[e.toLowerCase()] = t;
            }), i;
          }(e, i),
          u = r.method,
          l = r.method !== k ? {} : n(n({}, r.data), i.data),
          f = n(n(n({
            "x-algolia-agent": e.userAgent.value
          }, e.queryParameters), l), i.queryParameters),
          h = 0,
          d = function t(n, a) {
            var l = n.pop();
            if (void 0 === l) throw {
              name: "RetryError",
              message: "Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",
              transporterStackTrace: P(s)
            };
            var d = {
                data: o,
                headers: c,
                method: u,
                url: _(l, r.path, f),
                connectTimeout: a(h, e.timeouts.connect),
                responseTimeout: a(h, i.timeout)
              },
              p = function (e) {
                var t = {
                  request: d,
                  response: e,
                  host: l,
                  triesLeft: n.length
                };
                return s.push(t), t;
              },
              m = {
                onSuccess: function (e) {
                  return function (e) {
                    try {
                      return JSON.parse(e.content);
                    } catch (t) {
                      throw function (e, t) {
                        return {
                          name: "DeserializationError",
                          message: e,
                          response: t
                        };
                      }(t.message, e);
                    }
                  }(e);
                },
                onRetry: function (r) {
                  var i = p(r);
                  return r.isTimedOut && h++, Promise.all([e.logger.info("Retryable failure", O(i)), e.hostsCache.set(l, g(l, r.isTimedOut ? C : E))]).then(function () {
                    return t(n, a);
                  });
                },
                onFail: function (e) {
                  throw p(e), function (e, t) {
                    var n = e.content,
                      r = e.status,
                      i = n;
                    try {
                      i = JSON.parse(n).message;
                    } catch (e) {}
                    return function (e, t, n) {
                      return {
                        name: "ApiError",
                        message: e,
                        status: t,
                        transporterStackTrace: n
                      };
                    }(i, r, t);
                  }(e, P(s));
                }
              };
            return e.requester.send(d).then(function (e) {
              return function (e, t) {
                return function (e) {
                  var t = e.status;
                  return e.isTimedOut || function (e) {
                    var t = e.isTimedOut,
                      n = e.status;
                    return !t && 0 == ~~n;
                  }(e) || 2 != ~~(t / 100) && 4 != ~~(t / 100);
                }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e);
              }(e, m);
            });
          };
        return y(e.hostsCache, t).then(function (e) {
          return d(a(e.statelessHosts).reverse(), e.getTimeout);
        });
      }
      function R(e) {
        var t = e.hostsCache,
          n = e.logger,
          r = e.requester,
          a = e.requestsCache,
          s = e.responsesCache,
          o = e.timeouts,
          c = e.userAgent,
          u = e.hosts,
          l = e.queryParameters,
          f = {
            hostsCache: t,
            logger: n,
            requester: r,
            requestsCache: a,
            responsesCache: s,
            timeouts: o,
            userAgent: c,
            headers: e.headers,
            queryParameters: l,
            hosts: u.map(function (e) {
              return v(e);
            }),
            read: function (e, t) {
              var n = m(t, f.timeouts.read),
                r = function () {
                  return b(f, f.hosts.filter(function (e) {
                    return 0 != (e.accept & F.Read);
                  }), e, n);
                };
              if (!0 !== (void 0 !== n.cacheable ? n.cacheable : e.cacheable)) return r();
              var a = {
                request: e,
                mappedRequestOptions: n,
                transporter: {
                  queryParameters: f.queryParameters,
                  headers: f.headers
                }
              };
              return f.responsesCache.get(a, function () {
                return f.requestsCache.get(a, function () {
                  return f.requestsCache.set(a, r()).then(function (e) {
                    return Promise.all([f.requestsCache.delete(a), e]);
                  }, function (e) {
                    return Promise.all([f.requestsCache.delete(a), Promise.reject(e)]);
                  }).then(function (e) {
                    var t = i(e, 2);
                    return t[0], t[1];
                  });
                });
              }, {
                miss: function (e) {
                  return f.responsesCache.set(a, e);
                }
              });
            },
            write: function (e, t) {
              return b(f, f.hosts.filter(function (e) {
                return 0 != (e.accept & F.Write);
              }), e, m(t, f.timeouts.write));
            }
          };
        return f;
      }
      function S(e) {
        var t = {
          value: "Algolia for JavaScript (".concat(e, ")"),
          add: function (e) {
            var n = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
            return -1 === t.value.indexOf(n) && (t.value = "".concat(t.value).concat(n)), t;
          }
        };
        return t;
      }
      function _(e, t, n) {
        var r = w(n),
          i = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
        return r.length && (i += "?".concat(r)), i;
      }
      function w(e) {
        return Object.keys(e).map(function (t) {
          return p("%s=%s", t, (n = e[t], "[object Object]" === Object.prototype.toString.call(n) || "[object Array]" === Object.prototype.toString.call(n) ? JSON.stringify(e[t]) : e[t]));
          var n;
        }).join("&");
      }
      function P(e) {
        return e.map(function (e) {
          return O(e);
        });
      }
      function O(e) {
        var t = e.request.headers["x-algolia-api-key"] ? {
          "x-algolia-api-key": "*****"
        } : {};
        return n(n({}, e), {}, {
          request: n(n({}, e.request), {}, {
            headers: n(n({}, e.request.headers), t)
          })
        });
      }
      function x(e) {
        return function t(n) {
          return e.request(n).then(function (r) {
            if (void 0 !== e.batch && e.batch(r.hits), !e.shouldStop(r)) return t(r.cursor ? {
              cursor: r.cursor
            } : {
              page: (n.page || 0) + 1
            });
          });
        }({});
      }
      function j(e, t, r) {
        var i,
          a = {
            appId: e,
            apiKey: t,
            timeouts: {
              connect: 1,
              read: 2,
              write: 30
            },
            requester: {
              send: function (e) {
                return new Promise(function (t) {
                  var n = new XMLHttpRequest();
                  n.open(e.method, e.url, !0), Object.keys(e.headers).forEach(function (t) {
                    return n.setRequestHeader(t, e.headers[t]);
                  });
                  var r,
                    i = function (e, r) {
                      return setTimeout(function () {
                        n.abort(), t({
                          status: 0,
                          content: r,
                          isTimedOut: !0
                        });
                      }, 1e3 * e);
                    },
                    a = i(e.connectTimeout, "Connection timeout");
                  n.onreadystatechange = function () {
                    n.readyState > n.OPENED && void 0 === r && (clearTimeout(a), r = i(e.responseTimeout, "Socket timeout"));
                  }, n.onerror = function () {
                    0 === n.status && (clearTimeout(a), clearTimeout(r), t({
                      content: n.responseText || "Network request failed",
                      status: n.status,
                      isTimedOut: !1
                    }));
                  }, n.onload = function () {
                    clearTimeout(a), clearTimeout(r), t({
                      content: n.responseText,
                      status: n.status,
                      isTimedOut: !1
                    });
                  }, n.send(e.data);
                });
              }
            },
            logger: (i = vt, {
              debug: function (e, t) {
                return mt >= i && console.debug(e, t), Promise.resolve();
              },
              info: function (e, t) {
                return gt >= i && console.info(e, t), Promise.resolve();
              },
              error: function (e, t) {
                return console.error(e, t), Promise.resolve();
              }
            }),
            responsesCache: c(),
            requestsCache: c({
              serializable: !1
            }),
            hostsCache: o({
              caches: [s({
                key: "".concat("4.14.3", "-").concat(e)
              }), c()]
            }),
            userAgent: S("4.14.3").add({
              segment: "Browser"
            })
          },
          l = n(n({}, a), r),
          f = function () {
            return function (e) {
              return function (e) {
                var t = e.region || "us",
                  r = u(I.WithinHeaders, e.appId, e.apiKey),
                  i = R(n(n({
                    hosts: [{
                      url: "personalization.".concat(t, ".algolia.com")
                    }]
                  }, e), {}, {
                    headers: n(n(n({}, r.headers()), {
                      "content-type": "application/json"
                    }), e.headers),
                    queryParameters: n(n({}, r.queryParameters()), e.queryParameters)
                  }));
                return d({
                  appId: e.appId,
                  transporter: i
                }, e.methods);
              }(n(n(n({}, a), e), {}, {
                methods: {
                  getPersonalizationStrategy: W,
                  setPersonalizationStrategy: Q
                }
              }));
            };
          };
        return function (e) {
          var t = e.appId,
            r = u(void 0 !== e.authMode ? e.authMode : I.WithinHeaders, t, e.apiKey),
            i = R(n(n({
              hosts: [{
                url: "".concat(t, "-dsn.algolia.net"),
                accept: F.Read
              }, {
                url: "".concat(t, ".algolia.net"),
                accept: F.Write
              }].concat(h([{
                url: "".concat(t, "-1.algolianet.com")
              }, {
                url: "".concat(t, "-2.algolianet.com")
              }, {
                url: "".concat(t, "-3.algolianet.com")
              }]))
            }, e), {}, {
              headers: n(n(n({}, r.headers()), {
                "content-type": "application/x-www-form-urlencoded"
              }), e.headers),
              queryParameters: n(n({}, r.queryParameters()), e.queryParameters)
            }));
          return d({
            transporter: i,
            appId: t,
            addAlgoliaAgent: function (e, t) {
              i.userAgent.add({
                segment: e,
                version: t
              });
            },
            clearCache: function () {
              return Promise.all([i.requestsCache.clear(), i.responsesCache.clear()]).then(function () {});
            }
          }, e.methods);
        }(n(n({}, l), {}, {
          methods: {
            search: ge,
            searchForFacetValues: ve,
            multipleBatch: pe,
            multipleGetObjects: me,
            multipleQueries: ge,
            copyIndex: K,
            copySettings: G,
            copySynonyms: Y,
            copyRules: J,
            moveIndex: de,
            listIndices: fe,
            getLogs: ie,
            listClusters: le,
            multipleSearchForFacetValues: ve,
            getApiKey: te,
            addApiKey: U,
            listApiKeys: ue,
            updateApiKey: Oe,
            deleteApiKey: Z,
            restoreApiKey: Re,
            assignUserID: V,
            assignUserIDs: $,
            getUserID: se,
            searchUserIDs: we,
            listUserIDs: he,
            getTopUserIDs: ae,
            removeUserID: ye,
            hasPendingMappings: oe,
            clearDictionaryEntries: z,
            deleteDictionaryEntries: ee,
            getDictionarySettings: re,
            getAppTask: ne,
            replaceDictionaryEntries: be,
            saveDictionaryEntries: Se,
            searchDictionaryEntries: _e,
            setDictionarySettings: Pe,
            waitAppTask: xe,
            customRequest: X,
            initIndex: function (e) {
              return function (t) {
                return ce(e)(t, {
                  methods: {
                    batch: je,
                    delete: De,
                    findAnswers: We,
                    getObject: Ue,
                    getObjects: $e,
                    saveObject: tt,
                    saveObjects: nt,
                    search: ot,
                    searchForFacetValues: ct,
                    waitTask: ht,
                    setSettings: ft,
                    getSettings: Ke,
                    partialUpdateObject: Ge,
                    partialUpdateObjects: Ye,
                    deleteObject: Le,
                    deleteObjects: Me,
                    deleteBy: Ae,
                    clearObjects: Ce,
                    browseObjects: Ie,
                    getObjectPosition: Ve,
                    findObject: Qe,
                    exists: Be,
                    saveSynonym: at,
                    saveSynonyms: st,
                    getSynonym: Je,
                    searchSynonyms: lt,
                    browseSynonyms: Ne,
                    deleteSynonym: qe,
                    clearSynonyms: ke,
                    replaceAllObjects: Xe,
                    replaceAllSynonyms: et,
                    searchRules: ut,
                    getRule: ze,
                    deleteRule: He,
                    saveRule: rt,
                    saveRules: it,
                    replaceAllRules: Ze,
                    browseRules: Fe,
                    clearRules: Te
                  }
                });
              };
            },
            initAnalytics: function () {
              return function (e) {
                return function (e) {
                  var t = e.region || "us",
                    r = u(I.WithinHeaders, e.appId, e.apiKey),
                    i = R(n(n({
                      hosts: [{
                        url: "analytics.".concat(t, ".algolia.com")
                      }]
                    }, e), {}, {
                      headers: n(n(n({}, r.headers()), {
                        "content-type": "application/json"
                      }), e.headers),
                      queryParameters: n(n({}, r.queryParameters()), e.queryParameters)
                    }));
                  return d({
                    appId: e.appId,
                    transporter: i
                  }, e.methods);
                }(n(n(n({}, a), e), {}, {
                  methods: {
                    addABTest: L,
                    getABTest: H,
                    getABTests: q,
                    stopABTest: B,
                    deleteABTest: M
                  }
                }));
              };
            },
            initPersonalization: f,
            initRecommendation: function () {
              return function (e) {
                return l.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."), f()(e);
              };
            }
          }
        }));
      }
      var I = {
          WithinQueryParameters: 0,
          WithinHeaders: 1
        },
        F = {
          Read: 1,
          Write: 2,
          Any: 3
        },
        N = 1,
        E = 2,
        C = 3,
        T = "DELETE",
        k = "GET",
        A = "POST",
        D = "PUT",
        L = function (e) {
          return function (t, n) {
            return e.transporter.write({
              method: A,
              path: "2/abtests",
              data: t
            }, n);
          };
        },
        M = function (e) {
          return function (t, n) {
            return e.transporter.write({
              method: T,
              path: p("2/abtests/%s", t)
            }, n);
          };
        },
        H = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: k,
              path: p("2/abtests/%s", t)
            }, n);
          };
        },
        q = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "2/abtests"
            }, t);
          };
        },
        B = function (e) {
          return function (t, n) {
            return e.transporter.write({
              method: A,
              path: p("2/abtests/%s/stop", t)
            }, n);
          };
        },
        W = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "1/strategies/personalization"
            }, t);
          };
        },
        Q = function (e) {
          return function (t, n) {
            return e.transporter.write({
              method: A,
              path: "1/strategies/personalization",
              data: t
            }, n);
          };
        },
        U = function (e) {
          return function (t, i) {
            var a = i || {},
              s = a.queryParameters,
              o = r(a, ["queryParameters"]),
              c = n({
                acl: t
              }, void 0 !== s ? {
                queryParameters: s
              } : {});
            return f(e.transporter.write({
              method: A,
              path: "1/keys",
              data: c
            }, o), function (t, n) {
              return l(function (r) {
                return te(e)(t.key, n).catch(function (e) {
                  if (404 !== e.status) throw e;
                  return r();
                });
              });
            });
          };
        },
        V = function (e) {
          return function (t, n, r) {
            var i = m(r);
            return i.queryParameters["X-Algolia-User-ID"] = t, e.transporter.write({
              method: A,
              path: "1/clusters/mapping",
              data: {
                cluster: n
              }
            }, i);
          };
        },
        $ = function (e) {
          return function (t, n, r) {
            return e.transporter.write({
              method: A,
              path: "1/clusters/mapping/batch",
              data: {
                users: t,
                cluster: n
              }
            }, r);
          };
        },
        z = function (e) {
          return function (t, n) {
            return f(e.transporter.write({
              method: A,
              path: p("/1/dictionaries/%s/batch", t),
              data: {
                clearExistingDictionaryEntries: !0,
                requests: {
                  action: "addEntry",
                  body: []
                }
              }
            }, n), function (t, n) {
              return xe(e)(t.taskID, n);
            });
          };
        },
        K = function (e) {
          return function (t, n, r) {
            return f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/operation", t),
              data: {
                operation: "copy",
                destination: n
              }
            }, r), function (n, r) {
              return ce(e)(t, {
                methods: {
                  waitTask: ht
                }
              }).waitTask(n.taskID, r);
            });
          };
        },
        J = function (e) {
          return function (t, r, i) {
            return K(e)(t, r, n(n({}, i), {}, {
              scope: [pt.Rules]
            }));
          };
        },
        G = function (e) {
          return function (t, r, i) {
            return K(e)(t, r, n(n({}, i), {}, {
              scope: [pt.Settings]
            }));
          };
        },
        Y = function (e) {
          return function (t, r, i) {
            return K(e)(t, r, n(n({}, i), {}, {
              scope: [pt.Synonyms]
            }));
          };
        },
        X = function (e) {
          return function (t, n) {
            return t.method === k ? e.transporter.read(t, n) : e.transporter.write(t, n);
          };
        },
        Z = function (e) {
          return function (t, n) {
            return f(e.transporter.write({
              method: T,
              path: p("1/keys/%s", t)
            }, n), function (n, r) {
              return l(function (n) {
                return te(e)(t, r).then(n).catch(function (e) {
                  if (404 !== e.status) throw e;
                });
              });
            });
          };
        },
        ee = function (e) {
          return function (t, n, r) {
            var i = n.map(function (e) {
              return {
                action: "deleteEntry",
                body: {
                  objectID: e
                }
              };
            });
            return f(e.transporter.write({
              method: A,
              path: p("/1/dictionaries/%s/batch", t),
              data: {
                clearExistingDictionaryEntries: !1,
                requests: i
              }
            }, r), function (t, n) {
              return xe(e)(t.taskID, n);
            });
          };
        },
        te = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: k,
              path: p("1/keys/%s", t)
            }, n);
          };
        },
        ne = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: k,
              path: p("1/task/%s", t.toString())
            }, n);
          };
        },
        re = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "/1/dictionaries/*/settings"
            }, t);
          };
        },
        ie = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "1/logs"
            }, t);
          };
        },
        ae = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "1/clusters/mapping/top"
            }, t);
          };
        },
        se = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: k,
              path: p("1/clusters/mapping/%s", t)
            }, n);
          };
        },
        oe = function (e) {
          return function (t) {
            var n = t || {},
              i = n.retrieveMappings,
              a = r(n, ["retrieveMappings"]);
            return !0 === i && (a.getClusters = !0), e.transporter.read({
              method: k,
              path: "1/clusters/mapping/pending"
            }, a);
          };
        },
        ce = function (e) {
          return function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = {
                transporter: e.transporter,
                appId: e.appId,
                indexName: t
              };
            return d(r, n.methods);
          };
        },
        ue = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "1/keys"
            }, t);
          };
        },
        le = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "1/clusters"
            }, t);
          };
        },
        fe = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "1/indexes"
            }, t);
          };
        },
        he = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: "1/clusters/mapping"
            }, t);
          };
        },
        de = function (e) {
          return function (t, n, r) {
            return f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/operation", t),
              data: {
                operation: "move",
                destination: n
              }
            }, r), function (n, r) {
              return ce(e)(t, {
                methods: {
                  waitTask: ht
                }
              }).waitTask(n.taskID, r);
            });
          };
        },
        pe = function (e) {
          return function (t, n) {
            return f(e.transporter.write({
              method: A,
              path: "1/indexes/*/batch",
              data: {
                requests: t
              }
            }, n), function (t, n) {
              return Promise.all(Object.keys(t.taskID).map(function (r) {
                return ce(e)(r, {
                  methods: {
                    waitTask: ht
                  }
                }).waitTask(t.taskID[r], n);
              }));
            });
          };
        },
        me = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: A,
              path: "1/indexes/*/objects",
              data: {
                requests: t
              }
            }, n);
          };
        },
        ge = function (e) {
          return function (t, r) {
            var i = t.map(function (e) {
              return n(n({}, e), {}, {
                params: w(e.params || {})
              });
            });
            return e.transporter.read({
              method: A,
              path: "1/indexes/*/queries",
              data: {
                requests: i
              },
              cacheable: !0
            }, r);
          };
        },
        ve = function (e) {
          return function (t, i) {
            return Promise.all(t.map(function (t) {
              var a = t.params,
                s = a.facetName,
                o = a.facetQuery,
                c = r(a, ["facetName", "facetQuery"]);
              return ce(e)(t.indexName, {
                methods: {
                  searchForFacetValues: ct
                }
              }).searchForFacetValues(s, o, n(n({}, i), c));
            }));
          };
        },
        ye = function (e) {
          return function (t, n) {
            var r = m(n);
            return r.queryParameters["X-Algolia-User-ID"] = t, e.transporter.write({
              method: T,
              path: "1/clusters/mapping"
            }, r);
          };
        },
        be = function (e) {
          return function (t, n, r) {
            var i = n.map(function (e) {
              return {
                action: "addEntry",
                body: e
              };
            });
            return f(e.transporter.write({
              method: A,
              path: p("/1/dictionaries/%s/batch", t),
              data: {
                clearExistingDictionaryEntries: !0,
                requests: i
              }
            }, r), function (t, n) {
              return xe(e)(t.taskID, n);
            });
          };
        },
        Re = function (e) {
          return function (t, n) {
            return f(e.transporter.write({
              method: A,
              path: p("1/keys/%s/restore", t)
            }, n), function (n, r) {
              return l(function (n) {
                return te(e)(t, r).catch(function (e) {
                  if (404 !== e.status) throw e;
                  return n();
                });
              });
            });
          };
        },
        Se = function (e) {
          return function (t, n, r) {
            var i = n.map(function (e) {
              return {
                action: "addEntry",
                body: e
              };
            });
            return f(e.transporter.write({
              method: A,
              path: p("/1/dictionaries/%s/batch", t),
              data: {
                clearExistingDictionaryEntries: !1,
                requests: i
              }
            }, r), function (t, n) {
              return xe(e)(t.taskID, n);
            });
          };
        },
        _e = function (e) {
          return function (t, n, r) {
            return e.transporter.read({
              method: A,
              path: p("/1/dictionaries/%s/search", t),
              data: {
                query: n
              },
              cacheable: !0
            }, r);
          };
        },
        we = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: A,
              path: "1/clusters/mapping/search",
              data: {
                query: t
              }
            }, n);
          };
        },
        Pe = function (e) {
          return function (t, n) {
            return f(e.transporter.write({
              method: D,
              path: "/1/dictionaries/*/settings",
              data: t
            }, n), function (t, n) {
              return xe(e)(t.taskID, n);
            });
          };
        },
        Oe = function (e) {
          return function (t, n) {
            var i = Object.assign({}, n),
              a = n || {},
              s = a.queryParameters,
              o = r(a, ["queryParameters"]),
              c = s ? {
                queryParameters: s
              } : {},
              u = ["acl", "indexes", "referers", "restrictSources", "queryParameters", "description", "maxQueriesPerIPPerHour", "maxHitsPerQuery"];
            return f(e.transporter.write({
              method: D,
              path: p("1/keys/%s", t),
              data: c
            }, o), function (n, r) {
              return l(function (n) {
                return te(e)(t, r).then(function (e) {
                  return function (e) {
                    return Object.keys(i).filter(function (e) {
                      return -1 !== u.indexOf(e);
                    }).every(function (t) {
                      return e[t] === i[t];
                    });
                  }(e) ? Promise.resolve() : n();
                });
              });
            });
          };
        },
        xe = function (e) {
          return function (t, n) {
            return l(function (r) {
              return ne(e)(t, n).then(function (e) {
                return "published" !== e.status ? r() : void 0;
              });
            });
          };
        },
        je = function (e) {
          return function (t, n) {
            return f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/batch", e.indexName),
              data: {
                requests: t
              }
            }, n), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        Ie = function (e) {
          return function (t) {
            return x(n(n({
              shouldStop: function (e) {
                return void 0 === e.cursor;
              }
            }, t), {}, {
              request: function (n) {
                return e.transporter.read({
                  method: A,
                  path: p("1/indexes/%s/browse", e.indexName),
                  data: n
                }, t);
              }
            }));
          };
        },
        Fe = function (e) {
          return function (t) {
            var r = n({
              hitsPerPage: 1e3
            }, t);
            return x(n(n({
              shouldStop: function (e) {
                return e.hits.length < r.hitsPerPage;
              }
            }, r), {}, {
              request: function (t) {
                return ut(e)("", n(n({}, r), t)).then(function (e) {
                  return n(n({}, e), {}, {
                    hits: e.hits.map(function (e) {
                      return delete e._highlightResult, e;
                    })
                  });
                });
              }
            }));
          };
        },
        Ne = function (e) {
          return function (t) {
            var r = n({
              hitsPerPage: 1e3
            }, t);
            return x(n(n({
              shouldStop: function (e) {
                return e.hits.length < r.hitsPerPage;
              }
            }, r), {}, {
              request: function (t) {
                return lt(e)("", n(n({}, r), t)).then(function (e) {
                  return n(n({}, e), {}, {
                    hits: e.hits.map(function (e) {
                      return delete e._highlightResult, e;
                    })
                  });
                });
              }
            }));
          };
        },
        Ee = function (e) {
          return function (t, n, i) {
            var a = i || {},
              s = a.batchSize,
              o = r(a, ["batchSize"]),
              c = {
                taskIDs: [],
                objectIDs: []
              };
            return f(function r() {
              var i,
                a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                u = [];
              for (i = a; i < t.length && (u.push(t[i]), u.length !== (s || 1e3)); i++);
              return 0 === u.length ? Promise.resolve(c) : je(e)(u.map(function (e) {
                return {
                  action: n,
                  body: e
                };
              }), o).then(function (e) {
                return c.objectIDs = c.objectIDs.concat(e.objectIDs), c.taskIDs.push(e.taskID), i++, r(i);
              });
            }(), function (t, n) {
              return Promise.all(t.taskIDs.map(function (t) {
                return ht(e)(t, n);
              }));
            });
          };
        },
        Ce = function (e) {
          return function (t) {
            return f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/clear", e.indexName)
            }, t), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        Te = function (e) {
          return function (t) {
            var n = t || {},
              i = n.forwardToReplicas,
              a = m(r(n, ["forwardToReplicas"]));
            return i && (a.queryParameters.forwardToReplicas = 1), f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/rules/clear", e.indexName)
            }, a), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        ke = function (e) {
          return function (t) {
            var n = t || {},
              i = n.forwardToReplicas,
              a = m(r(n, ["forwardToReplicas"]));
            return i && (a.queryParameters.forwardToReplicas = 1), f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/synonyms/clear", e.indexName)
            }, a), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        Ae = function (e) {
          return function (t, n) {
            return f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/deleteByQuery", e.indexName),
              data: t
            }, n), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        De = function (e) {
          return function (t) {
            return f(e.transporter.write({
              method: T,
              path: p("1/indexes/%s", e.indexName)
            }, t), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        Le = function (e) {
          return function (t, n) {
            return f(Me(e)([t], n).then(function (e) {
              return {
                taskID: e.taskIDs[0]
              };
            }), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        Me = function (e) {
          return function (t, n) {
            var r = t.map(function (e) {
              return {
                objectID: e
              };
            });
            return Ee(e)(r, dt.DeleteObject, n);
          };
        },
        He = function (e) {
          return function (t, n) {
            var i = n || {},
              a = i.forwardToReplicas,
              s = m(r(i, ["forwardToReplicas"]));
            return a && (s.queryParameters.forwardToReplicas = 1), f(e.transporter.write({
              method: T,
              path: p("1/indexes/%s/rules/%s", e.indexName, t)
            }, s), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        qe = function (e) {
          return function (t, n) {
            var i = n || {},
              a = i.forwardToReplicas,
              s = m(r(i, ["forwardToReplicas"]));
            return a && (s.queryParameters.forwardToReplicas = 1), f(e.transporter.write({
              method: T,
              path: p("1/indexes/%s/synonyms/%s", e.indexName, t)
            }, s), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        Be = function (e) {
          return function (t) {
            return Ke(e)(t).then(function () {
              return !0;
            }).catch(function (e) {
              if (404 !== e.status) throw e;
              return !1;
            });
          };
        },
        We = function (e) {
          return function (t, n, r) {
            return e.transporter.read({
              method: A,
              path: p("1/answers/%s/prediction", e.indexName),
              data: {
                query: t,
                queryLanguages: n
              },
              cacheable: !0
            }, r);
          };
        },
        Qe = function (e) {
          return function (t, a) {
            var s = a || {},
              o = s.query,
              c = s.paginate,
              u = r(s, ["query", "paginate"]),
              l = 0;
            return function r() {
              return ot(e)(o || "", n(n({}, u), {}, {
                page: l
              })).then(function (e) {
                for (var n = 0, a = Object.entries(e.hits); n < a.length; n++) {
                  var s = i(a[n], 2),
                    o = s[0],
                    u = s[1];
                  if (t(u)) return {
                    object: u,
                    position: parseInt(o, 10),
                    page: l
                  };
                }
                if (l++, !1 === c || l >= e.nbPages) throw {
                  name: "ObjectNotFoundError",
                  message: "Object not found."
                };
                return r();
              });
            }();
          };
        },
        Ue = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: k,
              path: p("1/indexes/%s/%s", e.indexName, t)
            }, n);
          };
        },
        Ve = function () {
          return function (e, t) {
            for (var n = 0, r = Object.entries(e.hits); n < r.length; n++) {
              var a = i(r[n], 2),
                s = a[0];
              if (a[1].objectID === t) return parseInt(s, 10);
            }
            return -1;
          };
        },
        $e = function (e) {
          return function (t, i) {
            var a = i || {},
              s = a.attributesToRetrieve,
              o = r(a, ["attributesToRetrieve"]),
              c = t.map(function (t) {
                return n({
                  indexName: e.indexName,
                  objectID: t
                }, s ? {
                  attributesToRetrieve: s
                } : {});
              });
            return e.transporter.read({
              method: A,
              path: "1/indexes/*/objects",
              data: {
                requests: c
              }
            }, o);
          };
        },
        ze = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: k,
              path: p("1/indexes/%s/rules/%s", e.indexName, t)
            }, n);
          };
        },
        Ke = function (e) {
          return function (t) {
            return e.transporter.read({
              method: k,
              path: p("1/indexes/%s/settings", e.indexName),
              data: {
                getVersion: 2
              }
            }, t);
          };
        },
        Je = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: k,
              path: p("1/indexes/%s/synonyms/%s", e.indexName, t)
            }, n);
          };
        },
        Ge = function (e) {
          return function (t, n) {
            return f(Ye(e)([t], n).then(function (e) {
              return {
                objectID: e.objectIDs[0],
                taskID: e.taskIDs[0]
              };
            }), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        Ye = function (e) {
          return function (t, n) {
            var i = n || {},
              a = i.createIfNotExists,
              s = r(i, ["createIfNotExists"]),
              o = a ? dt.PartialUpdateObject : dt.PartialUpdateObjectNoCreate;
            return Ee(e)(t, o, s);
          };
        },
        Xe = function (e) {
          return function (t, s) {
            var o = s || {},
              c = o.safe,
              u = o.autoGenerateObjectIDIfNotExist,
              l = o.batchSize,
              h = r(o, ["safe", "autoGenerateObjectIDIfNotExist", "batchSize"]),
              d = function (t, n, r, i) {
                return f(e.transporter.write({
                  method: A,
                  path: p("1/indexes/%s/operation", t),
                  data: {
                    operation: r,
                    destination: n
                  }
                }, i), function (t, n) {
                  return ht(e)(t.taskID, n);
                });
              },
              m = Math.random().toString(36).substring(7),
              g = "".concat(e.indexName, "_tmp_").concat(m),
              v = nt({
                appId: e.appId,
                transporter: e.transporter,
                indexName: g
              }),
              y = [],
              b = d(e.indexName, g, "copy", n(n({}, h), {}, {
                scope: ["settings", "synonyms", "rules"]
              }));
            return y.push(b), f((c ? b.wait(h) : b).then(function () {
              var e = v(t, n(n({}, h), {}, {
                autoGenerateObjectIDIfNotExist: u,
                batchSize: l
              }));
              return y.push(e), c ? e.wait(h) : e;
            }).then(function () {
              var t = d(g, e.indexName, "move", h);
              return y.push(t), c ? t.wait(h) : t;
            }).then(function () {
              return Promise.all(y);
            }).then(function (e) {
              var t = i(e, 3),
                n = t[0],
                r = t[1],
                s = t[2];
              return {
                objectIDs: r.objectIDs,
                taskIDs: [n.taskID].concat(a(r.taskIDs), [s.taskID])
              };
            }), function (e, t) {
              return Promise.all(y.map(function (e) {
                return e.wait(t);
              }));
            });
          };
        },
        Ze = function (e) {
          return function (t, r) {
            return it(e)(t, n(n({}, r), {}, {
              clearExistingRules: !0
            }));
          };
        },
        et = function (e) {
          return function (t, r) {
            return st(e)(t, n(n({}, r), {}, {
              clearExistingSynonyms: !0
            }));
          };
        },
        tt = function (e) {
          return function (t, n) {
            return f(nt(e)([t], n).then(function (e) {
              return {
                objectID: e.objectIDs[0],
                taskID: e.taskIDs[0]
              };
            }), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        nt = function (e) {
          return function (t, n) {
            var i = n || {},
              a = i.autoGenerateObjectIDIfNotExist,
              s = r(i, ["autoGenerateObjectIDIfNotExist"]),
              o = a ? dt.AddObject : dt.UpdateObject;
            if (o === dt.UpdateObject) {
              var c = !0,
                u = !1,
                l = void 0;
              try {
                for (var h, d = t[Symbol.iterator](); !(c = (h = d.next()).done); c = !0) if (void 0 === h.value.objectID) return f(Promise.reject({
                  name: "MissingObjectIDError",
                  message: "All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."
                }));
              } catch (e) {
                u = !0, l = e;
              } finally {
                try {
                  c || null == d.return || d.return();
                } finally {
                  if (u) throw l;
                }
              }
            }
            return Ee(e)(t, o, s);
          };
        },
        rt = function (e) {
          return function (t, n) {
            return it(e)([t], n);
          };
        },
        it = function (e) {
          return function (t, n) {
            var i = n || {},
              a = i.forwardToReplicas,
              s = i.clearExistingRules,
              o = m(r(i, ["forwardToReplicas", "clearExistingRules"]));
            return a && (o.queryParameters.forwardToReplicas = 1), s && (o.queryParameters.clearExistingRules = 1), f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/rules/batch", e.indexName),
              data: t
            }, o), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        at = function (e) {
          return function (t, n) {
            return st(e)([t], n);
          };
        },
        st = function (e) {
          return function (t, n) {
            var i = n || {},
              a = i.forwardToReplicas,
              s = i.clearExistingSynonyms,
              o = i.replaceExistingSynonyms,
              c = m(r(i, ["forwardToReplicas", "clearExistingSynonyms", "replaceExistingSynonyms"]));
            return a && (c.queryParameters.forwardToReplicas = 1), (o || s) && (c.queryParameters.replaceExistingSynonyms = 1), f(e.transporter.write({
              method: A,
              path: p("1/indexes/%s/synonyms/batch", e.indexName),
              data: t
            }, c), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        ot = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: A,
              path: p("1/indexes/%s/query", e.indexName),
              data: {
                query: t
              },
              cacheable: !0
            }, n);
          };
        },
        ct = function (e) {
          return function (t, n, r) {
            return e.transporter.read({
              method: A,
              path: p("1/indexes/%s/facets/%s/query", e.indexName, t),
              data: {
                facetQuery: n
              },
              cacheable: !0
            }, r);
          };
        },
        ut = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: A,
              path: p("1/indexes/%s/rules/search", e.indexName),
              data: {
                query: t
              }
            }, n);
          };
        },
        lt = function (e) {
          return function (t, n) {
            return e.transporter.read({
              method: A,
              path: p("1/indexes/%s/synonyms/search", e.indexName),
              data: {
                query: t
              }
            }, n);
          };
        },
        ft = function (e) {
          return function (t, n) {
            var i = n || {},
              a = i.forwardToReplicas,
              s = m(r(i, ["forwardToReplicas"]));
            return a && (s.queryParameters.forwardToReplicas = 1), f(e.transporter.write({
              method: D,
              path: p("1/indexes/%s/settings", e.indexName),
              data: t
            }, s), function (t, n) {
              return ht(e)(t.taskID, n);
            });
          };
        },
        ht = function (e) {
          return function (t, n) {
            return l(function (r) {
              return function (e) {
                return function (t, n) {
                  return e.transporter.read({
                    method: k,
                    path: p("1/indexes/%s/task/%s", e.indexName, t.toString())
                  }, n);
                };
              }(e)(t, n).then(function (e) {
                return "published" !== e.status ? r() : void 0;
              });
            });
          };
        },
        dt = {
          AddObject: "addObject",
          UpdateObject: "updateObject",
          PartialUpdateObject: "partialUpdateObject",
          PartialUpdateObjectNoCreate: "partialUpdateObjectNoCreate",
          DeleteObject: "deleteObject",
          DeleteIndex: "delete",
          ClearIndex: "clear"
        },
        pt = {
          Settings: "settings",
          Synonyms: "synonyms",
          Rules: "rules"
        },
        mt = 1,
        gt = 2,
        vt = 3;
      return j.version = "4.14.3", j;
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return new i(e, t, n);
    }
    var i = n(4),
      a = n(5),
      s = n(15);
    r.version = n(26), r.AlgoliaSearchHelper = i, r.SearchParameters = a, r.SearchResults = s, e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      "function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (" + m + ")"), this.setClient(e);
      var r = n || {};
      r.index = t, this.state = s.make(r), this.lastResults = null, this._queryId = 0, this._lastQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0;
    }
    function i(e) {
      if (e < 0) throw new Error("Page requested below 0.");
      return this._change({
        state: this.state.setPage(e),
        isPageReset: !1
      }), this;
    }
    function a() {
      return this.state.page;
    }
    var s = n(5),
      o = n(15),
      c = n(22),
      u = n(25),
      l = n(23),
      f = n(24),
      h = n(12),
      d = n(11),
      p = n(6),
      m = n(26),
      g = n(20).escapeFacetValue;
    f(r, l), r.prototype.search = function () {
      return this._search({
        onlyWithDerivedHelpers: !1
      }), this;
    }, r.prototype.searchOnlyWithDerivedHelpers = function () {
      return this._search({
        onlyWithDerivedHelpers: !0
      }), this;
    }, r.prototype.getQuery = function () {
      var e = this.state;
      return u._getHitsSearchParams(e);
    }, r.prototype.searchOnce = function (e, t) {
      var n = e ? this.state.setQueryParameters(e) : this.state,
        r = u._getQueries(n.index, n),
        i = this;
      return this._currentNbQueries++, this.emit("searchOnce", {
        state: n
      }), t ? void this.client.search(r).then(function (e) {
        i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), t(null, new o(n, e.results), n);
      }).catch(function (e) {
        i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), t(e, null, n);
      }) : this.client.search(r).then(function (e) {
        return i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), {
          content: new o(n, e.results),
          state: n,
          _originalResponse: e
        };
      }, function (e) {
        throw i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), e;
      });
    }, r.prototype.findAnswers = function (e) {
      console.warn("[algoliasearch-helper] answers is no longer supported");
      var t = this.state,
        n = this.derivedHelpers[0];
      if (!n) return Promise.resolve([]);
      var r = n.getModifiedState(t),
        i = p({
          attributesForPrediction: e.attributesForPrediction,
          nbHits: e.nbHits
        }, {
          params: d(u._getHitsSearchParams(r), ["attributesToSnippet", "hitsPerPage", "restrictSearchableAttributes", "snippetEllipsisText"])
        }),
        a = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
      if ("function" != typeof this.client.initIndex) throw new Error(a);
      var s = this.client.initIndex(r.index);
      if ("function" != typeof s.findAnswers) throw new Error(a);
      return s.findAnswers(r.query, e.queryLanguages, i);
    }, r.prototype.searchForFacetValues = function (e, t, n, r) {
      var i = "function" == typeof this.client.searchForFacetValues,
        a = "function" == typeof this.client.initIndex;
      if (!i && !a && "function" != typeof this.client.search) throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
      var s = this.state.setQueryParameters(r || {}),
        o = s.isDisjunctiveFacet(e),
        c = u.getSearchForFacetQuery(e, t, n, s);
      this._currentNbQueries++;
      var l,
        f = this;
      return i ? l = this.client.searchForFacetValues([{
        indexName: s.index,
        params: c
      }]) : a ? l = this.client.initIndex(s.index).searchForFacetValues(c) : (delete c.facetName, l = this.client.search([{
        type: "facet",
        facet: e,
        indexName: s.index,
        params: c
      }]).then(function (e) {
        return e.results[0];
      })), this.emit("searchForFacetValues", {
        state: s,
        facet: e,
        query: t
      }), l.then(function (t) {
        return f._currentNbQueries--, 0 === f._currentNbQueries && f.emit("searchQueueEmpty"), t = Array.isArray(t) ? t[0] : t, t.facetHits.forEach(function (t) {
          t.escapedValue = g(t.value), t.isRefined = o ? s.isDisjunctiveFacetRefined(e, t.escapedValue) : s.isFacetRefined(e, t.escapedValue);
        }), t;
      }, function (e) {
        throw f._currentNbQueries--, 0 === f._currentNbQueries && f.emit("searchQueueEmpty"), e;
      });
    }, r.prototype.setQuery = function (e) {
      return this._change({
        state: this.state.resetPage().setQuery(e),
        isPageReset: !0
      }), this;
    }, r.prototype.clearRefinements = function (e) {
      return this._change({
        state: this.state.resetPage().clearRefinements(e),
        isPageReset: !0
      }), this;
    }, r.prototype.clearTags = function () {
      return this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: !0
      }), this;
    }, r.prototype.addDisjunctiveFacetRefinement = function (e, t) {
      return this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.addDisjunctiveRefine = function () {
      return this.addDisjunctiveFacetRefinement.apply(this, arguments);
    }, r.prototype.addHierarchicalFacetRefinement = function (e, t) {
      return this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.addNumericRefinement = function (e, t, n) {
      return this._change({
        state: this.state.resetPage().addNumericRefinement(e, t, n),
        isPageReset: !0
      }), this;
    }, r.prototype.addFacetRefinement = function (e, t) {
      return this._change({
        state: this.state.resetPage().addFacetRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.addRefine = function () {
      return this.addFacetRefinement.apply(this, arguments);
    }, r.prototype.addFacetExclusion = function (e, t) {
      return this._change({
        state: this.state.resetPage().addExcludeRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.addExclude = function () {
      return this.addFacetExclusion.apply(this, arguments);
    }, r.prototype.addTag = function (e) {
      return this._change({
        state: this.state.resetPage().addTagRefinement(e),
        isPageReset: !0
      }), this;
    }, r.prototype.removeNumericRefinement = function (e, t, n) {
      return this._change({
        state: this.state.resetPage().removeNumericRefinement(e, t, n),
        isPageReset: !0
      }), this;
    }, r.prototype.removeDisjunctiveFacetRefinement = function (e, t) {
      return this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.removeDisjunctiveRefine = function () {
      return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
    }, r.prototype.removeHierarchicalFacetRefinement = function (e) {
      return this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(e),
        isPageReset: !0
      }), this;
    }, r.prototype.removeFacetRefinement = function (e, t) {
      return this._change({
        state: this.state.resetPage().removeFacetRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.removeRefine = function () {
      return this.removeFacetRefinement.apply(this, arguments);
    }, r.prototype.removeFacetExclusion = function (e, t) {
      return this._change({
        state: this.state.resetPage().removeExcludeRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.removeExclude = function () {
      return this.removeFacetExclusion.apply(this, arguments);
    }, r.prototype.removeTag = function (e) {
      return this._change({
        state: this.state.resetPage().removeTagRefinement(e),
        isPageReset: !0
      }), this;
    }, r.prototype.toggleFacetExclusion = function (e, t) {
      return this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.toggleExclude = function () {
      return this.toggleFacetExclusion.apply(this, arguments);
    }, r.prototype.toggleRefinement = function (e, t) {
      return this.toggleFacetRefinement(e, t);
    }, r.prototype.toggleFacetRefinement = function (e, t) {
      return this._change({
        state: this.state.resetPage().toggleFacetRefinement(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.toggleRefine = function () {
      return this.toggleFacetRefinement.apply(this, arguments);
    }, r.prototype.toggleTag = function (e) {
      return this._change({
        state: this.state.resetPage().toggleTagRefinement(e),
        isPageReset: !0
      }), this;
    }, r.prototype.nextPage = function () {
      var e = this.state.page || 0;
      return this.setPage(e + 1);
    }, r.prototype.previousPage = function () {
      var e = this.state.page || 0;
      return this.setPage(e - 1);
    }, r.prototype.setCurrentPage = i, r.prototype.setPage = i, r.prototype.setIndex = function (e) {
      return this._change({
        state: this.state.resetPage().setIndex(e),
        isPageReset: !0
      }), this;
    }, r.prototype.setQueryParameter = function (e, t) {
      return this._change({
        state: this.state.resetPage().setQueryParameter(e, t),
        isPageReset: !0
      }), this;
    }, r.prototype.setState = function (e) {
      return this._change({
        state: s.make(e),
        isPageReset: !1
      }), this;
    }, r.prototype.overrideStateWithoutTriggeringChangeEvent = function (e) {
      return this.state = new s(e), this;
    }, r.prototype.hasRefinements = function (e) {
      return !!h(this.state.getNumericRefinements(e)) || (this.state.isConjunctiveFacet(e) ? this.state.isFacetRefined(e) : this.state.isDisjunctiveFacet(e) ? this.state.isDisjunctiveFacetRefined(e) : !!this.state.isHierarchicalFacet(e) && this.state.isHierarchicalFacetRefined(e));
    }, r.prototype.isExcluded = function (e, t) {
      return this.state.isExcludeRefined(e, t);
    }, r.prototype.isDisjunctiveRefined = function (e, t) {
      return this.state.isDisjunctiveFacetRefined(e, t);
    }, r.prototype.hasTag = function (e) {
      return this.state.isTagRefined(e);
    }, r.prototype.isTagRefined = function () {
      return this.hasTagRefinements.apply(this, arguments);
    }, r.prototype.getIndex = function () {
      return this.state.index;
    }, r.prototype.getCurrentPage = a, r.prototype.getPage = a, r.prototype.getTags = function () {
      return this.state.tagRefinements;
    }, r.prototype.getRefinements = function (e) {
      var t = [];
      if (this.state.isConjunctiveFacet(e)) {
        var n = this.state.getConjunctiveRefinements(e);
        n.forEach(function (e) {
          t.push({
            value: e,
            type: "conjunctive"
          });
        });
        var r = this.state.getExcludeRefinements(e);
        r.forEach(function (e) {
          t.push({
            value: e,
            type: "exclude"
          });
        });
      } else if (this.state.isDisjunctiveFacet(e)) {
        var i = this.state.getDisjunctiveRefinements(e);
        i.forEach(function (e) {
          t.push({
            value: e,
            type: "disjunctive"
          });
        });
      }
      var a = this.state.getNumericRefinements(e);
      return Object.keys(a).forEach(function (e) {
        var n = a[e];
        t.push({
          value: n,
          operator: e,
          type: "numeric"
        });
      }), t;
    }, r.prototype.getNumericRefinement = function (e, t) {
      return this.state.getNumericRefinement(e, t);
    }, r.prototype.getHierarchicalFacetBreadcrumb = function (e) {
      return this.state.getHierarchicalFacetBreadcrumb(e);
    }, r.prototype._search = function (e) {
      var t = this.state,
        n = [],
        r = [];
      e.onlyWithDerivedHelpers || (r = u._getQueries(t.index, t), n.push({
        state: t,
        queriesCount: r.length,
        helper: this
      }), this.emit("search", {
        state: t,
        results: this.lastResults
      }));
      var i = this.derivedHelpers.map(function (e) {
          var r = e.getModifiedState(t),
            i = u._getQueries(r.index, r);
          return n.push({
            state: r,
            queriesCount: i.length,
            helper: e
          }), e.emit("search", {
            state: r,
            results: e.lastResults
          }), i;
        }),
        a = Array.prototype.concat.apply(r, i),
        s = this._queryId++;
      this._currentNbQueries++;
      try {
        this.client.search(a).then(this._dispatchAlgoliaResponse.bind(this, n, s)).catch(this._dispatchAlgoliaError.bind(this, s));
      } catch (e) {
        this.emit("error", {
          error: e
        });
      }
    }, r.prototype._dispatchAlgoliaResponse = function (e, t, n) {
      if (!(t < this._lastQueryIdReceived)) {
        this._currentNbQueries -= t - this._lastQueryIdReceived, this._lastQueryIdReceived = t, 0 === this._currentNbQueries && this.emit("searchQueueEmpty");
        var r = n.results.slice();
        e.forEach(function (e) {
          var t = e.state,
            n = e.queriesCount,
            i = e.helper,
            a = r.splice(0, n),
            s = i.lastResults = new o(t, a);
          i.emit("result", {
            results: s,
            state: t
          });
        });
      }
    }, r.prototype._dispatchAlgoliaError = function (e, t) {
      e < this._lastQueryIdReceived || (this._currentNbQueries -= e - this._lastQueryIdReceived, this._lastQueryIdReceived = e, this.emit("error", {
        error: t
      }), 0 === this._currentNbQueries && this.emit("searchQueueEmpty"));
    }, r.prototype.containsRefinement = function (e, t, n, r) {
      return e || 0 !== t.length || 0 !== n.length || 0 !== r.length;
    }, r.prototype._hasDisjunctiveRefinements = function (e) {
      return this.state.disjunctiveRefinements[e] && this.state.disjunctiveRefinements[e].length > 0;
    }, r.prototype._change = function (e) {
      var t = e.state,
        n = e.isPageReset;
      t !== this.state && (this.state = t, this.emit("change", {
        state: this.state,
        results: this.lastResults,
        isPageReset: n
      }));
    }, r.prototype.clearCache = function () {
      return this.client.clearCache && this.client.clearCache(), this;
    }, r.prototype.setClient = function (e) {
      return this.client === e ? this : ("function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (" + m + ")"), this.client = e, this);
    }, r.prototype.getClient = function () {
      return this.client;
    }, r.prototype.derive = function (e) {
      var t = new c(this, e);
      return this.derivedHelpers.push(t), t;
    }, r.prototype.detachDerivedHelper = function (e) {
      var t = this.derivedHelpers.indexOf(e);
      if (t === -1) throw new Error("Derived helper already detached");
      this.derivedHelpers.splice(t, 1);
    }, r.prototype.hasPendingRequests = function () {
      return this._currentNbQueries > 0;
    }, e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return Array.isArray(e) && Array.isArray(t) ? e.length === t.length && e.every(function (e, n) {
        return r(t[n], e);
      }) : e === t;
    }
    function i(e, t) {
      return u(e, function (e) {
        return r(e, t);
      });
    }
    function a(e) {
      var t = e ? a._parseNumbers(e) : {};
      void 0 === t.userToken || d(t.userToken) || console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"), this.facets = t.facets || [], this.disjunctiveFacets = t.disjunctiveFacets || [], this.hierarchicalFacets = t.hierarchicalFacets || [], this.facetsRefinements = t.facetsRefinements || {}, this.facetsExcludes = t.facetsExcludes || {}, this.disjunctiveFacetsRefinements = t.disjunctiveFacetsRefinements || {}, this.numericRefinements = t.numericRefinements || {}, this.tagRefinements = t.tagRefinements || [], this.hierarchicalFacetsRefinements = t.hierarchicalFacetsRefinements || {};
      var n = this;
      Object.keys(t).forEach(function (e) {
        var r = a.PARAMETERS.indexOf(e) !== -1,
          i = void 0 !== t[e];
        !r && i && (n[e] = t[e]);
      });
    }
    var s = n(6),
      o = n(7),
      c = n(8),
      u = n(9),
      l = n(10),
      f = n(11),
      h = n(12),
      d = n(13),
      p = n(14);
    a.PARAMETERS = Object.keys(new a()), a._parseNumbers = function (e) {
      if (e instanceof a) return e;
      var t = {},
        n = ["aroundPrecision", "aroundRadius", "getRankingInfo", "minWordSizefor2Typos", "minWordSizefor1Typo", "page", "maxValuesPerFacet", "distinct", "minimumAroundRadius", "hitsPerPage", "minProximity"];
      if (n.forEach(function (n) {
        var r = e[n];
        if ("string" == typeof r) {
          var i = parseFloat(r);
          t[n] = isNaN(i) ? r : i;
        }
      }), Array.isArray(e.insideBoundingBox) && (t.insideBoundingBox = e.insideBoundingBox.map(function (e) {
        return Array.isArray(e) ? e.map(function (e) {
          return parseFloat(e);
        }) : e;
      })), e.numericRefinements) {
        var r = {};
        Object.keys(e.numericRefinements).forEach(function (t) {
          var n = e.numericRefinements[t] || {};
          r[t] = {}, Object.keys(n).forEach(function (e) {
            var i = n[e],
              a = i.map(function (e) {
                return Array.isArray(e) ? e.map(function (e) {
                  return "string" == typeof e ? parseFloat(e) : e;
                }) : "string" == typeof e ? parseFloat(e) : e;
              });
            r[t][e] = a;
          });
        }), t.numericRefinements = r;
      }
      return s({}, e, t);
    }, a.make = function (e) {
      var t = new a(e),
        n = e.hierarchicalFacets || [];
      return n.forEach(function (e) {
        if (e.rootPath) {
          var n = t.getHierarchicalRefinement(e.name);
          n.length > 0 && 0 !== n[0].indexOf(e.rootPath) && (t = t.clearRefinements(e.name)), n = t.getHierarchicalRefinement(e.name), 0 === n.length && (t = t.toggleHierarchicalFacetRefinement(e.name, e.rootPath));
        }
      }), t;
    }, a.validate = function (e, t) {
      var n = t || {};
      return e.tagFilters && n.tagRefinements && n.tagRefinements.length > 0 ? new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.") : e.tagRefinements.length > 0 && n.tagFilters ? new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.") : e.numericFilters && n.numericRefinements && h(n.numericRefinements) ? new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : h(e.numericRefinements) && n.numericFilters ? new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : null;
    }, a.prototype = {
      constructor: a,
      clearRefinements: function (e) {
        var t = {
          numericRefinements: this._clearNumericRefinements(e),
          facetsRefinements: p.clearRefinement(this.facetsRefinements, e, "conjunctiveFacet"),
          facetsExcludes: p.clearRefinement(this.facetsExcludes, e, "exclude"),
          disjunctiveFacetsRefinements: p.clearRefinement(this.disjunctiveFacetsRefinements, e, "disjunctiveFacet"),
          hierarchicalFacetsRefinements: p.clearRefinement(this.hierarchicalFacetsRefinements, e, "hierarchicalFacet")
        };
        return t.numericRefinements === this.numericRefinements && t.facetsRefinements === this.facetsRefinements && t.facetsExcludes === this.facetsExcludes && t.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && t.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(t);
      },
      clearTags: function () {
        return void 0 === this.tagFilters && 0 === this.tagRefinements.length ? this : this.setQueryParameters({
          tagFilters: void 0,
          tagRefinements: []
        });
      },
      setIndex: function (e) {
        return e === this.index ? this : this.setQueryParameters({
          index: e
        });
      },
      setQuery: function (e) {
        return e === this.query ? this : this.setQueryParameters({
          query: e
        });
      },
      setPage: function (e) {
        return e === this.page ? this : this.setQueryParameters({
          page: e
        });
      },
      setFacets: function (e) {
        return this.setQueryParameters({
          facets: e
        });
      },
      setDisjunctiveFacets: function (e) {
        return this.setQueryParameters({
          disjunctiveFacets: e
        });
      },
      setHitsPerPage: function (e) {
        return this.hitsPerPage === e ? this : this.setQueryParameters({
          hitsPerPage: e
        });
      },
      setTypoTolerance: function (e) {
        return this.typoTolerance === e ? this : this.setQueryParameters({
          typoTolerance: e
        });
      },
      addNumericRefinement: function (e, t, n) {
        var r = l(n);
        if (this.isNumericRefined(e, t, r)) return this;
        var i = s({}, this.numericRefinements);
        return i[e] = s({}, i[e]), i[e][t] ? (i[e][t] = i[e][t].slice(), i[e][t].push(r)) : i[e][t] = [r], this.setQueryParameters({
          numericRefinements: i
        });
      },
      getConjunctiveRefinements: function (e) {
        return this.isConjunctiveFacet(e) ? this.facetsRefinements[e] || [] : [];
      },
      getDisjunctiveRefinements: function (e) {
        return this.isDisjunctiveFacet(e) ? this.disjunctiveFacetsRefinements[e] || [] : [];
      },
      getHierarchicalRefinement: function (e) {
        return this.hierarchicalFacetsRefinements[e] || [];
      },
      getExcludeRefinements: function (e) {
        return this.isConjunctiveFacet(e) ? this.facetsExcludes[e] || [] : [];
      },
      removeNumericRefinement: function (e, t, n) {
        return void 0 !== n ? this.isNumericRefined(e, t, n) ? this.setQueryParameters({
          numericRefinements: this._clearNumericRefinements(function (i, a) {
            return a === e && i.op === t && r(i.val, l(n));
          })
        }) : this : void 0 !== t ? this.isNumericRefined(e, t) ? this.setQueryParameters({
          numericRefinements: this._clearNumericRefinements(function (n, r) {
            return r === e && n.op === t;
          })
        }) : this : this.isNumericRefined(e) ? this.setQueryParameters({
          numericRefinements: this._clearNumericRefinements(function (t, n) {
            return n === e;
          })
        }) : this;
      },
      getNumericRefinements: function (e) {
        return this.numericRefinements[e] || {};
      },
      getNumericRefinement: function (e, t) {
        return this.numericRefinements[e] && this.numericRefinements[e][t];
      },
      _clearNumericRefinements: function (e) {
        if (void 0 === e) return h(this.numericRefinements) ? {} : this.numericRefinements;
        if ("string" == typeof e) return f(this.numericRefinements, [e]);
        if ("function" == typeof e) {
          var t = !1,
            n = this.numericRefinements,
            r = Object.keys(n).reduce(function (r, i) {
              var a = n[i],
                s = {};
              return a = a || {}, Object.keys(a).forEach(function (n) {
                var r = a[n] || [],
                  o = [];
                r.forEach(function (t) {
                  var r = e({
                    val: t,
                    op: n
                  }, i, "numeric");
                  r || o.push(t);
                }), o.length !== r.length && (t = !0), s[n] = o;
              }), r[i] = s, r;
            }, {});
          return t ? r : this.numericRefinements;
        }
      },
      addFacet: function (e) {
        return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({
          facets: this.facets.concat([e])
        });
      },
      addDisjunctiveFacet: function (e) {
        return this.isDisjunctiveFacet(e) ? this : this.setQueryParameters({
          disjunctiveFacets: this.disjunctiveFacets.concat([e])
        });
      },
      addHierarchicalFacet: function (e) {
        if (this.isHierarchicalFacet(e.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + e.name + "`");
        return this.setQueryParameters({
          hierarchicalFacets: this.hierarchicalFacets.concat([e])
        });
      },
      addFacetRefinement: function (e, t) {
        if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
        return p.isRefined(this.facetsRefinements, e, t) ? this : this.setQueryParameters({
          facetsRefinements: p.addRefinement(this.facetsRefinements, e, t)
        });
      },
      addExcludeRefinement: function (e, t) {
        if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
        return p.isRefined(this.facetsExcludes, e, t) ? this : this.setQueryParameters({
          facetsExcludes: p.addRefinement(this.facetsExcludes, e, t)
        });
      },
      addDisjunctiveFacetRefinement: function (e, t) {
        if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return p.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this : this.setQueryParameters({
          disjunctiveFacetsRefinements: p.addRefinement(this.disjunctiveFacetsRefinements, e, t)
        });
      },
      addTagRefinement: function (e) {
        if (this.isTagRefined(e)) return this;
        var t = {
          tagRefinements: this.tagRefinements.concat(e)
        };
        return this.setQueryParameters(t);
      },
      removeFacet: function (e) {
        return this.isConjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
          facets: this.facets.filter(function (t) {
            return t !== e;
          })
        }) : this;
      },
      removeDisjunctiveFacet: function (e) {
        return this.isDisjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
          disjunctiveFacets: this.disjunctiveFacets.filter(function (t) {
            return t !== e;
          })
        }) : this;
      },
      removeHierarchicalFacet: function (e) {
        return this.isHierarchicalFacet(e) ? this.clearRefinements(e).setQueryParameters({
          hierarchicalFacets: this.hierarchicalFacets.filter(function (t) {
            return t.name !== e;
          })
        }) : this;
      },
      removeFacetRefinement: function (e, t) {
        if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
        return p.isRefined(this.facetsRefinements, e, t) ? this.setQueryParameters({
          facetsRefinements: p.removeRefinement(this.facetsRefinements, e, t)
        }) : this;
      },
      removeExcludeRefinement: function (e, t) {
        if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
        return p.isRefined(this.facetsExcludes, e, t) ? this.setQueryParameters({
          facetsExcludes: p.removeRefinement(this.facetsExcludes, e, t)
        }) : this;
      },
      removeDisjunctiveFacetRefinement: function (e, t) {
        if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return p.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this.setQueryParameters({
          disjunctiveFacetsRefinements: p.removeRefinement(this.disjunctiveFacetsRefinements, e, t)
        }) : this;
      },
      removeTagRefinement: function (e) {
        if (!this.isTagRefined(e)) return this;
        var t = {
          tagRefinements: this.tagRefinements.filter(function (t) {
            return t !== e;
          })
        };
        return this.setQueryParameters(t);
      },
      toggleRefinement: function (e, t) {
        return this.toggleFacetRefinement(e, t);
      },
      toggleFacetRefinement: function (e, t) {
        if (this.isHierarchicalFacet(e)) return this.toggleHierarchicalFacetRefinement(e, t);
        if (this.isConjunctiveFacet(e)) return this.toggleConjunctiveFacetRefinement(e, t);
        if (this.isDisjunctiveFacet(e)) return this.toggleDisjunctiveFacetRefinement(e, t);
        throw new Error("Cannot refine the undeclared facet " + e + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
      },
      toggleConjunctiveFacetRefinement: function (e, t) {
        if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
          facetsRefinements: p.toggleRefinement(this.facetsRefinements, e, t)
        });
      },
      toggleExcludeFacetRefinement: function (e, t) {
        if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
          facetsExcludes: p.toggleRefinement(this.facetsExcludes, e, t)
        });
      },
      toggleDisjunctiveFacetRefinement: function (e, t) {
        if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
          disjunctiveFacetsRefinements: p.toggleRefinement(this.disjunctiveFacetsRefinements, e, t)
        });
      },
      toggleHierarchicalFacetRefinement: function (e, t) {
        if (!this.isHierarchicalFacet(e)) throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var n = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)),
          r = {},
          i = void 0 !== this.hierarchicalFacetsRefinements[e] && this.hierarchicalFacetsRefinements[e].length > 0 && (this.hierarchicalFacetsRefinements[e][0] === t || 0 === this.hierarchicalFacetsRefinements[e][0].indexOf(t + n));
        return i ? t.indexOf(n) === -1 ? r[e] = [] : r[e] = [t.slice(0, t.lastIndexOf(n))] : r[e] = [t], this.setQueryParameters({
          hierarchicalFacetsRefinements: o({}, r, this.hierarchicalFacetsRefinements)
        });
      },
      addHierarchicalFacetRefinement: function (e, t) {
        if (this.isHierarchicalFacetRefined(e)) throw new Error(e + " is already refined.");
        if (!this.isHierarchicalFacet(e)) throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var n = {};
        return n[e] = [t], this.setQueryParameters({
          hierarchicalFacetsRefinements: o({}, n, this.hierarchicalFacetsRefinements)
        });
      },
      removeHierarchicalFacetRefinement: function (e) {
        if (!this.isHierarchicalFacetRefined(e)) return this;
        var t = {};
        return t[e] = [], this.setQueryParameters({
          hierarchicalFacetsRefinements: o({}, t, this.hierarchicalFacetsRefinements)
        });
      },
      toggleTagRefinement: function (e) {
        return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e);
      },
      isDisjunctiveFacet: function (e) {
        return this.disjunctiveFacets.indexOf(e) > -1;
      },
      isHierarchicalFacet: function (e) {
        return void 0 !== this.getHierarchicalFacetByName(e);
      },
      isConjunctiveFacet: function (e) {
        return this.facets.indexOf(e) > -1;
      },
      isFacetRefined: function (e, t) {
        return !!this.isConjunctiveFacet(e) && p.isRefined(this.facetsRefinements, e, t);
      },
      isExcludeRefined: function (e, t) {
        return !!this.isConjunctiveFacet(e) && p.isRefined(this.facetsExcludes, e, t);
      },
      isDisjunctiveFacetRefined: function (e, t) {
        return !!this.isDisjunctiveFacet(e) && p.isRefined(this.disjunctiveFacetsRefinements, e, t);
      },
      isHierarchicalFacetRefined: function (e, t) {
        if (!this.isHierarchicalFacet(e)) return !1;
        var n = this.getHierarchicalRefinement(e);
        return t ? n.indexOf(t) !== -1 : n.length > 0;
      },
      isNumericRefined: function (e, t, n) {
        if (void 0 === n && void 0 === t) return !!this.numericRefinements[e];
        var r = this.numericRefinements[e] && void 0 !== this.numericRefinements[e][t];
        if (void 0 === n || !r) return r;
        var a = l(n),
          s = void 0 !== i(this.numericRefinements[e][t], a);
        return r && s;
      },
      isTagRefined: function (e) {
        return this.tagRefinements.indexOf(e) !== -1;
      },
      getRefinedDisjunctiveFacets: function () {
        var e = this,
          t = c(Object.keys(this.numericRefinements).filter(function (t) {
            return Object.keys(e.numericRefinements[t]).length > 0;
          }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function (t) {
          return e.disjunctiveFacetsRefinements[t].length > 0;
        }).concat(t).concat(this.getRefinedHierarchicalFacets());
      },
      getRefinedHierarchicalFacets: function () {
        var e = this;
        return c(this.hierarchicalFacets.map(function (e) {
          return e.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function (t) {
          return e.hierarchicalFacetsRefinements[t].length > 0;
        }));
      },
      getUnrefinedDisjunctiveFacets: function () {
        var e = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function (t) {
          return e.indexOf(t) === -1;
        });
      },
      managedParameters: ["index", "facets", "disjunctiveFacets", "facetsRefinements", "hierarchicalFacets", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacetsRefinements"],
      getQueryParams: function () {
        var e = this.managedParameters,
          t = {},
          n = this;
        return Object.keys(this).forEach(function (r) {
          var i = n[r];
          e.indexOf(r) === -1 && void 0 !== i && (t[r] = i);
        }), t;
      },
      setQueryParameter: function (e, t) {
        if (this[e] === t) return this;
        var n = {};
        return n[e] = t, this.setQueryParameters(n);
      },
      setQueryParameters: function (e) {
        if (!e) return this;
        var t = a.validate(this, e);
        if (t) throw t;
        var n = this,
          r = a._parseNumbers(e),
          i = Object.keys(this).reduce(function (e, t) {
            return e[t] = n[t], e;
          }, {}),
          s = Object.keys(r).reduce(function (e, t) {
            var n = void 0 !== e[t],
              i = void 0 !== r[t];
            return n && !i ? f(e, [t]) : (i && (e[t] = r[t]), e);
          }, i);
        return new this.constructor(s);
      },
      resetPage: function () {
        return void 0 === this.page ? this : this.setPage(0);
      },
      _getHierarchicalFacetSortBy: function (e) {
        return e.sortBy || ["isRefined:desc", "name:asc"];
      },
      _getHierarchicalFacetSeparator: function (e) {
        return e.separator || " > ";
      },
      _getHierarchicalRootPath: function (e) {
        return e.rootPath || null;
      },
      _getHierarchicalShowParentLevel: function (e) {
        return "boolean" != typeof e.showParentLevel || e.showParentLevel;
      },
      getHierarchicalFacetByName: function (e) {
        return u(this.hierarchicalFacets, function (t) {
          return t.name === e;
        });
      },
      getHierarchicalFacetBreadcrumb: function (e) {
        if (!this.isHierarchicalFacet(e)) return [];
        var t = this.getHierarchicalRefinement(e)[0];
        if (!t) return [];
        var n = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)),
          r = t.split(n);
        return r.map(function (e) {
          return e.trim();
        });
      },
      toString: function () {
        return JSON.stringify(this, null, 2);
      }
    }, e.exports = a;
  }, function (e, t) {
    "use strict";

    function n(e) {
      return "object" == typeof e && null !== e ? i(Array.isArray(e) ? [] : {}, e) : e;
    }
    function r(e) {
      return "function" == typeof e || Array.isArray(e) || "[object Object]" === Object.prototype.toString.call(e);
    }
    function i(e, t) {
      if (e === t) return e;
      for (var a in t) if (Object.prototype.hasOwnProperty.call(t, a) && "__proto__" !== a && "constructor" !== a) {
        var s = t[a],
          o = e[a];
        "undefined" != typeof o && "undefined" == typeof s || (r(o) && r(s) ? e[a] = i(o, s) : e[a] = n(s));
      }
      return e;
    }
    function a(e) {
      r(e) || (e = {});
      for (var t = 1, n = arguments.length; t < n; t++) {
        var a = arguments[t];
        r(a) && i(e, a);
      }
      return e;
    }
    e.exports = a;
  }, function (e, t) {
    "use strict";

    e.exports = function () {
      var e = Array.prototype.slice.call(arguments);
      return e.reduceRight(function (e, t) {
        return Object.keys(Object(t)).forEach(function (n) {
          void 0 !== t[n] && (void 0 !== e[n] && delete e[n], e[n] = t[n]);
        }), e;
      }, {});
    };
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      return e.filter(function (n, r) {
        return t.indexOf(n) > -1 && e.indexOf(n) === r;
      });
    }
    e.exports = n;
  }, function (e, t) {
    "use strict";

    e.exports = function (e, t) {
      if (Array.isArray(e)) for (var n = 0; n < e.length; n++) if (t(e[n])) return e[n];
    };
  }, function (e, t) {
    "use strict";

    function n(e) {
      if ("number" == typeof e) return e;
      if ("string" == typeof e) return parseFloat(e);
      if (Array.isArray(e)) return e.map(n);
      throw new Error("The value should be a number, a parsable string or an array of those.");
    }
    e.exports = n;
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      if (null === e) return {};
      var n,
        r,
        i = {},
        a = Object.keys(e);
      for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    e.exports = n;
  }, function (e, t) {
    "use strict";

    function n(e) {
      return e && Object.keys(e).length > 0;
    }
    e.exports = n;
  }, function (e, t) {
    "use strict";

    e.exports = function (e) {
      return null !== e && /^[a-zA-Z0-9_-]{1,64}$/.test(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(7),
      i = n(11),
      a = n(12),
      s = {
        addRefinement: function (e, t, n) {
          if (s.isRefined(e, t, n)) return e;
          var i = "" + n,
            a = e[t] ? e[t].concat(i) : [i],
            o = {};
          return o[t] = a, r({}, o, e);
        },
        removeRefinement: function (e, t, n) {
          if (void 0 === n) return s.clearRefinement(e, function (e, n) {
            return t === n;
          });
          var r = "" + n;
          return s.clearRefinement(e, function (e, n) {
            return t === n && r === e;
          });
        },
        toggleRefinement: function (e, t, n) {
          if (void 0 === n) throw new Error("toggleRefinement should be used with a value");
          return s.isRefined(e, t, n) ? s.removeRefinement(e, t, n) : s.addRefinement(e, t, n);
        },
        clearRefinement: function (e, t, n) {
          if (void 0 === t) return a(e) ? {} : e;
          if ("string" == typeof t) return i(e, [t]);
          if ("function" == typeof t) {
            var r = !1,
              s = Object.keys(e).reduce(function (i, a) {
                var s = e[a] || [],
                  o = s.filter(function (e) {
                    return !t(e, a, n);
                  });
                return o.length !== s.length && (r = !0), i[a] = o, i;
              }, {});
            return r ? s : e;
          }
        },
        isRefined: function (e, t, n) {
          var r = !!e[t] && e[t].length > 0;
          if (void 0 === n || !r) return r;
          var i = "" + n;
          return e[t].indexOf(i) !== -1;
        }
      };
    e.exports = s;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = {};
      return e.forEach(function (e, n) {
        t[e] = n;
      }), t;
    }
    function i(e, t, n) {
      t && t[n] && (e.stats = t[n]);
    }
    function a(e, t) {
      return b(e, function (e) {
        var n = e.attributes || [];
        return n.indexOf(t) > -1;
      });
    }
    function s(e, t, n) {
      var s = t[0];
      this._rawResults = t;
      var o = this;
      Object.keys(s).forEach(function (e) {
        o[e] = s[e];
      }), Object.keys(n || {}).forEach(function (e) {
        o[e] = n[e];
      }), this.processingTimeMS = t.reduce(function (e, t) {
        return void 0 === t.processingTimeMS ? e : e + t.processingTimeMS;
      }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = e.hierarchicalFacets.map(function () {
        return [];
      }), this.facets = [];
      var c = e.getRefinedDisjunctiveFacets(),
        u = r(e.facets),
        l = r(e.disjunctiveFacets),
        f = 1,
        h = s.facets || {};
      Object.keys(h).forEach(function (t) {
        var n = h[t],
          r = a(e.hierarchicalFacets, t);
        if (r) {
          var c = r.attributes.indexOf(t),
            f = R(e.hierarchicalFacets, function (e) {
              return e.name === r.name;
            });
          o.hierarchicalFacets[f][c] = {
            attribute: t,
            data: n,
            exhaustive: s.exhaustiveFacetsCount
          };
        } else {
          var d,
            p = e.disjunctiveFacets.indexOf(t) !== -1,
            m = e.facets.indexOf(t) !== -1;
          p && (d = l[t], o.disjunctiveFacets[d] = {
            name: t,
            data: n,
            exhaustive: s.exhaustiveFacetsCount
          }, i(o.disjunctiveFacets[d], s.facets_stats, t)), m && (d = u[t], o.facets[d] = {
            name: t,
            data: n,
            exhaustive: s.exhaustiveFacetsCount
          }, i(o.facets[d], s.facets_stats, t));
        }
      }), this.hierarchicalFacets = y(this.hierarchicalFacets), c.forEach(function (n) {
        var r = t[f],
          a = r && r.facets ? r.facets : {},
          c = e.getHierarchicalFacetByName(n);
        Object.keys(a).forEach(function (t) {
          var n,
            u = a[t];
          if (c) {
            n = R(e.hierarchicalFacets, function (e) {
              return e.name === c.name;
            });
            var f = R(o.hierarchicalFacets[n], function (e) {
              return e.attribute === t;
            });
            if (f === -1) return;
            o.hierarchicalFacets[n][f].data = m({}, o.hierarchicalFacets[n][f].data, u);
          } else {
            n = l[t];
            var h = s.facets && s.facets[t] || {};
            o.disjunctiveFacets[n] = {
              name: t,
              data: g({}, u, h),
              exhaustive: r.exhaustiveFacetsCount
            }, i(o.disjunctiveFacets[n], r.facets_stats, t), e.disjunctiveFacetsRefinements[t] && e.disjunctiveFacetsRefinements[t].forEach(function (r) {
              !o.disjunctiveFacets[n].data[r] && e.disjunctiveFacetsRefinements[t].indexOf(P(r)) > -1 && (o.disjunctiveFacets[n].data[r] = 0);
            });
          }
        }), f++;
      }), e.getRefinedHierarchicalFacets().forEach(function (n) {
        var r = e.getHierarchicalFacetByName(n),
          i = e._getHierarchicalFacetSeparator(r),
          a = e.getHierarchicalRefinement(n);
        0 === a.length || a[0].split(i).length < 2 || t.slice(f).forEach(function (t) {
          var n = t && t.facets ? t.facets : {};
          Object.keys(n).forEach(function (t) {
            var s = n[t],
              c = R(e.hierarchicalFacets, function (e) {
                return e.name === r.name;
              }),
              u = R(o.hierarchicalFacets[c], function (e) {
                return e.attribute === t;
              });
            if (u !== -1) {
              var l = {};
              if (a.length > 0) {
                var f = a[0].split(i)[0];
                l[f] = o.hierarchicalFacets[c][u].data[f];
              }
              o.hierarchicalFacets[c][u].data = g(l, s, o.hierarchicalFacets[c][u].data);
            }
          }), f++;
        });
      }), Object.keys(e.facetsExcludes).forEach(function (t) {
        var n = e.facetsExcludes[t],
          r = u[t];
        o.facets[r] = {
          name: t,
          data: s.facets[t],
          exhaustive: s.exhaustiveFacetsCount
        }, n.forEach(function (e) {
          o.facets[r] = o.facets[r] || {
            name: t
          }, o.facets[r].data = o.facets[r].data || {}, o.facets[r].data[e] = 0;
        });
      }), this.hierarchicalFacets = this.hierarchicalFacets.map(O(e)), this.facets = y(this.facets), this.disjunctiveFacets = y(this.disjunctiveFacets), this._state = e;
    }
    function o(e, t) {
      function n(e) {
        return e.name === t;
      }
      if (e._state.isConjunctiveFacet(t)) {
        var r = b(e.facets, n);
        return r ? Object.keys(r.data).map(function (n) {
          var i = w(n);
          return {
            name: n,
            escapedValue: i,
            count: r.data[n],
            isRefined: e._state.isFacetRefined(t, i),
            isExcluded: e._state.isExcludeRefined(t, n)
          };
        }) : [];
      }
      if (e._state.isDisjunctiveFacet(t)) {
        var i = b(e.disjunctiveFacets, n);
        return i ? Object.keys(i.data).map(function (n) {
          var r = w(n);
          return {
            name: n,
            escapedValue: r,
            count: i.data[n],
            isRefined: e._state.isDisjunctiveFacetRefined(t, r)
          };
        }) : [];
      }
      if (e._state.isHierarchicalFacet(t)) return b(e.hierarchicalFacets, n);
    }
    function c(e, t, n, r) {
      if (r = r || 0, Array.isArray(t)) return e(t, n[r]);
      if (!t.data || 0 === t.data.length) return t;
      var i = t.data.map(function (t) {
          return c(e, t, n, r + 1);
        }),
        a = e(i, n[r]),
        s = g({
          data: a
        }, t);
      return s;
    }
    function u(e, t) {
      return t.sort(e);
    }
    function l(e, t) {
      var n = [],
        r = [],
        i = t.order || [],
        a = i.reduce(function (e, t, n) {
          return e[t] = n, e;
        }, {});
      e.forEach(function (e) {
        var t = e.path || e.name;
        void 0 !== a[t] ? n[a[t]] = e : r.push(e);
      }), n = n.filter(function (e) {
        return e;
      });
      var s,
        o = t.sortRemainingBy;
      return "hidden" === o ? n : (s = "alpha" === o ? [["path", "name"], ["asc", "asc"]] : [["count"], ["desc"]], n.concat(v(r, s[0], s[1])));
    }
    function f(e, t) {
      return e.renderingContent && e.renderingContent.facetOrdering && e.renderingContent.facetOrdering.values && e.renderingContent.facetOrdering.values[t];
    }
    function h(e, t) {
      var n = b(e, function (e) {
        return e.name === t;
      });
      return n && n.stats;
    }
    function d(e, t, n, r, i) {
      var a = b(i, function (e) {
          return e.name === n;
        }),
        s = a && a.data && a.data[r] ? a.data[r] : 0,
        o = a && a.exhaustive || !1;
      return {
        type: t,
        attributeName: n,
        name: r,
        count: s,
        exhaustive: o
      };
    }
    function p(e, t, n, r) {
      var i = e.getHierarchicalFacetByName(t),
        a = e._getHierarchicalFacetSeparator(i),
        s = n.split(a),
        o = b(r, function (e) {
          return e.name === t;
        }),
        c = s.reduce(function (e, t) {
          var n = e && b(e.data, function (e) {
            return e.name === t;
          });
          return void 0 !== n ? n : e;
        }, o),
        u = c && c.count || 0,
        l = c && c.exhaustive || !1,
        f = c && c.path || "";
      return {
        type: "hierarchical",
        attributeName: t,
        name: f,
        count: u,
        exhaustive: l
      };
    }
    var m = n(6),
      g = n(7),
      v = n(16),
      y = n(17),
      b = n(9),
      R = n(18),
      S = n(19),
      _ = n(20),
      w = _.escapeFacetValue,
      P = _.unescapeFacetValue,
      O = n(21);
    s.prototype.getFacetByName = function (e) {
      function t(t) {
        return t.name === e;
      }
      return b(this.facets, t) || b(this.disjunctiveFacets, t) || b(this.hierarchicalFacets, t);
    }, s.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"], s.prototype.getFacetValues = function (e, t) {
      var n = o(this, e);
      if (n) {
        var r,
          i = g({}, t, {
            sortBy: s.DEFAULT_SORT,
            facetOrdering: !(t && t.sortBy)
          }),
          a = this;
        if (Array.isArray(n)) r = [e];else {
          var h = a._state.getHierarchicalFacetByName(n.name);
          r = h.attributes;
        }
        return c(function (e, t) {
          if (i.facetOrdering) {
            var n = f(a, t);
            if (Boolean(n)) return l(e, n);
          }
          if (Array.isArray(i.sortBy)) {
            var r = S(i.sortBy, s.DEFAULT_SORT);
            return v(e, r[0], r[1]);
          }
          if ("function" == typeof i.sortBy) return u(i.sortBy, e);
          throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
        }, n, r);
      }
    }, s.prototype.getFacetStats = function (e) {
      return this._state.isConjunctiveFacet(e) ? h(this.facets, e) : this._state.isDisjunctiveFacet(e) ? h(this.disjunctiveFacets, e) : void 0;
    }, s.prototype.getRefinements = function () {
      var e = this._state,
        t = this,
        n = [];
      return Object.keys(e.facetsRefinements).forEach(function (r) {
        e.facetsRefinements[r].forEach(function (i) {
          n.push(d(e, "facet", r, i, t.facets));
        });
      }), Object.keys(e.facetsExcludes).forEach(function (r) {
        e.facetsExcludes[r].forEach(function (i) {
          n.push(d(e, "exclude", r, i, t.facets));
        });
      }), Object.keys(e.disjunctiveFacetsRefinements).forEach(function (r) {
        e.disjunctiveFacetsRefinements[r].forEach(function (i) {
          n.push(d(e, "disjunctive", r, i, t.disjunctiveFacets));
        });
      }), Object.keys(e.hierarchicalFacetsRefinements).forEach(function (r) {
        e.hierarchicalFacetsRefinements[r].forEach(function (i) {
          n.push(p(e, r, i, t.hierarchicalFacets));
        });
      }), Object.keys(e.numericRefinements).forEach(function (t) {
        var r = e.numericRefinements[t];
        Object.keys(r).forEach(function (e) {
          r[e].forEach(function (r) {
            n.push({
              type: "numeric",
              attributeName: t,
              name: r,
              numericValue: r,
              operator: e
            });
          });
        });
      }), e.tagRefinements.forEach(function (e) {
        n.push({
          type: "tag",
          attributeName: "_tags",
          name: e
        });
      }), n;
    }, e.exports = s;
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      if (e !== t) {
        var n = void 0 !== e,
          r = null === e,
          i = void 0 !== t,
          a = null === t;
        if (!a && e > t || r && i || !n) return 1;
        if (!r && e < t || a && n || !i) return -1;
      }
      return 0;
    }
    function r(e, t, r) {
      if (!Array.isArray(e)) return [];
      Array.isArray(r) || (r = []);
      var i = e.map(function (e, n) {
        return {
          criteria: t.map(function (t) {
            return e[t];
          }),
          index: n,
          value: e
        };
      });
      return i.sort(function (e, t) {
        for (var i = -1; ++i < e.criteria.length;) {
          var a = n(e.criteria[i], t.criteria[i]);
          if (a) return i >= r.length ? a : "desc" === r[i] ? -a : a;
        }
        return e.index - t.index;
      }), i.map(function (e) {
        return e.value;
      });
    }
    e.exports = r;
  }, function (e, t) {
    "use strict";

    e.exports = function (e) {
      return Array.isArray(e) ? e.filter(Boolean) : [];
    };
  }, function (e, t) {
    "use strict";

    e.exports = function (e, t) {
      if (!Array.isArray(e)) return -1;
      for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
      return -1;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(9);
    e.exports = function (e, t) {
      var n = (t || []).map(function (e) {
        return e.split(":");
      });
      return e.reduce(function (e, t) {
        var i = t.split(":"),
          a = r(n, function (e) {
            return e[0] === i[0];
          });
        return i.length > 1 || !a ? (e[0].push(i[0]), e[1].push(i[1]), e) : (e[0].push(a[0]), e[1].push(a[1]), e);
      }, [[], []]);
    };
  }, function (e, t) {
    "use strict";

    function n(e) {
      return "string" != typeof e ? e : String(e).replace(/^-/, "\\-");
    }
    function r(e) {
      return "string" != typeof e ? e : e.replace(/^\\-/, "-");
    }
    e.exports = {
      escapeFacetValue: n,
      unescapeFacetValue: r
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function (t, n) {
        var r = e.hierarchicalFacets[n],
          a = e.hierarchicalFacetsRefinements[r.name] && e.hierarchicalFacetsRefinements[r.name][0] || "",
          s = e._getHierarchicalFacetSeparator(r),
          o = e._getHierarchicalRootPath(r),
          c = e._getHierarchicalShowParentLevel(r),
          l = u(e._getHierarchicalFacetSortBy(r)),
          f = t.every(function (e) {
            return e.exhaustive;
          }),
          h = i(l, s, o, c, a),
          d = t;
        return o && (d = t.slice(o.split(s).length)), d.reduce(h, {
          name: e.hierarchicalFacets[n].name,
          count: null,
          isRefined: !0,
          path: null,
          escapedValue: null,
          exhaustive: f,
          data: null
        });
      };
    }
    function i(e, t, n, r, i) {
      return function (u, l, f) {
        var d = u;
        if (f > 0) {
          var p = 0;
          for (d = u; p < f;) {
            var m = d && Array.isArray(d.data) ? d.data : [];
            d = c(m, function (e) {
              return e.isRefined;
            }), p++;
          }
        }
        if (d) {
          var g = Object.keys(l.data).map(function (e) {
            return [e, l.data[e]];
          }).filter(function (e) {
            var s = e[0];
            return a(s, d.path || n, i, t, n, r);
          });
          d.data = o(g.map(function (e) {
            var n = e[0],
              r = e[1];
            return s(r, n, t, h(i), l.exhaustive);
          }), e[0], e[1]);
        }
        return u;
      };
    }
    function a(e, t, n, r, i, a) {
      return (!i || 0 === e.indexOf(i) && i !== e) && (!i && e.indexOf(r) === -1 || i && e.split(r).length - i.split(r).length === 1 || e.indexOf(r) === -1 && n.indexOf(r) === -1 || 0 === n.indexOf(e) || 0 === e.indexOf(t + r) && (a || 0 === e.indexOf(n)));
    }
    function s(e, t, n, r, i) {
      var a = t.split(n);
      return {
        name: a[a.length - 1].trim(),
        path: t,
        escapedValue: f(t),
        count: e,
        isRefined: r === t || 0 === r.indexOf(t + n),
        exhaustive: i,
        data: null
      };
    }
    e.exports = r;
    var o = n(16),
      c = n(9),
      u = n(19),
      l = n(20),
      f = l.escapeFacetValue,
      h = l.unescapeFacetValue;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      this.main = e, this.fn = t, this.lastResults = null;
    }
    var i = n(23),
      a = n(24);
    a(r, i), r.prototype.detach = function () {
      this.removeAllListeners(), this.main.detachDerivedHelper(this);
    }, r.prototype.getModifiedState = function (e) {
      return this.fn(e);
    }, e.exports = r;
  }, function (e, t) {
    function n() {
      this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
    }
    function r(e) {
      return "function" == typeof e;
    }
    function i(e) {
      return "number" == typeof e;
    }
    function a(e) {
      return "object" == typeof e && null !== e;
    }
    function s(e) {
      return void 0 === e;
    }
    e.exports = n, n.prototype._events = void 0, n.prototype._maxListeners = void 0, n.defaultMaxListeners = 10, n.prototype.setMaxListeners = function (e) {
      if (!i(e) || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
      return this._maxListeners = e, this;
    }, n.prototype.emit = function (e) {
      var t, n, i, o, c, u;
      if (this._events || (this._events = {}), "error" === e && (!this._events.error || a(this._events.error) && !this._events.error.length)) {
        if (t = arguments[1], t instanceof Error) throw t;
        var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
        throw l.context = t, l;
      }
      if (n = this._events[e], s(n)) return !1;
      if (r(n)) switch (arguments.length) {
        case 1:
          n.call(this);
          break;
        case 2:
          n.call(this, arguments[1]);
          break;
        case 3:
          n.call(this, arguments[1], arguments[2]);
          break;
        default:
          o = Array.prototype.slice.call(arguments, 1), n.apply(this, o);
      } else if (a(n)) for (o = Array.prototype.slice.call(arguments, 1), u = n.slice(), i = u.length, c = 0; c < i; c++) u[c].apply(this, o);
      return !0;
    }, n.prototype.addListener = function (e, t) {
      var i;
      if (!r(t)) throw TypeError("listener must be a function");
      return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, r(t.listener) ? t.listener : t), this._events[e] ? a(this._events[e]) ? this._events[e].push(t) : this._events[e] = [this._events[e], t] : this._events[e] = t, a(this._events[e]) && !this._events[e].warned && (i = s(this._maxListeners) ? n.defaultMaxListeners : this._maxListeners, i && i > 0 && this._events[e].length > i && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace && console.trace())), this;
    }, n.prototype.on = n.prototype.addListener, n.prototype.once = function (e, t) {
      function n() {
        this.removeListener(e, n), i || (i = !0, t.apply(this, arguments));
      }
      if (!r(t)) throw TypeError("listener must be a function");
      var i = !1;
      return n.listener = t, this.on(e, n), this;
    }, n.prototype.removeListener = function (e, t) {
      var n, i, s, o;
      if (!r(t)) throw TypeError("listener must be a function");
      if (!this._events || !this._events[e]) return this;
      if (n = this._events[e], s = n.length, i = -1, n === t || r(n.listener) && n.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t);else if (a(n)) {
        for (o = s; o-- > 0;) if (n[o] === t || n[o].listener && n[o].listener === t) {
          i = o;
          break;
        }
        if (i < 0) return this;
        1 === n.length ? (n.length = 0, delete this._events[e]) : n.splice(i, 1), this._events.removeListener && this.emit("removeListener", e, t);
      }
      return this;
    }, n.prototype.removeAllListeners = function (e) {
      var t, n;
      if (!this._events) return this;
      if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e], this;
      if (0 === arguments.length) {
        for (t in this._events) "removeListener" !== t && this.removeAllListeners(t);
        return this.removeAllListeners("removeListener"), this._events = {}, this;
      }
      if (n = this._events[e], r(n)) this.removeListener(e, n);else if (n) for (; n.length;) this.removeListener(e, n[n.length - 1]);
      return delete this._events[e], this;
    }, n.prototype.listeners = function (e) {
      var t;
      return t = this._events && this._events[e] ? r(this._events[e]) ? [this._events[e]] : this._events[e].slice() : [];
    }, n.prototype.listenerCount = function (e) {
      if (this._events) {
        var t = this._events[e];
        if (r(t)) return 1;
        if (t) return t.length;
      }
      return 0;
    }, n.listenerCount = function (e, t) {
      return e.listenerCount(t);
    };
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    }
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return Object.keys(e).sort(function (e, t) {
        return e.localeCompare(t);
      }).reduce(function (t, n) {
        return t[n] = e[n], t;
      }, {});
    }
    var i = n(6),
      a = {
        _getQueries: function (e, t) {
          var n = [];
          return n.push({
            indexName: e,
            params: a._getHitsSearchParams(t)
          }), t.getRefinedDisjunctiveFacets().forEach(function (r) {
            n.push({
              indexName: e,
              params: a._getDisjunctiveFacetSearchParams(t, r)
            });
          }), t.getRefinedHierarchicalFacets().forEach(function (r) {
            var i = t.getHierarchicalFacetByName(r),
              s = t.getHierarchicalRefinement(r),
              o = t._getHierarchicalFacetSeparator(i);
            if (s.length > 0 && s[0].split(o).length > 1) {
              var c = s[0].split(o).slice(0, -1).reduce(function (e, t, n) {
                return e.concat({
                  attribute: i.attributes[n],
                  value: 0 === n ? t : [e[e.length - 1].value, t].join(o)
                });
              }, []);
              c.forEach(function (r, s) {
                function o(e) {
                  return i.attributes.some(function (t) {
                    return t === e.split(":")[0];
                  });
                }
                var u = a._getDisjunctiveFacetSearchParams(t, r.attribute, 0 === s),
                  l = (u.facetFilters || []).reduce(function (e, t) {
                    if (Array.isArray(t)) {
                      var n = t.filter(function (e) {
                        return !o(e);
                      });
                      n.length > 0 && e.push(n);
                    }
                    return "string" != typeof t || o(t) || e.push(t), e;
                  }, []),
                  f = c[s - 1];
                s > 0 ? u.facetFilters = l.concat(f.attribute + ":" + f.value) : u.facetFilters = l.length > 0 ? l : void 0, n.push({
                  indexName: e,
                  params: u
                });
              });
            }
          }), n;
        },
        _getHitsSearchParams: function (e) {
          var t = e.facets.concat(e.disjunctiveFacets).concat(a._getHitsHierarchicalFacetsAttributes(e)),
            n = a._getFacetFilters(e),
            s = a._getNumericFilters(e),
            o = a._getTagFilters(e),
            c = {
              facets: t.indexOf("*") > -1 ? ["*"] : t,
              tagFilters: o
            };
          return n.length > 0 && (c.facetFilters = n), s.length > 0 && (c.numericFilters = s), r(i({}, e.getQueryParams(), c));
        },
        _getDisjunctiveFacetSearchParams: function (e, t, n) {
          var s = a._getFacetFilters(e, t, n),
            o = a._getNumericFilters(e, t),
            c = a._getTagFilters(e),
            u = {
              hitsPerPage: 0,
              page: 0,
              analytics: !1,
              clickAnalytics: !1
            };
          c.length > 0 && (u.tagFilters = c);
          var l = e.getHierarchicalFacetByName(t);
          return l ? u.facets = a._getDisjunctiveHierarchicalFacetAttribute(e, l, n) : u.facets = t, o.length > 0 && (u.numericFilters = o), s.length > 0 && (u.facetFilters = s), r(i({}, e.getQueryParams(), u));
        },
        _getNumericFilters: function (e, t) {
          if (e.numericFilters) return e.numericFilters;
          var n = [];
          return Object.keys(e.numericRefinements).forEach(function (r) {
            var i = e.numericRefinements[r] || {};
            Object.keys(i).forEach(function (e) {
              var a = i[e] || [];
              t !== r && a.forEach(function (t) {
                if (Array.isArray(t)) {
                  var i = t.map(function (t) {
                    return r + e + t;
                  });
                  n.push(i);
                } else n.push(r + e + t);
              });
            });
          }), n;
        },
        _getTagFilters: function (e) {
          return e.tagFilters ? e.tagFilters : e.tagRefinements.join(",");
        },
        _getFacetFilters: function (e, t, n) {
          var r = [],
            i = e.facetsRefinements || {};
          Object.keys(i).forEach(function (e) {
            var t = i[e] || [];
            t.forEach(function (t) {
              r.push(e + ":" + t);
            });
          });
          var a = e.facetsExcludes || {};
          Object.keys(a).forEach(function (e) {
            var t = a[e] || [];
            t.forEach(function (t) {
              r.push(e + ":-" + t);
            });
          });
          var s = e.disjunctiveFacetsRefinements || {};
          Object.keys(s).forEach(function (e) {
            var n = s[e] || [];
            if (e !== t && n && 0 !== n.length) {
              var i = [];
              n.forEach(function (t) {
                i.push(e + ":" + t);
              }), r.push(i);
            }
          });
          var o = e.hierarchicalFacetsRefinements || {};
          return Object.keys(o).forEach(function (i) {
            var a = o[i] || [],
              s = a[0];
            if (void 0 !== s) {
              var c,
                u,
                l = e.getHierarchicalFacetByName(i),
                f = e._getHierarchicalFacetSeparator(l),
                h = e._getHierarchicalRootPath(l);
              if (t === i) {
                if (s.indexOf(f) === -1 || !h && n === !0 || h && h.split(f).length === s.split(f).length) return;
                h ? (u = h.split(f).length - 1, s = h) : (u = s.split(f).length - 2, s = s.slice(0, s.lastIndexOf(f))), c = l.attributes[u];
              } else u = s.split(f).length - 1, c = l.attributes[u];
              c && r.push([c + ":" + s]);
            }
          }), r;
        },
        _getHitsHierarchicalFacetsAttributes: function (e) {
          var t = [];
          return e.hierarchicalFacets.reduce(function (t, n) {
            var r = e.getHierarchicalRefinement(n.name)[0];
            if (!r) return t.push(n.attributes[0]), t;
            var i = e._getHierarchicalFacetSeparator(n),
              a = r.split(i).length,
              s = n.attributes.slice(0, a + 1);
            return t.concat(s);
          }, t);
        },
        _getDisjunctiveHierarchicalFacetAttribute: function (e, t, n) {
          var r = e._getHierarchicalFacetSeparator(t);
          if (n === !0) {
            var i = e._getHierarchicalRootPath(t),
              a = 0;
            return i && (a = i.split(r).length), [t.attributes[a]];
          }
          var s = e.getHierarchicalRefinement(t.name)[0] || "",
            o = s.split(r).length - 1;
          return t.attributes.slice(0, o + 1);
        },
        getSearchForFacetQuery: function (e, t, n, s) {
          var o = s.isDisjunctiveFacet(e) ? s.clearRefinements(e) : s,
            c = {
              facetQuery: t,
              facetName: e
            };
          return "number" == typeof n && (c.maxFacetHits = n), r(i({}, a._getHitsSearchParams(o), c));
        }
      };
    e.exports = a;
  }, function (e, t) {
    "use strict";

    e.exports = "3.11.2";
  }, function (e, t, n) {
    var r = n(28);
    r.Template = n(29).Template, r.template = r.Template, e.exports = r;
  }, function (e, t, n) {
    !function (e) {
      function t(e) {
        "}" === e.n.substr(e.n.length - 1) && (e.n = e.n.substring(0, e.n.length - 1));
      }
      function n(e) {
        return e.trim ? e.trim() : e.replace(/^\s*|\s*$/g, "");
      }
      function r(e, t, n) {
        if (t.charAt(n) != e.charAt(0)) return !1;
        for (var r = 1, i = e.length; r < i; r++) if (t.charAt(n + r) != e.charAt(r)) return !1;
        return !0;
      }
      function i(t, n, r, o) {
        var c = [],
          u = null,
          l = null,
          f = null;
        for (l = r[r.length - 1]; t.length > 0;) {
          if (f = t.shift(), l && "<" == l.tag && !(f.tag in S)) throw new Error("Illegal content in < super tag.");
          if (e.tags[f.tag] <= e.tags.$ || a(f, o)) r.push(f), f.nodes = i(t, f.tag, r, o);else {
            if ("/" == f.tag) {
              if (0 === r.length) throw new Error("Closing tag without opener: /" + f.n);
              if (u = r.pop(), f.n != u.n && !s(f.n, u.n, o)) throw new Error("Nesting error: " + u.n + " vs. " + f.n);
              return u.end = f.i, c;
            }
            "\n" == f.tag && (f.last = 0 == t.length || "\n" == t[0].tag);
          }
          c.push(f);
        }
        if (r.length > 0) throw new Error("missing closing tag: " + r.pop().n);
        return c;
      }
      function a(e, t) {
        for (var n = 0, r = t.length; n < r; n++) if (t[n].o == e.n) return e.tag = "#", !0;
      }
      function s(e, t, n) {
        for (var r = 0, i = n.length; r < i; r++) if (n[r].c == e && n[r].o == t) return !0;
      }
      function o(e) {
        var t = [];
        for (var n in e) t.push('"' + u(n) + '": function(c,p,t,i) {' + e[n] + "}");
        return "{ " + t.join(",") + " }";
      }
      function c(e) {
        var t = [];
        for (var n in e.partials) t.push('"' + u(n) + '":{name:"' + u(e.partials[n].name) + '", ' + c(e.partials[n]) + "}");
        return "partials: {" + t.join(",") + "}, subs: " + o(e.subs);
      }
      function u(e) {
        return e.replace(y, "\\\\").replace(m, '\\"').replace(g, "\\n").replace(v, "\\r").replace(b, "\\u2028").replace(R, "\\u2029");
      }
      function l(e) {
        return ~e.indexOf(".") ? "d" : "f";
      }
      function f(e, t) {
        var n = "<" + (t.prefix || ""),
          r = n + e.n + _++;
        return t.partials[r] = {
          name: e.n,
          partials: {}
        }, t.code += 't.b(t.rp("' + u(r) + '",c,p,"' + (e.indent || "") + '"));', r;
      }
      function h(e, t) {
        t.code += "t.b(t.t(t." + l(e.n) + '("' + u(e.n) + '",c,p,0)));';
      }
      function d(e) {
        return "t.b(" + e + ");";
      }
      var p = /\S/,
        m = /\"/g,
        g = /\n/g,
        v = /\r/g,
        y = /\\/g,
        b = /\u2028/,
        R = /\u2029/;
      e.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        $: 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        _v: 9,
        "{": 10,
        "&": 11,
        _t: 12
      }, e.scan = function (i, a) {
        function s() {
          y.length > 0 && (b.push({
            tag: "_t",
            text: new String(y)
          }), y = "");
        }
        function o() {
          for (var t = !0, n = _; n < b.length; n++) if (t = e.tags[b[n].tag] < e.tags._v || "_t" == b[n].tag && null === b[n].text.match(p), !t) return !1;
          return t;
        }
        function c(e, t) {
          if (s(), e && o()) for (var n, r = _; r < b.length; r++) b[r].text && ((n = b[r + 1]) && ">" == n.tag && (n.indent = b[r].text.toString()), b.splice(r, 1));else t || b.push({
            tag: "\n"
          });
          R = !1, _ = b.length;
        }
        function u(e, t) {
          var r = "=" + P,
            i = e.indexOf(r, t),
            a = n(e.substring(e.indexOf("=", t) + 1, i)).split(" ");
          return w = a[0], P = a[a.length - 1], i + r.length - 1;
        }
        var l = i.length,
          f = 0,
          h = 1,
          d = 2,
          m = f,
          g = null,
          v = null,
          y = "",
          b = [],
          R = !1,
          S = 0,
          _ = 0,
          w = "{{",
          P = "}}";
        for (a && (a = a.split(" "), w = a[0], P = a[1]), S = 0; S < l; S++) m == f ? r(w, i, S) ? (--S, s(), m = h) : "\n" == i.charAt(S) ? c(R) : y += i.charAt(S) : m == h ? (S += w.length - 1, v = e.tags[i.charAt(S + 1)], g = v ? i.charAt(S + 1) : "_v", "=" == g ? (S = u(i, S), m = f) : (v && S++, m = d), R = S) : r(P, i, S) ? (b.push({
          tag: g,
          n: n(y),
          otag: w,
          ctag: P,
          i: "/" == g ? R - w.length : S + P.length
        }), y = "", S += P.length - 1, m = f, "{" == g && ("}}" == P ? S++ : t(b[b.length - 1]))) : y += i.charAt(S);
        return c(R, !0), b;
      };
      var S = {
        _t: !0,
        "\n": !0,
        $: !0,
        "/": !0
      };
      e.stringify = function (t, n, r) {
        return "{code: function (c,p,i) { " + e.wrapMain(t.code) + " }," + c(t) + "}";
      };
      var _ = 0;
      e.generate = function (t, n, r) {
        _ = 0;
        var i = {
          code: "",
          subs: {},
          partials: {}
        };
        return e.walk(t, i), r.asString ? this.stringify(i, n, r) : this.makeTemplate(i, n, r);
      }, e.wrapMain = function (e) {
        return 'var t=this;t.b(i=i||"");' + e + "return t.fl();";
      }, e.template = e.Template, e.makeTemplate = function (e, t, n) {
        var r = this.makePartials(e);
        return r.code = new Function("c", "p", "i", this.wrapMain(e.code)), new this.template(r, t, this, n);
      }, e.makePartials = function (e) {
        var t,
          n = {
            subs: {},
            partials: e.partials,
            name: e.name
          };
        for (t in n.partials) n.partials[t] = this.makePartials(n.partials[t]);
        for (t in e.subs) n.subs[t] = new Function("c", "p", "t", "i", e.subs[t]);
        return n;
      }, e.codegen = {
        "#": function (t, n) {
          n.code += "if(t.s(t." + l(t.n) + '("' + u(t.n) + '",c,p,1),c,p,0,' + t.i + "," + t.end + ',"' + t.otag + " " + t.ctag + '")){t.rs(c,p,function(c,p,t){', e.walk(t.nodes, n), n.code += "});c.pop();}";
        },
        "^": function (t, n) {
          n.code += "if(!t.s(t." + l(t.n) + '("' + u(t.n) + '",c,p,1),c,p,1,0,0,"")){', e.walk(t.nodes, n), n.code += "};";
        },
        ">": f,
        "<": function (t, n) {
          var r = {
            partials: {},
            code: "",
            subs: {},
            inPartial: !0
          };
          e.walk(t.nodes, r);
          var i = n.partials[f(t, n)];
          i.subs = r.subs, i.partials = r.partials;
        },
        $: function (t, n) {
          var r = {
            subs: {},
            code: "",
            partials: n.partials,
            prefix: t.n
          };
          e.walk(t.nodes, r), n.subs[t.n] = r.code, n.inPartial || (n.code += 't.sub("' + u(t.n) + '",c,p,i);');
        },
        "\n": function (e, t) {
          t.code += d('"\\n"' + (e.last ? "" : " + i"));
        },
        _v: function (e, t) {
          t.code += "t.b(t.v(t." + l(e.n) + '("' + u(e.n) + '",c,p,0)));';
        },
        _t: function (e, t) {
          t.code += d('"' + u(e.text) + '"');
        },
        "{": h,
        "&": h
      }, e.walk = function (t, n) {
        for (var r, i = 0, a = t.length; i < a; i++) r = e.codegen[t[i].tag], r && r(t[i], n);
        return n;
      }, e.parse = function (e, t, n) {
        return n = n || {}, i(e, "", [], n.sectionTags || []);
      }, e.cache = {}, e.cacheKey = function (e, t) {
        return [e, !!t.asString, !!t.disableLambda, t.delimiters, !!t.modelGet].join("||");
      }, e.compile = function (t, n) {
        n = n || {};
        var r = e.cacheKey(t, n),
          i = this.cache[r];
        if (i) {
          var a = i.partials;
          for (var s in a) delete a[s].instance;
          return i;
        }
        return i = this.generate(this.parse(this.scan(t, n.delimiters), t, n), t, n), this.cache[r] = i;
      };
    }(t);
  }, function (e, t, n) {
    !function (e) {
      function t(e, t, n) {
        var r;
        return t && "object" == typeof t && (void 0 !== t[e] ? r = t[e] : n && t.get && "function" == typeof t.get && (r = t.get(e))), r;
      }
      function n(e, t, n, r, i, a) {
        function s() {}
        function o() {}
        s.prototype = e, o.prototype = e.subs;
        var c,
          u = new s();
        u.subs = new o(), u.subsText = {}, u.buf = "", r = r || {}, u.stackSubs = r, u.subsText = a;
        for (c in t) r[c] || (r[c] = t[c]);
        for (c in r) u.subs[c] = r[c];
        i = i || {}, u.stackPartials = i;
        for (c in n) i[c] || (i[c] = n[c]);
        for (c in i) u.partials[c] = i[c];
        return u;
      }
      function r(e) {
        return String(null === e || void 0 === e ? "" : e);
      }
      function i(e) {
        return e = r(e), l.test(e) ? e.replace(a, "&amp;").replace(s, "&lt;").replace(o, "&gt;").replace(c, "&#39;").replace(u, "&quot;") : e;
      }
      e.Template = function (e, t, n, r) {
        e = e || {}, this.r = e.code || this.r, this.c = n, this.options = r || {}, this.text = t || "", this.partials = e.partials || {}, this.subs = e.subs || {}, this.buf = "";
      }, e.Template.prototype = {
        r: function (e, t, n) {
          return "";
        },
        v: i,
        t: r,
        render: function (e, t, n) {
          return this.ri([e], t || {}, n);
        },
        ri: function (e, t, n) {
          return this.r(e, t, n);
        },
        ep: function (e, t) {
          var r = this.partials[e],
            i = t[r.name];
          if (r.instance && r.base == i) return r.instance;
          if ("string" == typeof i) {
            if (!this.c) throw new Error("No compiler available.");
            i = this.c.compile(i, this.options);
          }
          if (!i) return null;
          if (this.partials[e].base = i, r.subs) {
            t.stackText || (t.stackText = {});
            for (key in r.subs) t.stackText[key] || (t.stackText[key] = void 0 !== this.activeSub && t.stackText[this.activeSub] ? t.stackText[this.activeSub] : this.text);
            i = n(i, r.subs, r.partials, this.stackSubs, this.stackPartials, t.stackText);
          }
          return this.partials[e].instance = i, i;
        },
        rp: function (e, t, n, r) {
          var i = this.ep(e, n);
          return i ? i.ri(t, n, r) : "";
        },
        rs: function (e, t, n) {
          var r = e[e.length - 1];
          if (!f(r)) return void n(e, t, this);
          for (var i = 0; i < r.length; i++) e.push(r[i]), n(e, t, this), e.pop();
        },
        s: function (e, t, n, r, i, a, s) {
          var o;
          return (!f(e) || 0 !== e.length) && ("function" == typeof e && (e = this.ms(e, t, n, r, i, a, s)), o = !!e, !r && o && t && t.push("object" == typeof e ? e : t[t.length - 1]), o);
        },
        d: function (e, n, r, i) {
          var a,
            s = e.split("."),
            o = this.f(s[0], n, r, i),
            c = this.options.modelGet,
            u = null;
          if ("." === e && f(n[n.length - 2])) o = n[n.length - 1];else for (var l = 1; l < s.length; l++) a = t(s[l], o, c), void 0 !== a ? (u = o, o = a) : o = "";
          return !(i && !o) && (i || "function" != typeof o || (n.push(u), o = this.mv(o, n, r), n.pop()), o);
        },
        f: function (e, n, r, i) {
          for (var a = !1, s = null, o = !1, c = this.options.modelGet, u = n.length - 1; u >= 0; u--) if (s = n[u], a = t(e, s, c), void 0 !== a) {
            o = !0;
            break;
          }
          return o ? (i || "function" != typeof a || (a = this.mv(a, n, r)), a) : !i && "";
        },
        ls: function (e, t, n, i, a) {
          var s = this.options.delimiters;
          return this.options.delimiters = a, this.b(this.ct(r(e.call(t, i)), t, n)), this.options.delimiters = s, !1;
        },
        ct: function (e, t, n) {
          if (this.options.disableLambda) throw new Error("Lambda features disabled.");
          return this.c.compile(e, this.options).render(t, n);
        },
        b: function (e) {
          this.buf += e;
        },
        fl: function () {
          var e = this.buf;
          return this.buf = "", e;
        },
        ms: function (e, t, n, r, i, a, s) {
          var o,
            c = t[t.length - 1],
            u = e.call(c);
          return "function" == typeof u ? !!r || (o = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text, this.ls(u, c, n, o.substring(i, a), s)) : u;
        },
        mv: function (e, t, n) {
          var i = t[t.length - 1],
            a = e.call(i);
          return "function" == typeof a ? this.ct(r(a.call(i)), i, n) : a;
        },
        sub: function (e, t, n, r) {
          var i = this.subs[e];
          i && (this.activeSub = e, i(t, n, this, r), this.activeSub = !1);
        }
      };
      var a = /&/g,
        s = /</g,
        o = />/g,
        c = /\'/g,
        u = /\"/g,
        l = /[&<>\"\']/,
        f = Array.isArray || function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        };
    }(t);
  }, function (e, t, n) {
    !function (e, n) {
      n(t);
    }(this, function (e) {
      "use strict";

      function t(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function n(e) {
        for (var n = 1; n < arguments.length; n++) {
          var r = null != arguments[n] ? arguments[n] : {};
          n % 2 ? t(Object(r), !0).forEach(function (t) {
            i(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }
      function r(e) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function i(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function a() {
        return a = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }, a.apply(this, arguments);
      }
      function s(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              i = {},
              a = Object.keys(e);
            for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }
      function o(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (null != n) {
            var r,
              i,
              a = [],
              s = !0,
              o = !1;
            try {
              for (n = n.call(e); !(s = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); s = !0);
            } catch (e) {
              o = !0, i = e;
            } finally {
              try {
                s || null == n.return || n.return();
              } finally {
                if (o) throw i;
              }
            }
            return a;
          }
        }(e, t) || u(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function c(e) {
        return function (e) {
          if (Array.isArray(e)) return l(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || u(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function u(e, t) {
        if (e) {
          if ("string" == typeof e) return l(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? l(e, t) : void 0;
        }
      }
      function l(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function f(e) {
        return {
          current: e
        };
      }
      function h(e, t) {
        var n = void 0;
        return function () {
          for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
          n && clearTimeout(n), n = setTimeout(function () {
            return e.apply(void 0, i);
          }, t);
        };
      }
      function d(e) {
        return e.reduce(function (e, t) {
          return e.concat(t);
        }, []);
      }
      function p() {
        return "autocomplete-".concat(qt++);
      }
      function m(e, t) {
        return t.reduce(function (e, t) {
          return e && e[t];
        }, e);
      }
      function g(e) {
        return 0 === e.collections.length ? 0 : e.collections.reduce(function (e, t) {
          return e + t.items.length;
        }, 0);
      }
      function v(e, t) {
        var n = t;
        return {
          then: function (t, r) {
            return v(e.then(b(t, n, e), b(r, n, e)), n);
          },
          catch: function (t) {
            return v(e.catch(b(t, n, e)), n);
          },
          finally: function (t) {
            return t && n.onCancelList.push(t), v(e.finally(b(t && function () {
              return n.onCancelList = [], t();
            }, n, e)), n);
          },
          cancel: function () {
            n.isCanceled = !0;
            var e = n.onCancelList;
            n.onCancelList = [], e.forEach(function (e) {
              e();
            });
          },
          isCanceled: function () {
            return !0 === n.isCanceled;
          }
        };
      }
      function y(e) {
        return v(e, {
          isCanceled: !1,
          onCancelList: []
        });
      }
      function b(e, t, n) {
        return e ? function (n) {
          return t.isCanceled ? n : e(n);
        } : n;
      }
      function R(e, t, n, r) {
        if (!n) return null;
        if (e < 0 && (null === t || null !== r && 0 === t)) return n + e;
        var i = (null === t ? -1 : t) + e;
        return i <= -1 || i >= n ? null === r ? null : 0 : i;
      }
      function S(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function _(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function w(e, t) {
        var n = [];
        return Promise.resolve(e(t)).then(function (e) {
          return Promise.all(e.filter(function (e) {
            return Boolean(e);
          }).map(function (e) {
            if (e.sourceId, n.includes(e.sourceId)) throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(e.sourceId), " is not unique."));
            n.push(e.sourceId);
            var t = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? S(Object(n), !0).forEach(function (t) {
                  _(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({
              getItemInputValue: function (e) {
                return e.state.query;
              },
              getItemUrl: function () {},
              onSelect: function (e) {
                (0, e.setIsOpen)(!1);
              },
              onActive: Bt
            }, e);
            return Promise.resolve(t);
          }));
        });
      }
      function P(e) {
        var t = function (e) {
          var t = e.collections.map(function (e) {
            return e.items.length;
          }).reduce(function (e, t, n) {
            var r = (e[n - 1] || 0) + t;
            return e.push(r), e;
          }, []).reduce(function (t, n) {
            return n <= e.activeItemId ? t + 1 : t;
          }, 0);
          return e.collections[t];
        }(e);
        if (!t) return null;
        var n = t.items[function (e) {
            for (var t = e.state, n = e.collection, r = !1, i = 0, a = 0; !1 === r;) {
              var s = t.collections[i];
              if (s === n) {
                r = !0;
                break;
              }
              a += s.items.length, i++;
            }
            return t.activeItemId - a;
          }({
            state: e,
            collection: t
          })],
          r = t.source;
        return {
          item: n,
          itemInputValue: r.getItemInputValue({
            item: n,
            state: e
          }),
          itemUrl: r.getItemUrl({
            item: n,
            state: e
          }),
          source: r
        };
      }
      function O(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function x(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? O(Object(n), !0).forEach(function (t) {
            j(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : O(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function j(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function I(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function F(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function N(e, t, n) {
        var r,
          i = t.initialState;
        return {
          getState: function () {
            return i;
          },
          dispatch: function (r, a) {
            var s = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? I(Object(n), !0).forEach(function (t) {
                  F(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({}, i);
            i = e(i, {
              type: r,
              props: t,
              payload: a
            }), n({
              state: i,
              prevState: s
            });
          },
          pendingRequests: (r = [], {
            add: function (e) {
              return r.push(e), e.finally(function () {
                r = r.filter(function (t) {
                  return t !== e;
                });
              });
            },
            cancelAll: function () {
              r.forEach(function (e) {
                return e.cancel();
              });
            },
            isEmpty: function () {
              return 0 === r.length;
            }
          })
        };
      }
      function E(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function C(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? E(Object(n), !0).forEach(function (t) {
            T(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : E(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function T(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function k(e) {
        return function (e) {
          if (Array.isArray(e)) return A(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return A(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? A(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function A(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function D(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function L(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? D(Object(n), !0).forEach(function (t) {
            M(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function M(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function H(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function q(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? H(Object(n), !0).forEach(function (t) {
            B(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : H(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function B(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function W(e) {
        return function (e) {
          if (Array.isArray(e)) return Q(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return Q(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Q(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function Q(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function U(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function V(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? U(Object(n), !0).forEach(function (t) {
            $(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : U(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function $(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function z(e) {
        return Boolean(e.execute);
      }
      function K(e, t) {
        return n = e, Boolean(null == n ? void 0 : n.execute) ? V(V({}, e), {}, {
          requests: e.queries.map(function (n) {
            return {
              query: n,
              sourceId: t,
              transformResponse: e.transformResponse
            };
          })
        }) : {
          items: e,
          sourceId: t
        };
        var n;
      }
      function J(e) {
        var t = e.reduce(function (e, t) {
          if (!z(t)) return e.push(t), e;
          var n = t.searchClient,
            r = t.execute,
            i = t.requesterId,
            a = t.requests,
            s = e.find(function (e) {
              return z(t) && z(e) && e.searchClient === n && Boolean(i) && e.requesterId === i;
            });
          if (s) {
            var o;
            (o = s.items).push.apply(o, W(a));
          } else {
            var c = {
              execute: r,
              requesterId: i,
              items: a,
              searchClient: n
            };
            e.push(c);
          }
          return e;
        }, []).map(function (e) {
          if (!z(e)) return Promise.resolve(e);
          var t = e,
            n = t.execute,
            r = t.items;
          return n({
            searchClient: t.searchClient,
            requests: r
          });
        });
        return Promise.all(t).then(function (e) {
          return d(e);
        });
      }
      function G(e, t) {
        return t.map(function (t) {
          var n = e.filter(function (e) {
              return e.sourceId === t.sourceId;
            }),
            r = n.map(function (e) {
              return e.items;
            }),
            i = n[0].transformResponse,
            a = i ? i(function (e) {
              var t = e.map(function (e) {
                var t;
                return x(x({}, e), {}, {
                  hits: null === (t = e.hits) || void 0 === t ? void 0 : t.map(function (t) {
                    return x(x({}, t), {}, {
                      __autocomplete_indexName: e.index,
                      __autocomplete_queryID: e.queryID
                    });
                  })
                });
              });
              return {
                results: t,
                hits: t.map(function (e) {
                  return e.hits;
                }).filter(Boolean),
                facetHits: t.map(function (e) {
                  var t;
                  return null === (t = e.facetHits) || void 0 === t ? void 0 : t.map(function (e) {
                    return {
                      label: e.value,
                      count: e.count,
                      _highlightResult: {
                        label: {
                          value: e.highlighted
                        }
                      }
                    };
                  });
                }).filter(Boolean)
              };
            }(r)) : r;
          return a.every(Boolean), 'The `getItems` function from source "'.concat(t.sourceId, '" must return an array of items but returned ').concat(JSON.stringify(void 0), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"), {
            source: t,
            items: a
          };
        });
      }
      function Y(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function X(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Y(Object(n), !0).forEach(function (t) {
            Z(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Y(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function Z(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function ee(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              i = {},
              a = Object.keys(e);
            for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }
      function te(e) {
        var t = e.event,
          n = e.nextState,
          r = void 0 === n ? {} : n,
          i = e.props,
          a = e.query,
          s = e.refresh,
          o = e.store,
          c = ee(e, Vt);
        $t && i.environment.clearTimeout($t);
        var u = c.setCollections,
          l = c.setIsOpen,
          f = c.setQuery,
          h = c.setActiveItemId,
          p = c.setStatus;
        if (f(a), h(i.defaultActiveItemId), !a && !1 === i.openOnFocus) {
          var m,
            g = o.getState().collections.map(function (e) {
              return X(X({}, e), {}, {
                items: []
              });
            });
          p("idle"), u(g), l(null !== (m = r.isOpen) && void 0 !== m ? m : i.shouldPanelOpen({
            state: o.getState()
          }));
          var v = y(zt(g).then(function () {
            return Promise.resolve();
          }));
          return o.pendingRequests.add(v);
        }
        p("loading"), $t = i.environment.setTimeout(function () {
          p("stalled");
        }, i.stallThreshold);
        var b = y(zt(i.getSources(X({
          query: a,
          refresh: s,
          state: o.getState()
        }, c)).then(function (e) {
          return Promise.all(e.map(function (e) {
            return Promise.resolve(e.getItems(X({
              query: a,
              refresh: s,
              state: o.getState()
            }, c))).then(function (t) {
              return K(t, e.sourceId);
            });
          })).then(J).then(function (t) {
            return G(t, e);
          }).then(function (e) {
            return function (e) {
              var t = e.collections,
                n = e.props,
                r = e.state,
                i = t.reduce(function (e, t) {
                  return q(q({}, e), {}, B({}, t.source.sourceId, q(q({}, t.source), {}, {
                    getItems: function () {
                      return d(t.items);
                    }
                  })));
                }, {});
              return d(n.reshape({
                sources: Object.values(i),
                sourcesBySourceId: i,
                state: r
              })).filter(Boolean).map(function (e) {
                return {
                  source: e,
                  items: e.getItems()
                };
              });
            }({
              collections: e,
              props: i,
              state: o.getState()
            });
          });
        }))).then(function (e) {
          var n;
          p("idle"), u(e);
          var f = i.shouldPanelOpen({
            state: o.getState()
          });
          l(null !== (n = r.isOpen) && void 0 !== n ? n : i.openOnFocus && !a && f || f);
          var h = P(o.getState());
          if (null !== o.getState().activeItemId && h) {
            var d = h.item,
              m = h.itemInputValue,
              g = h.itemUrl,
              v = h.source;
            v.onActive(X({
              event: t,
              item: d,
              itemInputValue: m,
              itemUrl: g,
              refresh: s,
              source: v,
              state: o.getState()
            }, c));
          }
        }).finally(function () {
          p("idle"), $t && i.environment.clearTimeout($t);
        });
        return o.pendingRequests.add(b);
      }
      function ne(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function re(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ne(Object(n), !0).forEach(function (t) {
            ie(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ne(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function ie(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function ae(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              i = {},
              a = Object.keys(e);
            for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }
      function se(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function oe(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? se(Object(n), !0).forEach(function (t) {
            ce(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : se(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function ce(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function ue(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              i = {},
              a = Object.keys(e);
            for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }
      function le(e) {
        var t = e.props,
          n = e.refresh,
          r = e.store,
          i = ue(e, Jt);
        return {
          getEnvironmentProps: function (e) {
            var n = e.inputElement,
              i = e.formElement,
              a = e.panelElement;
            return oe({
              onTouchStart: function (e) {
                !r.getState().isOpen && r.pendingRequests.isEmpty() || e.target === n || !1 === [i, a].some(function (t) {
                  return n = t, r = e.target, n === r || n.contains(r);
                  var n, r;
                }) && (r.dispatch("blur", null), t.debug || r.pendingRequests.cancelAll());
              },
              onTouchMove: function (e) {
                !1 !== r.getState().isOpen && n === t.environment.document.activeElement && e.target !== n && n.blur();
              }
            }, ue(e, Gt));
          },
          getRootProps: function (e) {
            return oe({
              role: "combobox",
              "aria-expanded": r.getState().isOpen,
              "aria-haspopup": "listbox",
              "aria-owns": r.getState().isOpen ? "".concat(t.id, "-list") : void 0,
              "aria-labelledby": "".concat(t.id, "-label")
            }, e);
          },
          getFormProps: function (e) {
            return e.inputElement, oe({
              action: "",
              noValidate: !0,
              role: "search",
              onSubmit: function (a) {
                var s;
                a.preventDefault(), t.onSubmit(oe({
                  event: a,
                  refresh: n,
                  state: r.getState()
                }, i)), r.dispatch("submit", null), null === (s = e.inputElement) || void 0 === s || s.blur();
              },
              onReset: function (a) {
                var s;
                a.preventDefault(), t.onReset(oe({
                  event: a,
                  refresh: n,
                  state: r.getState()
                }, i)), r.dispatch("reset", null), null === (s = e.inputElement) || void 0 === s || s.focus();
              }
            }, ue(e, Yt));
          },
          getLabelProps: function (e) {
            return oe({
              htmlFor: "".concat(t.id, "-input"),
              id: "".concat(t.id, "-label")
            }, e);
          },
          getInputProps: function (e) {
            function a(e) {
              (t.openOnFocus || Boolean(r.getState().query)) && te(oe({
                event: e,
                props: t,
                query: r.getState().completion || r.getState().query,
                refresh: n,
                store: r
              }, i)), r.dispatch("focus", null);
            }
            var s,
              o = "ontouchstart" in t.environment,
              c = e || {};
            c.inputElement;
            var u = c.maxLength,
              l = void 0 === u ? 512 : u,
              f = ue(c, Xt),
              h = P(r.getState()),
              d = function (e) {
                return Boolean(e && e.match(Ut));
              }(null === (s = t.environment.navigator) || void 0 === s ? void 0 : s.userAgent),
              p = null != h && h.itemUrl && !d ? "go" : "search";
            return oe({
              "aria-autocomplete": "both",
              "aria-activedescendant": r.getState().isOpen && null !== r.getState().activeItemId ? "".concat(t.id, "-item-").concat(r.getState().activeItemId) : void 0,
              "aria-controls": r.getState().isOpen ? "".concat(t.id, "-list") : void 0,
              "aria-labelledby": "".concat(t.id, "-label"),
              value: r.getState().completion || r.getState().query,
              id: "".concat(t.id, "-input"),
              autoComplete: "off",
              autoCorrect: "off",
              autoCapitalize: "off",
              enterKeyHint: p,
              spellCheck: "false",
              autoFocus: t.autoFocus,
              placeholder: t.placeholder,
              maxLength: l,
              type: "search",
              onChange: function (e) {
                te(oe({
                  event: e,
                  props: t,
                  query: e.currentTarget.value.slice(0, l),
                  refresh: n,
                  store: r
                }, i));
              },
              onKeyDown: function (e) {
                !function (e) {
                  var t = e.event,
                    n = e.props,
                    r = e.refresh,
                    i = e.store,
                    a = ae(e, Kt);
                  if ("ArrowUp" === t.key || "ArrowDown" === t.key) {
                    var s = function () {
                        var e = n.environment.document.getElementById("".concat(n.id, "-item-").concat(i.getState().activeItemId));
                        e && (e.scrollIntoViewIfNeeded ? e.scrollIntoViewIfNeeded(!1) : e.scrollIntoView(!1));
                      },
                      o = function () {
                        var e = P(i.getState());
                        if (null !== i.getState().activeItemId && e) {
                          var n = e.item,
                            s = e.itemInputValue,
                            o = e.itemUrl,
                            c = e.source;
                          c.onActive(re({
                            event: t,
                            item: n,
                            itemInputValue: s,
                            itemUrl: o,
                            refresh: r,
                            source: c,
                            state: i.getState()
                          }, a));
                        }
                      };
                    t.preventDefault(), !1 === i.getState().isOpen && (n.openOnFocus || Boolean(i.getState().query)) ? te(re({
                      event: t,
                      props: n,
                      query: i.getState().query,
                      refresh: r,
                      store: i
                    }, a)).then(function () {
                      i.dispatch(t.key, {
                        nextActiveItemId: n.defaultActiveItemId
                      }), o(), setTimeout(s, 0);
                    }) : (i.dispatch(t.key, {}), o(), s());
                  } else if ("Escape" === t.key) t.preventDefault(), i.dispatch(t.key, null), i.pendingRequests.cancelAll();else if ("Enter" === t.key) {
                    if (null === i.getState().activeItemId || i.getState().collections.every(function (e) {
                      return 0 === e.items.length;
                    })) return;
                    t.preventDefault();
                    var c = P(i.getState()),
                      u = c.item,
                      l = c.itemInputValue,
                      f = c.itemUrl,
                      h = c.source;
                    if (t.metaKey || t.ctrlKey) void 0 !== f && (h.onSelect(re({
                      event: t,
                      item: u,
                      itemInputValue: l,
                      itemUrl: f,
                      refresh: r,
                      source: h,
                      state: i.getState()
                    }, a)), n.navigator.navigateNewTab({
                      itemUrl: f,
                      item: u,
                      state: i.getState()
                    }));else if (t.shiftKey) void 0 !== f && (h.onSelect(re({
                      event: t,
                      item: u,
                      itemInputValue: l,
                      itemUrl: f,
                      refresh: r,
                      source: h,
                      state: i.getState()
                    }, a)), n.navigator.navigateNewWindow({
                      itemUrl: f,
                      item: u,
                      state: i.getState()
                    }));else if (t.altKey) ;else {
                      if (void 0 !== f) return h.onSelect(re({
                        event: t,
                        item: u,
                        itemInputValue: l,
                        itemUrl: f,
                        refresh: r,
                        source: h,
                        state: i.getState()
                      }, a)), void n.navigator.navigate({
                        itemUrl: f,
                        item: u,
                        state: i.getState()
                      });
                      te(re({
                        event: t,
                        nextState: {
                          isOpen: !1
                        },
                        props: n,
                        query: l,
                        refresh: r,
                        store: i
                      }, a)).then(function () {
                        h.onSelect(re({
                          event: t,
                          item: u,
                          itemInputValue: l,
                          itemUrl: f,
                          refresh: r,
                          source: h,
                          state: i.getState()
                        }, a));
                      });
                    }
                  }
                }(oe({
                  event: e,
                  props: t,
                  refresh: n,
                  store: r
                }, i));
              },
              onFocus: a,
              onBlur: function () {
                o || (r.dispatch("blur", null), t.debug || r.pendingRequests.cancelAll());
              },
              onClick: function (n) {
                e.inputElement !== t.environment.document.activeElement || r.getState().isOpen || a(n);
              }
            }, f);
          },
          getPanelProps: function (e) {
            return oe({
              onMouseDown: function (e) {
                e.preventDefault();
              },
              onMouseLeave: function () {
                r.dispatch("mouseleave", null);
              }
            }, e);
          },
          getListProps: function (e) {
            return oe({
              role: "listbox",
              "aria-labelledby": "".concat(t.id, "-label"),
              id: "".concat(t.id, "-list")
            }, e);
          },
          getItemProps: function (e) {
            var a = e.item,
              s = e.source,
              o = ue(e, Zt);
            return oe({
              id: "".concat(t.id, "-item-").concat(a.__autocomplete_id),
              role: "option",
              "aria-selected": r.getState().activeItemId === a.__autocomplete_id,
              onMouseMove: function (e) {
                if (a.__autocomplete_id !== r.getState().activeItemId) {
                  r.dispatch("mousemove", a.__autocomplete_id);
                  var t = P(r.getState());
                  if (null !== r.getState().activeItemId && t) {
                    var s = t.item,
                      o = t.itemInputValue,
                      c = t.itemUrl,
                      u = t.source;
                    u.onActive(oe({
                      event: e,
                      item: s,
                      itemInputValue: o,
                      itemUrl: c,
                      refresh: n,
                      source: u,
                      state: r.getState()
                    }, i));
                  }
                }
              },
              onMouseDown: function (e) {
                e.preventDefault();
              },
              onClick: function (e) {
                var o = s.getItemInputValue({
                    item: a,
                    state: r.getState()
                  }),
                  c = s.getItemUrl({
                    item: a,
                    state: r.getState()
                  });
                (c ? Promise.resolve() : te(oe({
                  event: e,
                  nextState: {
                    isOpen: !1
                  },
                  props: t,
                  query: o,
                  refresh: n,
                  store: r
                }, i))).then(function () {
                  s.onSelect(oe({
                    event: e,
                    item: a,
                    itemInputValue: o,
                    itemUrl: c,
                    refresh: n,
                    source: s,
                    state: r.getState()
                  }, i));
                });
              }
            }, o);
          }
        };
      }
      function fe(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function he(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? fe(Object(n), !0).forEach(function (t) {
            de(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fe(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function de(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function pe(e) {
        var t,
          n,
          r,
          i,
          a = e.plugins,
          s = e.options,
          o = null === (t = ((null === (n = s.__autocomplete_metadata) || void 0 === n ? void 0 : n.userAgents) || [])[0]) || void 0 === t ? void 0 : t.segment,
          c = o ? de({}, o, Object.keys((null === (r = s.__autocomplete_metadata) || void 0 === r ? void 0 : r.options) || {})) : {};
        return {
          plugins: a.map(function (e) {
            return {
              name: e.name,
              options: Object.keys(e.__autocomplete_pluginOptions || [])
            };
          }),
          options: he({
            "autocomplete-core": Object.keys(s)
          }, c),
          ua: Qt.concat((null === (i = s.__autocomplete_metadata) || void 0 === i ? void 0 : i.userAgents) || [])
        };
      }
      function me(e) {
        var t,
          n = e.state;
        return !1 === n.isOpen || null === n.activeItemId ? null : (null === (t = P(n)) || void 0 === t ? void 0 : t.itemInputValue) || null;
      }
      function ge(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function ve(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ge(Object(n), !0).forEach(function (t) {
            ye(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ge(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function ye(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function be(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Re(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? be(Object(n), !0).forEach(function (t) {
            Se(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : be(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function Se(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function _e(e) {
        function t() {
          return te(Re({
            event: new Event("input"),
            nextState: {
              isOpen: i.getState().isOpen
            },
            props: r,
            query: i.getState().query,
            refresh: t,
            store: i
          }, a));
        }
        var n = [],
          r = function (e, t) {
            var n,
              r = "undefined" != typeof window ? window : {},
              i = e.plugins || [];
            return L(L({
              debug: !1,
              openOnFocus: !1,
              placeholder: "",
              autoFocus: !1,
              defaultActiveItemId: null,
              stallThreshold: 300,
              environment: r,
              shouldPanelOpen: function (e) {
                return g(e.state) > 0;
              },
              reshape: function (e) {
                return e.sources;
              }
            }, e), {}, {
              id: null !== (n = e.id) && void 0 !== n ? n : p(),
              plugins: i,
              initialState: L({
                activeItemId: null,
                query: "",
                completion: null,
                collections: [],
                isOpen: !1,
                status: "idle",
                context: {}
              }, e.initialState),
              onStateChange: function (t) {
                var n;
                null === (n = e.onStateChange) || void 0 === n || n.call(e, t), i.forEach(function (e) {
                  var n;
                  return null === (n = e.onStateChange) || void 0 === n ? void 0 : n.call(e, t);
                });
              },
              onSubmit: function (t) {
                var n;
                null === (n = e.onSubmit) || void 0 === n || n.call(e, t), i.forEach(function (e) {
                  var n;
                  return null === (n = e.onSubmit) || void 0 === n ? void 0 : n.call(e, t);
                });
              },
              onReset: function (t) {
                var n;
                null === (n = e.onReset) || void 0 === n || n.call(e, t), i.forEach(function (e) {
                  var n;
                  return null === (n = e.onReset) || void 0 === n ? void 0 : n.call(e, t);
                });
              },
              getSources: function (n) {
                return Promise.all([].concat(k(i.map(function (e) {
                  return e.getSources;
                })), [e.getSources]).filter(Boolean).map(function (e) {
                  return w(e, n);
                })).then(function (e) {
                  return d(e);
                }).then(function (e) {
                  return e.map(function (e) {
                    return L(L({}, e), {}, {
                      onSelect: function (n) {
                        e.onSelect(n), t.forEach(function (e) {
                          var t;
                          return null === (t = e.onSelect) || void 0 === t ? void 0 : t.call(e, n);
                        });
                      },
                      onActive: function (n) {
                        e.onActive(n), t.forEach(function (e) {
                          var t;
                          return null === (t = e.onActive) || void 0 === t ? void 0 : t.call(e, n);
                        });
                      }
                    });
                  });
                });
              },
              navigator: L({
                navigate: function (e) {
                  var t = e.itemUrl;
                  r.location.assign(t);
                },
                navigateNewTab: function (e) {
                  var t = e.itemUrl,
                    n = r.open(t, "_blank", "noopener");
                  null == n || n.focus();
                },
                navigateNewWindow: function (e) {
                  var t = e.itemUrl;
                  r.open(t, "_blank", "noopener");
                }
              }, e.navigator)
            });
          }(e, n),
          i = N(en, r, function (e) {
            var n = e.prevState,
              i = e.state;
            r.onStateChange(Re({
              prevState: n,
              state: i,
              refresh: t
            }, a));
          }),
          a = function (e) {
            var t = e.store;
            return {
              setActiveItemId: function (e) {
                t.dispatch("setActiveItemId", e);
              },
              setQuery: function (e) {
                t.dispatch("setQuery", e);
              },
              setCollections: function (e) {
                var n = 0,
                  r = e.map(function (e) {
                    return C(C({}, e), {}, {
                      items: d(e.items).map(function (e) {
                        return C(C({}, e), {}, {
                          __autocomplete_id: n++
                        });
                      })
                    });
                  });
                t.dispatch("setCollections", r);
              },
              setIsOpen: function (e) {
                t.dispatch("setIsOpen", e);
              },
              setStatus: function (e) {
                t.dispatch("setStatus", e);
              },
              setContext: function (e) {
                t.dispatch("setContext", e);
              }
            };
          }({
            store: i
          }),
          s = le(Re({
            props: r,
            refresh: t,
            store: i
          }, a));
        return r.plugins.forEach(function (e) {
          var r;
          return null === (r = e.subscribe) || void 0 === r ? void 0 : r.call(e, Re(Re({}, a), {}, {
            refresh: t,
            onSelect: function (e) {
              n.push({
                onSelect: e
              });
            },
            onActive: function (e) {
              n.push({
                onActive: e
              });
            }
          }));
        }), function (e) {
          var t,
            n = e.metadata,
            r = e.environment;
          if (null === (t = r.navigator) || void 0 === t ? void 0 : t.userAgent.includes("Algolia Crawler")) {
            var i = r.document.createElement("meta"),
              a = r.document.querySelector("head");
            i.name = "algolia:metadata", setTimeout(function () {
              i.content = JSON.stringify(n), a.appendChild(i);
            }, 0);
          }
        }({
          metadata: pe({
            plugins: r.plugins,
            options: e
          }),
          environment: r.environment
        }), Re(Re({
          refresh: t
        }, s), a);
      }
      function we(e) {
        var t = nn.get(this);
        return t || (t = new Map(), nn.set(this, t)), (t = tn(this, t.get(e) || (t.set(e, t = function (e) {
          for (var t, n, r = 1, i = "", a = "", s = [0], o = function (e) {
              1 === r && (e || (i = i.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? s.push(0, e, i) : 3 === r && (e || i) ? (s.push(3, e, i), r = 2) : 2 === r && "..." === i && e ? s.push(4, e, 0) : 2 === r && i && !e ? s.push(5, 0, !0, i) : r >= 5 && ((i || !e && 5 === r) && (s.push(r, 0, i, n), r = 6), e && (s.push(r, e, 0, n), r = 6)), i = "";
            }, c = 0; c < e.length; c++) {
            c && (1 === r && o(), o(c));
            for (var u = 0; u < e[c].length; u++) t = e[c][u], 1 === r ? "<" === t ? (o(), s = [s], r = 3) : i += t : 4 === r ? "--" === i && ">" === t ? (r = 1, i = "") : i = t + i[0] : a ? t === a ? a = "" : i += t : '"' === t || "'" === t ? a = t : ">" === t ? (o(), r = 1) : r && ("=" === t ? (r = 5, n = i, i = "") : "/" === t && (r < 5 || ">" === e[c][u + 1]) ? (o(), 3 === r && (s = s[0]), r = s, (s = s[0]).push(2, 0, r), r = 0) : " " === t || "\t" === t || "\n" === t || "\r" === t ? (o(), r = 2) : i += t), 3 === r && "!--" === i && (r = 4, s = s[0]);
          }
          return o(), s;
        }(e)), t), arguments, [])).length > 1 ? t : t[0];
      }
      function Pe(e, t) {
        if ("string" == typeof t) {
          var n = e.document.querySelector(t);
          return "The element ".concat(JSON.stringify(t), " is not in the document."), n;
        }
        return t;
      }
      function Oe() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return t.reduce(function (e, t) {
          return Object.keys(t).forEach(function (n) {
            var r = e[n],
              i = t[n];
            r !== i && (e[n] = [r, i].filter(Boolean).join(" "));
          }), e;
        }, {});
      }
      function xe() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return t.reduce(function (e, t) {
          return Object.keys(t).forEach(function (n) {
            var r = e[n],
              i = t[n];
            Array.isArray(r) && Array.isArray(i) ? e[n] = r.concat.apply(r, c(i)) : an(r) && an(i) ? e[n] = xe(r, i) : e[n] = i;
          }), e;
        }, {});
      }
      function je(e, t) {
        return Object.entries(e).reduce(function (e, r) {
          var a = o(r, 2),
            s = a[0],
            c = a[1];
          return t({
            key: s,
            value: c
          }) ? n(n({}, e), {}, i({}, s, c)) : e;
        }, {});
      }
      function Ie(e, t, n) {
        e[t] = null === n ? "" : "number" != typeof n ? n : n + "px";
      }
      function Fe(e) {
        this._listeners[e.type](e);
      }
      function Ne(e, t, n) {
        var r,
          i,
          a = e[t];
        if ("style" === t) {
          if ("string" == typeof n) e.style = n;else if (null === n) e.style = "";else for (t in n) a && n[t] === a[t] || Ie(e.style, t, n[t]);
        } else "o" === t[0] && "n" === t[1] ? (r = t !== (t = t.replace(/Capture$/, "")), ((i = t.toLowerCase()) in e || sn.includes(i)) && (t = i), t = t.slice(2), e._listeners || (e._listeners = {}), e._listeners[t] = n, n ? a || e.addEventListener(t, Fe, r) : e.removeEventListener(t, Fe, r)) : "list" !== t && "tagName" !== t && "form" !== t && "type" !== t && "size" !== t && "download" !== t && "href" !== t && t in e ? e[t] = null == n ? "" : n : "function" != typeof n && "dangerouslySetInnerHTML" !== t && (null == n || !1 === n && !/^ar/.test(t) ? e.removeAttribute(t) : e.setAttribute(t, n));
      }
      function Ee(e) {
        return "onChange" === e ? "onInput" : e;
      }
      function Ce(e, t) {
        for (var n in t) Ne(e, Ee(n), t[n]);
      }
      function Te(e, t) {
        for (var n in t) "o" === n[0] && "n" === n[1] || Ne(e, Ee(n), t[n]);
      }
      function ke(e) {
        return function (t, n) {
          var r = n.children,
            i = void 0 === r ? [] : r,
            a = s(n, on),
            o = e.document.createElement(t);
          return Ce(o, a), o.append.apply(o, c(i)), o;
        };
      }
      function Ae(e) {
        var t = e.autocomplete,
          r = e.autocompleteScopeApi,
          i = e.classNames,
          a = e.environment,
          o = e.isDetached,
          c = e.placeholder,
          u = void 0 === c ? "Search" : c,
          l = e.propGetters,
          f = e.setIsModalOpen,
          h = e.state,
          d = e.translations,
          p = ke(a),
          m = l.getRootProps(n({
            state: h,
            props: t.getRootProps({})
          }, r)),
          g = p("div", n({
            class: i.root
          }, m)),
          v = p("div", {
            class: i.detachedContainer,
            onMouseDown: function (e) {
              e.stopPropagation();
            }
          }),
          y = p("div", {
            class: i.detachedOverlay,
            children: [v],
            onMouseDown: function () {
              f(!1), t.setIsOpen(!1);
            }
          }),
          b = l.getLabelProps(n({
            state: h,
            props: t.getLabelProps({})
          }, r)),
          R = p("button", {
            class: i.submitButton,
            type: "submit",
            title: d.submitButtonTitle,
            children: [ln({
              environment: a
            })]
          }),
          S = p("label", n({
            class: i.label,
            children: [R]
          }, b)),
          _ = p("button", {
            class: i.clearButton,
            type: "reset",
            title: d.clearButtonTitle,
            children: [rn({
              environment: a
            })]
          }),
          w = p("div", {
            class: i.loadingIndicator,
            children: [un({
              environment: a
            })]
          }),
          P = function (e) {
            var t = e.autocompleteScopeApi,
              r = e.environment;
            e.classNames;
            var i = e.getInputProps,
              a = e.getInputPropsCore,
              o = e.onDetachedEscape,
              c = e.state,
              u = s(e, cn),
              l = ke(r)("input", u),
              f = i(n({
                state: c,
                props: a({
                  inputElement: l
                }),
                inputElement: l
              }, t));
            return Ce(l, n(n({}, f), {}, {
              onKeyDown: function (e) {
                return o && "Escape" === e.key ? (e.preventDefault(), void o()) : void f.onKeyDown(e);
              }
            })), l;
          }({
            class: i.input,
            environment: a,
            state: h,
            getInputProps: l.getInputProps,
            getInputPropsCore: t.getInputProps,
            autocompleteScopeApi: r,
            onDetachedEscape: o ? function () {
              t.setIsOpen(!1), f(!1);
            } : void 0
          }),
          O = p("div", {
            class: i.inputWrapperPrefix,
            children: [S, w]
          }),
          x = p("div", {
            class: i.inputWrapperSuffix,
            children: [_]
          }),
          j = p("div", {
            class: i.inputWrapper,
            children: [P]
          }),
          I = l.getFormProps(n({
            state: h,
            props: t.getFormProps({
              inputElement: P
            })
          }, r)),
          F = p("form", n({
            class: i.form,
            children: [O, j, x]
          }, I)),
          N = l.getPanelProps(n({
            state: h,
            props: t.getPanelProps({})
          }, r)),
          E = p("div", n({
            class: i.panel
          }, N));
        if (o) {
          var C = p("div", {
              class: i.detachedSearchButtonIcon,
              children: [ln({
                environment: a
              })]
            }),
            T = p("div", {
              class: i.detachedSearchButtonPlaceholder,
              textContent: u
            }),
            k = p("button", {
              type: "button",
              class: i.detachedSearchButton,
              onClick: function () {
                f(!0);
              },
              children: [C, T]
            }),
            A = p("button", {
              type: "button",
              class: i.detachedCancelButton,
              textContent: d.detachedCancelButtonText,
              onTouchStart: function (e) {
                e.stopPropagation();
              },
              onClick: function () {
                t.setIsOpen(!1), f(!1);
              }
            }),
            D = p("div", {
              class: i.detachedFormContainer,
              children: [F, A]
            });
          v.appendChild(D), g.appendChild(k);
        } else g.appendChild(F);
        return {
          detachedContainer: v,
          detachedOverlay: y,
          inputWrapper: j,
          input: P,
          root: g,
          form: F,
          label: S,
          submitButton: R,
          clearButton: _,
          loadingIndicator: w,
          panel: E
        };
      }
      function De(e, t) {
        for (var n in t) e[n] = t[n];
        return e;
      }
      function Le(e) {
        var t = e.parentNode;
        t && t.removeChild(e);
      }
      function Me(e, t, n) {
        var r,
          i,
          a,
          s = {};
        for (a in t) "key" == a ? r = t[a] : "ref" == a ? i = t[a] : s[a] = t[a];
        if (arguments.length > 2 && (s.children = arguments.length > 3 ? kt.call(arguments, 2) : n), "function" == typeof e && null != e.defaultProps) for (a in e.defaultProps) void 0 === s[a] && (s[a] = e.defaultProps[a]);
        return He(e, s, r, i, null);
      }
      function He(e, t, n, r, i) {
        var a = {
          type: e,
          props: t,
          key: n,
          ref: r,
          __k: null,
          __: null,
          __b: 0,
          __e: null,
          __d: void 0,
          __c: null,
          __h: null,
          constructor: void 0,
          __v: null == i ? ++Dt : i
        };
        return null == i && null != At.vnode && At.vnode(a), a;
      }
      function qe(e) {
        return e.children;
      }
      function Be(e, t) {
        this.props = e, this.context = t;
      }
      function We(e, t) {
        if (null == t) return e.__ ? We(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var n; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
        return "function" == typeof e.type ? We(e) : null;
      }
      function Qe(e) {
        var t, n;
        if (null != (e = e.__) && null != e.__c) {
          for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) {
            e.__e = e.__c.base = n.__e;
            break;
          }
          return Qe(e);
        }
      }
      function Ue(e) {
        (!e.__d && (e.__d = !0) && Lt.push(e) && !Ve.__r++ || Ht !== At.debounceRendering) && ((Ht = At.debounceRendering) || Mt)(Ve);
      }
      function Ve() {
        for (var e; Ve.__r = Lt.length;) e = Lt.sort(function (e, t) {
          return e.__v.__b - t.__v.__b;
        }), Lt = [], e.some(function (e) {
          var t, n, r, i, a, s;
          e.__d && (a = (i = (t = e).__v).__e, (s = t.__P) && (n = [], (r = De({}, i)).__v = i.__v + 1, Ze(s, i, r, t.__n, void 0 !== s.ownerSVGElement, null != i.__h ? [a] : null, n, null == a ? We(i) : a, i.__h), et(n, i), i.__e != a && Qe(i)));
        });
      }
      function $e(e, t, n, r, i, a, s, o, c, u) {
        var l,
          f,
          h,
          d,
          p,
          m,
          g,
          v = r && r.__k || hn,
          y = v.length;
        for (n.__k = [], l = 0; l < t.length; l++) if (null != (d = n.__k[l] = null == (d = t[l]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? He(null, d, null, null, d) : Array.isArray(d) ? He(qe, {
          children: d
        }, null, null, null) : d.__b > 0 ? He(d.type, d.props, d.key, null, d.__v) : d)) {
          if (d.__ = n, d.__b = n.__b + 1, null === (h = v[l]) || h && d.key == h.key && d.type === h.type) v[l] = void 0;else for (f = 0; f < y; f++) {
            if ((h = v[f]) && d.key == h.key && d.type === h.type) {
              v[f] = void 0;
              break;
            }
            h = null;
          }
          Ze(e, d, h = h || fn, i, a, s, o, c, u), p = d.__e, (f = d.ref) && h.ref != f && (g || (g = []), h.ref && g.push(h.ref, null, d), g.push(f, d.__c || p, d)), null != p ? (null == m && (m = p), "function" == typeof d.type && d.__k === h.__k ? d.__d = c = ze(d, c, e) : c = Ke(e, d, h, v, p, c), "function" == typeof n.type && (n.__d = c)) : c && h.__e == c && c.parentNode != e && (c = We(h));
        }
        for (n.__e = m, l = y; l--;) null != v[l] && ("function" == typeof n.type && null != v[l].__e && v[l].__e == n.__d && (n.__d = We(r, l + 1)), rt(v[l], v[l]));
        if (g) for (l = 0; l < g.length; l++) nt(g[l], g[++l], g[++l]);
      }
      function ze(e, t, n) {
        for (var r, i = e.__k, a = 0; i && a < i.length; a++) (r = i[a]) && (r.__ = e, t = "function" == typeof r.type ? ze(r, t, n) : Ke(n, r, r, i, r.__e, t));
        return t;
      }
      function Ke(e, t, n, r, i, a) {
        var s, o, c;
        if (void 0 !== t.__d) s = t.__d, t.__d = void 0;else if (null == n || i != a || null == i.parentNode) e: if (null == a || a.parentNode !== e) e.appendChild(i), s = null;else {
          for (o = a, c = 0; (o = o.nextSibling) && c < r.length; c += 2) if (o == i) break e;
          e.insertBefore(i, a), s = a;
        }
        return void 0 !== s ? s : i.nextSibling;
      }
      function Je(e, t, n) {
        "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || dn.test(t) ? n : n + "px";
      }
      function Ge(e, t, n, r, i) {
        var a;
        e: if ("style" === t) {
          if ("string" == typeof n) e.style.cssText = n;else {
            if ("string" == typeof r && (e.style.cssText = r = ""), r) for (t in r) n && t in n || Je(e.style, t, "");
            if (n) for (t in n) r && n[t] === r[t] || Je(e.style, t, n[t]);
          }
        } else if ("o" === t[0] && "n" === t[1]) a = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + a] = n, n ? r || e.addEventListener(t, a ? Xe : Ye, a) : e.removeEventListener(t, a ? Xe : Ye, a);else if ("dangerouslySetInnerHTML" !== t) {
          if (i) t = t.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");else if ("href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e) try {
            e[t] = null == n ? "" : n;
            break e;
          } catch (e) {}
          "function" == typeof n || (null != n && (!1 !== n || "a" === t[0] && "r" === t[1]) ? e.setAttribute(t, n) : e.removeAttribute(t));
        }
      }
      function Ye(e) {
        this.l[e.type + !1](At.event ? At.event(e) : e);
      }
      function Xe(e) {
        this.l[e.type + !0](At.event ? At.event(e) : e);
      }
      function Ze(e, t, n, r, i, a, s, o, c) {
        var u,
          l,
          f,
          h,
          d,
          p,
          m,
          g,
          v,
          y,
          b,
          R = t.type;
        if (void 0 !== t.constructor) return null;
        null != n.__h && (c = n.__h, o = t.__e = n.__e, t.__h = null, a = [o]), (u = At.__b) && u(t);
        try {
          e: if ("function" == typeof R) {
            if (g = t.props, v = (u = R.contextType) && r[u.__c], y = u ? v ? v.props.value : u.__ : r, n.__c ? m = (l = t.__c = n.__c).__ = l.__E : ("prototype" in R && R.prototype.render ? t.__c = l = new R(g, y) : (t.__c = l = new Be(g, y), l.constructor = R, l.render = it), v && v.sub(l), l.props = g, l.state || (l.state = {}), l.context = y, l.__n = r, f = l.__d = !0, l.__h = []), null == l.__s && (l.__s = l.state), null != R.getDerivedStateFromProps && (l.__s == l.state && (l.__s = De({}, l.__s)), De(l.__s, R.getDerivedStateFromProps(g, l.__s))), h = l.props, d = l.state, f) null == R.getDerivedStateFromProps && null != l.componentWillMount && l.componentWillMount(), null != l.componentDidMount && l.__h.push(l.componentDidMount);else {
              if (null == R.getDerivedStateFromProps && g !== h && null != l.componentWillReceiveProps && l.componentWillReceiveProps(g, y), !l.__e && null != l.shouldComponentUpdate && !1 === l.shouldComponentUpdate(g, l.__s, y) || t.__v === n.__v) {
                l.props = g, l.state = l.__s, t.__v !== n.__v && (l.__d = !1), l.__v = t, t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function (e) {
                  e && (e.__ = t);
                }), l.__h.length && s.push(l);
                break e;
              }
              null != l.componentWillUpdate && l.componentWillUpdate(g, l.__s, y), null != l.componentDidUpdate && l.__h.push(function () {
                l.componentDidUpdate(h, d, p);
              });
            }
            l.context = y, l.props = g, l.state = l.__s, (u = At.__r) && u(t), l.__d = !1, l.__v = t, l.__P = e, u = l.render(l.props, l.state, l.context), l.state = l.__s, null != l.getChildContext && (r = De(De({}, r), l.getChildContext())), f || null == l.getSnapshotBeforeUpdate || (p = l.getSnapshotBeforeUpdate(h, d)), b = null != u && u.type === qe && null == u.key ? u.props.children : u, $e(e, Array.isArray(b) ? b : [b], t, n, r, i, a, s, o, c), l.base = t.__e, t.__h = null, l.__h.length && s.push(l), m && (l.__E = l.__ = null), l.__e = !1;
          } else null == a && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = tt(n.__e, t, n, r, i, a, s, c);
          (u = At.diffed) && u(t);
        } catch (e) {
          t.__v = null, (c || null != a) && (t.__e = o, t.__h = !!c, a[a.indexOf(o)] = null), At.__e(e, t, n);
        }
      }
      function et(e, t) {
        At.__c && At.__c(t, e), e.some(function (t) {
          try {
            e = t.__h, t.__h = [], e.some(function (e) {
              e.call(t);
            });
          } catch (e) {
            At.__e(e, t.__v);
          }
        });
      }
      function tt(e, t, n, r, i, a, s, o) {
        var c,
          u,
          l,
          f = n.props,
          h = t.props,
          d = t.type,
          p = 0;
        if ("svg" === d && (i = !0), null != a) for (; p < a.length; p++) if ((c = a[p]) && "setAttribute" in c == !!d && (d ? c.localName === d : 3 === c.nodeType)) {
          e = c, a[p] = null;
          break;
        }
        if (null == e) {
          if (null === d) return document.createTextNode(h);
          e = i ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, h.is && h), a = null, o = !1;
        }
        if (null === d) f === h || o && e.data === h || (e.data = h);else {
          if (a = a && kt.call(e.childNodes), u = (f = n.props || fn).dangerouslySetInnerHTML, l = h.dangerouslySetInnerHTML, !o) {
            if (null != a) for (f = {}, p = 0; p < e.attributes.length; p++) f[e.attributes[p].name] = e.attributes[p].value;
            (l || u) && (l && (u && l.__html == u.__html || l.__html === e.innerHTML) || (e.innerHTML = l && l.__html || ""));
          }
          if (function (e, t, n, r, i) {
            var a;
            for (a in n) "children" === a || "key" === a || a in t || Ge(e, a, null, n[a], r);
            for (a in t) i && "function" != typeof t[a] || "children" === a || "key" === a || "value" === a || "checked" === a || n[a] === t[a] || Ge(e, a, t[a], n[a], r);
          }(e, h, f, i, o), l) t.__k = [];else if (p = t.props.children, $e(e, Array.isArray(p) ? p : [p], t, n, r, i && "foreignObject" !== d, a, s, a ? a[0] : n.__k && We(n, 0), o), null != a) for (p = a.length; p--;) null != a[p] && Le(a[p]);
          o || ("value" in h && void 0 !== (p = h.value) && (p !== f.value || p !== e.value || "progress" === d && !p) && Ge(e, "value", p, f.value, !1), "checked" in h && void 0 !== (p = h.checked) && p !== e.checked && Ge(e, "checked", p, f.checked, !1));
        }
        return e;
      }
      function nt(e, t, n) {
        try {
          "function" == typeof e ? e(t) : e.current = t;
        } catch (e) {
          At.__e(e, n);
        }
      }
      function rt(e, t, n) {
        var r, i;
        if (At.unmount && At.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || nt(r, null, t)), null != (r = e.__c)) {
          if (r.componentWillUnmount) try {
            r.componentWillUnmount();
          } catch (e) {
            At.__e(e, t);
          }
          r.base = r.__P = null;
        }
        if (r = e.__k) for (i = 0; i < r.length; i++) r[i] && rt(r[i], t, "function" != typeof e.type);
        n || null == e.__e || Le(e.__e), e.__e = e.__d = void 0;
      }
      function it(e, t, n) {
        return this.constructor(e, n);
      }
      function at(e) {
        var t = e.highlightedValue.split(pn),
          n = t.shift(),
          r = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            return {
              get: function () {
                return e;
              },
              add: function (t) {
                var n = e[e.length - 1];
                (null == n ? void 0 : n.isHighlighted) === t.isHighlighted ? e[e.length - 1] = {
                  value: n.value + t.value,
                  isHighlighted: n.isHighlighted
                } : e.push(t);
              }
            };
          }(n ? [{
            value: n,
            isHighlighted: !1
          }] : []);
        return t.forEach(function (e) {
          var t = e.split(mn);
          r.add({
            value: t[0],
            isHighlighted: !0
          }), "" !== t[1] && r.add({
            value: t[1],
            isHighlighted: !1
          });
        }), r.get();
      }
      function st(e) {
        return function (e) {
          if (Array.isArray(e)) return ot(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return ot(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ot(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function ot(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function ct(e) {
        var t = e.hit,
          n = e.attribute,
          r = Array.isArray(n) ? n : [n],
          i = m(t, ["_highlightResult"].concat(st(r), ["value"]));
        return "string" != typeof i && (i = m(t, r) || ""), at({
          highlightedValue: i
        });
      }
      function ut(e, t) {
        var n,
          r,
          i,
          a = e[t],
          s = (null === (n = e[t + 1]) || void 0 === n ? void 0 : n.isHighlighted) || !0,
          o = (null === (r = e[t - 1]) || void 0 === r ? void 0 : r.isHighlighted) || !0;
        return vn.test((i = a.value) && bn.test(i) ? i.replace(yn, function (e) {
          return gn[e];
        }) : i) || o !== s ? a.isHighlighted : o;
      }
      function lt(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function ft(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? lt(Object(n), !0).forEach(function (t) {
            ht(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lt(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function ht(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function dt(e) {
        return e.some(function (e) {
          return e.isHighlighted;
        }) ? e.map(function (t, n) {
          return ft(ft({}, t), {}, {
            isHighlighted: !ut(e, n)
          });
        }) : e.map(function (e) {
          return ft(ft({}, e), {}, {
            isHighlighted: !1
          });
        });
      }
      function pt(e) {
        return function (e) {
          if (Array.isArray(e)) return mt(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return mt(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? mt(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function mt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function gt(e) {
        var t = e.hit,
          n = e.attribute,
          r = Array.isArray(n) ? n : [n],
          i = m(t, ["_snippetResult"].concat(pt(r), ["value"]));
        return "string" != typeof i && (i = m(t, r) || ""), at({
          highlightedValue: i
        });
      }
      function vt(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function yt(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? vt(Object(n), !0).forEach(function (t) {
            bt(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vt(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function bt(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function Rt(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function St(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Rt(Object(n), !0).forEach(function (t) {
            _t(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rt(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function _t(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function wt(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              i = {},
              a = Object.keys(e);
            for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }
      function Pt(e) {
        return function (e) {
          if (Array.isArray(e)) return Ot(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return Ot(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ot(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function Ot(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function xt(e) {
        function t(e) {
          var t = e.hit,
            i = e.attribute,
            a = e.tagName,
            s = void 0 === a ? "mark" : a;
          return n(r, {}, ct({
            hit: t,
            attribute: i
          }).map(function (e, t) {
            return e.isHighlighted ? n(s, {
              key: t
            }, e.value) : e.value;
          }));
        }
        var n = e.createElement,
          r = e.Fragment;
        return t.__autocomplete_componentName = "Highlight", t;
      }
      function jt(e) {
        function t(e) {
          var t,
            i = e.hit,
            a = e.attribute,
            s = e.tagName,
            o = void 0 === s ? "mark" : s;
          return n(r, {}, (t = {
            hit: i,
            attribute: a
          }, dt(ct(t))).map(function (e, t) {
            return e.isHighlighted ? n(o, {
              key: t
            }, e.value) : e.value;
          }));
        }
        var n = e.createElement,
          r = e.Fragment;
        return t.__autocomplete_componentName = "ReverseHighlight", t;
      }
      function It(e) {
        function t(e) {
          var t,
            i = e.hit,
            a = e.attribute,
            s = e.tagName,
            o = void 0 === s ? "mark" : s;
          return n(r, {}, (t = {
            hit: i,
            attribute: a
          }, dt(gt(t))).map(function (e, t) {
            return e.isHighlighted ? n(o, {
              key: t
            }, e.value) : e.value;
          }));
        }
        var n = e.createElement,
          r = e.Fragment;
        return t.__autocomplete_componentName = "ReverseSnippet", t;
      }
      function Ft(e) {
        function t(e) {
          var t = e.hit,
            i = e.attribute,
            a = e.tagName,
            s = void 0 === a ? "mark" : a;
          return n(r, {}, gt({
            hit: t,
            attribute: i
          }).map(function (e, t) {
            return e.isHighlighted ? n(s, {
              key: t
            }, e.value) : e.value;
          }));
        }
        var n = e.createElement,
          r = e.Fragment;
        return t.__autocomplete_componentName = "Snippet", t;
      }
      function Nt(e) {
        var t = e.panelPlacement,
          n = e.container,
          r = e.form,
          i = e.environment,
          a = n.getBoundingClientRect(),
          s = (i.pageYOffset || i.document.documentElement.scrollTop || i.document.body.scrollTop || 0) + a.top + a.height;
        switch (t) {
          case "start":
            return {
              top: s,
              left: a.left
            };
          case "end":
            return {
              top: s,
              right: i.document.documentElement.clientWidth - (a.left + a.width)
            };
          case "full-width":
            return {
              top: s,
              left: 0,
              right: 0,
              width: "unset",
              maxWidth: "unset"
            };
          case "input-wrapper-width":
            var o = r.getBoundingClientRect();
            return {
              top: s,
              left: o.left,
              right: i.document.documentElement.clientWidth - (o.left + o.width),
              width: "unset",
              maxWidth: "unset"
            };
          default:
            throw new Error("[Autocomplete] The `panelPlacement` value ".concat(JSON.stringify(t), " is not valid."));
        }
      }
      var Et,
        Ct,
        Tt,
        kt,
        At,
        Dt,
        Lt,
        Mt,
        Ht,
        qt = 0,
        Bt = function () {},
        Wt = "1.6.3",
        Qt = [{
          segment: "autocomplete-core",
          version: Wt
        }],
        Ut = /((gt|sm)-|galaxy nexus)|samsung[- ]/i,
        Vt = ["event", "nextState", "props", "query", "refresh", "store"],
        $t = null,
        zt = (Et = -1, Ct = -1, Tt = void 0, function (e) {
          var t = ++Et;
          return Promise.resolve(e).then(function (e) {
            return Tt && t < Ct ? Tt : (Ct = t, Tt = e, e);
          });
        }),
        Kt = ["event", "props", "refresh", "store"],
        Jt = ["props", "refresh", "store"],
        Gt = ["inputElement", "formElement", "panelElement"],
        Yt = ["inputElement"],
        Xt = ["inputElement", "maxLength"],
        Zt = ["item", "source"],
        en = function (e, t) {
          switch (t.type) {
            case "setActiveItemId":
            case "mousemove":
              return ve(ve({}, e), {}, {
                activeItemId: t.payload
              });
            case "setQuery":
              return ve(ve({}, e), {}, {
                query: t.payload,
                completion: null
              });
            case "setCollections":
              return ve(ve({}, e), {}, {
                collections: t.payload
              });
            case "setIsOpen":
              return ve(ve({}, e), {}, {
                isOpen: t.payload
              });
            case "setStatus":
              return ve(ve({}, e), {}, {
                status: t.payload
              });
            case "setContext":
              return ve(ve({}, e), {}, {
                context: ve(ve({}, e.context), t.payload)
              });
            case "ArrowDown":
              var n = ve(ve({}, e), {}, {
                activeItemId: t.payload.hasOwnProperty("nextActiveItemId") ? t.payload.nextActiveItemId : R(1, e.activeItemId, g(e), t.props.defaultActiveItemId)
              });
              return ve(ve({}, n), {}, {
                completion: me({
                  state: n
                })
              });
            case "ArrowUp":
              var r = ve(ve({}, e), {}, {
                activeItemId: R(-1, e.activeItemId, g(e), t.props.defaultActiveItemId)
              });
              return ve(ve({}, r), {}, {
                completion: me({
                  state: r
                })
              });
            case "Escape":
              return e.isOpen ? ve(ve({}, e), {}, {
                activeItemId: null,
                isOpen: !1,
                completion: null
              }) : ve(ve({}, e), {}, {
                activeItemId: null,
                query: "",
                status: "idle",
                collections: []
              });
            case "submit":
              return ve(ve({}, e), {}, {
                activeItemId: null,
                isOpen: !1,
                status: "idle"
              });
            case "reset":
              return ve(ve({}, e), {}, {
                activeItemId: !0 === t.props.openOnFocus ? t.props.defaultActiveItemId : null,
                status: "idle",
                query: ""
              });
            case "focus":
              return ve(ve({}, e), {}, {
                activeItemId: t.props.defaultActiveItemId,
                isOpen: (t.props.openOnFocus || Boolean(e.query)) && t.props.shouldPanelOpen({
                  state: e
                })
              });
            case "blur":
              return t.props.debug ? e : ve(ve({}, e), {}, {
                isOpen: !1,
                activeItemId: null
              });
            case "mouseleave":
              return ve(ve({}, e), {}, {
                activeItemId: t.props.defaultActiveItemId
              });
            default:
              return "The reducer action ".concat(JSON.stringify(t.type), " is not supported."), e;
          }
        },
        tn = function (e, t, n, r) {
          var i;
          t[0] = 0;
          for (var a = 1; a < t.length; a++) {
            var s = t[a++],
              o = t[a] ? (t[0] |= s ? 1 : 2, n[t[a++]]) : t[++a];
            3 === s ? r[0] = o : 4 === s ? r[1] = Object.assign(r[1] || {}, o) : 5 === s ? (r[1] = r[1] || {})[t[++a]] = o : 6 === s ? r[1][t[++a]] += o + "" : s ? (i = e.apply(o, tn(e, o, n, ["", null])), r.push(i), o[0] ? t[0] |= 2 : (t[a - 2] = 0, t[a] = i)) : r.push(o);
          }
          return r;
        },
        nn = new Map(),
        rn = function (e) {
          var t = e.environment,
            n = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
          n.setAttribute("class", "aa-ClearIcon"), n.setAttribute("viewBox", "0 0 24 24"), n.setAttribute("width", "18"), n.setAttribute("height", "18"), n.setAttribute("fill", "currentColor");
          var r = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
          return r.setAttribute("d", "M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"), n.appendChild(r), n;
        },
        an = function (e) {
          return e && "object" === r(e) && "[object Object]" === Object.prototype.toString.call(e);
        },
        sn = ["ontouchstart", "ontouchend", "ontouchmove", "ontouchcancel"],
        on = ["children"],
        cn = ["autocompleteScopeApi", "environment", "classNames", "getInputProps", "getInputPropsCore", "onDetachedEscape", "state"],
        un = function (e) {
          var t = e.environment.document.createElementNS("http://www.w3.org/2000/svg", "svg");
          return t.setAttribute("class", "aa-LoadingIcon"), t.setAttribute("viewBox", "0 0 100 100"), t.setAttribute("width", "20"), t.setAttribute("height", "20"), t.innerHTML = '<circle\n  cx="50"\n  cy="50"\n  fill="none"\n  r="35"\n  stroke="currentColor"\n  stroke-dasharray="164.93361431346415 56.97787143782138"\n  stroke-width="6"\n>\n  <animateTransform\n    attributeName="transform"\n    type="rotate"\n    repeatCount="indefinite"\n    dur="1s"\n    values="0 50 50;90 50 50;180 50 50;360 50 50"\n    keyTimes="0;0.40;0.65;1"\n  />\n</circle>', t;
        },
        ln = function (e) {
          var t = e.environment,
            n = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
          n.setAttribute("class", "aa-SubmitIcon"), n.setAttribute("viewBox", "0 0 24 24"), n.setAttribute("width", "20"), n.setAttribute("height", "20"), n.setAttribute("fill", "currentColor");
          var r = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
          return r.setAttribute("d", "M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"), n.appendChild(r), n;
        },
        fn = {},
        hn = [],
        dn = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
      kt = hn.slice, At = {
        __e: function (e, t) {
          for (var n, r, i; t = t.__;) if ((n = t.__c) && !n.__) try {
            if ((r = n.constructor) && null != r.getDerivedStateFromError && (n.setState(r.getDerivedStateFromError(e)), i = n.__d), null != n.componentDidCatch && (n.componentDidCatch(e), i = n.__d), i) return n.__E = n;
          } catch (t) {
            e = t;
          }
          throw e;
        }
      }, Dt = 0, Be.prototype.setState = function (e, t) {
        var n;
        n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = De({}, this.state), "function" == typeof e && (e = e(De({}, n), this.props)), e && De(n, e), null != e && this.__v && (t && this.__h.push(t), Ue(this));
      }, Be.prototype.forceUpdate = function (e) {
        this.__v && (this.__e = !0, e && this.__h.push(e), Ue(this));
      }, Be.prototype.render = qe, Lt = [], Mt = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Ve.__r = 0;
      var pn = "__aa-highlight__",
        mn = "__/aa-highlight__",
        gn = {
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        },
        vn = new RegExp(/\w/i),
        yn = /&(amp|quot|lt|gt|#39);/g,
        bn = RegExp(yn.source),
        Rn = ["params"],
        Sn = ["classNames", "container", "getEnvironmentProps", "getFormProps", "getInputProps", "getItemProps", "getLabelProps", "getListProps", "getPanelProps", "getRootProps", "panelContainer", "panelPlacement", "render", "renderNoResults", "renderer", "detachedMediaQuery", "components", "translations"],
        _n = {
          clearButton: "aa-ClearButton",
          detachedCancelButton: "aa-DetachedCancelButton",
          detachedContainer: "aa-DetachedContainer",
          detachedFormContainer: "aa-DetachedFormContainer",
          detachedOverlay: "aa-DetachedOverlay",
          detachedSearchButton: "aa-DetachedSearchButton",
          detachedSearchButtonIcon: "aa-DetachedSearchButtonIcon",
          detachedSearchButtonPlaceholder: "aa-DetachedSearchButtonPlaceholder",
          form: "aa-Form",
          input: "aa-Input",
          inputWrapper: "aa-InputWrapper",
          inputWrapperPrefix: "aa-InputWrapperPrefix",
          inputWrapperSuffix: "aa-InputWrapperSuffix",
          item: "aa-Item",
          label: "aa-Label",
          list: "aa-List",
          loadingIndicator: "aa-LoadingIndicator",
          panel: "aa-Panel",
          panelLayout: "aa-PanelLayout aa-Panel--scrollable",
          root: "aa-Autocomplete",
          source: "aa-Source",
          sourceFooter: "aa-SourceFooter",
          sourceHeader: "aa-SourceHeader",
          sourceNoResults: "aa-SourceNoResults",
          submitButton: "aa-SubmitButton"
        },
        wn = function (e, t) {
          var n = e.children;
          (0, e.render)(n, t);
        },
        Pn = {
          createElement: Me,
          Fragment: qe,
          render: function (e, t, n) {
            var r, i, a;
            At.__ && At.__(e, t), i = (r = "function" == typeof n) ? null : n && n.__k || t.__k, a = [], Ze(t, e = (!r && n || t).__k = Me(qe, null, [e]), i || fn, fn, void 0 !== t.ownerSVGElement, !r && n ? [n] : i ? null : t.firstChild ? kt.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r), et(a, e);
          }
        },
        On = [{
          segment: "autocomplete-js",
          version: Wt
        }],
        xn = ["components"],
        jn = function (e, t) {
          function n(t) {
            return e({
              searchClient: t.searchClient,
              queries: t.requests.map(function (e) {
                return e.query;
              })
            }).then(function (e) {
              return e.map(function (e, n) {
                var r = t.requests[n];
                return {
                  items: e,
                  sourceId: r.sourceId,
                  transformResponse: r.transformResponse
                };
              });
            });
          }
          return function (e) {
            return function (r) {
              return yt(yt({
                requesterId: t,
                execute: n
              }, e), r);
            };
          };
        }(function (e) {
          return function (e) {
            var t = e.searchClient,
              n = e.queries,
              r = e.userAgents,
              i = void 0 === r ? [] : r;
            return "function" == typeof t.addAlgoliaAgent && [].concat(Pt(Qt), Pt(i)).forEach(function (e) {
              var n = e.segment,
                r = e.version;
              t.addAlgoliaAgent(n, r);
            }), t.search(n.map(function (e) {
              var t = e.params;
              return St(St({}, wt(e, Rn)), {}, {
                params: St({
                  hitsPerPage: 5,
                  highlightPreTag: pn,
                  highlightPostTag: mn
                }, t)
              });
            })).then(function (e) {
              return e.results;
            });
          }(n(n({}, e), {}, {
            userAgents: On
          }));
        }, "algolia"),
        In = jn({
          transformResponse: function (e) {
            return e.hits;
          }
        });
      e.autocomplete = function (e) {
        function t() {
          Ce(E.value.panel, {
            style: O.value ? {} : Nt({
              panelPlacement: P.value.renderer.panelPlacement,
              container: E.value.root,
              form: E.value.form,
              environment: P.value.core.environment
            })
          });
        }
        function r(e) {
          j.current = e;
          var t = {
              autocomplete: x.value,
              autocompleteScopeApi: F,
              classNames: P.value.renderer.classNames,
              components: P.value.renderer.components,
              container: P.value.renderer.container,
              html: N.value,
              dom: E.value,
              panelContainer: O.value ? E.value.detachedContainer : P.value.renderer.panelContainer,
              propGetters: I,
              state: j.current,
              renderer: P.value.renderer.renderer
            },
            r = !g(e) && !S.current && P.value.renderer.renderNoResults || P.value.renderer.render;
          !function (e) {
            var t = e.autocomplete,
              r = e.autocompleteScopeApi,
              i = e.dom,
              a = e.propGetters,
              s = e.state;
            Te(i.root, a.getRootProps(n({
              state: s,
              props: t.getRootProps({})
            }, r))), Te(i.input, a.getInputProps(n({
              state: s,
              props: t.getInputProps({
                inputElement: i.input
              }),
              inputElement: i.input
            }, r))), Ce(i.label, {
              hidden: "stalled" === s.status
            }), Ce(i.loadingIndicator, {
              hidden: "stalled" !== s.status
            }), Ce(i.clearButton, {
              hidden: !s.query
            });
          }(t), function (e, t) {
            var r = t.autocomplete,
              i = t.autocompleteScopeApi,
              s = t.classNames,
              o = t.html,
              c = t.dom,
              u = t.panelContainer,
              l = t.propGetters,
              f = t.state,
              h = t.components,
              d = t.renderer;
            if (f.isOpen) {
              u.contains(c.panel) || "loading" === f.status || u.appendChild(c.panel), c.panel.classList.toggle("aa-Panel--stalled", "stalled" === f.status);
              var p = f.collections.filter(function (e) {
                  var t = e.source,
                    n = e.items;
                  return t.templates.noResults || n.length > 0;
                }).map(function (e, t) {
                  var c = e.source,
                    u = e.items;
                  return d.createElement("section", {
                    key: t,
                    className: s.source,
                    "data-autocomplete-source-id": c.sourceId
                  }, c.templates.header && d.createElement("div", {
                    className: s.sourceHeader
                  }, c.templates.header({
                    components: h,
                    createElement: d.createElement,
                    Fragment: d.Fragment,
                    items: u,
                    source: c,
                    state: f,
                    html: o
                  })), c.templates.noResults && 0 === u.length ? d.createElement("div", {
                    className: s.sourceNoResults
                  }, c.templates.noResults({
                    components: h,
                    createElement: d.createElement,
                    Fragment: d.Fragment,
                    source: c,
                    state: f,
                    html: o
                  })) : d.createElement("ul", a({
                    className: s.list
                  }, l.getListProps(n({
                    state: f,
                    props: r.getListProps({})
                  }, i))), u.map(function (e) {
                    var t = r.getItemProps({
                      item: e,
                      source: c
                    });
                    return d.createElement("li", a({
                      key: t.id,
                      className: s.item
                    }, l.getItemProps(n({
                      state: f,
                      props: t
                    }, i))), c.templates.item({
                      components: h,
                      createElement: d.createElement,
                      Fragment: d.Fragment,
                      item: e,
                      state: f,
                      html: o
                    }));
                  })), c.templates.footer && d.createElement("div", {
                    className: s.sourceFooter
                  }, c.templates.footer({
                    components: h,
                    createElement: d.createElement,
                    Fragment: d.Fragment,
                    items: u,
                    source: c,
                    state: f,
                    html: o
                  })));
                }),
                m = d.createElement(d.Fragment, null, d.createElement("div", {
                  className: s.panelLayout
                }, p), d.createElement("div", {
                  className: "aa-GradientBottom"
                })),
                g = p.reduce(function (e, t) {
                  return e[t.props["data-autocomplete-source-id"]] = t, e;
                }, {});
              e(n(n({
                children: m,
                state: f,
                sections: p,
                elements: g
              }, d), {}, {
                components: h,
                html: o
              }, i), c.panel);
            } else u.contains(c.panel) && u.removeChild(c.panel);
          }(r, t);
        }
        function o() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          m();
          var t = P.value.renderer,
            n = t.components,
            i = s(t, xn);
          _.current = xe(i, P.value.core, {
            components: je(n, function (e) {
              return !e.value.hasOwnProperty("__autocomplete_componentName");
            }),
            initialState: j.current
          }, e), R(), v(), x.value.refresh().then(function () {
            r(j.current);
          });
        }
        function c(e) {
          requestAnimationFrame(function () {
            var t = P.value.core.environment.document.body.contains(E.value.detachedOverlay);
            e !== t && (e ? (P.value.core.environment.document.body.appendChild(E.value.detachedOverlay), P.value.core.environment.document.body.classList.add("aa-Detached"), E.value.input.focus()) : (P.value.core.environment.document.body.removeChild(E.value.detachedOverlay), P.value.core.environment.document.body.classList.remove("aa-Detached"), x.value.setQuery(""), x.value.refresh()));
          });
        }
        var u,
          l = function () {
            function e(e) {
              t.push(e);
              var r = e();
              n.push(r);
            }
            var t = [],
              n = [];
            return {
              runEffect: e,
              cleanupEffects: function () {
                var e = n;
                n = [], e.forEach(function (e) {
                  e();
                });
              },
              runEffects: function () {
                var n = t;
                t = [], n.forEach(function (t) {
                  e(t);
                });
              }
            };
          }(),
          d = l.runEffect,
          m = l.cleanupEffects,
          v = l.runEffects,
          y = (u = [], {
            reactive: function (e) {
              var t = e(),
                n = {
                  _fn: e,
                  _ref: {
                    current: t
                  },
                  get value() {
                    return this._ref.current;
                  },
                  set value(e) {
                    this._ref.current = e;
                  }
                };
              return u.push(n), n;
            },
            runReactives: function () {
              u.forEach(function (e) {
                e._ref.current = e._fn();
              });
            }
          }),
          b = y.reactive,
          R = y.runReactives,
          S = f(!1),
          _ = f(e),
          w = f(void 0),
          P = b(function () {
            return function (e) {
              var t,
                r = e.classNames,
                i = e.container,
                a = e.getEnvironmentProps,
                o = e.getFormProps,
                c = e.getInputProps,
                u = e.getItemProps,
                l = e.getLabelProps,
                f = e.getListProps,
                h = e.getPanelProps,
                d = e.getRootProps,
                m = e.panelContainer,
                g = e.panelPlacement,
                v = e.render,
                y = e.renderNoResults,
                b = e.renderer,
                R = e.detachedMediaQuery,
                S = e.components,
                _ = e.translations,
                w = s(e, Sn),
                P = "undefined" != typeof window ? window : {},
                O = Pe(P, i);
              O.tagName;
              var x = n(n({}, Pn), b),
                j = {
                  Highlight: xt(x),
                  ReverseHighlight: jt(x),
                  ReverseSnippet: It(x),
                  Snippet: Ft(x)
                };
              return {
                renderer: {
                  classNames: Oe(_n, null != r ? r : {}),
                  container: O,
                  getEnvironmentProps: null != a ? a : function (e) {
                    return e.props;
                  },
                  getFormProps: null != o ? o : function (e) {
                    return e.props;
                  },
                  getInputProps: null != c ? c : function (e) {
                    return e.props;
                  },
                  getItemProps: null != u ? u : function (e) {
                    return e.props;
                  },
                  getLabelProps: null != l ? l : function (e) {
                    return e.props;
                  },
                  getListProps: null != f ? f : function (e) {
                    return e.props;
                  },
                  getPanelProps: null != h ? h : function (e) {
                    return e.props;
                  },
                  getRootProps: null != d ? d : function (e) {
                    return e.props;
                  },
                  panelContainer: m ? Pe(P, m) : P.document.body,
                  panelPlacement: null != g ? g : "input-wrapper-width",
                  render: null != v ? v : wn,
                  renderNoResults: y,
                  renderer: x,
                  detachedMediaQuery: null != R ? R : getComputedStyle(P.document.documentElement).getPropertyValue("--aa-detached-media-query"),
                  components: n(n({}, j), S),
                  translations: n(n({}, {
                    clearButtonTitle: "Clear",
                    detachedCancelButtonText: "Cancel",
                    submitButtonTitle: "Submit"
                  }), _)
                },
                core: n(n({}, w), {}, {
                  id: null !== (t = w.id) && void 0 !== t ? t : p(),
                  environment: P
                })
              };
            }(_.current);
          }),
          O = b(function () {
            return P.value.core.environment.matchMedia(P.value.renderer.detachedMediaQuery).matches;
          }),
          x = b(function () {
            return _e(n(n({}, P.value.core), {}, {
              onStateChange: function (e) {
                var t, n, r;
                S.current = e.state.collections.some(function (e) {
                  return e.source.templates.noResults;
                }), null === (t = w.current) || void 0 === t || t.call(w, e), null === (n = (r = P.value.core).onStateChange) || void 0 === n || n.call(r, e);
              },
              shouldPanelOpen: _.current.shouldPanelOpen || function (e) {
                var t = e.state;
                if (O.value) return !0;
                var n = g(t) > 0;
                if (!P.value.core.openOnFocus && !t.query) return n;
                var r = Boolean(S.current || P.value.renderer.renderNoResults);
                return !n && r || n;
              },
              __autocomplete_metadata: {
                userAgents: On,
                options: e
              }
            }));
          }),
          j = f(n({
            collections: [],
            completion: null,
            context: {},
            isOpen: !1,
            query: "",
            activeItemId: null,
            status: "idle"
          }, P.value.core.initialState)),
          I = {
            getEnvironmentProps: P.value.renderer.getEnvironmentProps,
            getFormProps: P.value.renderer.getFormProps,
            getInputProps: P.value.renderer.getInputProps,
            getItemProps: P.value.renderer.getItemProps,
            getLabelProps: P.value.renderer.getLabelProps,
            getListProps: P.value.renderer.getListProps,
            getPanelProps: P.value.renderer.getPanelProps,
            getRootProps: P.value.renderer.getRootProps
          },
          F = {
            setActiveItemId: x.value.setActiveItemId,
            setQuery: x.value.setQuery,
            setCollections: x.value.setCollections,
            setIsOpen: x.value.setIsOpen,
            setStatus: x.value.setStatus,
            setContext: x.value.setContext,
            refresh: x.value.refresh
          },
          N = b(function () {
            return we.bind(P.value.renderer.renderer.createElement);
          }),
          E = b(function () {
            return Ae({
              autocomplete: x.value,
              autocompleteScopeApi: F,
              classNames: P.value.renderer.classNames,
              environment: P.value.core.environment,
              isDetached: O.value,
              placeholder: P.value.core.placeholder,
              propGetters: I,
              setIsModalOpen: c,
              state: j.current,
              translations: P.value.renderer.translations
            });
          });
        return d(function () {
          var e = x.value.getEnvironmentProps({
            formElement: E.value.form,
            panelElement: E.value.panel,
            inputElement: E.value.input
          });
          return Ce(P.value.core.environment, e), function () {
            Ce(P.value.core.environment, Object.keys(e).reduce(function (e, t) {
              return n(n({}, e), {}, i({}, t, void 0));
            }, {}));
          };
        }), d(function () {
          var e = O.value ? P.value.core.environment.document.body : P.value.renderer.panelContainer,
            t = O.value ? E.value.detachedOverlay : E.value.panel;
          return O.value && j.current.isOpen && c(!0), r(j.current), function () {
            e.contains(t) && e.removeChild(t);
          };
        }), d(function () {
          var e = P.value.renderer.container;
          return e.appendChild(E.value.root), function () {
            e.removeChild(E.value.root);
          };
        }), d(function () {
          var e = h(function (e) {
            r(e.state);
          }, 0);
          return w.current = function (n) {
            var r = n.state,
              i = n.prevState;
            O.value && i.isOpen !== r.isOpen && c(r.isOpen), O.value || !r.isOpen || i.isOpen || t(), r.query !== i.query && P.value.core.environment.document.querySelectorAll(".aa-Panel--scrollable").forEach(function (e) {
              0 !== e.scrollTop && (e.scrollTop = 0);
            }), e({
              state: r
            });
          }, function () {
            w.current = void 0;
          };
        }), d(function () {
          var e = h(function () {
            var e = O.value;
            O.value = P.value.core.environment.matchMedia(P.value.renderer.detachedMediaQuery).matches, e !== O.value ? o({}) : requestAnimationFrame(t);
          }, 20);
          return P.value.core.environment.addEventListener("resize", e), function () {
            P.value.core.environment.removeEventListener("resize", e);
          };
        }), d(function () {
          function e(e) {
            E.value.detachedContainer.classList.toggle("aa-DetachedContainer--modal", e);
          }
          function t(t) {
            e(t.matches);
          }
          if (!O.value) return function () {};
          var n = P.value.core.environment.matchMedia(getComputedStyle(P.value.core.environment.document.documentElement).getPropertyValue("--aa-detached-modal-media-query"));
          e(n.matches);
          var r = Boolean(n.addEventListener);
          return r ? n.addEventListener("change", t) : n.addListener(t), function () {
            r ? n.removeEventListener("change", t) : n.removeListener(t);
          };
        }), d(function () {
          return requestAnimationFrame(t), function () {};
        }), n(n({}, F), {}, {
          update: o,
          destroy: function () {
            m();
          }
        });
      }, e.getAlgoliaFacets = function (e) {
        var t = jn({
            transformResponse: function (e) {
              return e.facetHits;
            }
          }),
          r = e.queries.map(function (e) {
            return n(n({}, e), {}, {
              type: "facet"
            });
          });
        return t(n(n({}, e), {}, {
          queries: r
        }));
      }, e.getAlgoliaResults = In, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    });
  }, function (e, t, n) {
    !function (e, n) {
      n(t);
    }(this, function (e) {
      "use strict";

      function t(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function n(e) {
        for (var n = 1; n < arguments.length; n++) {
          var i = null != arguments[n] ? arguments[n] : {};
          n % 2 ? t(Object(i), !0).forEach(function (t) {
            r(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function r(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function i(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function a(e, t) {
        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (!n) {
          if (Array.isArray(e) || (n = function (e, t) {
            if (e) {
              if ("string" == typeof e) return i(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? i(e, t) : void 0;
            }
          }(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var r = 0,
              a = function () {};
            return {
              s: a,
              n: function () {
                return r >= e.length ? {
                  done: !0
                } : {
                  done: !1,
                  value: e[r++]
                };
              },
              e: function (e) {
                throw e;
              },
              f: a
            };
          }
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var s,
          o = !0,
          c = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return o = e.done, e;
          },
          e: function (e) {
            c = !0, s = e;
          },
          f: function () {
            try {
              o || null == n.return || n.return();
            } finally {
              if (c) throw s;
            }
          }
        };
      }
      function s(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function o(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? s(Object(n), !0).forEach(function (t) {
            c(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function c(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function u(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function l(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? u(Object(n), !0).forEach(function (t) {
            f(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function f(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function h(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              r,
              i = {},
              a = Object.keys(e);
            for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }
      function d(e) {
        return function (e) {
          if (Array.isArray(e)) return p(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return p(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function p(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function m(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function g(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? m(Object(n), !0).forEach(function (t) {
            v(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function v(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function y(e) {
        var t = e.onTapAhead;
        return {
          item: function (e) {
            var n = e.item,
              r = e.createElement,
              i = e.components;
            return n.__autocomplete_qsCategory ? r("div", {
              className: "aa-ItemWrapper"
            }, r("div", {
              className: "aa-ItemContent aa-ItemContent--indented"
            }, r("div", {
              className: "aa-ItemContentSubtitle aa-ItemContentSubtitle--standalone"
            }, r("span", {
              className: "aa-ItemContentSubtitleIcon"
            }), r("span", null, "in", " ", r("span", {
              className: "aa-ItemContentSubtitleCategory"
            }, n.__autocomplete_qsCategory))))) : r("div", {
              className: "aa-ItemWrapper"
            }, r("div", {
              className: "aa-ItemContent"
            }, r("div", {
              className: "aa-ItemIcon aa-ItemIcon--noBorder"
            }, r("svg", {
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, r("path", {
              d: "M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"
            }))), r("div", {
              className: "aa-ItemContentBody"
            }, r("div", {
              className: "aa-ItemContentTitle"
            }, r(i.ReverseHighlight, {
              hit: n,
              attribute: "query"
            })))), r("div", {
              className: "aa-ItemActions"
            }, r("button", {
              className: "aa-ItemActionButton",
              title: 'Fill query with "'.concat(n.query, '"'),
              onClick: function (e) {
                e.preventDefault(), e.stopPropagation(), t(n);
              }
            }, r("svg", {
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, r("path", {
              d: "M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z"
            })))));
          }
        };
      }
      var b = "1.7.1",
        R = [{
          segment: "autocomplete-core",
          version: b
        }],
        S = ["params"],
        _ = [{
          segment: "autocomplete-js",
          version: b
        }],
        w = function (e, t) {
          function n(t) {
            return e({
              searchClient: t.searchClient,
              queries: t.requests.map(function (e) {
                return e.query;
              })
            }).then(function (e) {
              return e.map(function (e, n) {
                var r = t.requests[n];
                return {
                  items: e,
                  sourceId: r.sourceId,
                  transformResponse: r.transformResponse
                };
              });
            });
          }
          return function (e) {
            return function (r) {
              return o(o({
                requesterId: t,
                execute: n
              }, e), r);
            };
          };
        }(function (e) {
          return function (e) {
            var t = e.searchClient,
              n = e.queries,
              r = e.userAgents,
              i = void 0 === r ? [] : r;
            return "function" == typeof t.addAlgoliaAgent && [].concat(d(R), d(i)).forEach(function (e) {
              var n = e.segment,
                r = e.version;
              t.addAlgoliaAgent(n, r);
            }), t.search(n.map(function (e) {
              var t = e.params;
              return l(l({}, h(e, S)), {}, {
                params: l({
                  hitsPerPage: 5,
                  highlightPreTag: "__aa-highlight__",
                  highlightPostTag: "__/aa-highlight__"
                }, t)
              });
            })).then(function (e) {
              return e.results;
            });
          }(g(g({}, e), {}, {
            userAgents: _
          }));
        }, "algolia"),
        P = w({
          transformResponse: function (e) {
            return e.hits;
          }
        });
      e.createQuerySuggestionsPlugin = function (e) {
        var t = function (e) {
            return n({
              getSearchParams: function () {
                return {};
              },
              transformSource: function (e) {
                return e.source;
              },
              itemsWithCategories: 1,
              categoriesPerItem: 1
            }, e);
          }(e),
          r = t.searchClient,
          i = t.indexName,
          s = t.getSearchParams,
          o = t.transformSource,
          c = t.categoryAttribute,
          u = t.itemsWithCategories,
          l = t.categoriesPerItem;
        return {
          name: "aa.querySuggestionsPlugin",
          getSources: function (e) {
            function t(e) {
              h("".concat(e.query, " ")), d();
            }
            var f = e.query,
              h = e.setQuery,
              d = e.refresh,
              p = e.state;
            return [o({
              source: {
                sourceId: "querySuggestionsPlugin",
                getItemInputValue: function (e) {
                  return e.item.query;
                },
                getItems: function () {
                  return P({
                    searchClient: r,
                    queries: [{
                      indexName: i,
                      query: f,
                      params: s({
                        state: p
                      })
                    }],
                    transformResponse: function (e) {
                      var t = e.hits[0];
                      return f && c ? t.reduce(function (e, t, r) {
                        var i,
                          s,
                          o = [t];
                        if (r <= u - 1) {
                          var f,
                            h = (i = t, s = Array.isArray(c) ? c : [c], s.reduce(function (e, t) {
                              return e && e[t];
                            }, i)).map(function (e) {
                              return e.value;
                            }).slice(0, l),
                            d = a(h);
                          try {
                            for (d.s(); !(f = d.n()).done;) {
                              var p = f.value;
                              o.push(n({
                                __autocomplete_qsCategory: p
                              }, t));
                            }
                          } catch (e) {
                            d.e(e);
                          } finally {
                            d.f();
                          }
                        }
                        return e.push.apply(e, o), e;
                      }, []) : t;
                    }
                  });
                },
                templates: y({
                  onTapAhead: t
                })
              },
              onTapAhead: t,
              state: p
            })];
          },
          __autocomplete_pluginOptions: e
        };
      }, e.getTemplates = y, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    });
  }, function (e, t, n) {
    !function (e, n) {
      n(t);
    }(this, function (e) {
      "use strict";

      function t(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function n(e) {
        for (var n = 1; n < arguments.length; n++) {
          var i = null != arguments[n] ? arguments[n] : {};
          n % 2 ? t(Object(i), !0).forEach(function (t) {
            r(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function r(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function i(e) {
        return function (e) {
          if (Array.isArray(e)) return a(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return a(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function a(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function s(e) {
        var t = e.item,
          r = e.query;
        return n(n({}, t), {}, {
          _highlightResult: {
            label: {
              value: r ? t.label.replace(new RegExp(r.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "gi"), function (e) {
                return "__aa-highlight__".concat(e, "__/aa-highlight__");
              }) : t.label
            }
          }
        });
      }
      function o(e) {
        var t = e.key;
        return function () {
          try {
            return localStorage.setItem(p, ""), localStorage.removeItem(p), !0;
          } catch (e) {
            return !1;
          }
        }() ? {
          setItem: function (e) {
            return window.localStorage.setItem(t, JSON.stringify(e));
          },
          getItem: function () {
            var e = window.localStorage.getItem(t);
            return e ? JSON.parse(e) : [];
          }
        } : {
          setItem: function () {},
          getItem: function () {
            return [];
          }
        };
      }
      function c(e) {
        var t = e.onRemove,
          n = e.onTapAhead;
        return {
          item: function (e) {
            var r = e.item,
              i = e.createElement,
              a = e.components;
            return i("div", {
              className: "aa-ItemWrapper"
            }, i("div", {
              className: "aa-ItemContent"
            }, i("div", {
              className: "aa-ItemIcon aa-ItemIcon--noBorder"
            }, i("svg", {
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, i("path", {
              d: "M12.516 6.984v5.25l4.5 2.672-0.75 1.266-5.25-3.188v-6h1.5zM12 20.016q3.281 0 5.648-2.367t2.367-5.648-2.367-5.648-5.648-2.367-5.648 2.367-2.367 5.648 2.367 5.648 5.648 2.367zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055-7.055 2.93-7.055-2.93-2.93-7.055 2.93-7.055 7.055-2.93z"
            }))), i("div", {
              className: "aa-ItemContentBody"
            }, i("div", {
              className: "aa-ItemContentTitle"
            }, i(a.ReverseHighlight, {
              hit: r,
              attribute: "label"
            }), r.category && i("span", {
              className: "aa-ItemContentSubtitle aa-ItemContentSubtitle--inline"
            }, i("span", {
              className: "aa-ItemContentSubtitleIcon"
            }), " in", " ", i("span", {
              className: "aa-ItemContentSubtitleCategory"
            }, r.category))))), i("div", {
              className: "aa-ItemActions"
            }, i("button", {
              className: "aa-ItemActionButton",
              title: "Remove this search",
              onClick: function (e) {
                e.preventDefault(), e.stopPropagation(), t(r.id);
              }
            }, i("svg", {
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, i("path", {
              d: "M18 7v13c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-10c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-13zM17 5v-1c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-4c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v1h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v13c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h10c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-13h1c0.552 0 1-0.448 1-1s-0.448-1-1-1zM9 5v-1c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h4c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v1zM9 11v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1zM13 11v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1z"
            }))), i("button", {
              className: "aa-ItemActionButton",
              title: 'Fill query with "'.concat(r.label, '"'),
              onClick: function (e) {
                e.preventDefault(), e.stopPropagation(), n(r);
              }
            }, i("svg", {
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, i("path", {
              d: "M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z"
            })))));
          }
        };
      }
      function u(e) {
        return function (t) {
          (0, t.onSelect)(function (t) {
            var n = t.item,
              r = t.state,
              i = t.source,
              a = i.getItemInputValue({
                item: n,
                state: r
              });
            if ("querySuggestionsPlugin" === i.sourceId && a) {
              var s = {
                id: a,
                label: a,
                category: n.__autocomplete_qsCategory
              };
              e.addItem(s);
            }
          });
        };
      }
      function l(e) {
        var t = function (e) {
            return n({
              transformSource: function (e) {
                return e.source;
              }
            }, e);
          }(e),
          r = t.storage,
          a = t.transformSource,
          s = t.subscribe,
          o = function (e) {
            return {
              addItem: function (t) {
                e.onRemove(t.id), e.onAdd(t);
              },
              removeItem: function (t) {
                e.onRemove(t);
              },
              getAll: function (t) {
                return e.getAll(t);
              }
            };
          }(r),
          l = {
            current: []
          };
        return {
          name: "aa.recentSearchesPlugin",
          subscribe: null != s ? s : u(o),
          onSubmit: function (e) {
            var t = e.state.query;
            if (t) {
              var n = {
                id: t,
                label: t
              };
              o.addItem(n);
            }
          },
          getSources: function (e) {
            function t(e) {
              o.removeItem(e), s();
            }
            function n(e) {
              i(e.label), s();
            }
            var r = e.query,
              i = e.setQuery,
              s = e.refresh,
              u = e.state;
            return l.current = o.getAll(r), Promise.resolve(l.current).then(function (e) {
              return 0 === e.length ? [] : [a({
                source: {
                  sourceId: "recentSearchesPlugin",
                  getItemInputValue: function (e) {
                    return e.item.label;
                  },
                  getItems: function () {
                    return e;
                  },
                  templates: c({
                    onRemove: t,
                    onTapAhead: n
                  })
                },
                onRemove: t,
                onTapAhead: n,
                state: u
              })];
            });
          },
          data: n(n({}, o), {}, {
            getAlgoliaSearchParams: function () {
              var e,
                t,
                r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return Array.isArray(l.current) ? n(n({}, r), {}, {
                facetFilters: [].concat(i(null !== (e = r.facetFilters) && void 0 !== e ? e : []), i(l.current.map(function (e) {
                  return ["objectID:-".concat(e.label)];
                }))),
                hitsPerPage: Math.max(1, (null !== (t = r.hitsPerPage) && void 0 !== t ? t : 10) - l.current.length)
              }) : r;
            }
          }),
          __autocomplete_pluginOptions: e
        };
      }
      function f(e) {
        var t = e.query,
          n = e.items,
          r = e.limit;
        return t ? n.filter(function (e) {
          return e.label.toLowerCase().includes(t.toLowerCase());
        }).slice(0, r).map(function (e) {
          return s({
            item: e,
            query: t
          });
        }) : n.slice(0, r).map(function (e) {
          return s({
            item: e,
            query: t
          });
        });
      }
      function h(e) {
        return n({
          limit: 5,
          search: f,
          transformSource: function (e) {
            return e.source;
          }
        }, e);
      }
      var d = "AUTOCOMPLETE_RECENT_SEARCHES",
        p = "__AUTOCOMPLETE_RECENT_SEARCHES_PLUGIN_TEST_KEY__";
      e.addHighlightedAttribute = s, e.createLocalStorageRecentSearchesPlugin = function (e) {
        var t = h(e),
          r = t.key,
          a = t.limit,
          s = t.transformSource,
          c = t.search,
          u = t.subscribe,
          f = function (e) {
            var t = e.key,
              n = e.limit,
              r = e.search,
              a = o({
                key: t
              });
            return {
              onAdd: function (e) {
                a.setItem([e].concat(i(a.getItem())));
              },
              onRemove: function (e) {
                a.setItem(a.getItem().filter(function (t) {
                  return t.id !== e;
                }));
              },
              getAll: function () {
                return r({
                  query: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                  items: a.getItem(),
                  limit: n
                }).slice(0, n);
              }
            };
          }({
            key: [d, r].join(":"),
            limit: a,
            search: c
          });
        return n(n({}, l({
          transformSource: s,
          storage: f,
          subscribe: u
        })), {}, {
          name: "aa.localStorageRecentSearchesPlugin",
          __autocomplete_pluginOptions: e
        });
      }, e.createRecentSearchesPlugin = l, e.getTemplates = c, e.search = f, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    });
  }, function (e, t, n) {
    !function (e, n) {
      n(t);
    }(this, function (e) {
      "use strict";

      function t(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function n(e) {
        for (var n = 1; n < arguments.length; n++) {
          var i = null != arguments[n] ? arguments[n] : {};
          n % 2 ? t(Object(i), !0).forEach(function (t) {
            r(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function r(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function i(e) {
        return function (e) {
          if (Array.isArray(e)) return a(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return a(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function a(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function s(e, t) {
        var n = void 0;
        return function () {
          for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
          n && clearTimeout(n), n = setTimeout(function () {
            return e.apply(void 0, i);
          }, t);
        };
      }
      function o(e) {
        return e !== Object(e);
      }
      function c(e, t) {
        if (e === t) return !0;
        if (o(e) || o(t) || "function" == typeof e || "function" == typeof t) return e === t;
        if (Object.keys(e).length !== Object.keys(t).length) return !1;
        for (var n = 0, r = Object.keys(e); n < r.length; n++) {
          var i = r[n];
          if (!(i in t)) return !1;
          if (!c(e[i], t[i])) return !1;
        }
        return !0;
      }
      function u(e) {
        var t = e.item,
          n = e.items;
        return {
          index: t.__autocomplete_indexName,
          objectIDs: [t.objectID],
          positions: [1 + n.findIndex(function (e) {
            return e.objectID === t.objectID;
          })],
          queryID: t.__autocomplete_queryID
        };
      }
      function l(e) {
        var t = e.items.reduce(function (e, t) {
          var n;
          return e[t.__autocomplete_indexName] = (null !== (n = e[t.__autocomplete_indexName]) && void 0 !== n ? n : []).concat(t.objectID), e;
        }, {});
        return Object.keys(t).map(function (e) {
          return {
            index: e,
            objectIDs: t[e]
          };
        });
      }
      function f(e) {
        return e.objectID && e.__autocomplete_indexName && e.__autocomplete_queryID;
      }
      var h = function () {},
        d = s(function (e) {
          var t = e.onItemsChange,
            r = e.items,
            i = e.insights,
            a = e.state;
          t({
            insights: i,
            insightsEvents: l({
              items: r
            }).map(function (e) {
              return n({
                eventName: "Items Viewed"
              }, e);
            }),
            state: a
          });
        }, 400);
      e.createAlgoliaInsightsPlugin = function (e) {
        var t,
          r = function (e) {
            return n({
              onItemsChange: function (e) {
                var t = e.insights,
                  n = e.insightsEvents;
                t.viewedObjectIDs.apply(t, i(n));
              },
              onSelect: function (e) {
                var t = e.insights,
                  n = e.insightsEvents;
                t.clickedObjectIDsAfterSearch.apply(t, i(n));
              },
              onActive: h
            }, e);
          }(e),
          a = r.insightsClient,
          o = r.onItemsChange,
          l = r.onSelect,
          p = r.onActive,
          m = (t = a, {
            init: function (e, n) {
              t("init", {
                appId: e,
                apiKey: n
              });
            },
            setUserToken: function (e) {
              t("setUserToken", e);
            },
            clickedObjectIDsAfterSearch: function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              n.length > 0 && t.apply(void 0, ["clickedObjectIDsAfterSearch"].concat(n));
            },
            clickedObjectIDs: function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              n.length > 0 && t.apply(void 0, ["clickedObjectIDs"].concat(n));
            },
            clickedFilters: function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              n.length > 0 && t.apply(void 0, ["clickedFilters"].concat(n));
            },
            convertedObjectIDsAfterSearch: function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              n.length > 0 && t.apply(void 0, ["convertedObjectIDsAfterSearch"].concat(n));
            },
            convertedObjectIDs: function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              n.length > 0 && t.apply(void 0, ["convertedObjectIDs"].concat(n));
            },
            convertedFilters: function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              n.length > 0 && t.apply(void 0, ["convertedFilters"].concat(n));
            },
            viewedObjectIDs: function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              n.length > 0 && t.apply(void 0, ["viewedObjectIDs"].concat(n));
            },
            viewedFilters: function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              n.length > 0 && t.apply(void 0, ["viewedFilters"].concat(n));
            }
          }),
          g = {
            current: []
          },
          v = s(function (e) {
            var t = e.state;
            if (t.isOpen) {
              var n = t.collections.reduce(function (e, t) {
                return [].concat(i(e), i(t.items));
              }, []).filter(f);
              c(g.current.map(function (e) {
                return e.objectID;
              }), n.map(function (e) {
                return e.objectID;
              })) || (g.current = n, n.length > 0 && d({
                onItemsChange: o,
                items: n,
                insights: m,
                state: t
              }));
            }
          }, 0);
        return {
          name: "aa.algoliaInsightsPlugin",
          subscribe: function (e) {
            var t = e.setContext,
              r = e.onSelect,
              i = e.onActive;
            t({
              algoliaInsightsPlugin: {
                insights: m
              }
            }), r(function (e) {
              var t = e.item,
                r = e.state,
                i = e.event;
              f(t) && l({
                state: r,
                event: i,
                insights: m,
                item: t,
                insightsEvents: [n({
                  eventName: "Item Selected"
                }, u({
                  item: t,
                  items: g.current
                }))]
              });
            }), i(function (e) {
              var t = e.item,
                r = e.state,
                i = e.event;
              f(t) && p({
                state: r,
                event: i,
                insights: m,
                item: t,
                insightsEvents: [n({
                  eventName: "Item Active"
                }, u({
                  item: t,
                  items: g.current
                }))]
              });
            });
          },
          onStateChange: function (e) {
            var t = e.state;
            v({
              state: t
            });
          },
          __autocomplete_pluginOptions: e
        };
      }, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    });
  }]);
});

